{
  "app": {
    "brand": {
      "name": "Gharbatai Finance"
    },
    "starting": {
      "title": "Starting",
      "description": "Setting up your session"
    },
    "error": {
      "title": "Application Error",
      "description": "An unexpected error occurred. Please refresh the page to continue.",
      "retryLabel": "Refresh Page"
    }
  },
  "admin": {
    "title": "Admin",
    "organizationAccessInspector": {
      "title": "Organization Access Inspector",
      "identity": "Identity context",
      "delegation": "Delegation",
      "permissions": "Permissions",
      "modules": "Enabled modules",
      "accounts": "Account scope",
      "policy": "Persona policy",
      "subject": "Subject"
    },
    "inspector": {
      "persona": "Persona",
      "organizationId": "Organization ID",
      "branchId": "Branch ID",
      "scopeKind": "Scope",
      "delegated": "Delegated",
      "delegationId": "Delegation ID",
      "delegationTarget": "Delegation target organization",
      "permissions": "Permissions",
      "enabledModules": "Enabled modules",
      "clientAccountId": "Client account ID",
      "portfolioAccountId": "Portfolio account ID",
      "personaPolicy": "Persona policy",
      "subjectUserId": "Subject user ID",
      "subjectEmail": "Subject email",
      "subjectName": "Subject name",
      "subjectMfa": "MFA enrolled",
      "subjectRoles": "Assigned roles"
    },
    "overview": {
      "title": "Overview",
      "description": "Admin overview",
      "errorTitle": "Error"
    },
    "admin-users": {
      "metrics": {
        "totalUsers": "Total Users",
        "activeUsers": "Active Users",
        "pendingUsers": "Pending Users",
        "suspendedUsers": "Suspended Users"
      }
    },
    "admin-roles": {
      "metrics": {
        "totalRoles": "Total Roles",
        "activeRoles": "Active Roles",
        "pendingRoles": "Pending Roles",
        "suspendedRoles": "Suspended Roles"
      }
    },
    "governance": {
      "users": {
        "title": "Users",
        "description": "Manage users, status, and role assignments",
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "edit": "Edit",
          "editDesc": "Edit",
          "delete": "Delete",
          "deleteDesc": "Delete",
          "assignRole": "Assign Role",
          "assignRoleDesc": "Assign a role to this user",
          "assignScope": "Assign Scope",
          "assignScopeDesc": "Assign scope permissions to this user"
        }
      },
      "roles": {
        "title": "Roles",
        "description": "Define assignable roles and permission boundaries",
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "editPermissions": "Edit Permissions",
          "editPermissionsDesc": "Edit Permissions",
          "delete": "Delete",
          "deleteDesc": "Delete"
        }
      },
      "approvalsQueue": {
        "title": "Transaction Approval Governance",
        "description": "Review pending investment transaction approvals, exception decisions, and escalation outcomes."
      },
      "organization": {
        "title": "Organization",
        "description": "Manage organization settings and configuration",
        "organizationSettings": {
          "loadingSettings": "Loading settings",
          "failedToLoad": "Failed to load settings",
          "orgInfo": "Organization Info",
          "modules": "Modules",
          "orgInformation": "Organization Information",
          "name": "Name",
          "code": "Code",
          "codeReadOnly": "Code (Read Only)",
          "panNumber": "PAN Number",
          "vatNumber": "VAT Number",
          "email": "Email",
          "phone": "Phone",
          "address": "Address",
          "fiscalYearStart": "Fiscal Year Start",
          "notProvided": "Not provided",
          "notConfigured": "Not configured",
          "saving": "Saving...",
          "saveChanges": "Save Changes"
        },
        "actions": {
          "save": "Save",
          "saveDesc": "Save"
        },
        "saveSuccess": "Organization saved successfully"
      },
      "modules": {
        "title": "Modules",
        "description": "Manage module subscriptions and tier capabilities"
      },
      "audit": {
        "title": "Audit",
        "description": "Review system change history and audit trails",
        "lineageView": {
          "title": "Audit lineage"
        }
      },
      "permissionBundles": {
        "title": "Permission Bundles",
        "description": "Manage reusable permission templates for roles",
        "selectPermission": "Select permission",
        "selectRole": "Select role",
        "noAvailablePermissions": "No permissions available",
        "noAvailableRoles": "No roles available",
        "addPermission": "Add",
        "assignRole": "Assign",
        "noPermissionsAssigned": "No permissions assigned.",
        "noRolesAssigned": "No roles assigned.",
        "permissionList": "Assigned permissions",
        "roleList": "Assigned roles",
        "loadError": "Failed to load permission bundles",
        "createError": "Failed to create permission bundle",
        "deleteError": "Failed to delete permission bundle",
        "approveError": "Failed to approve permission bundle",
        "rejectError": "Failed to reject permission bundle",
        "addPermissionError": "Failed to add permission to bundle",
        "removePermissionError": "Failed to remove permission from bundle",
        "assignRoleError": "Failed to assign bundle to role",
        "removeRoleError": "Failed to remove bundle from role",
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "delete": "Delete",
          "deleteDesc": "Delete"
        }
      },
      "accessInspector": {
        "title": "Access Inspector",
        "description": "Inspect and validate access control policies"
      },
      "clientAccounts": {
        "title": "Client Accounts",
        "description": "Manage client account ownership, access assignments, and administrator delegations.",
        "actions": {
          "create": "Create",
          "createDesc": "Create a new client account",
          "update": "Update",
          "updateDesc": "Update client account details",
          "activate": "Activate",
          "activateDesc": "Activate this client account",
          "deactivate": "Deactivate",
          "deactivateDesc": "Deactivate this client account",
          "close": "Close",
          "closeDesc": "Close this client account",
          "kycVerify": "Verify KYC",
          "kycVerifyDesc": "Mark KYC as verified",
          "kycReject": "Reject KYC",
          "kycRejectDesc": "Reject KYC verification",
          "kycReset": "Reset KYC",
          "kycResetDesc": "Reset KYC to pending",
          "kycExpire": "Expire KYC",
          "kycExpireDesc": "Mark KYC as expired"
        }
      },
      "clientAdministration": {
        "title": "Client administration",
        "description": "Manage client account ownership, access assignments, and administrator delegations."
      },
      "system": {
        "title": "System",
        "description": "System administration and data operations"
      },
      "systemPosture": {
        "title": "System Posture",
        "description": "Monitor branch health, data operations, and platform posture"
      },
      "context": {
        "title": "Governance workspace context",
        "subtitle": "Review approvals first, then adjust users, roles, and modules.",
        "pendingApprovals": "{{count}} pending approval(s). Resolve before changing roles or modules to preserve audit traceability.",
        "pendingApprovalsLoading": "Loading pending approvals...",
        "pendingApprovalsUnavailable": "Pending approvals are temporarily unavailable. Open the approvals queue to verify status.",
        "sequence": "Apply module and role changes after resolving active approvals to preserve audit traceability."
      },
      "attention": {
        "title": "Governance action required",
        "pendingApprovals": "{{count}} pending approval(s)",
        "pendingApprovalsSingle": "1 approval pending",
        "pendingApprovalsPlural": "{{count}} approvals pending",
        "reviewAction": "Review approvals"
      },
      "snapshot": {
        "pendingApprovals": "pending approvals",
        "syncState": "sync state",
        "pendingApprovalsDesc": "Pending approval requests requiring review"
      },
      "noAccess": "No Access",
      "peopleAccess": {
        "title": "People Access"
      },
      "approvals": {
        "actions": {
          "approve": "Approve",
          "approveDesc": "Approve",
          "reject": "Reject",
          "rejectDesc": "Reject"
        }
      }
    },
    "system": {
      "title": "System Posture",
      "description": "System administration, posture monitoring, and data operations",
      "refresh": "Refresh",
      "dataOperationsTitle": "Data Operations",
      "dataOperationsDescription": "Manage system data operations including imports, exports, and database maintenance",
      "dataOperationsNote": "Note: Some operations may require elevated permissions",
      "dataOperationsAction": "Open Data Hub",
      "health": "Health",
      "backendApi": "Backend API",
      "unknown": "Unknown",
      "database": "Database",
      "unavailable": "Unavailable",
      "connected": "Connected",
      "initialization": "Initialization",
      "ready": "Ready",
      "bootstrapPending": "Bootstrap Pending",
      "currentUser": "Current User",
      "operatorAccounts": "Operator Accounts",
      "refreshStatus": "Refresh Status",
      "errorTitle": "Error",
      "errorDescription": "An error occurred while processing your request. Please try again.",
      "checks": {
        "database": {
          "label": "Database",
          "healthy": "Database is healthy",
          "critical": "Database connection failed",
          "unknown": "Database status unknown"
        },
        "cache": {
          "label": "Cache",
          "healthy": "Cache is healthy",
          "unknown": "Cache status unknown"
        },
        "queues": {
          "label": "Queues",
          "healthy": "Queues are healthy",
          "unknown": "Queue status unknown"
        },
        "apiHealth": {
          "label": "API Health",
          "unknown": "API health status unknown"
        },
        "backgroundJobs": {
          "label": "Background Jobs",
          "unknown": "Background job status unknown"
        },
        "auditWriter": {
          "label": "Audit Writer",
          "unknown": "Audit writer status unknown"
        },
        "marketDataFreshness": {
          "label": "Market Data Freshness",
          "unknown": "Market data freshness unknown"
        },
        "reportRuntime": {
          "label": "Report Runtime",
          "unknown": "Report runtime status unknown"
        },
        "storageExport": {
          "label": "Storage/Export Service",
          "unknown": "Storage/export service status unknown"
        },
        "databaseDesc": "Database connectivity and performance",
        "cacheDesc": "Cache layer health",
        "queuesDesc": "Background queue processing status"
      },
      "refreshPosture": "Refresh Posture",
      "refreshPostureSuccess": "System posture refreshed",
      "refreshPostureDesc": "Refresh system health posture"
    },
    "navigation": {
      "overview": "Overview",
      "users": "Users",
      "roles": "Roles",
      "approvals": "Approvals",
      "organization": "Organization",
      "modules": "Modules",
      "clientAccounts": "Client Accounts",
      "system": "System Posture",
      "audit": "Audit",
      "settings": "Settings",
      "moreTabs": "More tabs",
      "ariaLabel": "Aria"
    },
    "rootPowerTools": {
      "title": "Power Tools",
      "description": "Provider-level administrative tools. All actions are audited.",
      "warning": {
        "caution": "Caution:",
        "message": "Actions taken here affect real branch data. All operations require justification and are logged."
      },
      "common": {
        "branchId": "Branch ID",
        "branchUuidPlaceholder": "Branch UUID...",
        "reasonRequired": "Reason (required for audit)"
      },
      "passwordReset": {
        "title": "Reset Branch Admin Password",
        "description": "Generates a one-time temporary password for the branch admin. The admin must change it on next login.",
        "reasonPlaceholder": "e.g. Admin locked out, support ticket #1234",
        "action": "Reset Password",
        "oneTimeNotice": "Copy now — shown only once"
      },
      "statusChange": {
        "title": "Change Branch Status",
        "description": "Activate, suspend, or revert a branch to pending setup. This affects all users in that branch.",
        "newStatus": "New Status",
        "selectStatus": "Select status",
        "reasonPlaceholder": "e.g. Non-payment, service suspension",
        "action": "Apply Status Change"
      },
      "databaseReset": {
        "title": "Reset Branch Database",
        "destructiveLabel": "Destructive action:",
        "description": "Removes all data for a specific branch including users, transactions, and settings. This cannot be undone.",
        "reasonPlaceholder": "e.g. Data corruption, branch closure, GDPR request",
        "action": "Reset Database"
      },
      "messages": {
        "statusChanged": "Branch status changed to {{status}}"
      },
      "futureTools": {
        "title": "SQL Query Runner, Backup & Restore, and Job Retry tools",
        "description": "Coming in next release — require additional guardrails and environment checks."
      }
    },
    "rootSettings": {
      "title": "Provider Settings",
      "description": "Configure root security policy, provider identity, and operational thresholds.",
      "quickCards": {
        "sessionTimeout": {
          "title": "Session Timeout",
          "description": "Used by the root console inactivity timer."
        },
        "whitelistedIps": {
          "title": "Whitelisted IPs",
          "description": "Each entry should represent a trusted operator location."
        },
        "defaultBranchPlan": {
          "title": "Default Branch Plan",
          "description": "Used to prefill new branch onboarding."
        }
      },
      "sections": {
        "providerIdentity": "Provider Identity",
        "securityControls": "Security Controls",
        "operationalThresholds": "Operational Thresholds"
      },
      "fields": {
        "providerName": "Provider Name",
        "supportEmail": "Support Email",
        "supportWebsite": "Support Website",
        "defaultMaxUsers": "Default Max Users"
      },
      "security": {
        "requireMfa": {
          "title": "Require MFA",
          "description": "Raises a critical alert until MFA is configured."
        },
        "view": {
          "loadingHoldingsTitle": "Loading holdings",
          "loadingHoldingsDescription": "Fetching valuation, positions, and pricing status.",
          "unableToLoadHoldings": "Unable to load holdings",
          "totalInvestment": "Total Investment",
          "unrealizedPnL": "Unrealized P&L",
          "annualizedReturn": "Annualized return",
          "allHoldings": "All Holdings",
          "viewCostBasis": "View Cost Basis",
          "viewCostBasisAriaDisabled": "View Cost Basis disabled: no access to cost-basis data",
          "costBasisDataTitle": "Cost Basis Data",
          "costBasisDataDescription": "Raw cost-basis data without market pricing. Shows quantities, weighted average cost, and total cost.",
          "loadingCostBasisTitle": "Loading cost-basis data",
          "loadingCostBasisDescription": "Fetching raw holdings without market pricing.",
          "unableToLoadCostBasisData": "Unable to load cost-basis data",
          "costBasisHoldings": "Cost Basis Holdings",
          "noCostBasisRows": "No cost-basis rows",
          "noCostBasisRowsDescription": "No holdings are currently available in cost-basis mode.",
          "failedToLoadCostBasisData": "Failed to load cost-basis data"
        },
        "requireReasons": {
          "title": "Require Reasons",
          "description": "Applied to root-sensitive actions such as suspension and password resets."
        },
        "inactivityTimeoutMinutes": "Inactivity Timeout (minutes)",
        "whitelistedIps": "Whitelisted IPs",
        "whitelistPlaceholder": "One IP or CIDR per line",
        "mfaStatusTitle": "MFA Status"
      }
    },
    "rootBranches": {
      "description": "Provision, monitor, and retire branch organizations from the root console.",
      "actions": {
        "createBranch": "Create Branch",
        "viewBranchDetails": "View branch details",
        "viewDetails": "View Details",
        "suspendBranch": "Suspend Branch",
        "activateBranch": "Activate Branch",
        "retireBranch": "Retire Branch"
      },
      "filters": {
        "searchPlaceholder": "Search branches by name or code",
        "allStatuses": "All statuses",
        "pendingSetup": "Pending Setup"
      },
      "table": {
        "nameCode": "Name / Code",
        "maxUsers": "Max Users",
        "empty": "No branches matched the current filters."
      },
      "pagination": {
        "pageOfTotal": "Page {{page}} of {{totalPages}} ({{total}} total)"
      },
      "form": {
        "enabledModules": "Enabled Modules"
      },
      "statusChange": {
        "reasonPrompt": "Please provide a reason for this status change. This will be recorded in the audit log.",
        "reasonPlaceholder": "Reason (required)"
      },
      "retireDialog": {
        "archiveNoticePrefix": "This",
        "archiveNoticeEmphasis": "suspends and archives",
        "archiveNoticeSuffix": "the branch — it does not permanently delete any data.",
        "branchPrefix": "Branch",
        "branchSuffix": "will be suspended and hidden from active operations. Data can be recovered by reactivating the branch."
      }
    },
    "userManagement": {
      "title": "User Management",
      "createUser": {
        "label": "Create User",
        "confirmation": "Create this user?",
        "success": "User created successfully",
        "labelDesc": "Create a new user account"
      },
      "editUser": "Edit User",
      "refresh": "Refresh",
      "working": "Working…",
      "searchPlaceholder": "Search users",
      "allStatuses": "All Statuses",
      "allUserTypes": "All User Types",
      "summary": {
        "total": "Total Users",
        "active": "Active Users",
        "pending": "Pending Users",
        "suspended": "Suspended Users"
      },
      "table": {
        "userId": "User ID",
        "name": "Name",
        "email": "Email",
        "branch": "Branch",
        "type": "Type",
        "status": "Status",
        "createdAt": "Created At",
        "actions": "Actions"
      },
      "form": {
        "userId": "User ID",
        "userIdRequired": "User ID is required",
        "username": "Username",
        "usernameRequired": "Username is required",
        "email": "Email",
        "emailRequired": "Email is required",
        "invalidEmail": "Invalid email",
        "firstName": "First Name",
        "firstNameRequired": "First name is required",
        "surname": "Surname",
        "surnameRequired": "Surname is required",
        "password": "Password",
        "passwordRequired": "Password is required",
        "passwordRequirements": "Password must be between 8-128 characters and contain at least one letter and one number",
        "passwordHint": "8-128 characters, must contain letters and numbers",
        "branch": "Branch",
        "branchRequired": "Branch *",
        "noBranch": "— No branch —",
        "userType": "User Type",
        "userTypeRequired": "User Type *",
        "noType": "— No type —",
        "roleAssignment": "Role Assignment",
        "designation": "Designation",
        "designationPlaceholder": "Enter designation",
        "emailInvalid": "Email address is invalid",
        "emailPlaceholder": "Enter email address",
        "extension": "Extension",
        "extensionPlaceholder": "Enter extension",
        "firstNamePlaceholder": "Enter first name",
        "isActive": "Active",
        "mobile": "Mobile",
        "mobilePlaceholder": "Enter mobile number",
        "passwordPlaceholder": "Enter password",
        "surnamePlaceholder": "Enter surname",
        "telephone": "Telephone",
        "telephonePlaceholder": "Enter telephone number",
        "userIdPlaceholder": "Enter user ID",
        "usernamePlaceholder": "Enter username",
        "userIdDesc": "Unique user identifier",
        "usernameDesc": "Login username",
        "emailDesc": "Email address",
        "passwordDesc": "Account password",
        "firstNameDesc": "First name",
        "surnameDesc": "Surname or last name",
        "designationDesc": "Job designation",
        "branchDesc": "Assigned branch",
        "userTypeDesc": "User role type",
        "telephoneDesc": "Telephone number",
        "mobileDesc": "Mobile number",
        "extensionDesc": "Phone extension",
        "isActiveDesc": "Account active status",
        "clientAccountId": "Client Account",
        "clientAccountIdPlaceholder": "Select existing client account",
        "clientAccountCode": "Client Account Code",
        "clientAccountCodePlaceholder": "Enter client account code",
        "clientAccountName": "Client Account Name",
        "clientAccountNamePlaceholder": "Enter client account name",
        "clientAccountEmail": "Client Account Email",
        "clientAccountEmailPlaceholder": "Enter client account email",
        "clientAccountPhone": "Client Account Phone",
        "clientAccountPhonePlaceholder": "Enter client account phone",
        "clientAccountPanNumber": "Client Account PAN",
        "clientAccountPanNumberPlaceholder": "Enter client account PAN number",
        "organizationName": "Organization Name",
        "organizationNamePlaceholder": "Enter organization name",
        "organizationCode": "Organization Code",
        "organizationCodePlaceholder": "Enter organization code",
        "organizationPanNumber": "Organization PAN",
        "organizationPanNumberPlaceholder": "Enter organization PAN number",
        "organizationVatNumber": "Organization VAT",
        "organizationVatNumberPlaceholder": "Enter organization VAT number",
        "organizationAddress": "Organization Address",
        "organizationAddressPlaceholder": "Enter organization address",
        "organizationPhone": "Organization Phone",
        "organizationPhonePlaceholder": "Enter organization phone",
        "organizationEmail": "Organization Email",
        "organizationEmailPlaceholder": "Enter organization email"
      },
      "actions": {
        "edit": "Edit",
        "approve": "Approve",
        "reject": {
          "label": "Reject",
          "confirmation": "Are you sure you want to reject this user?",
          "labelDesc": "Reject this user account"
        },
        "suspend": {
          "label": "Suspend",
          "confirmation": "Are you sure you want to suspend this user?",
          "labelDesc": "Suspend this user account"
        },
        "activate": {
          "label": "Activate",
          "confirmation": "Are you sure you want to activate this user?",
          "labelDesc": "Activate this user account"
        },
        "unlock": {
          "label": "Unlock",
          "confirmation": "Are you sure you want to unlock this user?",
          "labelDesc": "Unlock this user account"
        },
        "cancel": "Cancel",
        "save": "Save",
        "saving": "Saving…",
        "creating": "Creating…",
        "createUser": "Create User",
        "editDesc": "Edit",
        "approveDesc": "Approve",
        "rejectDesc": "Reject",
        "suspendDesc": "Suspend",
        "activateDesc": "Activate this user",
        "unlockDesc": "Unlock this user account",
        "saveDesc": "Save",
        "delete": {
          "label": "Delete",
          "labelDesc": "Delete this user"
        },
        "approveDelete": {
          "label": "Approve Delete",
          "labelDesc": "Approve deletion of this user"
        },
        "reapply": {
          "label": "Reapply",
          "labelDesc": "Reapply user request"
        }
      },
      "messages": {
        "loadingPermissions": "Loading permissions...",
        "loadingUsers": "Loading users...",
        "accessDenied": "Access Denied",
        "accessDeniedDescription": "You do not have permission to view users.",
        "error": "Error",
        "failedToCreateUser": "Failed to create user",
        "userCreatedSuccessfully": "User created successfully",
        "failedToUpdateUser": "Failed to update user",
        "userUpdatedSuccessfully": "User updated successfully",
        "failedToAssignRole": "Failed to assign role. Profile was saved.",
        "failedToRemoveRole": "Failed to remove role. Profile was saved.",
        "failedToApproveUser": "Failed to approve user",
        "userApprovedSuccessfully": "User approved successfully",
        "userRejectedSuccessfully": "User rejected successfully",
        "suspendUser": "Suspend User",
        "suspendUserMessage": "Enter a reason for suspending this user:",
        "suspendConfirm": "Suspend",
        "suspensionReasonPlaceholder": "Suspension reason (required)",
        "failedToSuspendUser": "Failed to suspend user",
        "userSuspendedSuccessfully": "User suspended successfully",
        "failedToUnlockUser": "Failed to unlock user",
        "userUnlockedSuccessfully": "User unlocked successfully",
        "failedToReactivateUser": "Failed to reactivate user",
        "userReactivatedSuccessfully": "User reactivated successfully",
        "noUsersFound": "No users found. No results.",
        "pageOf": "Page {{page}} of {{totalPages}}",
        "total": " ({{total}} total)",
        "reactivationReason": "Reactivation Reason",
        "success": "Messages Success"
      },
      "fallback": {
        "administrator": "Administrator",
        "manager": "Manager",
        "operator": "Operator",
        "viewer": "Viewer",
        "mainBranch": "Main Branch"
      },
      "status": {
        "locked": "Locked",
        "active": "Active",
        "pendingApproval": "Pending Approval",
        "suspended": "Suspended",
        "rejected": "Rejected"
      },
      "pagination": {
        "previous": "Previous",
        "next": "Next"
      },
      "createUserDescription": "Create a new user account",
      "updateUser": "Update User",
      "updateUserDescription": "Update user account details",
      "createUserDesc": "Create a new user account",
      "emptyState": {
        "message": "No users found. Create a user to get started."
      }
    },
    "roleManagement": {
      "title": "Role Management",
      "createRole": {
        "label": "Create Role",
        "confirmation": "Create this role?",
        "success": "Role created successfully"
      },
      "refresh": "Refresh",
      "working": "Working…",
      "table": {
        "id": "ID",
        "roleId": "Role ID",
        "name": "Name",
        "type": "Type",
        "userType": "User Type",
        "users": "Users",
        "status": "Status",
        "functions": "Functions",
        "functionCount": "Functions",
        "userCount": "User Count",
        "actions": "Actions"
      },
      "form": {
        "roleId": "Role ID",
        "roleIdRequired": "Role ID",
        "roleName": "Role Name",
        "roleNameRequired": "Role Name *",
        "description": "Form description",
        "roleIdPlaceholder": "e.g., PORTFOLIO_MANAGER",
        "roleIdHint": "Max 50 characters, alphanumeric with hyphens/underscores",
        "roleNamePlaceholder": "e.g., Portfolio Manager",
        "descriptionPlaceholder": "Role description...",
        "functions": "Functions",
        "functionsRequired": "At least one function must be selected",
        "functionsHint": "Select the functions this role can perform",
        "userType": "User Type",
        "userTypeRequired": "User type is required",
        "functionsDesc": "Assigned functions and permissions",
        "roleIdDesc": "Role identifier",
        "roleNameDesc": "Role name",
        "userTypeDesc": "User type for this role"
      },
      "actions": {
        "edit": "Edit",
        "approve": "Approve",
        "reject": {
          "label": "Reject",
          "confirmation": "Are you sure you want to reject this role?"
        },
        "assignFunctions": "Assign Functions",
        "suspend": {
          "label": "Suspend",
          "confirmation": "Are you sure you want to suspend this role?"
        },
        "delete": {
          "label": "Delete",
          "confirmation": "Are you sure you want to delete this role?"
        },
        "deleteRole": "Delete role",
        "deleteConfirm": "Delete role",
        "cancel": "Cancel",
        "assignFunctionsButton": "Assign Functions",
        "creating": "Creating…",
        "createRole": "Create Role",
        "assignFunctionsDescription": "Assign permissions and functions to this role",
        "editDescription": "Edit role details",
        "approveDesc": "Approve",
        "rejectDesc": "Reject",
        "assignFunctionsDesc": "Assign Functions",
        "suspendDesc": "Suspend this role",
        "deleteDesc": "Delete this role",
        "assign": "Assign",
        "assignDesc": "Assign this role to users"
      },
      "messages": {
        "loadingPermissions": "Loading permissions...",
        "loadingRoles": "Loading roles...",
        "accessDenied": "You do not have permission to view roles.",
        "failedToLoadRoles": "Failed to load roles",
        "failedToLoadFunctions": "Failed to load functions",
        "failedToApproveRole": "Failed to approve role",
        "roleApproved": "Role approved",
        "roleRejected": "Role rejected",
        "roleApprovedMessage": "Role workflow action approved completed successfully.",
        "roleRejectedMessage": "Role workflow action rejected completed successfully.",
        "suspendRole": "Suspend Role",
        "suspendRoleMessage": "Enter a reason for suspending this role:",
        "suspendConfirm": "Suspend",
        "suspensionReasonPlaceholder": "Suspension reason (required)",
        "failedToSuspendRole": "Failed to suspend role",
        "roleSuspended": "Role suspended",
        "roleSuspendedMessage": "The role was suspended successfully.",
        "deleteRoleMessage": "Delete this role? This cannot be undone.",
        "failedToDeleteRole": "Failed to delete role",
        "roleDeleted": "Role deleted",
        "roleDeletedMessage": "The role was deleted successfully.",
        "assignFunctionsTitle": "Assign Functions to {{roleName}}",
        "failedToAssignFunctions": "Failed to assign functions",
        "functionsUpdated": "Functions updated",
        "functionsUpdatedMessage": "Role functions were updated successfully.",
        "system": "System",
        "functionsCount": "{{count}} functions",
        "failedToCreateRole": "Failed To Create Role"
      },
      "summary": {
        "total": "Total",
        "active": "Active",
        "pending": "Pending",
        "suspended": "Suspended"
      },
      "status": {
        "unknown": "Unknown"
      },
      "createRoleDescription": "Create a new role with permissions",
      "createRoleDesc": "Create a new role with permissions",
      "emptyState": {
        "message": "No roles found. Create a role to get started."
      }
    },
    "audit": {
      "title": "Audit",
      "description": "Review system diagnostics, governance events, and trace evidence.",
      "loadingEvents": "Loading audit events...",
      "noEvents": "No audit events found.",
      "views": {
        "diagnostics": {
          "title": "Audit diagnostics",
          "description": "Review system audit diagnostics, recent activity, and governance events.",
          "tab": "Diagnostics"
        },
        "traces": {
          "title": "Audit traces",
          "description": "Trace event lineage and delegated support evidence for investigation workflows.",
          "tab": "Traces"
        }
      },
      "columnTimestamp": "Timestamp",
      "columnActor": "Actor",
      "columnAction": "Action",
      "columnEntity": "Entity",
      "columnEntityId": "Entity ID",
      "columnComment": "Comment",
      "emptyMessage": "Message",
      "actor": "Actor",
      "actorPlaceholder": "Actor",
      "actorHelper": "Actor",
      "action": "Audit Action",
      "allActions": "All Actions",
      "entityType": "Entity Type",
      "allEntities": "All Entities",
      "fromDate": "From Date",
      "toDate": "To Date",
      "apply": "Apply",
      "reset": "Reset",
      "errorTitle": "Error",
      "loadingTitle": "Loading",
      "loadMore": "Load More",
      "totalLogs": "Total Logs",
      "today": "Today",
      "actions": {
        "create": "Create",
        "modify": "Modify",
        "delete": "Delete",
        "approve": "Approve",
        "reject": "Reject"
      },
      "invalidViewFallback": "Invalid View Fallback",
      "exportFormTitle": "Export Audit Logs",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "redactionPolicy": "Redaction Policy",
      "redaction": {
        "full": "Full",
        "metadataOnly": "Metadata Only",
        "redacted": "Redacted"
      },
      "export": "Export",
      "exportSuccess": "Audit export requested successfully",
      "exportDesc": "Export"
    },
    "clientAccounts": {
      "title": "Client Accounts",
      "description": "Manage client accounts and KYC status",
      "aboutTitle": "About Client Accounts",
      "aboutDescription": "Client accounts represent individual or corporate investment beneficiaries managed by your organization.",
      "form": {
        "validation": {
          "firstNameRequired": "First Name Required",
          "lastNameRequired": "Last Name Required",
          "validEmail": "Valid Email"
        },
        "error": {
          "generic": "Generic",
          "unexpected": "Unexpected"
        },
        "editTitle": "Edit Client Account",
        "addTitle": "Add Client Account",
        "firstName": "First Name",
        "placeholder": {
          "firstName": "First Name",
          "lastName": "Last Name",
          "email": "Email",
          "phone": "Phone",
          "address": "Address",
          "branchId": "Branch ID",
          "notes": "Notes",
          "code": "Code"
        },
        "codePlaceholder": "Enter code",
        "emailPlaceholder": "Enter email address",
        "fullNamePlaceholder": "Enter full name",
        "notesPlaceholder": "Enter notes",
        "panNumberPlaceholder": "Enter PAN number",
        "phonePlaceholder": "Enter phone number",
        "lastName": "Last Name",
        "branchId": "Branch ID",
        "branchIdHelp": "Select the branch for this client account",
        "kycStatus": "KYC Status",
        "accountStatus": "Account Status",
        "saving": "Saving",
        "saveChanges": "Save Changes",
        "createClient": "Create Client",
        "accountType": "Account Type",
        "code": "Account Code",
        "codeRequired": "Account code is required",
        "createDescription": "Create a new client account",
        "email": "Email Address",
        "emailInvalid": "Email address is invalid",
        "fullName": "Full Name",
        "fullNameRequired": "Full name is required",
        "isActive": "Active",
        "notes": "Notes",
        "notesTooLong": "Notes must be less than 500 characters",
        "panNumber": "PAN Number",
        "panNumberInvalid": "PAN number format is invalid",
        "phone": "Phone Number",
        "phoneInvalid": "Phone number is invalid",
        "updateClient": "Update Client Account",
        "updateDescription": "Update client account details",
        "codeDesc": "Account code",
        "fullNameDesc": "Full name",
        "emailDesc": "Email address",
        "phoneDesc": "Phone number",
        "panNumberDesc": "PAN number",
        "accountTypeDesc": "Account type",
        "notesDesc": "Internal notes",
        "isActiveDesc": "Account active status",
        "createClientDesc": "Create a new client account",
        "saveChangesDesc": "Save client account changes"
      },
      "kycStatus": {
        "pending": "Pending",
        "verified": "Verified",
        "rejected": "Rejected",
        "expired": "Expired",
        "verifiedDesc": "KYC verified",
        "pendingDesc": "KYC pending",
        "rejectedDesc": "KYC rejected",
        "expiredDesc": "KYC expired"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "closed": "Closed",
        "activeDesc": "Active account",
        "inactiveDesc": "Inactive account",
        "closedDesc": "Closed account"
      },
      "emptyState": {
        "title": "No Client Accounts",
        "description": "Get started by creating your first client account.",
        "message": "No client accounts found."
      },
      "actions": {
        "addClient": "Add Client",
        "activate": "Activate",
        "activateAccount": "Activate Account",
        "deactivate": "Deactivate",
        "deactivateAccount": "Deactivate Account",
        "closeAccount": "Close Account",
        "closeAccountConfirm": "Close Account Confirm {{displayName}}",
        "close": "Close",
        "verifyKyc": "Verify KYC",
        "markKycVerified": "Mark KYC Verified",
        "rejectKyc": "Reject KYC",
        "resetKyc": "Reset KYC",
        "resetKycToPending": "Reset KYC To Pending",
        "expireKyc": "Expire KYC",
        "markKycExpired": "Mark KYC Expired",
        "activateAccountDesc": "Activate this client account",
        "deactivateAccountDesc": "Deactivate this client account",
        "closeAccountDesc": "Close this client account",
        "markKycVerifiedDesc": "Mark KYC as verified",
        "rejectKycDesc": "Reject KYC verification",
        "resetKycToPendingDesc": "Reset KYC to pending status",
        "markKycExpiredDesc": "Mark KYC as expired",
        "create": {
          "label": "Create",
          "labelDesc": "Create a new client account"
        },
        "update": {
          "label": "Update",
          "labelDesc": "Update client account details"
        }
      },
      "filters": {
        "searchPlaceholder": "Search by name, email, or code",
        "allStatuses": "All Statuses",
        "allKyc": "All KYC",
        "allStatusesDesc": "Filter by account status",
        "allKycDesc": "Filter by KYC status"
      },
      "ariaLabels": {
        "accountActions": "Account Actions"
      },
      "loading": "Loading client accounts…",
      "error": {
        "notFound": "No client accounts found.",
        "forbidden": "You do not have permission to view client accounts.",
        "failed": "Failed to load client accounts {{error}}"
      },
      "table": {
        "title": "Client Accounts",
        "client": "Client",
        "email": "Email",
        "status": "Status",
        "kyc": "KYC",
        "portfolios": "Portfolios",
        "created": "Created"
      },
      "pagination": {
        "showing": "Showing {{start}} {{end}} {{total}}",
        "previous": "Previous",
        "pageOf": "Page Of {{page}} {{totalPages}}",
        "next": "Next"
      },
      "accountType": {
        "corporate": "Corporate",
        "individual": "Individual",
        "joint": "Joint",
        "individualDesc": "Individual",
        "corporateDesc": "Corporate",
        "jointDesc": "Joint"
      },
      "surface": {
        "description": "Manage client accounts and KYC status"
      }
    },
    "modules": {
      "title": "Modules",
      "description": "Modules description",
      "currentTier": "Current Tier",
      "managedUnder": "Managed Under",
      "organizationModules": "Organization Modules",
      "tab": "Tab",
      "activeModules": "Active Modules",
      "refreshModules": "Refresh Modules",
      "refreshSuccess": "Modules refreshed successfully",
      "currentTierDesc": "Current Tier",
      "activeModulesDesc": "Active Modules",
      "refreshModulesDesc": "Refresh Modules",
      "table": {
        "name": "Name",
        "nameDesc": "Name",
        "enabled": "Enabled",
        "enabledDesc": "Enabled",
        "tierRequired": "Tier Required",
        "tierRequiredDesc": "Tier Required",
        "lastUpdated": "Last Updated",
        "lastUpdatedDesc": "Last Updated",
        "activeUsers": "Active Users",
        "clientAccounts": "Client Accounts"
      },
      "moduleNames": {
        "investment": "Investment",
        "accounting": "Accounting",
        "inventory": "Inventory",
        "rebalancing": "Rebalancing",
        "taxCompliance": "Tax Compliance"
      },
      "tier": {
        "basic": "Basic",
        "professional": "Professional"
      },
      "tableTitle": "Modules"
    },
    "operationalNotes": {
      "title": "Operational Notes",
      "supportContact": "Support Contact",
      "currentOperator": "Current Operator",
      "note": "Note"
    },
    "platformSettings": {
      "title": "Platform Settings",
      "description": "Platform Settings description",
      "noOrganization": "No Organization",
      "loading": "Platform Settings Loading",
      "featureDisabled": "Feature Disabled",
      "sessionTimeout": "Session Timeout",
      "sessionTimeoutDesc": "Session Timeout",
      "maxLoginAttempts": "Max Login Attempts",
      "maxLoginAttemptsDesc": "Max Login Attempts"
    },
    "recentActivity": {
      "table": {
        "time": "Time",
        "user": "User",
        "system": "System",
        "action": "Action",
        "entity": "Entity",
        "comment": "Comment"
      },
      "title": "Recent Activity",
      "description": "Recent Activity description",
      "noActivity": "No Activity"
    },
    "stats": {
      "totalUsers": "Total Users",
      "totalUsersValue": "Total Users Value {{count}}",
      "activeUsers": "Active Users",
      "activeUsersValue": "Active Users Value {{count}}",
      "pendingApprovals": "Pending Approvals",
      "pendingApprovalsValue": "Pending Approvals Value {{count}}",
      "totalRoles": "Total Roles",
      "totalRolesValue": "Total Roles Value {{count}}"
    },
    "diagnostics": {
      "title": "Diagnostics",
      "health": "Health",
      "readiness": "Readiness",
      "initialized": "Initialized",
      "bootstrapPending": "Bootstrap Pending",
      "uptime": "Uptime",
      "minutes": "Minutes",
      "startupBootstrap": "Startup Bootstrap",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "operatorAccounts": "Operator Accounts"
    },
    "approvals": {
      "actions": {
        "create": "Create",
        "update": "Update",
        "delete": "Delete",
        "reapply": "Reapply",
        "approve": "Approve",
        "reject": {
          "label": "Reject",
          "confirmation": "Are you sure you want to reject this workflow?"
        },
        "unknown": "Unknown",
        "approveDesc": "Approve",
        "rejectDesc": "Reject"
      },
      "entityType": {
        "user": "User",
        "role": "Role",
        "transaction": "Transaction",
        "unknown": "Unknown"
      },
      "status": {
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected",
        "unknown": "Unknown"
      },
      "error": {
        "loadApprovals": "Load Approvals",
        "loadStats": "Load Stats",
        "approveFailed": "Approve Failed",
        "rejectFailed": "Reject Failed",
        "forbidden": "Forbidden"
      },
      "success": {
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "rejectWorkflow": "Reject Workflow",
      "rejectReasonMessage": "Reject Reason Message",
      "rejectReasonPlaceholder": "Reject Reason",
      "reject": "Reject",
      "loadingPermissions": "Loading Permissions",
      "loading": "Approvals Loading",
      "title": "Approvals",
      "pendingApprovals": "Pending Approvals",
      "todayPending": "Today Pending",
      "approvedWorkflows": "Approved Workflows",
      "rejectedWorkflows": "Rejected Workflows",
      "activeFilter": "Active Filter",
      "approved": "Approved",
      "rejected": "Rejected",
      "allWorkflows": "All Workflows",
      "workflows": "Workflows",
      "working": "Working",
      "refresh": "Refresh",
      "table": {
        "comment": "Comment",
        "type": "Type",
        "action": "Action",
        "status": "Status",
        "requestedBy": "Requested By",
        "requestedAt": "Requested At",
        "entityLabel": "Entity",
        "actions": "Actions"
      },
      "approve": "Approve",
      "empty": {
        "all": "All",
        "filtered": "Filtered"
      },
      "description": "Review and approve or reject pending workflows"
    },
    "route": {
      "users": {
        "description": "Manage users, status, and role assignments"
      },
      "roles": {
        "description": "Define assignable roles and permission boundaries"
      },
      "approvals": {
        "description": "Review pending investment transaction approvals, exception decisions, and escalation outcomes."
      },
      "organization": {
        "description": "Manage organization settings and configuration"
      },
      "modules": {
        "description": "Manage module subscriptions and tier capabilities"
      },
      "system": {
        "description": "System administration and data operations"
      }
    },
    "accessInspector": {
      "platformRootRestriction": "Platform Root Restriction",
      "restricted": "Restricted",
      "notRestricted": "Not Restricted",
      "clientMode": "Client Mode",
      "moduleEnabled": "Module Enabled",
      "tierSatisfied": "Tier Satisfied",
      "permissionsSatisfied": "Permissions Satisfied",
      "adminRequired": "Admin Required",
      "resourceIdentifierRequired": "Resource Identifier Required",
      "title": "Access Inspector",
      "description": "Inspect effective permissions, scope, module entitlements, and the policy decision behind access.",
      "accessDenied": "Access Denied",
      "accessDeniedDescription": "You do not have permission to access this resource.",
      "inspectAccessDecision": "Inspect Access Decision",
      "resourceType": "Resource Type",
      "selectResourceType": "Select Resource Type",
      "resourceTypes": {
        "route": "Route",
        "action": "Resource Types Action",
        "report": "Report",
        "dashboardCard": "Dashboard Card"
      },
      "resourceIdentifier": "Resource Identifier",
      "httpMethod": "HTTP Method",
      "explaining": "Explaining",
      "explainAccess": "Explain Access",
      "requestFailed": "Request Failed",
      "decisionSummary": "Decision Summary",
      "allowed": "Allowed",
      "decision": "Decision",
      "reason": "Reason",
      "message": "Access Inspector Message",
      "subjectContext": "Subject Context",
      "userId": "User ID",
      "role": "Role",
      "tier": "Tier",
      "organization": "Organization",
      "branch": "Branch",
      "clientAccount": "Client Account",
      "functions": "Functions",
      "requiredAccess": "Required Access",
      "requiredPermissions": "Required Permissions",
      "requiredTier": "Required Tier",
      "requiredModule": "Required Module",
      "individualChecks": "Individual Checks",
      "runExplainAccess": "Run Explain Access",
      "explainSuccess": "Access explanation completed",
      "formTitle": "Access Inspector",
      "routeId": "Route ID",
      "runExplainAccessDesc": "Run Explain Access",
      "userIdDesc": "User ID",
      "routeIdDesc": "Route ID",
      "query": {
        "title": "Access decision inspection",
        "description": "Evaluate one canonical operation, route, or resource against the current authenticated context. Requested scope values are tested only and never change your session.",
        "operationId": "Operation ID",
        "routeId": "Route ID",
        "resourceId": "Resource ID",
        "subjectUserId": "Subject user ID",
        "organizationId": "Requested organization ID",
        "branchId": "Requested branch ID",
        "clientAccountId": "Requested client account ID",
        "portfolioId": "Requested portfolio ID",
        "inspect": "Inspect access",
        "clear": "Clear",
        "result": "Decision explanation",
        "noSelection": "Enter an operation, route, or resource ID to inspect a decision.",
        "error": "The access decision could not be inspected. Review the identifiers and try again."
      }
    },
    "permissionBundles": {
      "loadError": "Load Error",
      "createAccessRequired": "Create Access Required",
      "functionsRequired": "Functions Required",
      "createError": "Create Error",
      "deleteAccessRequired": "Delete Access Required",
      "deleteError": "Delete Error",
      "approveAccessRequired": "Approve Access Required",
      "approveError": "Approve Error",
      "rejectAccessRequired": "Reject Access Required",
      "rejectionReasonRequired": "Rejection Reason Required",
      "rejectError": "Reject Error",
      "addPermissionError": "Add Permission Error",
      "removePermissionError": "Remove Permission Error",
      "assignRoleError": "Assign Role Error",
      "removeRoleError": "Remove Role Error",
      "title": "Permission Bundles",
      "description": "Permission Bundles description",
      "accessDenied": "Access Denied",
      "accessDeniedDescription": "Access Denied description",
      "createBundle": "Create Bundle",
      "createTitle": "Create",
      "moduleDescription": "Module description",
      "modulePlaceholder": "Module",
      "functions": "Functions",
      "functionsDescription": "Functions description",
      "loadingFunctions": "Loading Functions",
      "noFunctionsAvailable": "No Functions Available",
      "creating": "Creating",
      "system": "System",
      "inactive": "Inactive",
      "module": "Module",
      "permissions": "Permissions",
      "roles": "Roles",
      "permissionList": "Permission List",
      "noPermissionsAssigned": "No Permissions Assigned",
      "selectPermission": "Select Permission",
      "noAvailablePermissions": "No Available Permissions",
      "addPermission": "Add Permission",
      "roleList": "Role List",
      "noRolesAssigned": "No Roles Assigned",
      "selectRole": "Select Role",
      "noAvailableRoles": "No Available Roles",
      "assignRole": "Assign Role",
      "approve": {
        "label": "Approve",
        "success": "Approved successfully"
      },
      "reject": {
        "label": "Reject",
        "success": "Rejected successfully"
      },
      "deleteTitle": "Delete Permission Bundle",
      "deleteDescription": "Permanently remove this permission bundle from the system.",
      "deleting": "Deleting",
      "deleteBundle": "Delete Bundle",
      "rejectTitle": "Reject Permission Bundle",
      "rejectDescription": "Decline this permission bundle request and notify the requester.",
      "rejectionReason": "Rejection Reason",
      "rejectionReasonPlaceholder": "Rejection Reason",
      "rejecting": "Rejecting",
      "confirmRejection": "Confirm Rejection",
      "create": {
        "success": "Permission bundle created successfully"
      },
      "formTitle": "Permission Bundle",
      "name": "Name",
      "actions": {
        "create": "Create",
        "createDesc": "Create",
        "edit": "Edit",
        "editDesc": "Edit",
        "delete": "Delete",
        "deleteDesc": "Delete",
        "deleteConfirmation": "Are you sure you want to delete this permission bundle?",
        "approve": "Approve",
        "approveDesc": "Approve",
        "reject": "Reject",
        "rejectDesc": "Reject",
        "rejectConfirmation": "Are you sure you want to reject this permission bundle?",
        "activate": "Activate",
        "activateDesc": "Activate this permission bundle",
        "deactivate": "Deactivate",
        "deactivateDesc": "Deactivate this permission bundle",
        "assignFunctions": "Assign Functions",
        "assignFunctionsDesc": "Assign Functions"
      },
      "emptyState": {
        "message": "No permission bundles found. Create a bundle to get started."
      },
      "metrics": {
        "totalBundles": "Total Bundles",
        "activeBundles": "Active Bundles"
      },
      "createDesc": "Create",
      "edit": {
        "label": "Edit",
        "success": "Edited successfully"
      },
      "editDesc": "Edit",
      "delete": {
        "label": "Delete",
        "success": "Deleted successfully"
      },
      "deleteDesc": "Delete",
      "activate": {
        "label": "Activate",
        "success": "Activated successfully"
      },
      "activateDesc": "Activate this permission bundle",
      "deactivate": {
        "label": "Deactivate",
        "success": "Deactivated successfully"
      },
      "deactivateDesc": "Deactivate this permission bundle",
      "assignFunctions": {
        "label": "Assign Functions",
        "success": "Functions assigned successfully"
      },
      "assignFunctionsDesc": "Assign functions to this permission bundle",
      "nameDesc": "Permission bundle name",
      "descriptionDesc": "Permission bundle description",
      "table": {
        "name": "Name",
        "nameDesc": "Permission bundle name",
        "description": "Permission Bundles description",
        "descriptionDesc": "Permission bundle description",
        "functionCount": "Function Count",
        "functionCountDesc": "Number of assigned functions",
        "roleUsageCount": "Role Usage Count",
        "roleUsageCountDesc": "Number of roles using this bundle",
        "status": "Status",
        "statusDesc": "Current activation status"
      },
      "archive": "Archive",
      "archiveDesc": "Archive this permission bundle",
      "form": {
        "create": "Create Permission Bundle",
        "edit": "Edit Permission Bundle",
        "assignFunctions": "Assign Functions to Permission Bundle",
        "reject": "Reject Permission Bundle",
        "createDescription": "Create a new permission bundle with a name and description.",
        "editDescription": "Edit the permission bundle name and description.",
        "assignFunctionsDescription": "Select functions to assign to this permission bundle.",
        "rejectDescription": "Reject this permission bundle with a reason.",
        "name": "Name",
        "nameRequired": "Name is required",
        "namePlaceholder": "Enter permission bundle name",
        "description": "Form description",
        "descriptionPlaceholder": "Enter a description for this permission bundle",
        "functions": "Functions",
        "functionsRequired": "At least one function is required",
        "functionsHint": "Select the functions this bundle will grant",
        "rejectReason": "Rejection Reason",
        "rejectReasonRequired": "A rejection reason is required",
        "rejectReasonPlaceholder": "Enter reason for rejection"
      }
    },
    "settings": {
      "title": "Settings",
      "description": "Settings description",
      "changeCaution": "Change Caution",
      "highSeverityException": "High Severity Exception",
      "exceptionsPlural": "Exceptions Plural",
      "detected": "Detected",
      "deferChanges": "Defer Changes",
      "systemStatus": "System Status",
      "lastCheck": "Last Check",
      "pendingApprovals": "Pending Approvals",
      "today": "Today",
      "auditEvents": "Audit Events",
      "exceptionLoad": "Exception Load",
      "critical": "Critical",
      "high": "High",
      "runtimeHealthContext": "Runtime Health Context",
      "healthyServices": "Healthy Services",
      "degradedServices": "Degraded Services",
      "downServices": "Down Services",
      "configChangeWarning": "Config Change Warning"
    },
    "labels": {
      "unknown": {
        "role": "Role",
        "tier": "Tier",
        "action": "Unknown Action",
        "entity": "Entity",
        "status": "Unknown Status",
        "decision": "Decision",
        "reason": "Reason",
        "module": "Module"
      },
      "entity": {
        "default": "Default",
        "import_job": "Import job",
        "import_job_row": "Import row",
        "market_price": "Market price",
        "transaction": "Transaction",
        "opening_balance": "Opening balance",
        "corporate_action": "Corporate action",
        "portfolio_holding": "Portfolio holding",
        "report_run": "Report run",
        "report_export": "Report export",
        "report_definition": "Report definition",
        "user": "User",
        "organization": "Organization",
        "instrument": "Instrument"
      },
      "actions": {
        "import": "Import",
        "import_completed": "Import completed",
        "import_failed": "Import failed",
        "post": "Post",
        "apply": "Apply",
        "reconcile": "Reconcile",
        "valuation": "Valuation",
        "report": "Report",
        "export": "Export",
        "certify": "Certify",
        "create_transaction": "Created transaction",
        "update_transaction": "Updated transaction",
        "delete_transaction": "Deleted transaction",
        "create_user": "Created user",
        "update_user": "Updated user",
        "delete_user": "Deleted user",
        "login": "Login",
        "logout": "Logout",
        "approve_self": "Approve (self)"
      },
      "accessMessage": {
        "default": "Default"
      }
    },
    "routeUnavailable": {
      "title": "Page unavailable",
      "description": "This page could not be loaded. Please try again."
    },
    "clientAccountList": {
      "organizationScopeRequired": "Organization scope required",
      "selectOrganization": "Please select an organization to view client accounts."
    },
    "organization": {
      "title": "Organization",
      "orgName": "Organization Name",
      "orgId": "Organization ID",
      "tier": "Tier",
      "settingsFormTitle": "Organization Settings",
      "name": "Name",
      "organizationCode": "Organization Code",
      "legalName": "Legal Name",
      "email": "Email",
      "phone": "Phone",
      "website": "Website",
      "description": "Organization description",
      "orgNameDesc": "Organization Name",
      "orgIdDesc": "Organization ID",
      "tierDesc": "Tier",
      "nameDesc": "Name",
      "address": "Address",
      "addressDesc": "Address",
      "country": "Country",
      "timezone": "Timezone",
      "baseCurrency": "Base Currency",
      "locale": "Locale"
    },
    "test": {
      "columns": {
        "sensitiveData": "Sensitive Data",
        "sensitiveDataDesc": "Sensitive Data"
      }
    },
    "actionResult": {
      "entityCreated": "Entity Created",
      "entityId": "Entity Id",
      "entityType": "Entity Type",
      "entityUpdated": "Entity Updated",
      "changedFields": "Changed Fields",
      "status": "Status",
      "statusError": "Status Error",
      "exportCreated": "Export Created",
      "exportId": "Export Id",
      "recordCount": "Record Count",
      "download": "Download",
      "entityDeleted": "Entity Deleted",
      "refreshCompleted": "Refresh Completed",
      "refreshedAt": "Refreshed At",
      "affectedCount": "Affected Count",
      "generic": "Generic"
    },
    "branchList": {
      "title": "Client Accounts",
      "newBranch": "New Branch",
      "createBranch": "Create Branch",
      "editBranch": "Edit Branch",
      "view": "View",
      "edit": "Edit",
      "operationFailed": "Operation failed",
      "table": {
        "code": "Code",
        "name": "Name",
        "email": "Email",
        "status": "Status",
        "kyc": "KYC",
        "portfolios": "Portfolios",
        "actions": "Actions"
      },
      "form": {
        "code": "Code",
        "codePlaceholder": "BRANCH001",
        "name": "Name",
        "namePlaceholder": "Branch Name",
        "type": "Type",
        "defaultCurrency": "Default Currency",
        "defaultCurrencyPlaceholder": "NPR",
        "timezone": "Timezone",
        "timezonePlaceholder": "Asia/Kathmandu"
      }
    },
    "orgList": {
      "title": "Organizations",
      "newOrganization": "New Organization",
      "createOrganization": "Create Organization",
      "editOrganization": "Edit Organization",
      "view": "View",
      "edit": "Edit",
      "operationFailed": "Operation failed",
      "table": {
        "code": "Code",
        "name": "Name",
        "plan": "Plan",
        "status": "Status",
        "created": "Created",
        "actions": "Actions"
      },
      "form": {
        "code": "Code",
        "codePlaceholder": "ORG001",
        "name": "Name",
        "namePlaceholder": "Organization Name",
        "plan": "Plan",
        "status": "Status"
      }
    },
    "moduleEntitlements": {
      "title": "Module Entitlements",
      "description": "Manage module access for branches",
      "assign": "Assign",
      "assignModule": "Assign Module",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "cancel": "Cancel",
      "operationFailed": "Operation failed",
      "table": {
        "module": "Module",
        "description": "Module Entitlements description",
        "version": "Version",
        "status": "Status",
        "features": "Features",
        "branchAssignments": "Branch Assignments",
        "actions": "Actions"
      },
      "form": {
        "assignTitle": "Assign {{name}}",
        "branchId": "Branch ID",
        "branchIdPlaceholder": "BRANCH001",
        "enabled": "Enabled"
      }
    },
    "auditLog": {
      "title": "Audit Log",
      "export": "Export",
      "refresh": "Refresh",
      "previous": "Previous",
      "next": "Next",
      "pageOf": "Page {{page}} of {{totalPages}}",
      "before": "Before",
      "after": "After",
      "all": "All",
      "searchPlaceholder": "Search (entity ID, user, etc.)",
      "filters": {
        "entityType": "Entity Type",
        "action": "Action",
        "from": "From",
        "to": "To"
      },
      "table": {
        "time": "Time",
        "entity": "Entity",
        "action": "Action",
        "user": "User",
        "ipAddress": "IP Address",
        "details": "Details"
      },
      "entityTypes": {
        "TRANSACTION": "Transaction",
        "ACCOUNT": "Account",
        "PARTY": "Party",
        "CORPORATE_ACTION": "Corporate Action",
        "RECONCILIATION": "Reconciliation",
        "REPORT": "Report",
        "USER": "User",
        "ORGANIZATION": "Organization",
        "BRANCH": "Branch",
        "MODULE": "Module"
      },
      "actions": {
        "CREATE": "Create",
        "UPDATE": "Update",
        "DELETE": "Delete",
        "APPROVE": "Approve",
        "REJECT": "Reject",
        "POST": "Post",
        "REVERSE": "Reverse",
        "LOGIN": "Login",
        "LOGOUT": "Logout",
        "MFA_ENROLL": "MFA Enroll",
        "MFA_VERIFY": "MFA Verify"
      },
      "exportSuccess": "Audit events were exported.",
      "exportError": "Audit events could not be exported. Review the filters and try again."
    },
    "profile": {
      "overview": "Overview",
      "overviewDescription": "Organization identity and status",
      "details": "Details",
      "detailsDescription": "System-managed identifiers and timestamps",
      "fields": {
        "name": "Name",
        "legalName": "Legal name",
        "baseCurrency": "Base currency",
        "jurisdiction": "Jurisdiction",
        "locale": "Locale",
        "timeZone": "Time zone",
        "status": "Status",
        "id": "ID",
        "createdAt": "Created",
        "updatedAt": "Updated",
        "calendarSystem": "Calendar system"
      },
      "saveError": "The organization profile could not be saved. Review the values and try again.",
      "saveSuccess": "Organization profile saved.",
      "validation": {
        "nameRequired": "Organization name is required.",
        "currencyInvalid": "Use a three-letter currency code, such as NPR or USD."
      }
    },
    "userDetail": {
      "title": "User details",
      "section": {
        "identity": "Identity",
        "security": "Security",
        "securityDescription": "Authentication and account security"
      },
      "field": {
        "id": "User ID",
        "email": "Email",
        "firstName": "First name",
        "lastName": "Last name",
        "status": "Status",
        "aal": "Assurance level",
        "mfaEnabled": "MFA enabled",
        "lastLoginAt": "Last login",
        "createdAt": "Created at"
      },
      "confirm": {
        "delete": {
          "title": "Deactivate user"
        }
      }
    },
    "roleDetail": {
      "title": "Role details",
      "section": {
        "definition": "Definition",
        "permissions": "Permissions"
      },
      "field": {
        "code": "Role code",
        "name": "Role name",
        "status": "Status",
        "description": "Description",
        "permissionCount": "Permission count",
        "permissionSummary": "Permission summary"
      },
      "confirm": {
        "delete": {
          "title": "Deactivate role"
        }
      }
    },
    "platformAccessInspector": {
      "title": "Platform Access Inspector",
      "identity": "Identity",
      "delegation": "Delegation",
      "permissions": "Permissions",
      "modules": "Modules",
      "policy": "Policy"
    },
    "platformHealth": {
      "title": "Platform Health",
      "description": "Platform health status",
      "overview": "Overview",
      "overallStatus": "Overall status",
      "errorsDetected": "Errors detected",
      "details": "Details",
      "noDetails": "No details available"
    },
    "platformModules": {
      "title": "Platform Modules",
      "description": "Manage platform module licenses",
      "licenses": "Licenses",
      "noLicenses": "No licenses configured",
      "organization": "Organization",
      "maxBranches": "Max branches",
      "maxUsers": "Max users",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to"
    },
    "maintenanceDelegations": {
      "title": "Maintenance delegations",
      "description": "Every grant requires AAL2, a support ticket, explicit capabilities, exact operations, and a target organization scope.",
      "createTitle": "Create maintenance delegation",
      "createDescription": "Select the support user, exact target scope, purpose, capabilities, and operations. Grants are limited to 24 hours.",
      "viewTitle": "Maintenance delegation details",
      "viewDescription": "Review the approved scope, capabilities, operations, policy, and active session state.",
      "revokeTitle": "Revoke maintenance delegation",
      "revokeDescription": "Revocation immediately terminates any active delegated session.",
      "columns": {
        "supportUserIdentityId": "Support user",
        "targetOrganizationId": "Organization",
        "purpose": "Purpose",
        "ticketReference": "Ticket",
        "status": "Status",
        "effectiveFrom": "Effective from",
        "expiresAt": "Expires at",
        "sessionStartedAt": "Session started",
        "sessionEndedAt": "Session ended",
        "policyVersion": "Policy version"
      },
      "fields": {
        "supportUserIdentityId": "Platform support user",
        "targetOrganizationId": "Target organization",
        "targetBranchId": "Target branch",
        "targetClientAccountId": "Target client account",
        "targetPortfolioAccountId": "Target portfolio account",
        "purpose": "Maintenance purpose",
        "justification": "Business justification",
        "ticketReference": "Support ticket",
        "capabilities": "Delegated capabilities",
        "allowedOperationIds": "Allowed operations",
        "resourceIds": "Restricted resources",
        "effectiveFrom": "Effective from",
        "expiresAt": "Expires at",
        "reason": "Revocation reason",
        "requiredAal": "Required assurance level",
        "policyVersion": "Policy version",
        "status": "Status",
        "sessionStartedAt": "Session started",
        "sessionEndedAt": "Session ended"
      },
      "help": {
        "supportUserIdentityId": "Choose an active platform support identity that is different from the approver.",
        "targetOrganizationId": "The organization whose data and configuration may be maintained.",
        "targetBranchId": "Optionally limit access to one branch in the target organization.",
        "targetClientAccountId": "Optionally limit access to one client account.",
        "targetPortfolioAccountId": "Portfolio scope requires a matching client account.",
        "purpose": "Select the approved operational reason for maintenance access.",
        "justification": "Describe why delegated access is necessary and what will be changed or inspected.",
        "ticketReference": "Enter the incident, support, or change ticket that authorizes this work.",
        "capabilities": "Capabilities establish the maximum category of work allowed.",
        "allowedOperationIds": "Only these canonical operations may be executed in the delegated session.",
        "resourceIds": "Optionally restrict the grant to specific canonical resources.",
        "effectiveFrom": "The grant cannot be used before this time.",
        "expiresAt": "The grant must expire within 24 hours of its effective time.",
        "reason": "Explain why the grant is being revoked."
      },
      "actions": {
        "create": "Create delegation",
        "revoke": "Revoke",
        "confirmRevoke": "Confirm revocation"
      },
      "purpose": {
        "FAILED_IMPORT_INVESTIGATION": "Failed import investigation",
        "DATA_MIGRATION": "Data migration",
        "CONFIGURATION_CORRECTION": "Configuration correction",
        "CALCULATION_DEFECT_INVESTIGATION": "Calculation defect investigation",
        "MARKET_DATA_MAPPING_REPAIR": "Market-data mapping repair",
        "RECONCILIATION_SUPPORT": "Reconciliation support",
        "ORGANIZATION_ADMINISTRATION_ASSISTANCE": "Organization administration assistance",
        "PRODUCTION_REMEDIATION_VALIDATION": "Production remediation validation",
        "AUDIT_SUPPORT": "Audit support",
        "ACCESS_TROUBLESHOOTING": "Access troubleshooting"
      },
      "capability": {
        "ORG_CONFIG_VIEW": "View organization configuration",
        "ORG_CONFIG_MANAGE": "Manage organization configuration",
        "ORG_IDENTITY_VIEW": "View organization identities",
        "ORG_IDENTITY_MANAGE": "Manage organization identities",
        "ORG_AUDIT_VIEW": "View organization audit",
        "ORG_DATA_VIEW": "View organization data",
        "ORG_DATA_CORRECT": "Correct organization data",
        "ORG_IMPORT_RETRY": "Retry organization imports",
        "ORG_RECONCILIATION_VIEW": "View reconciliation",
        "ORG_RECONCILIATION_MANAGE": "Manage reconciliation",
        "ORG_REPORT_VIEW": "View reports",
        "ORG_REPORT_RUN": "Run reports",
        "ORG_FINANCIAL_EXPORT": "Export financial data",
        "ORG_ACCESS_INSPECT": "Inspect access decisions"
      }
    },
    "marketCalendar": {
      "cardTitle": "Market calendar",
      "cardDescription": "Set regular exchange closures and holiday/open-date exceptions used by valuation and market-data freshness checks.",
      "title": "Market calendar",
      "subtitle": "Configure the trading schedule used to determine current and stale market prices for the single exchange in this release.",
      "currentStatus": "Current setup",
      "statusConfigured": "Configured",
      "statusNeedsSetup": "Setup required",
      "version": "Calendar version {{version}}",
      "noVersion": "No governed calendar version yet",
      "exchangeNotDetected": "Exchange not detected",
      "scheduleTitle": "Regular trading schedule",
      "exchange": "Exchange",
      "exchangeDetectedHelp": "Detected automatically from active instruments.",
      "exchangeManualHelp": "Enter the exchange code when configuring the calendar before instruments are loaded.",
      "timeZone": "Market time zone",
      "timeZoneHelp": "Use an IANA time zone such as Asia/Kathmandu.",
      "closedWeekdays": "Regular closed days",
      "closedWeekdaysHelp": "Select the weekdays when the exchange is normally closed.",
      "closedWeekdaysRequired": "Select at least one regular closed day.",
      "exceptionsTitle": "Exceptional sessions",
      "closedDates": "Holiday / closed dates",
      "closedDatesHelp": "Enter YYYY-MM-DD dates, one per line or comma-separated.",
      "openDates": "Exceptional open dates",
      "openDatesHelp": "Enter dates when the exchange is open despite its regular schedule.",
      "stopgapNotice": "This is the V1 single-exchange setup. Saving creates a governed, versioned calendar used by valuation, reporting, and pre-trade market-data freshness checks.",
      "readOnlyNotice": "You can review the governed calendar, but changing it requires market-data management permission.",
      "saving": "Saving…",
      "saveSuccess": "Market calendar saved.",
      "saveError": "Could not save the market calendar.",
      "loadError": "Could not load the market calendar.",
      "closedDatesPlaceholder": "YYYY-MM-DD",
      "openDatesPlaceholder": "YYYY-MM-DD",
      "weekdays": {
        "short": {
          "0": "Sun",
          "1": "Mon",
          "2": "Tue",
          "3": "Wed",
          "4": "Thu",
          "5": "Fri",
          "6": "Sat"
        }
      }
    }
  },
  "accounting": {
    "code": "Code",
    "name": "Name",
    "type": "Type",
    "group": "Group",
    "balance": "Balance",
    "status": "Status",
    "noGroup": "No Group",
    "bankReconciliation": {
      "title": "Bank Reconciliation",
      "refreshAccounts": "Refresh Accounts",
      "startReconciliation": "Start Reconciliation",
      "newReconciliation": "New Reconciliation",
      "bankAccount": "Bank Account",
      "select": "Select",
      "statementDate": "Statement Date",
      "statementBalance": "Statement Balance",
      "bookBalance": "Book Balance",
      "difference": "Difference",
      "date": "Date",
      "description": "Bank Reconciliation description",
      "amount": "Amount",
      "matched": "Matched",
      "matching": "Matching",
      "autoMatch": "Auto Match",
      "completing": "Completing",
      "completeReconciliation": "Complete Reconciliation",
      "noBankAccounts": "No Bank Accounts",
      "starting": "Starting",
      "start": "Start",
      "cancel": "Cancel",
      "saving": "Saving",
      "add": "Add"
    },
    "chartOfAccounts": {
      "title": "Chart of Accounts",
      "loading": "Loading accounts...",
      "failedToLoadAccounts": "Failed to load accounts",
      "failedToLoadGroups": "Failed to load groups",
      "failedToCreateAccount": "Failed to create account",
      "failedToCreateInvestmentAccounts": "Failed to create investment accounts",
      "autoCreateInvestmentAccounts": "Auto Create Investment Accounts",
      "newAccount": "New Account"
    },
    "journalList": {
      "title": "Journal Entries",
      "loadingJournals": "Loading journals...",
      "failedToLoad": "Failed to load journals",
      "failedToLoadDetails": "Failed to load journal details",
      "failedToPost": "Failed to post journal entry",
      "journalEntry": "Journal Entry",
      "journalEntryPosted": "Journal Entry Posted",
      "journalEntryPostedMessage": "The journal entry has been posted successfully",
      "postFailed": "Post Failed",
      "posting": "Posting",
      "postJournalEntry": "Post Journal Entry",
      "refresh": "Refresh",
      "date": "Date",
      "ref": "Ref",
      "account": "Account",
      "debit": "Debit",
      "credit": "Credit",
      "description": "Journal List description",
      "entryNumber": "Entry Number",
      "reference": "Reference",
      "status": "Status",
      "draft": "Draft",
      "posted": "Posted",
      "reversed": "Reversed",
      "post": "Post",
      "noJournalEntries": "No Journal Entries"
    }
  },
  "ui": {
    "pageContractNotFound": "Page contract not found",
    "pageNotAccessible": "Page not accessible",
    "accessibleButton": {
      "loading": "Loading"
    },
    "dashboardClientSelector": {
      "selectClientAccount": "Select Client Account",
      "allClientAccounts": "All Client Accounts"
    },
    "monthlyPnl": {
      "realizedOnly": "Realized Only",
      "realizedAmount": "Realized Amount",
      "ariaLabel": "Monthly Profit and Loss",
      "title": "Monthly P&L",
      "dataWillAppearAfterRealized": "Monthly P&L data will appear after you have realized gains/losses from closed positions.",
      "dataSourceRecovering": "Data Source Recovering",
      "viewReportAriaLabel": "View Report Aria",
      "chartAriaLabel": "Chart Aria",
      "subtitle": "Subtitle",
      "netRealized": "Net Realized",
      "barChartAriaLabel": "Bar Chart Aria"
    },
    "nfrsPortfolio": {
      "portfolioValueMtm": "Portfolio Value (MTM)",
      "unrealizedGainPnL": "Unrealized Gain/Loss",
      "totalInvestment": "Total Investment",
      "realizedGainPnL": "Realized Gain/Loss",
      "loadingAria": "Loading NFRS portfolio",
      "unavailableAria": "NFRS portfolio unavailable",
      "reportNotAvailableTitle": "NFRS report not available"
    },
    "recentActivity": {
      "ariaLabel": "Recent Activity",
      "title": "Recent Activity",
      "viewAllAuditActivityAria": "View all audit activity",
      "viewAll": "View All",
      "noRecentActivityYet": "No recent activity yet",
      "eventsWillAppearHere": "Recent governance and workflow events will appear here"
    },
    "transactionExport": {
      "permissionRequired": "You do not have permission to export transactions",
      "exportFilteredTransactions": "Export Filtered Transactions"
    },
    "transactionTable": {
      "requestReversal": "Request Reversal"
    },
    "portfolioOwnershipSettings": {
      "title": "Portfolio Ownership Settings",
      "description": "Configure portfolio ownership between organization and client accounts",
      "organizationPortfolios": "Organization Portfolios",
      "organizationPortfoliosDescription": "Portfolios owned directly by the organization",
      "clientPortfolios": "Client Portfolios",
      "clientPortfoliosDescription": "Portfolios owned by client accounts"
    },
    "portfolioView": {
      "loadingHoldingsTitle": "Loading Holdings",
      "loadingHoldingsDescription": "Please wait while we load your portfolio holdings",
      "pricingSource": {
        "quoted": "Quoted",
        "mixed": "Mixed",
        "costBasis": "Cost Basis"
      },
      "costBasisLabel": "Cost Basis",
      "totalUnitsLabel": "Total Units {{units}}",
      "currentMarketValueLabel": "Current Market Value",
      "pricesAsOf": "Prices as of",
      "officialSnapshotValueLine": "Official snapshot value",
      "dashboardPortfolioValueMatches": "Dashboard portfolio value matches",
      "unrealizedPnL": "Unrealized P&L",
      "unrealizedLossLabel": "Unrealized Loss",
      "unrealizedFromCanonicalCurrentMarketValuation": "Unrealized from canonical current market valuation",
      "xirrLabel": "XIRR",
      "annualizedReturn": "Annualized Return",
      "allHoldings": "All Holdings",
      "positionsInPortfolio": "positions in portfolio {{count}} {{plural}}",
      "viewCostBasis": "View Cost Basis",
      "recalculatePortfolio": "Recalculate Portfolio",
      "costBasisDataTitle": "Cost Basis Data",
      "costBasisDataDescription": "Detailed cost basis information for your holdings",
      "failedToLoadCostBasisData": "Failed to load cost basis data",
      "recalculationScopeUnsupported": "Recalculation scope unsupported",
      "valueUnavailable": "Value unavailable",
      "valuationDiagnosticsDelta": "Valuation diagnostics delta",
      "visibleRowTotal": "Visible row total",
      "canonicalCurrentMarketValue": "Canonical current market value",
      "deltaValue": "Delta value",
      "scopeClientAccount": "Scope Client Account {{clientAccountId}}",
      "scopePortfolio": "Scope Portfolio {{portfolioId}}",
      "scopeAsOfDate": "Scope As Of Date {{asOfDate}}",
      "recalculationFailed": "Recalculation Failed",
      "recalculationUnexpectedError": "Recalculation Unexpected Error",
      "costBasisLoadFailed": "Cost Basis Load Failed",
      "unableToLoadHoldings": "Unable To Load Holdings",
      "currentMarketValueUnavailable": "Current Market Value Unavailable",
      "dashboardPortfolioValueDelta": "Dashboard Portfolio Value Delta {{dashboardValue}} {{delta}}",
      "unrealizedGainLabel": "Unrealized Gain",
      "zeroUntilQuotesConfigured": "Zero Until Quotes Configured",
      "noCostBasisAccess": "No Cost Basis Access",
      "viewCostBasisAriaDisabled": "View Cost Basis Aria Disabled",
      "noRecalculationAccess": "No Recalculation Access",
      "recalculatePortfolioAriaDisabled": "Recalculate Portfolio Aria Disabled",
      "recalculating": "Recalculating",
      "loadingCostBasisTitle": "Loading Cost Basis",
      "loadingCostBasisDescription": "Loading Cost Basis description",
      "unableToLoadCostBasisData": "Unable To Load Cost Basis Data",
      "costBasisHoldings": "Cost Basis Holdings",
      "costBasisOnlyDescription": "Cost Basis Only description {{count}} {{plural}}",
      "noCostBasisRows": "No Cost Basis Rows",
      "noCostBasisRowsDescription": "No Cost Basis Rows description"
    },
    "backend": {
      "factOrchestrator": {
        "importFactTransactionNotFound": "Import fact transaction not found",
        "missingClientOrInstrumentScope": "Missing client or instrument scope",
        "saleNoDisposalEvidence": "Sale has no disposal evidence"
      }
    },
    "setupWizard": {
      "selectExcelFile": "Select Excel File",
      "errorLabel": "Error",
      "startWithoutImport": "Start Without Import"
    },
    "dataMatrixTable": {
      "noDataToDisplay": "No Data To Display"
    },
    "companySettings": {
      "moduleAccess": "Module Access"
    },
    "profitLossLineChart": {
      "realizedLabelSuffix": "Realized Label Suffix",
      "unrealizedLabelSuffix": "Unrealized Label Suffix"
    },
    "settingsFormShell": {
      "unsupportedFieldType": "Unsupported Field Type"
    },
    "approvalWorkQueue": {
      "title": "Approval Work Queue",
      "pendingDescriptionPrefix": "Pending Description Prefix",
      "pendingSuffix": "Pending Suffix",
      "unableToLoadApprovals": "Unable To Load Approvals",
      "noPendingTransactions": "No Pending Transactions",
      "transactionIdLabel": "Transaction Id",
      "statusLabel": "Status",
      "rejectionReasonLabel": "Rejection Reason"
    },
    "transactionGrid": {
      "title": "Transaction Grid",
      "description": "Transaction Grid description",
      "clientAccountRequired": "Client Account Required",
      "selectClientAccount": "Select Client Account",
      "columns": {
        "billNo": "Bill No",
        "pricePerUnit": "Price Per Unit",
        "totalAmount": "Total Amount"
      },
      "selectCompany": "Select Company",
      "billNumberPlaceholder": "Bill Number",
      "autoCalculated": "Auto Calculated",
      "addRow": "Add Row",
      "quickEntryTipsTitle": "Quick Entry Tips",
      "quickTips": {
        "useTab": "Use Tab",
        "useArrows": "Use Arrows",
        "autoTotal": "Auto Total",
        "validateOnSave": "Validate On Save",
        "emptyRowsIgnored": "Rows Ignored"
      }
    },
    "transactionListController": {
      "retryTransactions": "Retry Transactions"
    },
    "errorState": {
      "requestIdLabel": "Request ID"
    },
    "dashboardHeader": {
      "pricesSynced": "Prices Synced",
      "instruments": "Instruments",
      "failedImports": "Failed Imports"
    },
    "dataQualityBadge": {
      "dataQualityIssues": "Data Quality Issues"
    },
    "pageShell": {
      "errorTitle": "Error",
      "nothingToShowYet": "Nothing To Show Yet"
    },
    "pageRouteRenderer": {
      "errorLoadingPage": "Error Loading Page"
    },
    "holdingsReportRuntime": {
      "title": "Holdings Report Runtime",
      "description": "Holdings Report Runtime description"
    },
    "taxPage": {
      "title": "Tax Page",
      "description": "Tax Page description",
      "attentionRequired": "Attention Required",
      "attentionDescription": "Attention description",
      "filingStatus": "Filing Status",
      "attentionNeeded": "Attention Needed",
      "ready": "Ready",
      "checkTaxCalendarForDeadlines": "Check Tax Calendar For Deadlines",
      "upcomingDeadline": "Upcoming Deadline",
      "notAvailable": "Not Available",
      "checkTaxCalendar": "Check Tax Calendar",
      "estimatedTax": "Estimated Tax",
      "unrealizedLabel": "Unrealized",
      "complianceBreakdown": "Compliance Breakdown",
      "concentrationBreaches": "Concentration Breaches",
      "criticalExceptions": "Critical Exceptions",
      "highExceptions": "High Exceptions",
      "recentTaxActivity": "Recent Tax Activity",
      "noRecentTaxAuditEvents": "No Recent Tax Audit Events"
    },
    "settingsHub": {
      "tierLabel": "Tier",
      "configureLink": "Configure Link",
      "description": "Settings Hub description",
      "governanceAlert": "Governance Alert",
      "detectedSuffix": "Detected Suffix",
      "validateModuleChanges": "Validate Module Changes",
      "modulesAndOfferings": "Modules And Offerings",
      "dangerZone": "Danger Zone",
      "permanentDeleteWarning": "Permanent Delete Warning"
    }
  },
  "cgt": {
    "title": "Capital Gains Tax",
    "description": "View capital gains tax calculations and liability reports."
  },
  "portfolio": {
    "positive": "Positive",
    "negative": "Negative",
    "holdingsTable": {
      "missingFacts": "Missing facts",
      "dataIssue": "Data issue",
      "missingPrices": "Missing prices",
      "stalePrices": "Stale prices",
      "instrument": "Instrument",
      "groupingRequiresContext": "Grouping Requires Context",
      "transactions": "Transactions",
      "qty": "Qty",
      "price": "Price",
      "value": "Value",
      "pl": "Pl",
      "return": "Return",
      "avgCost": "Avg Cost",
      "actions": "Actions",
      "none": "None",
      "sector": "Sector",
      "instrumentType": "Instrument Type",
      "unassigned": "Unassigned",
      "portfolioHoldings": "Portfolio Holdings",
      "detailedHoldings": "Detailed Holdings",
      "groupedHoldingsRequireContext": "Grouped Holdings Require Context"
    },
    "excellent": "Excellent",
    "ge15PercentReturn": "≥15% Return",
    "good": "Good",
    "tenTo15PercentReturn": "10–15% Return",
    "fiveTo10PercentReturn": "5–10% Return",
    "fair": "Fair",
    "zeroTo5PercentReturn": "0–5% Return",
    "lt0PercentReturn": "<0% Return",
    "performanceRating": "Performance Rating",
    "noOrganization": "No organization",
    "failedToLoadClientAccounts": "Failed to load client accounts",
    "clientAccountLabel": "Client Account",
    "noActiveClientAccounts": "No active client accounts",
    "couldNotLoadClientAccounts": "Could not load client accounts",
    "selectClientAccount": "Select client account",
    "portfolioOwnershipLabel": "Portfolio Ownership",
    "portfolioOwnershipDesc": "Portfolio ownership description",
    "organizationPortfolio": "Organization Portfolio",
    "organizationPortfolioDesc": "Organization portfolio description",
    "clientPortfolio": "Client Portfolio",
    "clientPortfolioDesc": "Client portfolio description",
    "benchmarks": "Benchmarks",
    "goodBenchmark": "Good benchmark",
    "fairBenchmark": "Fair benchmark",
    "poorBenchmark": "Poor benchmark",
    "portfolioHoldings": "Portfolio Holdings",
    "detailedViewSortingFiltering": "Detailed view with sorting and filtering",
    "allHoldings": "All Holdings",
    "positiveReturns": "Positive Returns",
    "negativeReturns": "Negative Returns",
    "symbol": "Symbol",
    "avgCost": "Avg. Cost",
    "price": "Price",
    "value": "Value",
    "returnPct": "Return %",
    "portfolioPct": "Portfolio %",
    "transactions": "Transactions",
    "shares": "Shares",
    "viewTransactions": "View Transactions",
    "noHoldingsMatchFilter": "No holdings match the selected filter",
    "actionableInsights": {
      "excellentPerformance": "Excellent Performance",
      "portfolioPerformingWell": "Portfolio Performing Well",
      "totalReturn": "Total Return",
      "highConcentrationRisk": "High Concentration Risk",
      "topHoldingRepresents": "Top Holding Represents {{symbol}} {{percent}}",
      "representsPercent": "Represents Percent",
      "ofPortfolio": "Of Portfolio",
      "topHoldingPercent": "Top Holding Percent",
      "viewHoldings": "View Holdings",
      "lowDiversification": "Low Diversification",
      "portfolioHighlyConcentrated": "Portfolio Highly Concentrated",
      "diversificationScore": "Diversification Score",
      "exploreDiversification": "Explore Diversification",
      "xirrBelowTarget": "Xirr Below Target",
      "xirrBelowTargetDesc": "Xirr Below Target",
      "highVolatility": "High Volatility",
      "portfolioVolatilityHigh": "Portfolio Volatility High",
      "volatility": "Volatility",
      "lowRiskAdjustedReturns": "Low Risk Adjusted Returns",
      "sharpeRatioLow": "Sharpe Ratio Low",
      "sharpeRatio": "Sharpe Ratio",
      "significantDrawdown": "Significant Drawdown",
      "portfolioExperiencedDrawdown": "Portfolio Experienced Drawdown",
      "maxDrawdown": "Max Drawdown",
      "positivePerformance": "Positive Performance",
      "portfolioPositiveReturns": "Portfolio Positive Returns",
      "negativeReturns": "Negative Returns",
      "portfolioShowingLosses": "Portfolio Showing Losses",
      "moderateConcentration": "Moderate Concentration",
      "topHoldingRepresentsMonitor": "Top Holding Represents Monitor {{symbol}} {{percent}}",
      "wellDiversified": "Well Diversified",
      "portfolioGoodDiversification": "Portfolio Good Diversification",
      "portfolioOverview": "Portfolio Overview",
      "portfolioNormalParameters": "Portfolio Normal Parameters",
      "actionableInsights": "Actionable Insights",
      "personalizedRecommendations": "Personalized Recommendations",
      "target": "Target"
    },
    "companyStatement": {
      "failedLoadTransactions": "Failed Load Transactions",
      "lastAvailableQuote": "Last Available Quote",
      "loadingStatement": "Loading Statement",
      "noStatementRows": "No Statement Rows",
      "portfolioStatementFY": "Portfolio Statement F Y",
      "marketInformation": "Market Information",
      "currentMarketQuote": "Current Market Quote",
      "currentValuationBasis": "Current Valuation Basis",
      "currentPrice": "Current Price",
      "basis": "Basis",
      "quoted": "Quoted",
      "costBasis": "Cost Basis",
      "lastUpdated": "Last Updated",
      "coverage": "Coverage",
      "currentHoldings": "Current Holdings",
      "units": "Units",
      "totalInvestment": "Total Investment",
      "avgCost": "Avg Cost",
      "perUnit": "Per Unit",
      "currentValue": "Current Value",
      "currentPriceLabel": "Current Price",
      "totalPL": "Total P&L",
      "realized": "Realized",
      "unrealized": "Unrealized",
      "xirr": "XIRR",
      "avgHoldingPeriod": "Avg Holding Period",
      "days": "Days",
      "returnOnInvestment": "Return On Investment",
      "transactionHistory": "Transaction History",
      "transactionHistoryDesc": "Transaction History",
      "date": "Date",
      "type": "Type",
      "billNo": "Bill No",
      "quantity": "Quantity",
      "pricePerUnit": "Price Per Unit",
      "totalAmount": "Total Amount",
      "commission": "Commission",
      "tax": "Tax",
      "netAmount": "Net Amount"
    },
    "charts": {
      "sectorDistributionDescription": "Sector distribution across portfolio",
      "noSectorDataAvailable": "No Sector Data Available",
      "topHoldingsDescription": "Top holdings by value",
      "noHoldingsDataAvailable": "No Holdings Data Available",
      "transactionActivityDescription": "Transaction activity over time",
      "concentrationMonitor": "Concentration Monitor",
      "concentrationDescription": "Position concentration analysis",
      "severity": {
        "critical": "Critical",
        "high": "High"
      }
    }
  },
  "data-quality": {
    "title": "Data Quality",
    "description": "View data quality metrics and validation status for your portfolio data."
  },
  "holdings": {
    "title": "Portfolio Holdings",
    "description": "View your current portfolio holdings and allocation."
  },
  "profit-loss": {
    "title": "Profit & Loss",
    "description": "View profit and loss analysis for your portfolio."
  },
  "realized-pnl": {
    "title": "Realized Profit & Loss",
    "description": "View realized gains and losses from closed positions."
  },
  "nfrs-dashboard": {
    "title": "NFRS Dashboard",
    "description": "View portfolio as per Nepal Financial Reporting Standard."
  },
  "organizations": {
    "organizationSettings": {
      "loadingSettings": "Loading settings",
      "failedToLoad": "Failed to load settings",
      "orgInfo": "Organization Info",
      "modules": "Modules",
      "orgInformation": "Organization Information",
      "name": "Name",
      "code": "Code",
      "codeReadOnly": "Code (Read Only)",
      "panNumber": "PAN Number",
      "vatNumber": "VAT Number",
      "email": "Email",
      "phone": "Phone",
      "address": "Address",
      "fiscalYearStart": "Fiscal Year Start",
      "notProvided": "Not provided",
      "notConfigured": "Not configured",
      "saving": "Saving...",
      "saveChanges": "Save Changes",
      "failedToLoadOrg": "Failed to load organization",
      "failedToLoadModules": "Failed to load modules",
      "failedToSave": "Failed to save settings",
      "networkError": "Network error",
      "noOrgLinked": "No organization linked",
      "pan": "PAN",
      "moduleAccess": "Module Access",
      "investment": "Investment",
      "accounting": "Accounting",
      "inventory": "Inventory"
    }
  },
  "reports": {
    "description": "Find trusted portfolio, performance, tax, accounting, and NFRS reports.",
    "planned": "Reports are planned and not yet available.",
    "exportCsv": "Export CSV",
    "exportFailed": "Report export failed.",
    "holdings": "Holdings",
    "cash": "Cash positions",
    "activity": "Activity",
    "marketValue": "Market value",
    "unrealizedGainLoss": "Unrealized gain/loss",
    "currentBalance": "Current balance",
    "activityCount": "{{count}} transactions in period",
    "showingCount": "Showing {{count}} of {{total}} holdings",
    "dataQualityIssues": "Data quality issues",
    "missingValuations": "missing valuations",
    "reconciliation": {
      "status": "Reconciliation status"
    },
    "clientStatement": {
      "cutoff": "Cutoff date",
      "performance": "Performance summary",
      "openingValue": "Opening value",
      "closingValue": "Closing value",
      "netGainLoss": "Net gain/loss",
      "twr": "Time-weighted return",
      "feesAndTax": "Fees and tax",
      "totalFees": "Total fees",
      "capitalGainTax": "Capital gains tax",
      "parametersTitle": "Find a statement",
      "parametersDescription": "Optionally choose an exact statement period. Leave the dates blank to open your latest completed statement."
    },
    "types": {
      "sebonMonthly": "SEBON monthly",
      "irdCgt": "IRD capital gains",
      "nrbQuarterly": "NRB quarterly",
      "fiuAmlCtf": "FIU AML/CTF",
      "portfolioCustodyEvidence": "CDSC custody identity evidence",
      "clientPortfolioCustodyEvidence": "My CDSC custody identity evidence",
      "clientStatement": "Portfolio statement",
      "organizationClientStatement": "Client statements",
      "portfolioHoldings": "Portfolio holdings",
      "clientHoldings": "My holdings",
      "accountingTrialBalance": "Trial balance",
      "reconciliationBreaks": "Reconciliation breaks",
      "transactionActivity": "Transaction activity and gain/loss",
      "accountingFinancialStatements": "Financial statements",
      "accountingProfitAndLoss": "Profit and loss",
      "portfolioPerformanceNepal": "Portfolio performance and Nepal evidence",
      "clientPortfolioPerformanceNepal": "My portfolio performance and Nepal evidence",
      "realizedGainLoss": "Realized gain/loss",
      "unrealizedGainLoss": "Unrealized gain/loss",
      "analyticalCgt": "Capital gains tax analysis",
      "cashPosition": "Cash Position",
      "cashMovement": "Cash Movement",
      "investmentIncome": "Investment Income",
      "feesExpenses": "Fees & Expenses",
      "taxLots": "Tax Lots & Cost Basis",
      "corporateActions": "Corporate Actions",
      "generalLedger": "General Ledger",
      "valuationQuality": "Valuation Quality",
      "allocationExposure": "Allocation & Exposure",
      "managementSummary": "Portfolio Management Summary"
    },
    "descriptions": {
      "sebonMonthly": "Monthly posted-trade report for SEBON.",
      "irdCgt": "Capital gains schedule for IRD.",
      "nrbQuarterly": "Quarterly large-transaction and risk report for NRB.",
      "fiuAmlCtf": "AML/CTF transaction and suspicious-activity report for FIU.",
      "portfolioCustodyEvidence": "BOID, DP code, internal position coverage, and verified CDSC or demat document evidence. External balances are not treated as reconciled until structured positions are ingested.",
      "clientPortfolioCustodyEvidence": "Your BOID, DP code, internal position coverage, and verified CDSC or demat document evidence without exposing private document locations.",
      "clientStatement": "Your latest completed portfolio statement with investments, cash, performance, fees, taxes, and data-quality context.",
      "organizationClientStatement": "Review completed governed statements for an authorized client or portfolio without entering the statement-generation lifecycle.",
      "portfolioHoldings": "Latest governed position and valuation snapshot by client, portfolio, instrument, and currency.",
      "clientHoldings": "A client-scoped latest position and valuation snapshot containing only records assigned to the signed-in client.",
      "accountingTrialBalance": "Opening balances, posted movements, closing debits and credits, fiscal-period state, and exact equality checks.",
      "reconciliationBreaks": "Gross and net reconciliation exposure by currency with severity, aging, adjustment, and statement evidence.",
      "transactionActivity": "Scoped transaction activity with posting treatment, realized gain or loss, and the latest matching unrealized valuation evidence.",
      "accountingFinancialStatements": "Balance sheet, profit and loss, and direct cash-flow statement from posted ledger entries with explicit cash-flow classification.",
      "accountingProfitAndLoss": "Posted-ledger profit and loss for the selected accounting period. This is the accounting statement basis; portfolio market performance, realized/unrealized investment returns, and TWR are presented in the portfolio performance reports.",
      "portfolioPerformanceNepal": "Portfolio valuation, gains, capital-gain tax, tax-rule provenance, and NFRS evidence using the governed portfolio calculation authority.",
      "clientPortfolioPerformanceNepal": "Your scoped portfolio valuation, gains, capital-gain tax, tax-rule provenance, and NFRS evidence.",
      "realizedGainLoss": "Review disposal proceeds, cost basis, deductible charges, realized gain or loss, and linked capital gains tax for the selected period.",
      "unrealizedGainLoss": "Review the latest governed valuation for each position at or before the selected date, including cost, market value, and unrealized gain or loss.",
      "analyticalCgt": "Review governed capital gains tax facts by disposal, including taxable gain, applied rate, holding period, and tax-rule evidence.",
      "cashPosition": "Review current cash balances by portfolio and currency. This is a current-state view, not a historical cash reconstruction.",
      "cashMovement": "Review posted cash deposits, withdrawals, and transfers for the selected period, with reversed movements excluded from financial totals.",
      "investmentIncome": "Review recognized investment income from posted corporate-action cash receipts and posted coupon or interest lifecycle events.",
      "feesExpenses": "Review issued management and performance fee amounts, taxes, and gross charges for the selected period.",
      "taxLots": "Review current tax-lot quantities and acquisition cost evidence. Remaining quantities are current state rather than a historical as-of reconstruction.",
      "corporateActions": "Review corporate-action events together with entitlement, quantity, and posted cash-impact evidence.",
      "generalLedger": "Review posted journal lines by account and period from the authoritative accounting ledger.",
      "valuationQuality": "Review latest valuation coverage and identify positions whose governed valuation fact is missing price or market value.",
      "allocationExposure": "Review portfolio allocation by governed currency, instrument, instrument type, or sector using latest valuation facts. Weights are calculated only within one currency and are omitted when cross-currency comparison would be misleading.",
      "managementSummary": "Review portfolio and client valuation summaries by currency with valuation-completeness indicators."
    },
    "custodyParameters": {
      "title": "Custody evidence parameters",
      "description": "Select an authorized client or portfolio. The result distinguishes identity and document evidence from external balance reconciliation."
    },
    "custodyColumns": {
      "portfolio": "Portfolio",
      "identifierType": "Identifier type",
      "participantIdentifier": "Participant identifier",
      "primaryIdentifier": "Owner identifier",
      "ownerType": "Owner type",
      "positionCount": "Internal positions",
      "instrumentCount": "Instruments",
      "identityComplete": "Identity complete",
      "externalStatementAvailable": "External statement available",
      "externalStatementVerified": "External statement verified",
      "reconciliationState": "Balance reconciliation",
      "evidenceAsOf": "Evidence as of",
      "dpCode": "DP code",
      "boid": "BOID"
    },
    "columns": {
      "id": "Run ID",
      "status": "Status",
      "periodStart": "Period start",
      "periodEnd": "Period end",
      "createdAt": "Created",
      "averageCostPerUnit": "Average cost per unit",
      "symbol": "Symbol",
      "totalCost": "Total cost",
      "clientAccount": "Client account",
      "portfolioAccount": "Portfolio account",
      "instrument": "Instrument",
      "currency": "Currency",
      "quantity": "Quantity",
      "costBasis": "Cost basis",
      "marketPrice": "Market price",
      "marketValue": "Market value",
      "unrealizedGainLoss": "Unrealized gain or loss",
      "sourceAsOf": "Evidence as of",
      "accountCode": "Account code",
      "accountName": "Account name",
      "accountType": "Account type",
      "openingBalance": "Opening balance",
      "movementDebit": "Movement debit",
      "movementCredit": "Movement credit",
      "closingDebit": "Closing debit",
      "closingCredit": "Closing credit",
      "signedBalance": "Signed balance",
      "debit": "Debit",
      "credit": "Credit",
      "balance": "Balance",
      "runId": "Run",
      "breakId": "Break",
      "severity": "Severity",
      "difference": "Difference",
      "netDifference": "Net difference",
      "grossDifference": "Gross difference",
      "sourceMismatch": "Mismatch source",
      "agingBusinessDays": "Age in business days",
      "transactionDate": "Transaction date",
      "transactionType": "Transaction type",
      "totalAmount": "Total amount",
      "postingStatus": "Posting status",
      "realizedGainLoss": "Realized gain or loss",
      "statement": "Statement",
      "cashFlowClassification": "Cash-flow classification",
      "amount": "Amount",
      "asOfDate": "As of date",
      "saleDate": "Sale date",
      "saleProceeds": "Sale proceeds",
      "deductibleCharges": "Deductible charges",
      "taxableGain": "Taxable gain",
      "capitalGainTax": "Capital gains tax",
      "holdingPeriodDays": "Holding period (days)",
      "cgtRate": "CGT rate",
      "taxRuleVersion": "Tax rule version",
      "taxRuleSourceReference": "Tax rule source",
      "currentBalance": "Current balance",
      "businessDate": "Business date",
      "movementType": "Movement type",
      "incomeDate": "Income date",
      "incomeType": "Income type",
      "grossAmount": "Gross amount",
      "withholdingTaxAmount": "Withholding tax",
      "netAmount": "Net amount",
      "feeType": "Fee type",
      "taxAmount": "Tax amount",
      "acquisitionDate": "Acquisition date",
      "originalQuantity": "Original quantity",
      "remainingQuantity": "Remaining quantity",
      "costPerUnit": "Cost per unit",
      "remainingCostBasis": "Remaining cost basis",
      "recordDate": "Record date",
      "actionType": "Action type",
      "entitlementCount": "Entitlements",
      "cashImpact": "Cash impact by currency",
      "quantityImpact": "Quantity impact",
      "postingDate": "Posting date",
      "journal": "Journal",
      "description": "Description",
      "reference": "Reference",
      "source": "Source",
      "updatedAt": "Updated at",
      "qualityState": "Valuation quality",
      "dimension": "Allocation",
      "weightPct": "Weight",
      "positions": "Positions",
      "totalGainLoss": "Total gain/loss",
      "accountGroupName": "Account group"
    },
    "parameters": {
      "title": "Report parameters",
      "description": "Choose the report type and reporting period.",
      "reportType": "Report type",
      "periodStart": "Period start",
      "periodEnd": "Period end",
      "fiscalYear": "Fiscal year",
      "fiscalYearName": "Fiscal year",
      "year": "Year",
      "month": "Month",
      "quarter": "Quarter",
      "clientAccount": "Client account",
      "portfolioAccount": "Portfolio account",
      "accountCode": "Account code",
      "currency": "Currency",
      "dimension": "Allocation dimension"
    },
    "definitionForm": {
      "title": "Report definition",
      "description": "Configure a reusable regulatory report definition.",
      "code": "Report code",
      "name": "Report name",
      "type": "Report type",
      "body": "Regulatory body"
    },
    "runForm": {
      "title": "Generate report",
      "description": "Generate a scoped report run for a validated period.",
      "definition": "Report definition",
      "start": "Period start",
      "end": "Period end",
      "fiscalYear": "Fiscal year",
      "fiscalYearHelp": "Use the canonical Nepali fiscal-year label, for example 2082/83. The entered dates must exactly match that fiscal year.",
      "fiscalYearInvalid": "Use the fiscal-year format YYYY/YY, for example 2082/83.",
      "irdFiscalYear": {
        "description": "Generate the IRD fiscal year report for a validated period.",
        "fiscalYear": "Fiscal year",
        "title": "Generate IRD fiscal year report"
      },
      "reportType": "Report type",
      "irdTitle": "Generate IRD capital-gains schedule",
      "irdDescription": "Generate an IRD schedule only for an exact, closed, and fully locked canonical fiscal year.",
      "parametersSection": "Filing parameters"
    },
    "actions": {
      "saveDefinition": "Save definition",
      "generateRun": "Generate report",
      "cancel": "Cancel",
      "viewReport": "View Report",
      "exportReport": "Export Report",
      "refreshReport": "Refresh Report",
      "filterReport": "Filter Report",
      "view": "View",
      "remediate": "Remediate",
      "reviewRequirement": "Review requirement",
      "fixDataIssue": "Fix data issue",
      "upgrade": "Upgrade access",
      "requestAccess": "Request access",
      "backToReports": "Back To Reports",
      "learnMore": "Learn More",
      "viewDesc": "View",
      "runLive": "Run report"
    },
    "summary": {
      "marketValue": "Market value",
      "costBasis": "Cost basis",
      "realizedGainLoss": "Realized gain/loss",
      "unrealizedGainLoss": "Unrealized gain/loss",
      "totalGainLoss": "Total gain/loss",
      "totalPnl": "Total P&L",
      "totalDebit": "Total debit",
      "totalCredit": "Total credit",
      "netProfit": "Net profit",
      "count": "Count",
      "total": "Total",
      "openingBalance": "Opening balance",
      "closingBalance": "Closing balance",
      "transactionCount": "Transaction count",
      "valuationCoverageRatio": "Valuation coverage ratio",
      "breaks": "Breaks",
      "openBreaks": "Open breaks",
      "positions": "Positions",
      "currency": "Currency",
      "asOfDate": "As of date",
      "asOfDateBs": "As of date (BS)",
      "periodStart": "Period start",
      "periodStartBs": "Period start (BS)",
      "totalCost": "Total cost",
      "capitalGainTax": "Capital gains tax",
      "benchmarkId": "Benchmark ID",
      "benchmarkCurrency": "Benchmark currency",
      "benchmarkReturnPct": "Benchmark return %",
      "benchmarkAsOf": "Benchmark as of",
      "benchmarkStatus": "Benchmark status",
      "missingPriceCount": "Missing price count",
      "stalePriceCount": "Stale price count",
      "costBasisMissingCount": "Cost basis missing count",
      "unrealizedGainLossMissingCount": "Unrealized gain/loss missing count",
      "taxDisposalCount": "Tax disposal count",
      "taxProvenanceCount": "Tax provenance count",
      "missingTaxProvenanceCount": "Missing tax provenance count",
      "taxProvenanceCoveragePct": "Tax provenance coverage %",
      "nfrsFactCount": "NFRS fact count",
      "nfrsEvidenceAvailable": "NFRS evidence available",
      "partialData": "Partial data",
      "methodology": "Methodology",
      "methodologyVersion": "Methodology version",
      "sourceBook": "Source book",
      "jurisdictionPackage": "Jurisdiction package",
      "sourceAsOf": "Source as of",
      "limitations": "Limitations",
      "authoritativePerformanceMethodology": "Authoritative performance methodology",
      "totalIncome": "Total income",
      "totalExpenses": "Total expenses",
      "portfolioValueByCurrency": "Portfolio value by currency",
      "cashByCurrency": "Cash by currency",
      "feesByCurrency": "Fees by currency",
      "taxByCurrency": "Tax by currency",
      "quality": "Quality",
      "totalAmountByCurrency": "Total amount by currency",
      "countByStatus": "Count by status",
      "countByPostingStatus": "Count by posting status",
      "exposureByCurrency": "Exposure by currency",
      "adjustmentsByStatus": "Adjustments by status",
      "balanceSheet": "Balance sheet",
      "profitAndLoss": "Profit & loss",
      "cashFlow": "Cash flow",
      "missingValuationCount": "Positions missing complete valuation",
      "saleProceedsByCurrency": "Sale proceeds by currency",
      "costBasisByCurrency": "Cost basis by currency",
      "deductibleChargesByCurrency": "Deductible charges by currency",
      "realizedGainLossByCurrency": "Realized gain/loss by currency",
      "taxableGainByCurrency": "Taxable gain by currency",
      "capitalGainTaxByCurrency": "Capital gains tax by currency",
      "totalCostByCurrency": "Cost by currency",
      "marketValueByCurrency": "Market value by currency",
      "unrealizedGainLossByCurrency": "Unrealized gain/loss by currency",
      "depositsByCurrency": "Deposits by currency",
      "withdrawalsByCurrency": "Withdrawals by currency",
      "transfersByCurrency": "Transfers by currency",
      "grossIncomeByCurrency": "Gross income by currency",
      "withholdingByCurrency": "Withholding tax by currency",
      "netIncomeByCurrency": "Net income by currency",
      "netFeesByCurrency": "Net fees by currency",
      "grossFeesByCurrency": "Gross fees by currency",
      "remainingCostBasisByCurrency": "Remaining cost basis by currency",
      "affectedMarketValueByCurrency": "Affected market value by currency",
      "totalGainLossByCurrency": "Total gain/loss by currency",
      "reversedCount": "Reversed movements",
      "clientCount": "Clients",
      "portfolioCount": "Portfolios",
      "totalDebits": "Total debits",
      "totalCredits": "Total credits",
      "variance": "Debit/credit variance",
      "balanced": "Balanced",
      "countBySeverity": "Breaks by severity",
      "agingBuckets": "Break aging",
      "age0To2": "0–2 business days",
      "age3To5": "3–5 business days",
      "age6To10": "6–10 business days",
      "age11Plus": "11+ business days",
      "assets": "Assets",
      "liabilities": "Liabilities",
      "equity": "Equity",
      "netAssets": "Net assets",
      "revenue": "Revenue",
      "expenses": "Expenses",
      "netIncome": "Net income",
      "netCashChange": "Net cash change",
      "unclassifiedCashMovement": "Unclassified cash movement",
      "complete": "Complete",
      "netDifference": "Net difference",
      "grossDifference": "Gross difference",
      "positiveDifference": "Positive difference",
      "negativeDifference": "Negative difference",
      "INFO": "Info",
      "WARNING": "Warning",
      "CRITICAL": "Critical",
      "DRAFT": "Draft",
      "SUBMITTED": "Submitted",
      "PENDING_APPROVAL": "Pending approval",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "WITHDRAWN": "Withdrawn",
      "POSTED": "Posted",
      "REVERSED": "Reversed",
      "ROLLED_BACK": "Rolled back",
      "OPEN": "Open",
      "RESOLVED": "Resolved",
      "PENDING": "Pending",
      "POSTING": "Posting"
    },
    "groups": {
      "portfolio": "Portfolio & performance",
      "client": "Client reporting",
      "transactions": "Transactions",
      "tax": "Tax",
      "accounting": "Accounting",
      "reconciliation": "Reconciliation",
      "regulatoryOperations": "Regulatory & operations",
      "management": "Management"
    },
    "scopes": {
      "branch": "Branch",
      "client": "Client",
      "portfolio": "Portfolio",
      "organization": "Organization",
      "platform": "Platform"
    },
    "activeFilter": {
      "clearAll": "Clear all filters",
      "availability": "Availability",
      "search": "Search"
    },
    "scopeBanner": {
      "scope": "Scope:",
      "organization": "Organization:",
      "branch": "Branch:",
      "client": "Client:",
      "profile": "Profile:"
    },
    "runtime": {
      "dash": "-",
      "percent": "%",
      "previous": "Previous",
      "all": "All",
      "noResultsMatch": "No results match the selected filters",
      "noRowsToDisplay": "No rows to display",
      "booleanYes": "Yes",
      "booleanNo": "No",
      "optionalFilters": {
        "title": "Optional filters",
        "subtitle": "Expand to view additional filtering options",
        "titleWithCount": "Title With Count"
      },
      "additionalColumnsTitle": "Additional columns",
      "pageShell": {
        "unavailableTitle": "Report Unavailable",
        "generatedAt": "Generated",
        "asOfDate": "As of",
        "dataQuality": "Data Quality",
        "viewCanonicalAria": "View canonical report",
        "canonicalLink": "Canonical",
        "viewDrilldownAria": "View drill-down details",
        "drilldownLink": "Drill down",
        "accessLockedTitle": "Report Access Locked",
        "lockedDescription": "Your current tier or permissions do not include access to this report.",
        "unavailableDescription": "This report requires additional data or configuration to be generated.",
        "learnEnableAccessAria": "Learn how to enable report access",
        "learnMoreLink": "Learn more",
        "dataQualityError": "Data Quality Error",
        "dataQualityWarning": "Data Quality Warning",
        "qualityCheckFailed": "Quality check failed",
        "reason": "Reason",
        "reconciliationUnbalanced": "Reconciliation Unbalanced",
        "reconciliationPending": "Reconciliation Pending",
        "reconciliationCheckFailed": "Reconciliation check failed",
        "scope": "Scope"
      },
      "additionalColumnsDescription": "Adapter-defined secondary columns for wider reports.",
      "technicalColumnsTitle": "Technical details",
      "technicalColumnsDescription": "Adapter-defined technical columns for diagnostics and support review.",
      "exportNotAvailable": "Export not available",
      "exportNotAvailableDescription": "{{format}} export is not enabled for this report",
      "exportFailed": "Export failed",
      "exportComplete": "Export complete",
      "exportCompleteDescription": "Report exported as {{format}}",
      "errorLoading": "Error loading report",
      "unknownError": "Unknown error occurred",
      "accessDenied": "Access Denied",
      "accessDeniedDescription": "You do not have permission to view this report.",
      "requiredTier": "Required: {{tier}} tier",
      "requiredPermissions": "Required permissions: {{permissions}}",
      "retry": "Retry",
      "failedToFetch": "Failed to fetch report data",
      "exportStarted": "Report export started",
      "exportRequiresClientAccount": "Select a client account to enable export.",
      "exportFailedFormat": "{{format}} export failed",
      "exporting": "Exporting...",
      "export": "Export",
      "dataStillLoading": "Report data is still loading",
      "resolveErrorBeforeExport": "Resolve the report error before exporting",
      "dataQualityIssues": "Data Quality Issues Detected",
      "dataQualityWarnings": "Data Quality Warnings",
      "loadingReport": "Loading report data...",
      "loading": "Loading",
      "errorLoadingReport": "Error Loading Report",
      "failedToLoadReport": "Failed to load report data",
      "noRecordsMatchFilters": "No records match the selected filters",
      "filterBar": {
        "organizationLabel": "Organization:",
        "branchLabel": "Branch:",
        "reset": "Reset",
        "resetAria": "Reset report filters",
        "selectPlaceholder": "Select..."
      },
      "visualization": {
        "chartType": "{{type}} chart",
        "dataPoints": "{{count}} data points",
        "total": "Total:"
      },
      "reconciliationFooter": {
        "totalRecords": "Total Records",
        "totalValue": "Total Value",
        "discrepancies": "Discrepancies",
        "lastUpdated": "Last Updated"
      },
      "registryNotReached": "The report registry could not be reached. Please try again.",
      "table": {
        "caption": "Caption",
        "groupCaption": "Group Caption"
      },
      "missing": {
        "key": "Key",
        "with": {
          "fallback": "Fallback"
        }
      },
      "reconciliation": {
        "unbalanced": "Unbalanced",
        "pending": "Pending"
      },
      "dashboardContext": {
        "fromDashboard": "From Dashboard"
      },
      "totalsBasis": {
        "canonical": "Canonical",
        "filtered": "Filtered"
      },
      "exportColumnValidationError": "Export Column Validation Error",
      "invalidFilterQuery": "Invalid Filter Query",
      "unavailableTitle": "Unavailable",
      "unavailableDescription": "Unavailable description",
      "custom": {
        "dataSource": {
          "required": "Data source is required"
        }
      }
    },
    "tableHeaders": {
      "month": "Month",
      "year": "Year",
      "company": "Company",
      "purchaseQty": "Purchase Qty",
      "purchaseAmount": "Purchase Amount",
      "salesQty": "Sales Qty",
      "salesAmount": "Sales Amount",
      "closingUnits": "Closing Units",
      "wacc": "WACC",
      "realizedPL": "Realized P&L",
      "netTradeAmount": "Net Trade Amount",
      "date": "Date",
      "type": "Type",
      "symbol": "Symbol",
      "quantity": "Quantity",
      "price": "Price",
      "totalAmount": "Total",
      "commission": "Commission",
      "status": "Status"
    },
    "totalPurchases": "Total Purchases",
    "months": "{{count}} months",
    "exporting": "Exporting...",
    "exportTransactions": "Export Transactions",
    "additionalIssues": "...{{count}} more issues",
    "triggerDataRecalculation": "Trigger Data Recalculation",
    "totalSales": "Total Sales",
    "allMonths": "All Months",
    "showingAllMonths": "Showing {{count}} records across all months",
    "showingForMonth": "Showing {{count}} records for {{month}}",
    "monthlyPortfolioSummary": "Monthly Portfolio Summary",
    "portfolioSummary": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "asOfDate": "As Of Date",
      "asOfDateDesc": "As Of Date",
      "includeMonthly": "Include Monthly",
      "includeMonthlyDesc": "Include Monthly",
      "includeMonthlyOption": {
        "yes": "Yes",
        "yesDesc": "Yes",
        "no": "No",
        "noDesc": "No"
      },
      "metric": "Metric",
      "metricDesc": "Metric",
      "value": "Value",
      "valueDesc": "Value",
      "valueText": "Value Text",
      "valueTextDesc": "Value Text",
      "unit": "Unit",
      "unitDesc": "Unit",
      "totalMarketValue": "Total Market Value",
      "totalMarketValueDesc": "Total Market Value",
      "totalInvestment": "Total Investment",
      "totalInvestmentDesc": "Total Investment",
      "totalGainLoss": "Total Gain Loss",
      "totalGainLossDesc": "Total Gain Loss"
    },
    "performanceBreakdown": "Performance Breakdown",
    "performanceMetricsDesc": "Performance metrics grouped by {{groupBy}}, filtered by {{timeDimension}}",
    "groupBy": "Group by",
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "justNow": "Just now",
    "hoursAgo": "{{hours}}h ago",
    "daysAgo": "{{days}}d ago",
    "bytes": "{{bytes}} B",
    "kilobytes": "{{kb}} KB",
    "megabytes": "{{mb}} MB",
    "recentReports": "Recent Reports",
    "empty": {
      "noMatches": "No matches",
      "noLockedReports": "No locked reports",
      "noUnavailableReports": "No unavailable reports",
      "noAvailableReports": "No available reports",
      "noReports": "No reports",
      "filterDescription": "No reports match the current filters. Try adjusting your search or filters.",
      "searchDescription": "Adjust search or browse other categories",
      "lockedDescription": "All reports in this category are available or unavailable.",
      "unavailableDescription": "No reports are currently unavailable.",
      "availableDescription": "Check locked or unavailable states.",
      "categoryDescription": "No reports configured for this category.",
      "resetCategory": "Reset category",
      "description": "No investment report surfaces are currently available for this account."
    },
    "hub": {
      "searchPlaceholder": "Search holdings, transactions, gain/loss, NFRS, or performance reports",
      "searchAriaLabel": "Search reports (Escape to clear)",
      "refineFiltersTitle": "Refine report filters",
      "refineFiltersSubtitle": "Use optional filters only when narrowing a large report set.",
      "secondaryDisclosureTitle": "Secondary Disclosure",
      "secondaryDisclosureSubtitle": "Additional context and metadata",
      "contextTitle": "Context",
      "contextSubtitle": "Report context information",
      "totalReports": "Total Reports",
      "availableLocked": "Available / Locked",
      "dataQualityAvailability": "Data Quality Availability",
      "reportAvailabilityLabel": "Report availability",
      "availabilityReady": "{{count}} ready",
      "availabilityLocked": "{{count}} locked",
      "availabilityUnavailable": "{{count}} unavailable",
      "context": {
        "title": "Reports workspace context",
        "subtitle": "Access portfolio, performance, tax, accounting, and data-quality reports.",
        "availableReports": "{{count}} report(s) available.",
        "filterInfo": "Use individual report filters to narrow down specific data ranges and parameters."
      },
      "badges": {
        "lockedTier": "Tier locked",
        "lockedPermission": "Access restricted",
        "unavailableData": "Data unavailable",
        "unavailableRoute": "Route unavailable",
        "trustWarning": "Trust warning",
        "trustError": "Trust error",
        "exportReady": "Export ready",
        "issueCount": "{{count}} issues",
        "exportDisabled": "Export disabled"
      },
      "disabledReason": {
        "unavailableData": "Report data is currently unavailable.",
        "unavailableRoute": "Report route is unavailable for this account."
      },
      "trustStatus": {
        "title": "Report trust needs review",
        "description": "One or more reports are currently affected by data quality or certification issues."
      },
      "card": {
        "badges": {
          "exportReady": "Export ready",
          "exportDisabled": "Export disabled"
        }
      },
      "groups": {
        "portfolio": {
          "title": "Portfolio reports"
        },
        "performance": {
          "title": "Performance reports"
        },
        "compliance": {
          "title": "Tax, NFRS, and compliance reports"
        },
        "other": {
          "title": "Other reports"
        }
      },
      "lockReasons": {
        "routeUnavailable": "Report route unavailable"
      },
      "remediation": {
        "enableValuationFacts": "Review market prices and valuation facts to enable this report",
        "upgradeTier": "Upgrade to Professional tier to access this report",
        "requestPermission": "Contact administrator for required permissions",
        "resolveNfrsDataQuality": "Resolve NFRS data-quality gaps to enable this report",
        "importPortfolioData": "Import transactions and generate portfolio data to enable this report"
      },
      "workspaceTools": {
        "title": "Workspace tools"
      },
      "trust": {
        "verified": "Verified",
        "warning": "Warning",
        "error": "Error"
      },
      "support": {
        "title": "Support tools",
        "recentActivity": {
          "title": "Recent report activity",
          "description": "Review latest report generation activity and runtime evidence."
        },
        "exportReadiness": {
          "title": "Export readiness",
          "description": "Check export capability and runtime adapter readiness for report endpoints."
        }
      }
    },
    "titles": {
      "sectorAllocation": "Sector Allocation",
      "concentration": "Concentration",
      "performanceHub": "Performance",
      "performanceDrivers": "Performance Drivers",
      "performanceBenchmark": "Performance Benchmark",
      "performanceRisk": "Performance Risk",
      "holdingsReport": "Holdings Report",
      "transactionsReport": "Transactions Report",
      "profitAndLoss": "Profit & Loss",
      "realizedProfitAndLoss": "Realized Profit & Loss",
      "nfrsDashboard": "NFRS Dashboard",
      "nfrsMonthly": "NFRS Monthly",
      "dataQualityReport": "Data Quality Report",
      "pivotAnalysis": "Pivot Analysis"
    },
    "Concentration": "Concentration Risk",
    "trustBanner": {
      "verifiedTitle": "Data quality verified",
      "warningTitle": "Data quality warnings",
      "errorTitle": "Data quality errors",
      "verifiedAriaLabel": "All data quality checks passed",
      "verifiedMessage": "All data quality checks passed",
      "issue": {
        "unknown": "Some report data needs review.",
        "dataStale": "Some report inputs are stale and may need refresh.",
        "dataMissing": "Some required report data is missing.",
        "dataDelayed": "Latest report data is delayed.",
        "reconciliationPending": "Reconciliation is pending for one or more report sources.",
        "reconciliationUnbalanced": "Reconciliation checks found an imbalance.",
        "qualityCheckFailed": "A data quality check failed for this report.",
        "exportSourceUnavailable": "A source required for report exports is unavailable.",
        "metadataMissing": "Report metadata is incomplete and needs review."
      }
    },
    "filters": {
      "asOfDate": {
        "label": "As Of Date"
      },
      "dateFrom": {
        "label": "Date From"
      },
      "dateTo": {
        "label": "Date To"
      },
      "clientAccountId": {
        "label": "Client"
      },
      "portfolioAccountId": {
        "label": "Portfolio Account"
      },
      "instrument": {
        "label": "Instrument"
      },
      "sector": {
        "label": "Sector"
      },
      "symbol": {
        "label": "Symbol"
      },
      "transactionType": {
        "label": "Type",
        "options": {
          "purchase": "Purchase",
          "sale": "Sale",
          "bonus": "Bonus",
          "right": "Right",
          "redemption": "Redemption"
        }
      },
      "certaintyLevel": {
        "label": "Certainty",
        "options": {
          "high": "High",
          "medium": "Medium",
          "low": "Low",
          "invalid": "Invalid"
        }
      },
      "boid": {
        "label": "BOID",
        "labelDesc": "BOID"
      },
      "dateFromDesc": "Date From",
      "dateToDesc": "Date To",
      "sectorDesc": "Sector",
      "accountNumber": "Account Number",
      "accountNumberDesc": "Account Number",
      "taxId": "Tax ID",
      "taxIdDesc": "Tax ID",
      "internalCode": "Internal Code",
      "internalCodeDesc": "Internal Code",
      "secretKey": "Secret Key",
      "secretKeyDesc": "Secret Key",
      "status": {
        "open": "Open",
        "resolved": "Resolved",
        "approved": "Approved",
        "rejected": "Rejected",
        "submitted": "Submitted",
        "pendingApproval": "Pending approval",
        "posted": "Posted",
        "cancelled": "Cancelled",
        "draft": "Draft",
        "withdrawn": "Withdrawn",
        "reversed": "Reversed",
        "rolledBack": "Rolled back"
      },
      "type": {
        "buy": "Buy",
        "sell": "Sell",
        "corporateAction": "Corporate action",
        "transfer": "Transfer",
        "openingBalance": "Opening balance",
        "bonusShare": "Bonus shares",
        "rightShare": "Rights shares",
        "split": "Stock split",
        "consolidation": "Share consolidation",
        "merger": "Merger",
        "transferIn": "Transfer in",
        "transferOut": "Transfer out",
        "fee": "Fee",
        "tax": "Tax"
      },
      "severity": {
        "info": "Information",
        "warning": "Warning",
        "critical": "Critical"
      }
    },
    "names": {
      "portfolioHoldings": "Portfolio Holdings",
      "transactionHistory": "Transaction History",
      "monthlyPnL": "Monthly P&L",
      "realizedGainLoss": "Realized Gain/Loss",
      "unrealizedGainLoss": "Unrealized Gain/Loss",
      "nfrsPortfolio": "NFRS Portfolio",
      "taxSummary": "Tax Summary",
      "dividendReport": "Dividend Report",
      "capitalGainReport": "Capital Gain Report"
    },
    "status": {
      "pending": "Pending",
      "pendingApproval": "Pending Approval",
      "approved": "Approved",
      "rejected": "Rejected",
      "posted": "Posted",
      "finalized": "Finalized",
      "cancelled": "Cancelled",
      "failed": "Failed",
      "processing": "Processing",
      "completed": "Completed",
      "available": "Available",
      "unavailable": "Status not checked",
      "locked": "Locked",
      "dataUnavailable": "Data Unavailable",
      "disabled": "Disabled",
      "dataIssues": "Data Issues",
      "dataErrors": "Data Errors",
      "verified": "Verified",
      "locked_tier": "Requires higher tier",
      "locked_permission": "Permission required",
      "unavailable_data": "Data unavailable",
      "unavailable_route": "Route unavailable",
      "checking": "Checking status",
      "not_checked": "Status not checked",
      "needsReview": "Needs review",
      "dataIssue": "Data issue",
      "unknown": "Unknown",
      "ok": "OK",
      "warning": "Warning",
      "error": "Error"
    },
    "ariaLabels": {
      "reportLocked": "Report locked",
      "dataUnavailable": "Report data unavailable",
      "reportRouteUnavailable": "Report route unavailable",
      "dataQualityWarning": "Report data quality warning",
      "dataQualityError": "Report data quality error",
      "reportVerified": "Report verified",
      "lockedSuffix": "locked",
      "disabledSuffix": "disabled",
      "dataIssuesSuffix": "has data issues",
      "reportMetadata": "Report metadata",
      "availableExportFormats": "Available export formats"
    },
    "availability": {
      "OK": "Available",
      "NO_DATA": "No Data",
      "PARTIAL": "Partial Data",
      "UNAVAILABLE": "Unavailable",
      "ERROR": "Error",
      "LOCKED": "Locked",
      "ariaLabel": "Filter by availability",
      "all": "All",
      "available": "Available",
      "unavailable": "Unavailable",
      "locked": "Locked"
    },
    "availability_description": {
      "OK": "Report data is complete and available.",
      "NO_DATA": "No data has been imported for this report yet.",
      "PARTIAL": "Report data is partially available. Some records may be missing.",
      "UNAVAILABLE": "Report is temporarily unavailable due to a data source issue.",
      "ERROR": "An error occurred while generating this report.",
      "LOCKED": "This report is locked for your current subscription tier."
    },
    "locked": {
      "tier": "Upgrade your subscription to access this report.",
      "permission": "You do not have permission to view this report. Contact your administrator.",
      "tierCta": "Upgrade Plan",
      "permissionCta": "Request Access"
    },
    "unavailable": {
      "data": "Report data is currently unavailable. Please try again later.",
      "dataHelp": "This may be caused by an ongoing data refresh or a temporary service issue.",
      "route": "Report route is currently unavailable.",
      "feature": "This report feature is currently unavailable.",
      "exportUnsupported": "Export is not supported for this report.",
      "exportUnsupportedHelp": "Contact your administrator to enable export for this report.",
      "genericDescription": "Generic description",
      "reportTitle": "Report",
      "genericTitle": "Generic"
    },
    "dataQuality": {
      "error": "Report data has critical quality issues.",
      "warning": "Report data has quality warnings.",
      "stale": "Report data appears stale.",
      "missing": "Report data is missing.",
      "metadataMissing": "This report cannot be shown because its generated/as-of metadata is missing. Refresh the report or review data quality before using it.",
      "reconciliation": {
        "unbalanced": "Report reconciliation is unbalanced.",
        "pending": "Report reconciliation is pending.",
        "failed": "Report reconciliation failed."
      },
      "missingMarketPrices": "Market prices are missing for one or more holdings.",
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "asOfDate": "As Of Date",
      "asOfDateDesc": "As Of Date",
      "qualityCategory": "Quality Category",
      "qualityCategoryDesc": "Quality Category",
      "category": "Category",
      "categoryDesc": "Category",
      "checkName": "Check Name",
      "checkNameDesc": "Check Name",
      "status": "Status",
      "statusDesc": "Status",
      "affectedRecords": "Affected Records",
      "affectedRecordsDesc": "Affected Records",
      "severity": "Severity",
      "severityDesc": "Severity",
      "lastChecked": "Last Checked",
      "lastCheckedDesc": "Last Checked",
      "description": "Data Quality description",
      "descriptionDesc": "Description",
      "totalChecks": "Total Checks",
      "totalChecksDesc": "Total Checks",
      "passedChecks": "Passed Checks",
      "passedChecksDesc": "Passed Checks",
      "failedChecks": "Failed Checks",
      "failedChecksDesc": "Failed Checks",
      "overallQualityScore": "Overall Quality Score",
      "overallQualityScoreDesc": "Overall Quality Score"
    },
    "export": {
      "generating": "Generating export…",
      "ready": "Export ready",
      "downloading": "Downloading…",
      "failed": "Export failed",
      "notAvailable": "Export not available",
      "formatPdf": "Export as PDF",
      "formatExcel": "Export as Excel",
      "formatCsv": "Export as CSV",
      "error": {
        "title": "Export failed",
        "transactions": "Unable to export transactions",
        "holdings": "Unable to export holdings"
      }
    },
    "transactions": {
      "error": {
        "loadFailed": "Unable to load transactions",
        "approveFailed": "Failed to approve transaction",
        "rejectFailed": "Failed to reject transaction",
        "deleteFailed": "Failed to delete transaction",
        "submitFailed": "Failed to submit transaction",
        "reversalRequestFailed": "Failed to request reversal",
        "reversalApproveFailed": "Failed to approve reversal",
        "reversalRejectFailed": "Failed to reject reversal",
        "repairFailed": "Failed to repair transaction",
        "reversalsLoadFailed": "Unable to load reversals queue",
        "exportFailed": "Failed to export file",
        "saveFailed": "Failed to save transactions"
      },
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "instrument": "Instrument",
      "instrumentDesc": "Instrument",
      "transactionType": "Transaction Type",
      "transactionTypeDesc": "Transaction Type",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "date": "Date",
      "dateDesc": "Date",
      "client": "Client",
      "clientDesc": "Client",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "type": "Type",
      "typeDesc": "Type",
      "quantity": "Quantity",
      "quantityDesc": "Quantity",
      "price": "Price",
      "priceDesc": "Price",
      "totalAmount": "Total Amount",
      "totalAmountDesc": "Total Amount",
      "commission": "Commission",
      "commissionDesc": "Commission",
      "billNo": "Bill No",
      "billNoDesc": "Bill No",
      "brokerNo": "Broker No",
      "brokerNoDesc": "Broker No",
      "status": "Status",
      "statusDesc": "Status",
      "createdBy": "Created By",
      "createdByDesc": "Created By",
      "importBatchId": "Import Batch ID",
      "importBatchIdDesc": "Import Batch ID",
      "importEntryId": "Import Entry ID",
      "importEntryIdDesc": "Import Entry ID",
      "sourceRowNumber": "Source Row Number",
      "sourceRowNumberDesc": "Source Row Number",
      "totalTransactions": "Total Transactions",
      "totalTransactionsDesc": "Total Transactions",
      "totalCommission": "Total Commission",
      "totalCommissionDesc": "Total Commission"
    },
    "recent": {
      "unknownReport": "Unknown report",
      "generatedByOrganization": "Generated by organization",
      "generatedInternally": "Generated internally",
      "report": "Report",
      "completed": "Completed",
      "output": "Output",
      "actor": "Actor",
      "noRecentReports": "No Recent Reports"
    },
    "loading": "Loading report data...",
    "lastGenerated": {
      "label": "Last generated",
      "justNow": "Just now",
      "hoursAgo": "{{hours}}h ago",
      "daysAgo": "{{days}}d ago"
    },
    "rowCount": "{{count}} records",
    "formats": {
      "label": "Formats",
      "format": "Export format"
    },
    "audit": {
      "allEntityTypes": "All entity types",
      "portfolio": "Portfolio",
      "transaction": "Transaction",
      "instrument": "Instrument",
      "journal": "Journal",
      "user": "User",
      "organization": "Organization",
      "report": "Report",
      "import": "Import",
      "views": {
        "lineage": {
          "title": "Lineage evidence",
          "description": "Trace lineage evidence across imports, posting, valuation, and report lifecycle events.",
          "summary": "Import-to-report traceability for investigation and evidence workflows.",
          "empty": "No lineage evidence was found for the selected filters."
        }
      },
      "showingUpTo": "showing up to",
      "entries": "Entries",
      "system": "System",
      "title": "Audit Reports",
      "description": "Review system change history, access certification evidence, and verify operational audit trails.",
      "unavailable": "Audit reports unavailable",
      "changeHistory": "Change history",
      "governanceTrail": "Governance trail",
      "certificationEvidence": "Certification evidence",
      "datasetCertifications": "Dataset certifications",
      "operationalAudit": "Operational audit",
      "operationalSurfaces": "Operational surfaces",
      "activity": "Recent Activity",
      "filteredBy": "filtered by",
      "noActivity": "No entries recorded",
      "time": "Time",
      "action": "Action",
      "entity": "Entity",
      "page": "Page",
      "matchingFilter": "matching filter",
      "loadError": "Failed to load audit entries",
      "notRegistered": {
        "title": "Not registered",
        "description": "You do not have access to audit reports.",
        "action": "Return to dashboard"
      },
      "accessDenied": {
        "title": "Access denied",
        "description": "You do not have permission to view audit reports.",
        "action": "Return to dashboard"
      },
      "scopeNotice": "Showing audit entries within your access scope.",
      "auditHubLink": "Open audit hub",
      "activityTrail": {
        "title": "Activity trail"
      },
      "loading": "Loading audit entries…",
      "noEvents": "No events found",
      "defaultEntityType": "All entity types",
      "openAuditHub": "Open audit hub",
      "invalidViewFallback": "Invalid View Fallback",
      "exportLogs": "Export Logs",
      "exportLogsDesc": "Export Logs",
      "viewLineage": "View Lineage",
      "viewLineageDesc": "View Lineage",
      "redactClientNames": "Redact Client Names",
      "redactClientNamesDesc": "Redact Client Names",
      "redactAmounts": "Redact Amounts",
      "redactAmountsDesc": "Redact Amounts"
    },
    "catalog": {
      "investment": "Investment Reports",
      "investmentDescription": "Track portfolio performance, view holdings, and export transaction data for your investment portfolio.",
      "accounting": "Accounting Reports",
      "accountingDescription": "Access general ledger, journal entries, reconciliation summaries, and accounting-ready exports.",
      "tax": "Tax Reports",
      "taxDescription": "Generate VAT and IRD reports, analyze capital gains, and track tax filing workflow status.",
      "organization": "Organization Reports",
      "organizationDescription": "View cross-module executive summaries, workflow oversight, and operational health metrics.",
      "audit": "Audit Reports",
      "auditDescription": "Review system change history, access certification evidence, and verify operational audit trails.",
      "dataQuality": "Data Quality Reports",
      "dataQualityDescription": "Monitor reconciliation diagnostics, trust exceptions, and overall data health across the system.",
      "highlights": {
        "investment": {
          "performanceReturnsAndRiskMetrics": "Performance returns and risk metrics",
          "holdingsWithCostBasisAndGains": "Holdings with cost basis and gains",
          "transactionHistoryAndMonthlyAnalysis": "Transaction history and monthly analysis"
        },
        "accounting": {
          "generalLedgerWithOpeningClosingBalances": "General ledger with opening/closing balances",
          "journalEntriesWithApprovalHistory": "Journal entries with approval history",
          "bankReconciliationStatusAndTrialBalance": "Bank reconciliation status and trial balance"
        },
        "tax": {
          "vatAndIrdComplianceReporting": "VAT and IRD compliance reporting",
          "capitalGainsTaxLotAnalysis": "Capital gains tax lot analysis",
          "filingDeadlineTrackingAndWorkflowStatus": "Filing deadline tracking and workflow status"
        },
        "organization": {
          "executiveSummaryAcrossAllModules": "Executive summary across all modules",
          "workflowApprovalStatusAndDataTrust": "Workflow approval status and data trust",
          "moduleLevelOperationalHealthMetrics": "Module-level operational health metrics"
        },
        "audit": {
          "completeChangeHistoryAndGovernanceTrail": "Complete change history and governance trail",
          "datasetAndReportCertificationEvidence": "Dataset and report certification evidence",
          "operationalAuditSurfacesAndCompliance": "Operational audit surfaces and compliance"
        },
        "dataQuality": {
          "reconciliationBreakAnalysisAndDiagnostics": "Reconciliation break analysis and diagnostics",
          "trustScoreAndContinuityExceptionTracking": "Trust score and continuity exception tracking",
          "dataHealthExportForAuditAndValidation": "Data health export for audit and validation"
        }
      },
      "access-control-audit": {
        "description": "View the Access Control Audit report.",
        "title": "Access Control Audit"
      },
      "accounts-payable-aging": {
        "description": "View the Accounts Payable Aging report.",
        "title": "Accounts Payable Aging"
      },
      "accounts-receivable-aging": {
        "description": "View the Accounts Receivable Aging report.",
        "title": "Accounts Receivable Aging"
      },
      "accrued-interest": {
        "description": "View the Accrued Interest report.",
        "title": "Accrued Interest"
      },
      "ad-hoc-query-results": {
        "description": "View the Ad Hoc Query Results report.",
        "title": "Ad Hoc Query Results"
      },
      "aifmd-annex-iv": {
        "description": "View the Aifmd Annex Iv report.",
        "title": "Aifmd Annex Iv"
      },
      "alpha-generation": {
        "description": "View the Alpha Generation report.",
        "title": "Alpha Generation"
      },
      "amortization-schedule": {
        "description": "View the Amortization Schedule report.",
        "title": "Amortization Schedule"
      },
      "annual-general-meeting-materials": {
        "description": "View the Annual General Meeting Materials report.",
        "title": "Annual General Meeting Materials"
      },
      "annual-investment-report": {
        "description": "View the Annual Investment Report report.",
        "title": "Annual Investment Report"
      },
      "asset-allocation-current": {
        "description": "View the Asset Allocation Current report.",
        "title": "Asset Allocation Current"
      },
      "asset-allocation-target": {
        "description": "View the Asset Allocation Target report.",
        "title": "Asset Allocation Target"
      },
      "asset-class-exposure": {
        "description": "View the Asset Class Exposure report.",
        "title": "Asset Class Exposure"
      },
      "attribution-analysis": {
        "description": "View the Attribution Analysis report.",
        "title": "Attribution Analysis"
      },
      "audit-support-package": {
        "description": "View the Audit Support Package report.",
        "title": "Audit Support Package"
      },
      "audit-trail": {
        "description": "View the Audit Trail report.",
        "title": "Audit Trail"
      },
      "aum-flow-analysis": {
        "description": "View the Aum Flow Analysis report.",
        "title": "Aum Flow Analysis"
      },
      "automation-coverage": {
        "description": "View the Automation Coverage report.",
        "title": "Automation Coverage"
      },
      "backtesting-results": {
        "description": "View the Backtesting Results report.",
        "title": "Backtesting Results"
      },
      "balance-sheet": {
        "description": "View the Balance Sheet report.",
        "title": "Balance Sheet"
      },
      "bank-reconciliation": {
        "description": "View the Bank Reconciliation report.",
        "title": "Bank Reconciliation"
      },
      "basel-iii-pillar3": {
        "description": "View the Basel Iii Pillar3 report.",
        "title": "Basel Iii Pillar3"
      },
      "benchmark-comparison": {
        "description": "View the Benchmark Comparison report.",
        "title": "Benchmark Comparison"
      },
      "best-execution-report": {
        "description": "View the Best Execution Report report.",
        "title": "Best Execution Report"
      },
      "beta-analysis": {
        "description": "View the Beta Analysis report.",
        "title": "Beta Analysis"
      },
      "billing-usage-report": {
        "description": "View the Billing Usage Report report.",
        "title": "Billing Usage Report"
      },
      "board-reporting-package": {
        "description": "View the Board Reporting Package report.",
        "title": "Board Reporting Package"
      },
      "bond-portfolio-valuation": {
        "description": "View the Bond Portfolio Valuation report.",
        "title": "Bond Portfolio Valuation"
      },
      "branch-usage-metrics": {
        "description": "View the Branch Usage Metrics report.",
        "title": "Branch Usage Metrics"
      },
      "breach-notification-log": {
        "description": "View the Breach Notification Log report.",
        "title": "Breach Notification Log"
      },
      "budget-variance": {
        "description": "View the Budget Variance report.",
        "title": "Budget Variance"
      },
      "budget-vs-actual": {
        "description": "View the Budget Vs Actual report.",
        "title": "Budget Vs Actual"
      },
      "business-performance-overview": {
        "description": "View the Business Performance Overview report.",
        "title": "Business Performance Overview"
      },
      "call-put-analysis": {
        "description": "View the Call Put Analysis report.",
        "title": "Call Put Analysis"
      },
      "calmar-ratio": {
        "description": "View the Calmar Ratio report.",
        "title": "Calmar Ratio"
      },
      "carbon-footprint": {
        "description": "View the Carbon Footprint report.",
        "title": "Carbon Footprint"
      },
      "carried-interest-allocation": {
        "description": "View the Carried Interest Allocation report.",
        "title": "Carried Interest Allocation"
      },
      "cash-flow-forecast": {
        "description": "View the Cash Flow Forecast report.",
        "title": "Cash Flow Forecast"
      },
      "cash-flow-projection": {
        "description": "View the Cash Flow Projection report.",
        "title": "Cash Flow Projection"
      },
      "cash-flow-statement": {
        "description": "View the Cash Flow Statement report.",
        "title": "Cash Flow Statement"
      },
      "cash-position-by-currency": {
        "description": "View the Cash Position By Currency report.",
        "title": "Cash Position By Currency"
      },
      "cash-projection": {
        "description": "View the Cash Projection report.",
        "title": "Cash Projection"
      },
      "cdsc-account-freeze-unfreeze": {
        "description": "View the Cdsc Account Freeze Unfreeze report.",
        "title": "Cdsc Account Freeze Unfreeze"
      },
      "cdsc-beneficial-ownership": {
        "description": "View the Cdsc Beneficial Ownership report.",
        "title": "Cdsc Beneficial Ownership"
      },
      "cdsc-demat-remat": {
        "description": "View the Cdsc Demat Remat report.",
        "title": "Cdsc Demat Remat"
      },
      "cdsc-isin-allocation": {
        "description": "View the Cdsc Isin Allocation report.",
        "title": "Cdsc Isin Allocation"
      },
      "cdsc-pledge-unpledge": {
        "description": "View the Cdsc Pledge Unpledge report.",
        "title": "Cdsc Pledge Unpledge"
      },
      "cdsc-transfer-transmission": {
        "description": "View the Cdsc Transfer Transmission report.",
        "title": "Cdsc Transfer Transmission"
      },
      "cftc-reporting": {
        "description": "View the Cftc Reporting report.",
        "title": "Cftc Reporting"
      },
      "clawback-calculation": {
        "description": "View the Clawback Calculation report.",
        "title": "Clawback Calculation"
      },
      "client-acquisition-metrics": {
        "description": "View the Client Acquisition Metrics report.",
        "title": "Client Acquisition Metrics"
      },
      "client-advisory-notes": {
        "description": "View the Client Advisory Notes report.",
        "title": "Client Advisory Notes"
      },
      "client-asset-allocation": {
        "description": "View the Client Asset Allocation report.",
        "title": "Client Asset Allocation"
      },
      "client-beneficiary-report": {
        "description": "View the Client Beneficiary Report report.",
        "title": "Client Beneficiary Report"
      },
      "client-capital-gain-loss": {
        "description": "View the Client Capital Gain Loss report.",
        "title": "Client Capital Gain Loss"
      },
      "client-consolidated-view": {
        "description": "View the Client Consolidated View report.",
        "title": "Client Consolidated View"
      },
      "client-fee-statement": {
        "description": "View the Client Fee Statement report.",
        "title": "Client Fee Statement"
      },
      "client-holdings": {
        "description": "View the Client Holdings report.",
        "title": "Client Holdings"
      },
      "client-income-statement": {
        "description": "View the Client Income Statement report.",
        "title": "Client Income Statement"
      },
      "client-investment-policy-compliance": {
        "description": "View the Client Investment Policy Compliance report.",
        "title": "Client Investment Policy Compliance"
      },
      "client-onboarding-package": {
        "description": "View the Client Onboarding Package report.",
        "title": "Client Onboarding Package"
      },
      "client-performance-summary": {
        "description": "View the Client Performance Summary report.",
        "title": "Client Performance Summary"
      },
      "client-portfolio-statement": {
        "description": "View the Client Portfolio Statement report.",
        "title": "Client Portfolio Statement"
      },
      "client-retention-analysis": {
        "description": "View the Client Retention Analysis report.",
        "title": "Client Retention Analysis"
      },
      "client-risk-profile": {
        "description": "View the Client Risk Profile report.",
        "title": "Client Risk Profile"
      },
      "client-tax-statement": {
        "description": "View the Client Tax Statement report.",
        "title": "Client Tax Statement"
      },
      "client-transaction-history": {
        "description": "View the Client Transaction History report.",
        "title": "Client Transaction History"
      },
      "code-of-ethics-attestation": {
        "description": "View the Code Of Ethics Attestation report.",
        "title": "Code Of Ethics Attestation"
      },
      "collateral-management": {
        "description": "View the Collateral Management report.",
        "title": "Collateral Management"
      },
      "commodity-exposure": {
        "description": "View the Commodity Exposure report.",
        "title": "Commodity Exposure"
      },
      "compliance-monitoring-dashboard": {
        "description": "View the Compliance Monitoring Dashboard report.",
        "title": "Compliance Monitoring Dashboard"
      },
      "compliance-training-tracking": {
        "description": "View the Compliance Training Tracking report.",
        "title": "Compliance Training Tracking"
      },
      "concentration-risk": {
        "description": "View the Concentration Risk report.",
        "title": "Concentration Risk"
      },
      "conflict-of-interest": {
        "description": "View the Conflict Of Interest report.",
        "title": "Conflict Of Interest"
      },
      "consolidated-financial-statements": {
        "description": "View the Consolidated Financial Statements report.",
        "title": "Consolidated Financial Statements"
      },
      "controversy-monitoring": {
        "description": "View the Controversy Monitoring report.",
        "title": "Controversy Monitoring"
      },
      "convertible-bond-analysis": {
        "description": "View the Convertible Bond Analysis report.",
        "title": "Convertible Bond Analysis"
      },
      "corep": {
        "description": "View the Corep report.",
        "title": "Corep"
      },
      "corporate-action-processing": {
        "description": "View the Corporate Action Processing report.",
        "title": "Corporate Action Processing"
      },
      "corporate-announcement": {
        "description": "View the Corporate Announcement report.",
        "title": "Corporate Announcement"
      },
      "corporate-governance-report": {
        "description": "View the Corporate Governance Report report.",
        "title": "Corporate Governance Report"
      },
      "correlation-matrix": {
        "description": "View the Correlation Matrix report.",
        "title": "Correlation Matrix"
      },
      "cost-allocation": {
        "description": "View the Cost Allocation report.",
        "title": "Cost Allocation"
      },
      "counterparty-risk": {
        "description": "View the Counterparty Risk report.",
        "title": "Counterparty Risk"
      },
      "coupon-payment-schedule": {
        "description": "View the Coupon Payment Schedule report.",
        "title": "Coupon Payment Schedule"
      },
      "credit-rating-distribution": {
        "description": "View the Credit Rating Distribution report.",
        "title": "Credit Rating Distribution"
      },
      "credit-risk-exposure": {
        "description": "View the Credit Risk Exposure report.",
        "title": "Credit Risk Exposure"
      },
      "credit-spread-analysis": {
        "description": "View the Credit Spread Analysis report.",
        "title": "Credit Spread Analysis"
      },
      "cross-entity-risk-aggregation": {
        "description": "View the Cross Entity Risk Aggregation report.",
        "title": "Cross Entity Risk Aggregation"
      },
      "cryptocurrency-holdings": {
        "description": "View the Cryptocurrency Holdings report.",
        "title": "Cryptocurrency Holdings"
      },
      "currency-exposure": {
        "description": "View the Currency Exposure report.",
        "title": "Currency Exposure"
      },
      "custom-report-builder": {
        "description": "View the Custom Report Builder report.",
        "title": "Custom Report Builder"
      },
      "data-breach-notification": {
        "description": "View the Data Breach Notification report.",
        "title": "Data Breach Notification"
      },
      "data-completeness": {
        "description": "View the Data Completeness report.",
        "title": "Data Completeness"
      },
      "data-lineage": {
        "description": "View the Data Lineage report.",
        "title": "Data Lineage"
      },
      "data-quality-dashboard": {
        "description": "View the Data Quality Dashboard report.",
        "title": "Data Quality Dashboard"
      },
      "depreciation-schedule": {
        "description": "View the Depreciation Schedule report.",
        "title": "Depreciation Schedule"
      },
      "derivative-portfolio-analysis": {
        "description": "View the Derivative Portfolio Analysis report.",
        "title": "Derivative Portfolio Analysis"
      },
      "disaster-recovery-test": {
        "description": "View the Disaster Recovery Test report.",
        "title": "Disaster Recovery Test"
      },
      "dividend-calendar": {
        "description": "View the Dividend Calendar report.",
        "title": "Dividend Calendar"
      },
      "dividend-report": {
        "description": "View the Dividend Report report.",
        "title": "Dividend Report"
      },
      "drawdown-analysis": {
        "description": "View the Drawdown Analysis report.",
        "title": "Drawdown Analysis"
      },
      "drift-analysis": {
        "description": "View the Drift Analysis report.",
        "title": "Drift Analysis"
      },
      "due-diligence-package": {
        "description": "View the Due Diligence Package report.",
        "title": "Due Diligence Package"
      },
      "duration-convexity-analysis": {
        "description": "View the Duration Convexity Analysis report.",
        "title": "Duration Convexity Analysis"
      },
      "earnings-calendar": {
        "description": "View the Earnings Calendar report.",
        "title": "Earnings Calendar"
      },
      "economic-indicator": {
        "description": "View the Economic Indicator report.",
        "title": "Economic Indicator"
      },
      "efficient-frontier": {
        "description": "View the Efficient Frontier report.",
        "title": "Efficient Frontier"
      },
      "emir-reporting": {
        "description": "View the Emir Reporting report.",
        "title": "Emir Reporting"
      },
      "entity-performance-comparison": {
        "description": "View the Entity Performance Comparison report.",
        "title": "Entity Performance Comparison"
      },
      "equalization-calculation": {
        "description": "View the Equalization Calculation report.",
        "title": "Equalization Calculation"
      },
      "error-rate-tracking": {
        "description": "View the Error Rate Tracking report.",
        "title": "Error Rate Tracking"
      },
      "es-report": {
        "description": "View the Es Report report.",
        "title": "Es Report"
      },
      "esg-scorecard": {
        "description": "View the Esg Scorecard report.",
        "title": "Esg Scorecard"
      },
      "exception-alert-summary": {
        "description": "View the Exception Alert Summary report.",
        "title": "Exception Alert Summary"
      },
      "exception-report": {
        "description": "View the Exception Report report.",
        "title": "Exception Report"
      },
      "executive-dashboard": {
        "description": "View the Executive Dashboard report.",
        "title": "Executive Dashboard"
      },
      "expense-analysis": {
        "description": "View the Expense Analysis report.",
        "title": "Expense Analysis"
      },
      "factor-exposure": {
        "description": "View the Factor Exposure report.",
        "title": "Factor Exposure"
      },
      "failed-trade": {
        "description": "View the Failed Trade report.",
        "title": "Failed Trade"
      },
      "fatca-crs-reporting": {
        "description": "View the Fatca Crs Reporting report.",
        "title": "Fatca Crs Reporting"
      },
      "fee-report": {
        "description": "View the Fee Report report.",
        "title": "Fee Report"
      },
      "financial-ratios": {
        "description": "View the Financial Ratios report.",
        "title": "Financial Ratios"
      },
      "finrep": {
        "description": "View the Finrep report.",
        "title": "Finrep"
      },
      "fixed-asset-register": {
        "description": "View the Fixed Asset Register report.",
        "title": "Fixed Asset Register"
      },
      "form-pf": {
        "description": "View the Form Pf report.",
        "title": "Form Pf"
      },
      "forward-contract-analysis": {
        "description": "View the Forward Contract Analysis report.",
        "title": "Forward Contract Analysis"
      },
      "fund-balance-report": {
        "description": "View the Fund Balance Report report.",
        "title": "Fund Balance Report"
      },
      "fund-factsheet": {
        "description": "View the Fund Factsheet report.",
        "title": "Fund Factsheet"
      },
      "fund-of-funds-look-through": {
        "description": "View the Fund Of Funds Look Through report.",
        "title": "Fund Of Funds Look Through"
      },
      "general-ledger": {
        "description": "View the General Ledger report.",
        "title": "General Ledger"
      },
      "geographic-exposure": {
        "description": "View the Geographic Exposure report.",
        "title": "Geographic Exposure"
      },
      "gips-compliance": {
        "description": "View the Gips Compliance report.",
        "title": "Gips Compliance"
      },
      "hedge-fund-performance": {
        "description": "View the Hedge Fund Performance report.",
        "title": "Hedge Fund Performance"
      },
      "high-water-mark-tracking": {
        "description": "View the High Water Mark Tracking report.",
        "title": "High Water Mark Tracking"
      },
      "holdings-based-analysis": {
        "description": "View the Holdings Based Analysis report.",
        "title": "Holdings Based Analysis"
      },
      "hurdle-rate-calculation": {
        "description": "View the Hurdle Rate Calculation report.",
        "title": "Hurdle Rate Calculation"
      },
      "ifrs13-fair-value-hierarchy": {
        "description": "View the Ifrs13 Fair Value Hierarchy report.",
        "title": "Ifrs13 Fair Value Hierarchy"
      },
      "ifrs15-revenue-disaggregation": {
        "description": "View the Ifrs15 Revenue Disaggregation report.",
        "title": "Ifrs15 Revenue Disaggregation"
      },
      "ifrs16-lease-schedule": {
        "description": "View the Ifrs16 Lease Schedule report.",
        "title": "Ifrs16 Lease Schedule"
      },
      "ifrs7-financial-instrument-risk": {
        "description": "View the Ifrs7 Financial Instrument Risk report.",
        "title": "Ifrs7 Financial Instrument Risk"
      },
      "ifrs9-ecl-impairment": {
        "description": "View the Ifrs9 Ecl Impairment report.",
        "title": "Ifrs9 Ecl Impairment"
      },
      "impact-measurement": {
        "description": "View the Impact Measurement report.",
        "title": "Impact Measurement"
      },
      "impairment-assessment": {
        "description": "View the Impairment Assessment report.",
        "title": "Impairment Assessment"
      },
      "income-report": {
        "description": "View the Income Report report.",
        "title": "Income Report"
      },
      "income-statement": {
        "description": "View the Income Statement report.",
        "title": "Income Statement"
      },
      "index-performance": {
        "description": "View the Index Performance report.",
        "title": "Index Performance"
      },
      "information-ratio": {
        "description": "View the Information Ratio report.",
        "title": "Information Ratio"
      },
      "intercompany-eliminations": {
        "description": "View the Intercompany Eliminations report.",
        "title": "Intercompany Eliminations"
      },
      "intercompany-loan-tracking": {
        "description": "View the Intercompany Loan Tracking report.",
        "title": "Intercompany Loan Tracking"
      },
      "interim-financial-report": {
        "description": "View the Interim Financial Report report.",
        "title": "Interim Financial Report"
      },
      "ipo-pipeline": {
        "description": "View the Ipo Pipeline report.",
        "title": "Ipo Pipeline"
      },
      "iso20022-messaging": {
        "description": "View the Iso20022 Messaging report.",
        "title": "Iso20022 Messaging"
      },
      "key-metrics-summary": {
        "description": "View the Key Metrics Summary report.",
        "title": "Key Metrics Summary"
      },
      "key-performance-indicators": {
        "description": "View the Key Performance Indicators report.",
        "title": "Key Performance Indicators"
      },
      "kyc-aml-status": {
        "description": "View the Kyc Aml Status report.",
        "title": "Kyc Aml Status"
      },
      "license-compliance": {
        "description": "View the License Compliance report.",
        "title": "License Compliance"
      },
      "liquidity-forecast": {
        "description": "View the Liquidity Forecast report.",
        "title": "Liquidity Forecast"
      },
      "liquidity-risk": {
        "description": "View the Liquidity Risk report.",
        "title": "Liquidity Risk"
      },
      "liquidity-tier-analysis": {
        "description": "View the Liquidity Tier Analysis report.",
        "title": "Liquidity Tier Analysis"
      },
      "loan-portfolio-summary": {
        "description": "View the Loan Portfolio Summary report.",
        "title": "Loan Portfolio Summary"
      },
      "look-through-analysis": {
        "description": "View the Look Through Analysis report.",
        "title": "Look Through Analysis"
      },
      "manual-adjustment-audit": {
        "description": "View the Manual Adjustment Audit report.",
        "title": "Manual Adjustment Audit"
      },
      "manual-intervention-tracking": {
        "description": "View the Manual Intervention Tracking report.",
        "title": "Manual Intervention Tracking"
      },
      "market-capitalization": {
        "description": "View the Market Capitalization report.",
        "title": "Market Capitalization"
      },
      "market-risk-exposure": {
        "description": "View the Market Risk Exposure report.",
        "title": "Market Risk Exposure"
      },
      "market-share-analysis": {
        "description": "View the Market Share Analysis report.",
        "title": "Market Share Analysis"
      },
      "master-feeder-allocation": {
        "description": "View the Master Feeder Allocation report.",
        "title": "Master Feeder Allocation"
      },
      "maturity-ladder": {
        "description": "View the Maturity Ladder report.",
        "title": "Maturity Ladder"
      },
      "mifid-transaction-reporting": {
        "description": "View the Mifid Transaction Reporting report.",
        "title": "Mifid Transaction Reporting"
      },
      "model-validation": {
        "description": "View the Model Validation report.",
        "title": "Model Validation"
      },
      "money-weighted-return": {
        "description": "View the Money Weighted Return report.",
        "title": "Money Weighted Return"
      },
      "monte-carlo-simulation": {
        "description": "View the Monte Carlo Simulation report.",
        "title": "Monte Carlo Simulation"
      },
      "monthly-commentary": {
        "description": "View the Monthly Commentary report.",
        "title": "Monthly Commentary"
      },
      "multi-currency-consolidation": {
        "description": "View the Multi Currency Consolidation report.",
        "title": "Multi Currency Consolidation"
      },
      "multi-entity-consolidation": {
        "description": "View the Multi Entity Consolidation report.",
        "title": "Multi Entity Consolidation"
      },
      "nav-production-status": {
        "description": "View the Nav Production Status report.",
        "title": "Nav Production Status"
      },
      "nepal-advance-tax-calculation": {
        "description": "View the Nepal Advance Tax Calculation report.",
        "title": "Nepal Advance Tax Calculation"
      },
      "nepal-aml-ctr-report": {
        "description": "View the Nepal Aml Ctr Report report.",
        "title": "Nepal Aml Ctr Report"
      },
      "nepal-aml-str-report": {
        "description": "View the Nepal Aml Str Report report.",
        "title": "Nepal Aml Str Report"
      },
      "nepal-annual-return-filing": {
        "description": "View the Nepal Annual Return Filing report.",
        "title": "Nepal Annual Return Filing"
      },
      "nepal-annual-tax-audit": {
        "description": "View the Nepal Annual Tax Audit report.",
        "title": "Nepal Annual Tax Audit"
      },
      "nepal-board-resolution-filing": {
        "description": "View the Nepal Board Resolution Filing report.",
        "title": "Nepal Board Resolution Filing"
      },
      "nepal-capital-gains-tax-report": {
        "description": "View the Nepal Capital Gains Tax Report report.",
        "title": "Nepal Capital Gains Tax Report"
      },
      "nepal-cit-contribution-report": {
        "description": "View the Nepal Cit Contribution Report report.",
        "title": "Nepal Cit Contribution Report"
      },
      "nepal-compliance-audit": {
        "description": "View the Nepal Compliance Audit report.",
        "title": "Nepal Compliance Audit"
      },
      "nepal-customs-duty-report": {
        "description": "View the Nepal Customs Duty Report report.",
        "title": "Nepal Customs Duty Report"
      },
      "nepal-dividend-tax-report": {
        "description": "View the Nepal Dividend Tax Report report.",
        "title": "Nepal Dividend Tax Report"
      },
      "nepal-epf-contribution-report": {
        "description": "View the Nepal Epf Contribution Report report.",
        "title": "Nepal Epf Contribution Report"
      },
      "nepal-excise-duty-report": {
        "description": "View the Nepal Excise Duty Report report.",
        "title": "Nepal Excise Duty Report"
      },
      "nepal-fiscal-year-report": {
        "description": "View the Nepal Fiscal Year Report report.",
        "title": "Nepal Fiscal Year Report"
      },
      "nepal-gratuity-fund-valuation": {
        "description": "View the Nepal Gratuity Fund Valuation report.",
        "title": "Nepal Gratuity Fund Valuation"
      },
      "nepal-internal-audit-report": {
        "description": "View the Nepal Internal Audit Report report.",
        "title": "Nepal Internal Audit Report"
      },
      "nepal-memorandum-amendment-filing": {
        "description": "View the Nepal Memorandum Amendment Filing report.",
        "title": "Nepal Memorandum Amendment Filing"
      },
      "nepal-mutual-fund-distribution": {
        "description": "View the Nepal Mutual Fund Distribution report.",
        "title": "Nepal Mutual Fund Distribution"
      },
      "nepal-mutual-fund-investment-compliance": {
        "description": "View the Nepal Mutual Fund Investment Compliance report.",
        "title": "Nepal Mutual Fund Investment Compliance"
      },
      "nepal-mutual-fund-nav-calculation": {
        "description": "View the Nepal Mutual Fund Nav Calculation report.",
        "title": "Nepal Mutual Fund Nav Calculation"
      },
      "nepal-mutual-fund-unit-holder-report": {
        "description": "View the Nepal Mutual Fund Unit Holder Report report.",
        "title": "Nepal Mutual Fund Unit Holder Report"
      },
      "nepal-nfrs-accounting-policies": {
        "description": "View the Nepal Nfrs Accounting Policies report.",
        "title": "Nepal Nfrs Accounting Policies"
      },
      "nepal-nfrs-borrowing-costs": {
        "description": "View the Nepal Nfrs Borrowing Costs report.",
        "title": "Nepal Nfrs Borrowing Costs"
      },
      "nepal-nfrs-cash-flow": {
        "description": "View the Nepal Nfrs Cash Flow report.",
        "title": "Nepal Nfrs Cash Flow"
      },
      "nepal-nfrs-day-one-gain-loss-deferral": {
        "description": "View the Nepal Nfrs Day One Gain Loss Deferral report.",
        "title": "Nepal Nfrs Day One Gain Loss Deferral"
      },
      "nepal-nfrs-earnings-per-share": {
        "description": "View the Nepal Nfrs Earnings Per Share report.",
        "title": "Nepal Nfrs Earnings Per Share"
      },
      "nepal-nfrs-embedded-derivative-identification": {
        "description": "View the Nepal Nfrs Embedded Derivative Identification report.",
        "title": "Nepal Nfrs Embedded Derivative Identification"
      },
      "nepal-nfrs-employee-benefits": {
        "description": "View the Nepal Nfrs Employee Benefits report.",
        "title": "Nepal Nfrs Employee Benefits"
      },
      "nepal-nfrs-events-after-reporting": {
        "description": "View the Nepal Nfrs Events After Reporting report.",
        "title": "Nepal Nfrs Events After Reporting"
      },
      "nepal-nfrs-fair-value-option-designation": {
        "description": "View the Nepal Nfrs Fair Value Option Designation report.",
        "title": "Nepal Nfrs Fair Value Option Designation"
      },
      "nepal-nfrs-financial-instrument-disclosure": {
        "description": "View the Nepal Nfrs Financial Instrument Disclosure report.",
        "title": "Nepal Nfrs Financial Instrument Disclosure"
      },
      "nepal-nfrs-first-time-adoption-reconciliation": {
        "description": "View the Nepal Nfrs First Time Adoption Reconciliation report.",
        "title": "Nepal Nfrs First Time Adoption Reconciliation"
      },
      "nepal-nfrs-first-time-adoption": {
        "description": "View the Nepal Nfrs First Time Adoption report.",
        "title": "Nepal Nfrs First Time Adoption"
      },
      "nepal-nfrs-foreign-exchange": {
        "description": "View the Nepal Nfrs Foreign Exchange report.",
        "title": "Nepal Nfrs Foreign Exchange"
      },
      "nepal-nfrs-impairment-assets": {
        "description": "View the Nepal Nfrs Impairment Assets report.",
        "title": "Nepal Nfrs Impairment Assets"
      },
      "nepal-nfrs-income-taxes": {
        "description": "View the Nepal Nfrs Income Taxes report.",
        "title": "Nepal Nfrs Income Taxes"
      },
      "nepal-nfrs-intangible-assets": {
        "description": "View the Nepal Nfrs Intangible Assets report.",
        "title": "Nepal Nfrs Intangible Assets"
      },
      "nepal-nfrs-interim-reporting": {
        "description": "View the Nepal Nfrs Interim Reporting report.",
        "title": "Nepal Nfrs Interim Reporting"
      },
      "nepal-nfrs-investment-property": {
        "description": "View the Nepal Nfrs Investment Property report.",
        "title": "Nepal Nfrs Investment Property"
      },
      "nepal-nfrs-presentation-financial-statements": {
        "description": "View the Nepal Nfrs Presentation Financial Statements report.",
        "title": "Nepal Nfrs Presentation Financial Statements"
      },
      "nepal-nfrs-prior-period-restatement": {
        "description": "View the Nepal Nfrs Prior Period Restatement report.",
        "title": "Nepal Nfrs Prior Period Restatement"
      },
      "nepal-nfrs-property-plant-equipment": {
        "description": "View the Nepal Nfrs Property Plant Equipment report.",
        "title": "Nepal Nfrs Property Plant Equipment"
      },
      "nepal-nfrs-provisions-contingencies": {
        "description": "View the Nepal Nfrs Provisions Contingencies report.",
        "title": "Nepal Nfrs Provisions Contingencies"
      },
      "nepal-nfrs-related-party-disclosure": {
        "description": "View the Nepal Nfrs Related Party Disclosure report.",
        "title": "Nepal Nfrs Related Party Disclosure"
      },
      "nepal-nfrs-related-party": {
        "description": "View the Nepal Nfrs Related Party report.",
        "title": "Nepal Nfrs Related Party"
      },
      "nepal-nfrs13-fair-value-hierarchy": {
        "description": "View the Nepal Nfrs13 Fair Value Hierarchy report.",
        "title": "Nepal Nfrs13 Fair Value Hierarchy"
      },
      "nepal-nfrs13-level-transfers": {
        "description": "View the Nepal Nfrs13 Level Transfers report.",
        "title": "Nepal Nfrs13 Level Transfers"
      },
      "nepal-nfrs13-level3-rollforward": {
        "description": "View the Nepal Nfrs13 Level3 Rollforward report.",
        "title": "Nepal Nfrs13 Level3 Rollforward"
      },
      "nepal-nfrs13-unobservable-input-sensitivity": {
        "description": "View the Nepal Nfrs13 Unobservable Input Sensitivity report.",
        "title": "Nepal Nfrs13 Unobservable Input Sensitivity"
      },
      "nepal-nfrs13-valuation-technique": {
        "description": "View the Nepal Nfrs13 Valuation Technique report.",
        "title": "Nepal Nfrs13 Valuation Technique"
      },
      "nepal-nfrs15-revenue-recognition": {
        "description": "View the Nepal Nfrs15 Revenue Recognition report.",
        "title": "Nepal Nfrs15 Revenue Recognition"
      },
      "nepal-nfrs16-lease": {
        "description": "View the Nepal Nfrs16 Lease report.",
        "title": "Nepal Nfrs16 Lease"
      },
      "nepal-nfrs17-insurance-contract": {
        "description": "View the Nepal Nfrs17 Insurance Contract report.",
        "title": "Nepal Nfrs17 Insurance Contract"
      },
      "nepal-nfrs7-collateral-credit-enhancement": {
        "description": "View the Nepal Nfrs7 Collateral Credit Enhancement report.",
        "title": "Nepal Nfrs7 Collateral Credit Enhancement"
      },
      "nepal-nfrs7-credit-concentration": {
        "description": "View the Nepal Nfrs7 Credit Concentration report.",
        "title": "Nepal Nfrs7 Credit Concentration"
      },
      "nepal-nfrs7-maturity-analysis": {
        "description": "View the Nepal Nfrs7 Maturity Analysis report.",
        "title": "Nepal Nfrs7 Maturity Analysis"
      },
      "nepal-nfrs7-transferred-assets-not-derecognized": {
        "description": "View the Nepal Nfrs7 Transferred Assets Not Derecognized report.",
        "title": "Nepal Nfrs7 Transferred Assets Not Derecognized"
      },
      "nepal-nfrs9-business-model-assessment": {
        "description": "View the Nepal Nfrs9 Business Model Assessment report.",
        "title": "Nepal Nfrs9 Business Model Assessment"
      },
      "nepal-nfrs9-classification-measurement": {
        "description": "View the Nepal Nfrs9 Classification Measurement report.",
        "title": "Nepal Nfrs9 Classification Measurement"
      },
      "nepal-nfrs9-ecl-impairment": {
        "description": "View the Nepal Nfrs9 Ecl Impairment report.",
        "title": "Nepal Nfrs9 Ecl Impairment"
      },
      "nepal-nfrs9-ecl-movement-reconciliation": {
        "description": "View the Nepal Nfrs9 Ecl Movement Reconciliation report.",
        "title": "Nepal Nfrs9 Ecl Movement Reconciliation"
      },
      "nepal-nfrs9-ecl-provision-matrix": {
        "description": "View the Nepal Nfrs9 Ecl Provision Matrix report.",
        "title": "Nepal Nfrs9 Ecl Provision Matrix"
      },
      "nepal-nfrs9-ecl-staging-analysis": {
        "description": "View the Nepal Nfrs9 Ecl Staging Analysis report.",
        "title": "Nepal Nfrs9 Ecl Staging Analysis"
      },
      "nepal-nfrs9-hedge-accounting": {
        "description": "View the Nepal Nfrs9 Hedge Accounting report.",
        "title": "Nepal Nfrs9 Hedge Accounting"
      },
      "nepal-nfrs9-impairment-reversal": {
        "description": "View the Nepal Nfrs9 Impairment Reversal report.",
        "title": "Nepal Nfrs9 Impairment Reversal"
      },
      "nepal-nfrs9-modification-gain-loss": {
        "description": "View the Nepal Nfrs9 Modification Gain Loss report.",
        "title": "Nepal Nfrs9 Modification Gain Loss"
      },
      "nepal-nfrs9-sppi-test-assessment": {
        "description": "View the Nepal Nfrs9 Sppi Test Assessment report.",
        "title": "Nepal Nfrs9 Sppi Test Assessment"
      },
      "nepal-pep-screening-report": {
        "description": "View the Nepal Pep Screening Report report.",
        "title": "Nepal Pep Screening Report"
      },
      "nepal-quarterly-advance-tax": {
        "description": "View the Nepal Quarterly Advance Tax report.",
        "title": "Nepal Quarterly Advance Tax"
      },
      "nepal-sanctions-compliance": {
        "description": "View the Nepal Sanctions Compliance report.",
        "title": "Nepal Sanctions Compliance"
      },
      "nepal-share-register-update": {
        "description": "View the Nepal Share Register Update report.",
        "title": "Nepal Share Register Update"
      },
      "nepal-social-security-fund-report": {
        "description": "View the Nepal Social Security Fund Report report.",
        "title": "Nepal Social Security Fund Report"
      },
      "nepal-statutory-audit-report": {
        "description": "View the Nepal Statutory Audit Report report.",
        "title": "Nepal Statutory Audit Report"
      },
      "nepal-tax-audit": {
        "description": "View the Nepal Tax Audit report.",
        "title": "Nepal Tax Audit"
      },
      "nepal-tax-return-preparation": {
        "description": "View the Nepal Tax Return Preparation report.",
        "title": "Nepal Tax Return Preparation"
      },
      "nepal-tds-certificate-tracking": {
        "description": "View the Nepal Tds Certificate Tracking report.",
        "title": "Nepal Tds Certificate Tracking"
      },
      "nepal-vat-return": {
        "description": "View the Nepal Vat Return report.",
        "title": "Nepal Vat Return"
      },
      "nepal-withholding-tax-report": {
        "description": "View the Nepal Withholding Tax Report report.",
        "title": "Nepal Withholding Tax Report"
      },
      "nepse-52-week-high-low": {
        "description": "View the Nepse 52 Week High Low report.",
        "title": "Nepse 52 Week High Low"
      },
      "nepse-block-bulk-deals": {
        "description": "View the Nepse Block Bulk Deals report.",
        "title": "Nepse Block Bulk Deals"
      },
      "nepse-broker-transaction": {
        "description": "View the Nepse Broker Transaction report.",
        "title": "Nepse Broker Transaction"
      },
      "nepse-daily-trading-summary": {
        "description": "View the Nepse Daily Trading Summary report.",
        "title": "Nepse Daily Trading Summary"
      },
      "nepse-index-composition": {
        "description": "View the Nepse Index Composition report.",
        "title": "Nepse Index Composition"
      },
      "nepse-margin-trading-exposure": {
        "description": "View the Nepse Margin Trading Exposure report.",
        "title": "Nepse Margin Trading Exposure"
      },
      "nepse-market-depth": {
        "description": "View the Nepse Market Depth report.",
        "title": "Nepse Market Depth"
      },
      "nepse-sector-performance": {
        "description": "View the Nepse Sector Performance report.",
        "title": "Nepse Sector Performance"
      },
      "nepse-settlement-obligation": {
        "description": "View the Nepse Settlement Obligation report.",
        "title": "Nepse Settlement Obligation"
      },
      "nepse-short-sale-disclosure": {
        "description": "View the Nepse Short Sale Disclosure report.",
        "title": "Nepse Short Sale Disclosure"
      },
      "nrb-agriculture-lending": {
        "description": "View the Nrb Agriculture Lending report.",
        "title": "Nrb Agriculture Lending"
      },
      "nrb-aml-suspicious-transaction": {
        "description": "View the Nrb Aml Suspicious Transaction report.",
        "title": "Nrb Aml Suspicious Transaction"
      },
      "nrb-base-rate-calculation": {
        "description": "View the Nrb Base Rate Calculation report.",
        "title": "Nrb Base Rate Calculation"
      },
      "nrb-capital-adequacy-basel": {
        "description": "View the Nrb Capital Adequacy Basel report.",
        "title": "Nrb Capital Adequacy Basel"
      },
      "nrb-crr-slr-compliance": {
        "description": "View the Nrb Crr Slr Compliance report.",
        "title": "Nrb Crr Slr Compliance"
      },
      "nrb-deprived-sector-lending": {
        "description": "View the Nrb Deprived Sector Lending report.",
        "title": "Nrb Deprived Sector Lending"
      },
      "nrb-energy-lending": {
        "description": "View the Nrb Energy Lending report.",
        "title": "Nrb Energy Lending"
      },
      "nrb-forex-position": {
        "description": "View the Nrb Forex Position report.",
        "title": "Nrb Forex Position"
      },
      "nrb-ict-risk-assessment": {
        "description": "View the Nrb Ict Risk Assessment report.",
        "title": "Nrb Ict Risk Assessment"
      },
      "nrb-interest-rate-risk": {
        "description": "View the Nrb Interest Rate Risk report.",
        "title": "Nrb Interest Rate Risk"
      },
      "nrb-interest-rate-spread": {
        "description": "View the Nrb Interest Rate Spread report.",
        "title": "Nrb Interest Rate Spread"
      },
      "nrb-large-exposure": {
        "description": "View the Nrb Large Exposure report.",
        "title": "Nrb Large Exposure"
      },
      "nrb-liquidity-coverage": {
        "description": "View the Nrb Liquidity Coverage report.",
        "title": "Nrb Liquidity Coverage"
      },
      "nrb-loan-loss-provisioning": {
        "description": "View the Nrb Loan Loss Provisioning report.",
        "title": "Nrb Loan Loss Provisioning"
      },
      "nrb-mfi-reporting": {
        "description": "View the Nrb Mfi Reporting report.",
        "title": "Nrb Mfi Reporting"
      },
      "nrb-net-stable-funding": {
        "description": "View the Nrb Net Stable Funding report.",
        "title": "Nrb Net Stable Funding"
      },
      "nrb-npa-aging": {
        "description": "View the Nrb Npa Aging report.",
        "title": "Nrb Npa Aging"
      },
      "nrb-priority-sector-lending": {
        "description": "View the Nrb Priority Sector Lending report.",
        "title": "Nrb Priority Sector Lending"
      },
      "nrb-refinancing-report": {
        "description": "View the Nrb Refinancing Report report.",
        "title": "Nrb Refinancing Report"
      },
      "nrb-related-party-lending": {
        "description": "View the Nrb Related Party Lending report.",
        "title": "Nrb Related Party Lending"
      },
      "nrb-remittance": {
        "description": "View the Nrb Remittance report.",
        "title": "Nrb Remittance"
      },
      "nrb-sectoral-lending": {
        "description": "View the Nrb Sectoral Lending report.",
        "title": "Nrb Sectoral Lending"
      },
      "nrb-stress-test": {
        "description": "View the Nrb Stress Test report.",
        "title": "Nrb Stress Test"
      },
      "nrb-tourism-lending": {
        "description": "View the Nrb Tourism Lending report.",
        "title": "Nrb Tourism Lending"
      },
      "nrb-wholesale-lending": {
        "description": "View the Nrb Wholesale Lending report.",
        "title": "Nrb Wholesale Lending"
      },
      "operational-cost-per-trade": {
        "description": "View the Operational Cost Per Trade report.",
        "title": "Operational Cost Per Trade"
      },
      "operational-risk-events": {
        "description": "View the Operational Risk Events report.",
        "title": "Operational Risk Events"
      },
      "ops-break-report": {
        "description": "View the Ops Break Report report.",
        "title": "Ops Break Report"
      },
      "ops-daily-checklist": {
        "description": "View the Ops Daily Checklist report.",
        "title": "Ops Daily Checklist"
      },
      "ops-sla-dashboard": {
        "description": "View the Ops Sla Dashboard report.",
        "title": "Ops Sla Dashboard"
      },
      "ops-team-productivity": {
        "description": "View the Ops Team Productivity report.",
        "title": "Ops Team Productivity"
      },
      "ops-vendor-performance": {
        "description": "View the Ops Vendor Performance report.",
        "title": "Ops Vendor Performance"
      },
      "optimization-results": {
        "description": "View the Optimization Results report.",
        "title": "Optimization Results"
      },
      "option-greeks": {
        "description": "View the Option Greeks report.",
        "title": "Option Greeks"
      },
      "overlay-exposure": {
        "description": "View the Overlay Exposure report.",
        "title": "Overlay Exposure"
      },
      "peer-comparison": {
        "description": "View the Peer Comparison report.",
        "title": "Peer Comparison"
      },
      "performance-fee-calculation": {
        "description": "View the Performance Fee Calculation report.",
        "title": "Performance Fee Calculation"
      },
      "personal-account-dealing": {
        "description": "View the Personal Account Dealing report.",
        "title": "Personal Account Dealing"
      },
      "pm-attribution-report": {
        "description": "View the Pm Attribution Report report.",
        "title": "Pm Attribution Report"
      },
      "pm-cash-management": {
        "description": "View the Pm Cash Management report.",
        "title": "Pm Cash Management"
      },
      "pm-daily-report": {
        "description": "View the Pm Daily Report report.",
        "title": "Pm Daily Report"
      },
      "pm-risk-report": {
        "description": "View the Pm Risk Report report.",
        "title": "Pm Risk Report"
      },
      "pm-trade-idea-tracking": {
        "description": "View the Pm Trade Idea Tracking report.",
        "title": "Pm Trade Idea Tracking"
      },
      "policy-exception-report": {
        "description": "View the Policy Exception Report report.",
        "title": "Policy Exception Report"
      },
      "portfolio-performance": {
        "description": "View the Portfolio Performance report.",
        "title": "Portfolio Performance"
      },
      "position-limit-monitoring": {
        "description": "View the Position Limit Monitoring report.",
        "title": "Position Limit Monitoring"
      },
      "price-history": {
        "description": "View the Price History report.",
        "title": "Price History"
      },
      "private-equity-valuation": {
        "description": "View the Private Equity Valuation report.",
        "title": "Private Equity Valuation"
      },
      "product-performance-analysis": {
        "description": "View the Product Performance Analysis report.",
        "title": "Product Performance Analysis"
      },
      "profitability-by-client": {
        "description": "View the Profitability By Client report.",
        "title": "Profitability By Client"
      },
      "profitability-by-strategy": {
        "description": "View the Profitability By Strategy report.",
        "title": "Profitability By Strategy"
      },
      "proxy-voting-report": {
        "description": "View the Proxy Voting Report report.",
        "title": "Proxy Voting Report"
      },
      "quarterly-investment-review": {
        "description": "View the Quarterly Investment Review report.",
        "title": "Quarterly Investment Review"
      },
      "real-estate-valuation": {
        "description": "View the Real Estate Valuation report.",
        "title": "Real Estate Valuation"
      },
      "realized-unrealized-pnl": {
        "description": "View the Realized Unrealized Pnl report.",
        "title": "Realized Unrealized Pnl"
      },
      "rebalancing-recommendation": {
        "description": "View the Rebalancing Recommendation report.",
        "title": "Rebalancing Recommendation"
      },
      "reconciliation-summary": {
        "description": "View the Reconciliation Summary report.",
        "title": "Reconciliation Summary"
      },
      "reference-data-change-log": {
        "description": "View the Reference Data Change Log report.",
        "title": "Reference Data Change Log"
      },
      "regulatory-change-impact": {
        "description": "View the Regulatory Change Impact report.",
        "title": "Regulatory Change Impact"
      },
      "regulatory-examination-package": {
        "description": "View the Regulatory Examination Package report.",
        "title": "Regulatory Examination Package"
      },
      "regulatory-filing-calendar": {
        "description": "View the Regulatory Filing Calendar report.",
        "title": "Regulatory Filing Calendar"
      },
      "related-party-transactions": {
        "description": "View the Related Party Transactions report.",
        "title": "Related Party Transactions"
      },
      "report-distribution-log": {
        "description": "View the Report Distribution Log report.",
        "title": "Report Distribution Log"
      },
      "restricted-list-compliance": {
        "description": "View the Restricted List Compliance report.",
        "title": "Restricted List Compliance"
      },
      "returns-based-analysis": {
        "description": "View the Returns Based Analysis report.",
        "title": "Returns Based Analysis"
      },
      "revenue-recognition": {
        "description": "View the Revenue Recognition report.",
        "title": "Revenue Recognition"
      },
      "risk-adjusted-return": {
        "description": "View the Risk Adjusted Return report.",
        "title": "Risk Adjusted Return"
      },
      "risk-appetite-dashboard": {
        "description": "View the Risk Appetite Dashboard report.",
        "title": "Risk Appetite Dashboard"
      },
      "risk-limit-utilization": {
        "description": "View the Risk Limit Utilization report.",
        "title": "Risk Limit Utilization"
      },
      "rm-client-activity-summary": {
        "description": "View the Rm Client Activity Summary report.",
        "title": "Rm Client Activity Summary"
      },
      "rm-client-meeting-notes": {
        "description": "View the Rm Client Meeting Notes report.",
        "title": "Rm Client Meeting Notes"
      },
      "rm-client-portfolio-overview": {
        "description": "View the Rm Client Portfolio Overview report.",
        "title": "Rm Client Portfolio Overview"
      },
      "rm-client-satisfaction-survey": {
        "description": "View the Rm Client Satisfaction Survey report.",
        "title": "Rm Client Satisfaction Survey"
      },
      "rm-cross-sell-opportunities": {
        "description": "View the Rm Cross Sell Opportunities report.",
        "title": "Rm Cross Sell Opportunities"
      },
      "rolling-performance": {
        "description": "View the Rolling Performance report.",
        "title": "Rolling Performance"
      },
      "sanctions-screening": {
        "description": "View the Sanctions Screening report.",
        "title": "Sanctions Screening"
      },
      "scenario-analysis": {
        "description": "View the Scenario Analysis report.",
        "title": "Scenario Analysis"
      },
      "scheduled-report-status": {
        "description": "View the Scheduled Report Status report.",
        "title": "Scheduled Report Status"
      },
      "sebon-annual-audit": {
        "description": "View the Sebon Annual Audit report.",
        "title": "Sebon Annual Audit"
      },
      "sebon-circuit-breaker-report": {
        "description": "View the Sebon Circuit Breaker Report report.",
        "title": "Sebon Circuit Breaker Report"
      },
      "sebon-client-account-segregation": {
        "description": "View the Sebon Client Account Segregation report.",
        "title": "Sebon Client Account Segregation"
      },
      "sebon-credit-rating-report": {
        "description": "View the Sebon Credit Rating Report report.",
        "title": "Sebon Credit Rating Report"
      },
      "sebon-daily-trading": {
        "description": "View the Sebon Daily Trading report.",
        "title": "Sebon Daily Trading"
      },
      "sebon-debenture-trustee-report": {
        "description": "View the Sebon Debenture Trustee Report report.",
        "title": "Sebon Debenture Trustee Report"
      },
      "sebon-dmat-account-verification": {
        "description": "View the Sebon Dmat Account Verification report.",
        "title": "Sebon Dmat Account Verification"
      },
      "sebon-foreign-investment-report": {
        "description": "View the Sebon Foreign Investment Report report.",
        "title": "Sebon Foreign Investment Report"
      },
      "sebon-insider-trading-surveillance": {
        "description": "View the Sebon Insider Trading Surveillance report.",
        "title": "Sebon Insider Trading Surveillance"
      },
      "sebon-issue-manager-report": {
        "description": "View the Sebon Issue Manager Report report.",
        "title": "Sebon Issue Manager Report"
      },
      "sebon-margin-trading-disclosure": {
        "description": "View the Sebon Margin Trading Disclosure report.",
        "title": "Sebon Margin Trading Disclosure"
      },
      "sebon-market-maker-obligation": {
        "description": "View the Sebon Market Maker Obligation report.",
        "title": "Sebon Market Maker Obligation"
      },
      "sebon-market-manipulation-detection": {
        "description": "View the Sebon Market Manipulation Detection report.",
        "title": "Sebon Market Manipulation Detection"
      },
      "sebon-monthly-compliance": {
        "description": "View the Sebon Monthly Compliance report.",
        "title": "Sebon Monthly Compliance"
      },
      "sebon-mutual-fund-nav": {
        "description": "View the Sebon Mutual Fund Nav report.",
        "title": "Sebon Mutual Fund Nav"
      },
      "sebon-net-capital-adequacy": {
        "description": "View the Sebon Net Capital Adequacy report.",
        "title": "Sebon Net Capital Adequacy"
      },
      "sebon-online-trading-compliance": {
        "description": "View the Sebon Online Trading Compliance report.",
        "title": "Sebon Online Trading Compliance"
      },
      "sebon-portfolio-manager-quarterly": {
        "description": "View the Sebon Portfolio Manager Quarterly report.",
        "title": "Sebon Portfolio Manager Quarterly"
      },
      "sebon-prospectus-filing": {
        "description": "View the Sebon Prospectus Filing report.",
        "title": "Sebon Prospectus Filing"
      },
      "sebon-quarterly-financial": {
        "description": "View the Sebon Quarterly Financial report.",
        "title": "Sebon Quarterly Financial"
      },
      "sebon-share-registrar-report": {
        "description": "View the Sebon Share Registrar Report report.",
        "title": "Sebon Share Registrar Report"
      },
      "sebon-short-selling-report": {
        "description": "View the Sebon Short Selling Report report.",
        "title": "Sebon Short Selling Report"
      },
      "sebon-underwriter-quarterly": {
        "description": "View the Sebon Underwriter Quarterly report.",
        "title": "Sebon Underwriter Quarterly"
      },
      "sector-attribution": {
        "description": "View the Sector Attribution report.",
        "title": "Sector Attribution"
      },
      "sector-exposure": {
        "description": "View the Sector Exposure report.",
        "title": "Sector Exposure"
      },
      "sector-performance": {
        "description": "View the Sector Performance report.",
        "title": "Sector Performance"
      },
      "security-attribution": {
        "description": "View the Security Attribution report.",
        "title": "Security Attribution"
      },
      "security-incident-report": {
        "description": "View the Security Incident Report report.",
        "title": "Security Incident Report"
      },
      "segment-reporting": {
        "description": "View the Segment Reporting report.",
        "title": "Segment Reporting"
      },
      "series-class-accounting": {
        "description": "View the Series Class Accounting report.",
        "title": "Series Class Accounting"
      },
      "settlement-status": {
        "description": "View the Settlement Status report.",
        "title": "Settlement Status"
      },
      "sfdr-classification": {
        "description": "View the Sfdr Classification report.",
        "title": "Sfdr Classification"
      },
      "share-based-payment-valuation": {
        "description": "View the Share Based Payment Valuation report.",
        "title": "Share Based Payment Valuation"
      },
      "shareholder-letter": {
        "description": "View the Shareholder Letter report.",
        "title": "Shareholder Letter"
      },
      "sharpe-ratio-analysis": {
        "description": "View the Sharpe Ratio Analysis report.",
        "title": "Sharpe Ratio Analysis"
      },
      "side-pocket-valuation": {
        "description": "View the Side Pocket Valuation report.",
        "title": "Side Pocket Valuation"
      },
      "sla-compliance": {
        "description": "View the Sla Compliance report.",
        "title": "Sla Compliance"
      },
      "sortino-ratio": {
        "description": "View the Sortino Ratio report.",
        "title": "Sortino Ratio"
      },
      "spread-analysis": {
        "description": "View the Spread Analysis report.",
        "title": "Spread Analysis"
      },
      "statement-of-changes-in-equity": {
        "description": "View the Statement Of Changes In Equity report.",
        "title": "Statement Of Changes In Equity"
      },
      "straight-through-processing-rate": {
        "description": "View the Straight Through Processing Rate report.",
        "title": "Straight Through Processing Rate"
      },
      "stress-test-results": {
        "description": "View the Stress Test Results report.",
        "title": "Stress Test Results"
      },
      "structured-product-valuation": {
        "description": "View the Structured Product Valuation report.",
        "title": "Structured Product Valuation"
      },
      "style-analysis": {
        "description": "View the Style Analysis report.",
        "title": "Style Analysis"
      },
      "sustainable-investment-allocation": {
        "description": "View the Sustainable Investment Allocation report.",
        "title": "Sustainable Investment Allocation"
      },
      "swap-valuation": {
        "description": "View the Swap Valuation report.",
        "title": "Swap Valuation"
      },
      "system-availability": {
        "description": "View the System Availability report.",
        "title": "System Availability"
      },
      "system-performance-metrics": {
        "description": "View the System Performance Metrics report.",
        "title": "System Performance Metrics"
      },
      "tail-risk-analysis": {
        "description": "View the Tail Risk Analysis report.",
        "title": "Tail Risk Analysis"
      },
      "tax-loss-harvesting": {
        "description": "View the Tax Loss Harvesting report.",
        "title": "Tax Loss Harvesting"
      },
      "tcfd-climate-risk": {
        "description": "View the Tcfd Climate Risk report.",
        "title": "Tcfd Climate Risk"
      },
      "time-weighted-return": {
        "description": "View the Time Weighted Return report.",
        "title": "Time Weighted Return"
      },
      "tracking-error": {
        "description": "View the Tracking Error report.",
        "title": "Tracking Error"
      },
      "trade-execution-summary": {
        "description": "View the Trade Execution Summary report.",
        "title": "Trade Execution Summary"
      },
      "trade-surveillance": {
        "description": "View the Trade Surveillance report.",
        "title": "Trade Surveillance"
      },
      "treasury-management": {
        "description": "View the Treasury Management report.",
        "title": "Treasury Management"
      },
      "trial-balance": {
        "description": "View the Trial Balance report.",
        "title": "Trial Balance"
      },
      "upside-downside-capture": {
        "description": "View the Upside Downside Capture report.",
        "title": "Upside Downside Capture"
      },
      "user-activity": {
        "description": "View the User Activity report.",
        "title": "User Activity"
      },
      "var-report": {
        "description": "View the Var Report report.",
        "title": "Var Report"
      },
      "vendor-data-quality": {
        "description": "View the Vendor Data Quality report.",
        "title": "Vendor Data Quality"
      },
      "vendor-expense-tracking": {
        "description": "View the Vendor Expense Tracking report.",
        "title": "Vendor Expense Tracking"
      },
      "vendor-risk-assessment": {
        "description": "View the Vendor Risk Assessment report.",
        "title": "Vendor Risk Assessment"
      },
      "volatility-surface": {
        "description": "View the Volatility Surface report.",
        "title": "Volatility Surface"
      },
      "volume-analysis": {
        "description": "View the Volume Analysis report.",
        "title": "Volume Analysis"
      },
      "what-if-analysis": {
        "description": "View the What If Analysis report.",
        "title": "What If Analysis"
      },
      "workflow-status": {
        "description": "View the Workflow Status report.",
        "title": "Workflow Status"
      },
      "working-capital-analysis": {
        "description": "View the Working Capital Analysis report.",
        "title": "Working Capital Analysis"
      },
      "year-end-tax-package": {
        "description": "View the Year End Tax Package report.",
        "title": "Year End Tax Package"
      },
      "yield-analysis": {
        "description": "View the Yield Analysis report.",
        "title": "Yield Analysis"
      },
      "yield-curve-analysis": {
        "description": "View the Yield Curve Analysis report.",
        "title": "Yield Curve Analysis"
      }
    },
    "errors": {
      "notFoundTitle": "Report Not Found",
      "notFoundDescription": "The requested report could not be found.",
      "missingReportId": "Missing report ID",
      "missingReportIdDescription": "No report ID was provided in the URL.",
      "invalidReportId": "Invalid Report ID",
      "invalidReportIdDescription": "The report \"{{reportId}}\" is not a valid report. Please navigate from the reports hub.",
      "unauthorizedTitle": "Report access denied",
      "unauthorizedDescription": "You do not have access to this report route for the current organization context.",
      "unauthorizedAuditDescription": "You do not have access to view audit trails for this report. Audit access requires both report permissions and audit view permissions."
    },
    "trust": {
      "verified": "Verified",
      "warning": "Trust warning",
      "error": "Trust error"
    },
    "card": {
      "badges": {
        "exportReady": "Export ready",
        "viewOnly": "View only",
        "issueCount": "{{count}} issues"
      },
      "actions": {
        "reviewReadiness": "Review report readiness",
        "reviewStatus": "Review report status",
        "remediate": "Resolve issue"
      },
      "snapshot": {
        "issues": "Issues",
        "status": "Status"
      }
    },
    "statusPage": {
      "title": "Report status",
      "description": "Review availability, trust, and remediation guidance for all report routes.",
      "errorTitle": "Report status unavailable",
      "errorDescription": "Unable to load report status. Retry after confirming report registry connectivity.",
      "summary": {
        "total": "Total reports",
        "available": "Available",
        "locked": "Locked",
        "unavailable": "Unavailable"
      },
      "trustSummary": "Trust signals detected: {{warnings}} warning(s), {{errors}} error(s). Review affected reports before distribution.",
      "table": {
        "title": "Registry status by report",
        "report": "Report",
        "availability": "Availability",
        "trust": "Trust",
        "remediation": "Remediation"
      },
      "empty": "No reports are currently registered for this scope.",
      "none": "None",
      "legend": {
        "available": "Available",
        "availableDescription": "Route is accessible and report data is ready.",
        "locked": "Locked",
        "lockedDescription": "Route exists but requires tier upgrade or additional permission.",
        "unavailable": "Unavailable",
        "unavailableDescription": "Route or source data is not currently available for this report."
      },
      "fallback": {
        "statusNotChecked": "Status not checked",
        "statusUnavailable": "Status unavailable",
        "reportTitle": "Report {{reportId}}",
        "trustSummary": "Trust signals detected: {{warnings}} warning(s), {{errors}} error(s). Review affected reports before distribution."
      }
    },
    "overview": "Overview",
    "portfolioHoldings": "Portfolio Holdings",
    "transactionsLots": "Transactions Lots",
    "gainLossTax": "Gain Loss Tax",
    "monthlyAnalytics": "Monthly Analytics",
    "nepalNfrs": "Nepal NFRS",
    "qualityAuditExports": "Quality Audit Exports",
    "reportCategories": "Report Categories",
    "registry": {
      "fallback": {
        "description": "Fallback description"
      }
    },
    "month": "Month",
    "year": "Year",
    "company": "Company",
    "purchaseQty": "Purchase Qty",
    "purchaseAmount": "Purchase Amount",
    "salesQty": "Sales Qty",
    "salesAmount": "Sales Amount",
    "closingUnits": "Closing Units",
    "wacc": "Wacc",
    "realizedPL": "Realized P L",
    "netTradeAmount": "Net Trade Amount",
    "date": "Date",
    "type": "Type",
    "symbol": "Symbol",
    "quantity": "Quantity",
    "price": "Price",
    "totalAmount": "Total Amount",
    "commission": "Commission",
    "grossSaleProceeds": "Gross Sale Proceeds",
    "purchasesMinusSales": "Purchases Minus Sales",
    "activeCompanies": "Active Companies",
    "uniqueHoldings": "Unique Holdings",
    "monthlyFilterTitle": "Monthly Filter",
    "monthlyFilterDescription": "Monthly Filter description",
    "selectMonth": "Select Month",
    "portfolioActivityDesc": "Portfolio Activity",
    "noMonthlyData": "No Monthly Data",
    "purchaseQuantity": "Purchase Quantity",
    "salesQuantity": "Sales Quantity",
    "waccNfrs": "Wacc Nfrs",
    "backingTransactions": "Backing Transactions",
    "loadingTransactions": "Loading Transactions",
    "noTransactionsMatch": "No Transactions Match",
    "failedToLoadPerformanceBreakdown": "Failed To Load Performance Breakdown",
    "na": "Na",
    "sector": "Sector",
    "secondary": "Secondary",
    "timeDimension": "Time Dimension",
    "byYear": "By Year",
    "byMonth": "By Month",
    "dateRange": "Date Range",
    "secondaryGroup": "Secondary Group",
    "from": "From",
    "to": "To",
    "symbolPlaceholder": "Symbol",
    "sectorPlaceholder": "Sector",
    "performanceBy": "Performance By",
    "returnFormula": "Return Formula",
    "totalInvestment": "Total Investment",
    "portfolioValue": "Portfolio Value",
    "realizedGain": "Realized Gain",
    "soldCostBasis": "Sold Cost Basis",
    "realizedReturnPct": "Realized Return Pct",
    "unrealizedGain": "Unrealized Gain",
    "returnPct": "Return Pct",
    "noResultsMatch": "No Results Match",
    "capitalGainTax": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "instrument": "Instrument",
      "instrumentDesc": "Instrument",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "holdingPeriod": "Holding Period",
      "holdingPeriodDesc": "Holding Period",
      "saleDate": "Sale Date",
      "saleDateDesc": "Sale Date",
      "client": "Client",
      "clientDesc": "Client",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "instrumentName": "Instrument Name",
      "instrumentNameDesc": "Instrument Name",
      "quantity": "Quantity",
      "quantityDesc": "Quantity",
      "capitalGain": "Capital Gain",
      "capitalGainDesc": "Capital Gain",
      "cgtRate": "CGT Rate",
      "cgtRateDesc": "CGT Rate",
      "cgt": "CGT",
      "cgtDesc": "CGT",
      "grossProceeds": "Gross Proceeds",
      "grossProceedsDesc": "Gross Proceeds",
      "taxCostBasis": "Tax Cost Basis",
      "taxCostBasisDesc": "Tax Cost Basis",
      "deductibleSellingCharges": "Deductible Selling Charges",
      "deductibleSellingChargesDesc": "Deductible Selling Charges",
      "nonDeductibleSellingCharges": "Non Deductible Selling Charges",
      "nonDeductibleSellingChargesDesc": "Non Deductible Selling Charges",
      "taxableCapitalGain": "Taxable Capital Gain",
      "taxableCapitalGainDesc": "Taxable Capital Gain",
      "holdingPeriodDays": "Holding Period Days",
      "holdingPeriodDaysDesc": "Holding Period Days",
      "holdingPeriodBucket": "Holding Period Bucket",
      "holdingPeriodBucketDesc": "Holding Period Bucket",
      "investorType": "Investor Type",
      "investorTypeDesc": "Investor Type",
      "rateSource": "Rate Source",
      "rateSourceDesc": "Rate Source",
      "rateVersion": "Rate Version",
      "rateVersionDesc": "Rate Version",
      "costBasisMethod": "Cost Basis Method",
      "costBasisMethodDesc": "Cost Basis Method",
      "calculationSource": "Calculation Source",
      "calculationSourceDesc": "Calculation Source",
      "sourcePriceDate": "Source Price Date",
      "sourcePriceDateDesc": "Source Price Date",
      "brokerNo": "Broker No",
      "brokerNoDesc": "Broker No",
      "totalCapitalGain": "Total Capital Gain",
      "totalCapitalGainDesc": "Total Capital Gain",
      "totalCgt": "Total Cgt",
      "totalCgtDesc": "Total Cgt",
      "disposalCount": "Disposal Count",
      "disposalCountDesc": "Disposal Count",
      "averageCgtRate": "Average Cgt Rate",
      "averageCgtRateDesc": "Average Cgt Rate"
    },
    "companyStatement": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "instrumentSymbol": "Instrument Symbol",
      "instrumentSymbolDesc": "Instrument Symbol",
      "asOfDate": "As Of Date",
      "asOfDateDesc": "As Of Date",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "includeUnapproved": "Include Unapproved",
      "includeUnapprovedDesc": "Include Unapproved",
      "transactionDate": "Transaction Date",
      "transactionDateDesc": "Transaction Date",
      "transactionType": "Transaction Type",
      "transactionTypeDesc": "Transaction Type",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "purchaseQuantity": "Purchase Quantity",
      "purchaseQuantityDesc": "Purchase Quantity",
      "purchaseAmount": "Purchase Amount",
      "purchaseAmountDesc": "Purchase Amount",
      "salesQuantity": "Sales Quantity",
      "salesQuantityDesc": "Sales Quantity",
      "salesAmount": "Sales Amount",
      "salesAmountDesc": "Sales Amount",
      "plNfrs": "P&L (NFRS)",
      "plNfrsDesc": "P&L (NFRS)",
      "netReceivables": "Net Receivables",
      "netReceivablesDesc": "Net Receivables",
      "status": "Status",
      "statusDesc": "Status",
      "totalPurchaseAmount": "Total Purchase Amount",
      "totalPurchaseAmountDesc": "Total Purchase Amount",
      "totalSalesAmount": "Total Sales Amount",
      "totalSalesAmountDesc": "Total Sales Amount",
      "totalPrincipalCostNfrs": "Total Principal Cost (NFRS)",
      "totalPrincipalCostNfrsDesc": "Total Principal Cost (NFRS)",
      "totalPlNfrs": "Total P&L (NFRS)",
      "totalPlNfrsDesc": "Total P&L (NFRS)",
      "totalNetReceivables": "Total Net Receivables",
      "totalNetReceivablesDesc": "Total Net Receivables",
      "transactionCount": "Transaction Count",
      "transactionCountDesc": "Transaction Count"
    },
    "concentration": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "portfolioAccount": "Portfolio Account",
      "portfolioAccountDesc": "Portfolio Account",
      "asOfDate": "As Of Date",
      "asOfDateDesc": "As Of Date",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "name": "Name",
      "nameDesc": "Name",
      "sector": "Sector",
      "sectorDesc": "Sector",
      "quantity": "Quantity",
      "quantityDesc": "Quantity",
      "marketValue": "Market Value",
      "marketValueDesc": "Market Value",
      "allocationPercent": "Allocation Percent",
      "allocationPercentDesc": "Allocation Percent",
      "riskLevel": "Risk Level",
      "riskLevelDesc": "Risk Level",
      "totalMarketValue": "Total Market Value",
      "totalMarketValueDesc": "Total Market Value",
      "top10Concentration": "Top10 Concentration",
      "top10ConcentrationDesc": "Top10 Concentration"
    },
    "fifoVsNfrs": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "instrument": "Instrument",
      "instrumentDesc": "Instrument",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "client": "Client",
      "clientDesc": "Client",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "instrumentName": "Instrument Name",
      "instrumentNameDesc": "Instrument Name",
      "fifoCostBasis": "Fifo Cost Basis",
      "fifoCostBasisDesc": "Fifo Cost Basis",
      "nfrsCostBasis": "Nfrs Cost Basis",
      "nfrsCostBasisDesc": "Nfrs Cost Basis",
      "costBasisDiff": "Cost Basis Diff",
      "costBasisDiffDesc": "Cost Basis Diff",
      "costBasisDiffPct": "Cost Basis Diff Pct",
      "costBasisDiffPctDesc": "Cost Basis Diff Pct",
      "fifoUnrealizedGainLoss": "Fifo Unrealized Gain Loss",
      "fifoUnrealizedGainLossDesc": "Fifo Unrealized Gain Loss",
      "nfrsUnrealizedGainLoss": "Nfrs Unrealized Gain Loss",
      "nfrsUnrealizedGainLossDesc": "Nfrs Unrealized Gain Loss",
      "unrealizedGainLossDiff": "Unrealized Gain Loss Diff",
      "unrealizedGainLossDiffDesc": "Unrealized Gain Loss Diff",
      "reconciliationStatus": "Reconciliation Status",
      "reconciliationStatusDesc": "Reconciliation Status",
      "totalFifoCostBasis": "Total Fifo Cost Basis",
      "totalFifoCostBasisDesc": "Total Fifo Cost Basis",
      "totalNfrsCostBasis": "Total Nfrs Cost Basis",
      "totalNfrsCostBasisDesc": "Total Nfrs Cost Basis",
      "totalCostBasisDiff": "Total Cost Basis Diff",
      "totalCostBasisDiffDesc": "Total Cost Basis Diff",
      "totalFifoUnrealizedGainLoss": "Total Fifo Unrealized Gain Loss",
      "totalFifoUnrealizedGainLossDesc": "Total Fifo Unrealized Gain Loss",
      "totalNfrsUnrealizedGainLoss": "Total Nfrs Unrealized Gain Loss",
      "totalNfrsUnrealizedGainLossDesc": "Total Nfrs Unrealized Gain Loss",
      "reconciledPositions": "Reconciled Positions",
      "reconciledPositionsDesc": "Reconciled Positions",
      "unreconciledPositions": "Unreconciled Positions",
      "unreconciledPositionsDesc": "Unreconciled Positions"
    },
    "monthlyMovement": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "instrument": "Instrument",
      "instrumentDesc": "Instrument",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "month": "Month",
      "monthDesc": "Month",
      "client": "Client",
      "clientDesc": "Client",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "instrumentName": "Instrument Name",
      "instrumentNameDesc": "Instrument Name",
      "openingQuantity": "Opening Quantity",
      "openingQuantityDesc": "Opening Quantity",
      "purchases": "Purchases",
      "purchasesDesc": "Purchases",
      "sales": "Sales",
      "salesDesc": "Sales",
      "closingQuantity": "Closing Quantity",
      "closingQuantityDesc": "Closing Quantity",
      "openingValue": "Opening Value",
      "openingValueDesc": "Opening Value",
      "purchaseValue": "Purchase Value",
      "purchaseValueDesc": "Purchase Value",
      "saleValue": "Sale Value",
      "saleValueDesc": "Sale Value",
      "closingValue": "Closing Value",
      "closingValueDesc": "Closing Value",
      "netMovement": "Net Movement",
      "netMovementDesc": "Net Movement",
      "netMovementPct": "Net Movement Pct",
      "netMovementPctDesc": "Net Movement Pct",
      "totalPurchases": "Total Purchases",
      "totalPurchasesDesc": "Total Purchases",
      "totalSales": "Total Sales",
      "totalSalesDesc": "Total Sales",
      "totalNetMovement": "Total Net Movement",
      "totalNetMovementDesc": "Total Net Movement",
      "totalClosingValue": "Total Closing Value",
      "totalClosingValueDesc": "Total Closing Value"
    },
    "nfrsDashboard": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "instrument": "Instrument",
      "instrumentDesc": "Instrument",
      "asOfDate": "As Of Date",
      "asOfDateDesc": "As Of Date",
      "client": "Client",
      "clientDesc": "Client",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "instrumentName": "Instrument Name",
      "instrumentNameDesc": "Instrument Name",
      "quantity": "Quantity",
      "quantityDesc": "Quantity",
      "nfrsCostPerUnit": "Nfrs Cost Per Unit",
      "nfrsCostPerUnitDesc": "Nfrs Cost Per Unit",
      "nfrsTotalCost": "Nfrs Total Cost",
      "nfrsTotalCostDesc": "Nfrs Total Cost",
      "marketPrice": "Market Price",
      "marketPriceDesc": "Market Price",
      "marketValue": "Market Value",
      "marketValueDesc": "Market Value",
      "nfrsUnrealizedGainLoss": "Nfrs Unrealized Gain Loss",
      "nfrsUnrealizedGainLossDesc": "Nfrs Unrealized Gain Loss",
      "nfrsUnrealizedGainLossPct": "Nfrs Unrealized Gain Loss Pct",
      "nfrsUnrealizedGainLossPctDesc": "Nfrs Unrealized Gain Loss Pct",
      "sector": "Sector",
      "sectorDesc": "Sector",
      "lastPriceDate": "Last Price Date",
      "lastPriceDateDesc": "Last Price Date",
      "totalNfrsCost": "Total Nfrs Cost",
      "totalNfrsCostDesc": "Total Nfrs Cost",
      "totalMarketValue": "Total Market Value",
      "totalMarketValueDesc": "Total Market Value",
      "totalNfrsUnrealizedGainLoss": "Total Nfrs Unrealized Gain Loss",
      "totalNfrsUnrealizedGainLossDesc": "Total Nfrs Unrealized Gain Loss",
      "positionCount": "Position Count",
      "positionCountDesc": "Position Count"
    },
    "nfrsMonthly": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "instrument": "Instrument",
      "instrumentDesc": "Instrument",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "month": "Month",
      "monthDesc": "Month",
      "client": "Client",
      "clientDesc": "Client",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "instrumentName": "Instrument Name",
      "instrumentNameDesc": "Instrument Name",
      "openingNfrsCost": "Opening Nfrs Cost",
      "openingNfrsCostDesc": "Opening Nfrs Cost",
      "purchasesNfrs": "Purchases Nfrs",
      "purchasesNfrsDesc": "Purchases Nfrs",
      "salesNfrs": "Sales Nfrs",
      "salesNfrsDesc": "Sales Nfrs",
      "closingNfrsCost": "Closing Nfrs Cost",
      "closingNfrsCostDesc": "Closing Nfrs Cost",
      "nfrsProfitLoss": "Nfrs Profit Loss",
      "nfrsProfitLossDesc": "Nfrs Profit Loss",
      "nfrsProfitLossPct": "Nfrs Profit Loss Pct",
      "nfrsProfitLossPctDesc": "Nfrs Profit Loss Pct",
      "totalPurchasesNfrs": "Total Purchases Nfrs",
      "totalPurchasesNfrsDesc": "Total Purchases Nfrs",
      "totalSalesNfrs": "Total Sales Nfrs",
      "totalSalesNfrsDesc": "Total Sales Nfrs",
      "totalNfrsProfitLoss": "Total Nfrs Profit Loss",
      "totalNfrsProfitLossDesc": "Total Nfrs Profit Loss",
      "totalClosingNfrsCost": "Total Closing Nfrs Cost",
      "totalClosingNfrsCostDesc": "Total Closing Nfrs Cost"
    },
    "performanceBenchmark": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "benchmark": "Benchmark",
      "benchmarkDesc": "Benchmark",
      "startDate": "Start Date",
      "startDateDesc": "Start Date",
      "endDate": "End Date",
      "endDateDesc": "End Date",
      "period": "Period",
      "periodDesc": "Period",
      "portfolioReturn": "Portfolio Return",
      "portfolioReturnDesc": "Portfolio Return",
      "benchmarkReturn": "Benchmark Return",
      "benchmarkReturnDesc": "Benchmark Return",
      "excessReturn": "Excess Return",
      "excessReturnDesc": "Excess Return",
      "trackingError": "Tracking Error",
      "trackingErrorDesc": "Tracking Error",
      "informationRatio": "Information Ratio",
      "informationRatioDesc": "Information Ratio",
      "avgExcessReturn": "Avg Excess Return",
      "avgExcessReturnDesc": "Avg Excess Return",
      "avgTrackingError": "Avg Tracking Error",
      "avgTrackingErrorDesc": "Avg Tracking Error"
    },
    "performanceDrivers": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "startDate": "Start Date",
      "startDateDesc": "Start Date",
      "endDate": "End Date",
      "endDateDesc": "End Date",
      "driver": "Driver",
      "driverDesc": "Driver",
      "contribution": "Contribution",
      "contributionDesc": "Contribution",
      "contributionPercent": "Contribution Percent",
      "contributionPercentDesc": "Contribution Percent",
      "description": "Performance Drivers description",
      "descriptionDesc": "Description",
      "totalReturn": "Total Return",
      "totalReturnDesc": "Total Return",
      "totalAttribution": "Total Attribution",
      "totalAttributionDesc": "Total Attribution"
    },
    "performanceRisk": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "startDate": "Start Date",
      "startDateDesc": "Start Date",
      "endDate": "End Date",
      "endDateDesc": "End Date",
      "riskMetric": "Risk Metric",
      "riskMetricDesc": "Risk Metric",
      "metricOption": {
        "volatility": "Volatility",
        "volatilityDesc": "Volatility",
        "sharpeRatio": "Sharpe Ratio",
        "sharpeRatioDesc": "Sharpe Ratio",
        "maxDrawdown": "Max Drawdown",
        "maxDrawdownDesc": "Max Drawdown",
        "sortinoRatio": "Sortino Ratio",
        "sortinoRatioDesc": "Sortino Ratio",
        "var95": "Var95",
        "var95Desc": "Var95"
      },
      "value": "Value",
      "valueDesc": "Value",
      "benchmark": "Benchmark",
      "benchmarkDesc": "Benchmark",
      "percentile": "Percentile",
      "percentileDesc": "Percentile",
      "status": "Status",
      "statusDesc": "Status",
      "description": "Performance Risk description",
      "descriptionDesc": "Description",
      "overallRiskScore": "Overall Risk Score",
      "overallRiskScoreDesc": "Overall Risk Score",
      "riskAdjustedReturn": "Risk Adjusted Return",
      "riskAdjustedReturnDesc": "Risk Adjusted Return"
    },
    "performanceSummary": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "month": "Month",
      "monthDesc": "Month",
      "purchases": "Purchases",
      "purchasesDesc": "Purchases",
      "sales": "Sales",
      "salesDesc": "Sales",
      "netFlow": "Net Flow",
      "netFlowDesc": "Net Flow",
      "totalPurchases": "Total Purchases",
      "totalPurchasesDesc": "Total Purchases",
      "totalSales": "Total Sales",
      "totalSalesDesc": "Total Sales",
      "totalNetFlow": "Total Net Flow",
      "totalNetFlowDesc": "Total Net Flow",
      "monthCount": "Month Count",
      "monthCountDesc": "Month Count"
    },
    "pivotAnalysis": {
      "pivotBy": "Pivot By",
      "pivotByDesc": "Pivot By",
      "pivotByOption": {
        "sector": "Sector",
        "sectorDesc": "Sector",
        "symbol": "Symbol",
        "symbolDesc": "Symbol"
      },
      "timeDimension": "Time Dimension",
      "timeDimensionDesc": "Time Dimension",
      "timeDimensionOption": {
        "month": "Month",
        "monthDesc": "Month",
        "year": "Year",
        "yearDesc": "Year",
        "all": "All",
        "allDesc": "All",
        "dateRange": "Date Range",
        "dateRangeDesc": "Date Range"
      },
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "instrument": "Instrument",
      "instrumentDesc": "Instrument",
      "sector": "Sector",
      "sectorDesc": "Sector",
      "group": "Group",
      "groupDesc": "Group",
      "totalInvestment": "Total Investment",
      "totalInvestmentDesc": "Total Investment",
      "portfolioValue": "Portfolio Value",
      "portfolioValueDesc": "Portfolio Value",
      "returnPct": "Return Pct",
      "returnPctDesc": "Return Pct",
      "rowCount": "Row Count",
      "rowCountDesc": "Row Count"
    },
    "profitLoss": {
      "realizedLens": {
        "tax": "Tax",
        "taxDesc": "Tax",
        "afterTaxCash": "After Tax Cash",
        "afterTaxCashDesc": "After Tax Cash",
        "nfrs": "NFRS",
        "nfrsDesc": "NFRS"
      },
      "realizedLensDesc": "Realized Lens"
    },
    "realizedProfitLoss": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "instrument": "Instrument",
      "instrumentDesc": "Instrument",
      "dateFrom": "Date From",
      "dateFromDesc": "Date From",
      "dateTo": "Date To",
      "dateToDesc": "Date To",
      "saleDate": "Sale Date",
      "saleDateDesc": "Sale Date",
      "client": "Client",
      "clientDesc": "Client",
      "symbol": "Symbol",
      "symbolDesc": "Symbol",
      "instrumentName": "Instrument Name",
      "instrumentNameDesc": "Instrument Name",
      "quantity": "Quantity",
      "quantityDesc": "Quantity",
      "saleRate": "Sale Rate",
      "saleRateDesc": "Sale Rate",
      "saleAmount": "Sale Amount",
      "saleAmountDesc": "Sale Amount",
      "costBasis": "Cost Basis",
      "costBasisDesc": "Cost Basis",
      "grossGain": "Gross Gain",
      "grossGainDesc": "Gross Gain",
      "sellingCharges": "Selling Charges",
      "sellingChargesDesc": "Selling Charges",
      "cgt": "CGT",
      "cgtDesc": "CGT",
      "netGain": "Net Gain",
      "netGainDesc": "Net Gain",
      "capitalGain": "Capital Gain",
      "capitalGainDesc": "Capital Gain",
      "cgtRate": "CGT Rate",
      "cgtRateDesc": "CGT Rate",
      "holdingPeriodDays": "Holding Period Days",
      "holdingPeriodDaysDesc": "Holding Period Days",
      "holdingPeriodBucket": "Holding Period Bucket",
      "holdingPeriodBucketDesc": "Holding Period Bucket",
      "brokerNo": "Broker No",
      "brokerNoDesc": "Broker No",
      "totalSales": "Total Sales",
      "totalSalesDesc": "Total Sales",
      "totalCostBasis": "Total Cost Basis",
      "totalCostBasisDesc": "Total Cost Basis",
      "totalGrossGain": "Total Gross Gain",
      "totalGrossGainDesc": "Total Gross Gain",
      "totalSellingCharges": "Total Selling Charges",
      "totalSellingChargesDesc": "Total Selling Charges",
      "totalCgt": "Total Cgt",
      "totalCgtDesc": "Total Cgt",
      "totalNetGain": "Total Net Gain",
      "totalNetGainDesc": "Total Net Gain",
      "disposalCount": "Disposal Count",
      "disposalCountDesc": "Disposal Count"
    },
    "reportsHub": {
      "category": "Category",
      "categoryDesc": "Category",
      "availability": "Availability",
      "availabilityDesc": "Availability",
      "report": "Report",
      "reportDesc": "Report",
      "tier": "Tier",
      "tierDesc": "Tier",
      "exports": "Exports",
      "exportsDesc": "Exports",
      "reports": "Reports",
      "reportsDesc": "Reports",
      "available": "Available",
      "availableDesc": "Available",
      "locked": "Locked",
      "lockedDesc": "Locked",
      "unavailable": "Unavailable",
      "unavailableDesc": "Unavailable"
    },
    "sectorAllocation": {
      "clientAccount": "Client Account",
      "clientAccountDesc": "Client Account",
      "portfolioAccount": "Portfolio Account",
      "portfolioAccountDesc": "Portfolio Account",
      "sector": "Sector",
      "sectorDesc": "Sector",
      "asOfDate": "As Of Date",
      "asOfDateDesc": "As Of Date",
      "marketValue": "Market Value",
      "marketValueDesc": "Market Value",
      "allocationPercent": "Allocation Percent",
      "allocationPercentDesc": "Allocation Percent",
      "positionCount": "Position Count",
      "positionCountDesc": "Position Count",
      "missingValuationCount": "Missing Valuation Count",
      "missingValuationCountDesc": "Missing Valuation Count",
      "denominatorBasis": "Denominator Basis",
      "denominatorBasisDesc": "Denominator Basis",
      "totalMarketValue": "Total Market Value",
      "totalMarketValueDesc": "Total Market Value",
      "sectorCount": "Sector Count",
      "sectorCountDesc": "Sector Count",
      "totalPositionCount": "Total Position Count",
      "totalPositionCountDesc": "Total Position Count"
    },
    "organizationClientStatement": {
      "parametersTitle": "Find a client statement",
      "parametersDescription": "Choose the client and, if needed, a portfolio or exact statement period. Only completed governed statements are returned."
    },
    "liveParameters": {
      "title": "Report parameters",
      "description": "Narrow the governed live report without expanding your authorized data scope.",
      "run": "Run report",
      "requestFailed": "The report request could not be completed.",
      "asOfDate": "As-of date",
      "clientAccount": "Client account",
      "portfolioAccount": "Portfolio account",
      "reconciliationRun": "Reconciliation run",
      "status": "Status",
      "severity": "Severity",
      "from": "Transaction date from",
      "to": "Transaction date to",
      "transactionType": "Transaction type",
      "instrument": "Instrument symbol",
      "periodStart": "Performance period start",
      "periodStartHelp": "First date included in realized-gain and Nepal tax evidence.",
      "requested": "Report request submitted."
    },
    "platformInstrumentInventory": {
      "title": "Instrument inventory",
      "description": "Review instrument reference data, lifecycle state, metadata completeness, and market-price coverage.",
      "parameters": {
        "title": "Instrument inventory parameters",
        "description": "Optionally filter instruments by lifecycle status.",
        "accessibilityLabel": "Instrument inventory report parameters",
        "status": "Lifecycle status"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "suspended": "Suspended",
        "delisted": "Delisted"
      },
      "columns": {
        "symbol": "Symbol",
        "name": "Instrument name",
        "isin": "ISIN",
        "exchange": "Exchange",
        "sector": "Sector",
        "type": "Instrument type",
        "currency": "Currency",
        "status": "Status",
        "marketDataCount": "Price records",
        "latestPriceDate": "Latest price date",
        "updatedAt": "Last updated"
      }
    },
    "performanceParameters": {
      "title": "Portfolio performance parameters",
      "description": "Choose the as-of date, performance period, client, and portfolio available to your authorized scope."
    },
    "authority": {
      "section": {
        "title": "Filing authority",
        "description": "Classify this definition as an internal control or a regulator-authorized filing. Authoritative filing requires verified template metadata and an applicable organization license."
      },
      "fields": {
        "classification": "Output classification",
        "regulator": "Regulator",
        "templateId": "Official template ID",
        "templateVersion": "Template version",
        "submissionChannel": "Submission channel",
        "sourceReference": "Authority source reference",
        "effectiveFrom": "Template effective from",
        "effectiveTo": "Template effective to"
      },
      "help": {
        "classification": "Leave blank or select internal control when the output is not approved for submission.",
        "regulator": "Select the authority that issued the verified form or schema.",
        "templateId": "Use the regulator-issued form, schema, or message identifier.",
        "submissionChannel": "For example, regulator portal, signed upload, or a verified machine submission adapter.",
        "sourceReference": "Record the directive, form publication, circular, or other authoritative source."
      },
      "classification": {
        "internalControl": "Internal control only",
        "authoritativeFiling": "Authoritative regulatory filing"
      }
    },
    "visualizations": {
      "allocation": {
        "title": "Portfolio concentration",
        "description": "Percentage concentration for the selected grouping within a single governed currency.",
        "tableCaption": "Accessible portfolio concentration data",
        "empty": "No comparable allocation data is available for this selection.",
        "partial": "The allocation view is incomplete because one or more active positions do not have complete valuation coverage."
      }
    },
    "options": {
      "dimension": {
        "currency": "Currency",
        "instrument": "Instrument",
        "instrumentType": "Instrument type",
        "sector": "Sector"
      }
    }
  },
  "dashboard": {
    "title": "Home",
    "platform": {
      "title": "Platform operations",
      "branchHealth": "Organizations",
      "jobFailures": "Failed fact jobs",
      "authorizationPosture": "Enabled entitlements",
      "empty": "No platform data is available.",
      "emptyDescription": "There is no platform data for this scope.",
      "partial": "Some platform widgets are temporarily unavailable."
    },
    "organization": {
      "title": "Organization portfolio",
      "empty": "No portfolio holdings are available for this scope.",
      "emptyDescription": "There are no holdings for this organization.",
      "partial": "Portfolio data is partially available."
    },
    "client": {
      "title": "Client portfolio",
      "empty": "No client holdings are available.",
      "emptyDescription": "There are no holdings for this client.",
      "partial": "Client portfolio data is partially available."
    },
    "widgets": {
      "marketValue": "Market value",
      "costBasis": "Cost basis",
      "unrealizedGain": "Unrealized gain/loss",
      "realizedGain": "Realized gain/loss",
      "totalGainLoss": "Total gain/loss",
      "returnOnCost": "Return on cost",
      "capitalGainTax": "Capital gain tax",
      "taxProvenanceCoverage": "Tax provenance coverage",
      "nfrsEvidence": "NFRS evidence facts",
      "missingPrices": "Missing prices",
      "pendingApprovals": "Pending approvals",
      "failedImports": "Failed or partial imports",
      "reconciliationBreaks": "Open reconciliation breaks",
      "periodReturn": "Period return",
      "cash": "Cash",
      "holdings": "Holdings",
      "recentActivity": "Recent activity"
    },
    "home": {
      "needsAttention": "Needs attention",
      "criticalDataQualityIssues": "Critical data quality issues require immediate attention",
      "PERIOD_RETURN_REQUIRES_SINGLE_PORTFOLIO_SCOPE": "Period return requires a single portfolio scope",
      "PERIOD_RETURN_TWR_UNAVAILABLE": "Time-weighted return is not available",
      "CASH_POSITION_AUTHORITY_UNAVAILABLE": "Cash balance is temporarily unavailable",
      "CASH_POSITION_EMPTY": "No cash positions in scope",
      "CASH_MULTI_CURRENCY_REPORT_FIRST": "Multi-currency cash — showing first currency",
      "asOfContext": "Financial position as of {{date}}",
      "returnMethodologyContext": "Return: {{methodology}}",
      "sourceAsOfContext": "Evidence updated {{date}}",
      "needsAttentionDescription": "Prioritized items that may affect portfolio operations or financial reporting.",
      "attentionCount": "{{count}} item(s) require review",
      "review": "Review",
      "CASH_AS_OF_UNAVAILABLE": "Historical cash is unavailable for this date because the current cash balance changed after the selected financial date."
    },
    "dragWidget": "Drag to reorder widget",
    "widgetReordered": "Widget order updated",
    "tagline": "Operational portfolio controls with auditable records",
    "signedInTagline": "Portfolio operations, accounting controls, and auditable workflow management",
    "asOf": "As of {{date}}",
    "liveIndicator": "Live",
    "liveAsOf": "Live · As of {{date}}",
    "sectorDistribution": "Sector Distribution",
    "topHoldings": "Top Holdings",
    "transactionActivity": "Transaction Activity",
    "buyTransactions": "Buy Transactions",
    "sellTransactions": "Sell Transactions",
    "totalTransactions": "Total Transactions",
    "supportPanel": {
      "ariaLabel": "Dashboard support panel"
    },
    "sidebar": {
      "ariaLabel": "Dashboard sidebar navigation"
    },
    "status": {
      "asOf": "As of {{date}}",
      "positions": "{{count}} positions",
      "dataQuality": "Data {{quality}}",
      "suggested": "Suggested",
      "report": "Report"
    },
    "kpiStrip": {
      "portfolioValue": "Portfolio Value",
      "currentPortfolioMarketValue": "Current Portfolio Market Value",
      "portfolioKpiSummaryAria": "Portfolio KPI summary",
      "ytdReturnVsBenchmark": "YTD Return vs Benchmark",
      "benchmark": "Benchmark",
      "benchmarkNotSet": "Benchmark (not set)",
      "benchmarkNotSetSubtext": "Benchmark not set",
      "unrealizedGain": "Unrealized Gain",
      "vsCost": "vs cost",
      "costBasis": "Cost basis",
      "alerts": "Alerts",
      "positions": "Positions",
      "positionsWithPriceDate": "{{count}} positions · Prices as of {{date}}",
      "costBasisWithDate": "Cost basis {{costBasis}} · Prices as of {{date}}",
      "critical": "Critical",
      "alertMix": "{{monitoring}} monitoring · {{attention}} attention",
      "approvalsPending": "approvals pending",
      "noActiveAlerts": "No active alerts",
      "outperformance": "Outperformance",
      "checkingReportAvailability": "Checking report availability…",
      "reportUnavailable": "Report unavailable",
      "approvalsUnavailable": "Approvals unavailable",
      "disabledReasonTier": "Disabled Reason Tier",
      "disabledReasonTierGeneric": "Disabled Reason Tier Generic",
      "disabledReasonPermission": "Disabled Reason Permission",
      "asOfUnavailable": "As of date unavailable",
      "disabledReasonPermissionGeneric": "Disabled Reason Permission Generic",
      "disabledReasonQuality": "Disabled Reason Quality",
      "disabledReasonReportUnavailable": "Disabled Reason Report Unavailable",
      "disabledReasonDataUnavailable": "Disabled Reason Data Unavailable",
      "disabledReasonGeneric": "Disabled Reason Generic",
      "gapVsTarget": "Gap Vs Target",
      "remediationHoldings": "Contact administrator to enable holdings report access",
      "remediationPerformance": "Configure benchmark data or enable performance report access",
      "remediationGainLoss": "Enable gain/loss report access to view detailed breakdown",
      "explanationMeaning": "Explanation Meaning",
      "explanationSource": "Explanation Source",
      "explanationAsOfDate": "Explanation As Of Date",
      "explanationValuationPolicy": "Explanation Valuation Policy",
      "explanationQualityStatus": "Explanation Quality Status",
      "valueExplanation": "Value Explanation",
      "hideValueExplanation": "Hide Value Explanation",
      "showValueExplanation": "Show Value Explanation",
      "explanationReconciliationTarget": "Explanation Reconciliation Target",
      "unknownSource": "Unknown Source",
      "unknownPolicy": "Unknown Policy",
      "asOfDate": "As Of Date",
      "explanationScopeHash": "Explanation Scope Hash",
      "explanationValue": "Explanation Value",
      "explanationCurrency": "Explanation Currency",
      "explanationLabel": "Explanation",
      "explanationIncludedCount": "Explanation Included Count",
      "explanationExcludedCount": "Explanation Excluded Count",
      "remediationHoldingsDesc": "Remediation Holdings"
    },
    "monthlySummary": {
      "reportValidation": "Report validation:",
      "unitInvestmentChecksPassed": "Unit and investment continuity checks passed for the currently displayed periods.",
      "endingInvestment": "Ending Investment",
      "endingValue": "Ending Value",
      "realizedGain": "Realized Gain",
      "soldCostBasis": "Sold Cost Basis",
      "realizedReturnPct": "Realized Return %",
      "s": "s",
      "period": "Period",
      "from": "from ",
      "to": "to ",
      "costBasis": "Cost basis: ",
      "noResultsMatch": "No results match the selected filters.",
      "rowPeriodChecks": "row period check(s)",
      "grandTotalChecks": "grand-total period check(s) do not reconcile. Review both bridges together: Beginning Units + Period Purch Qty - Period Sales Qty = Ending Units, and Beginning Investment + Period Purch Amt - Sold Cost Basis = Ending Investment. Current issue counts: units",
      "row": "row",
      "total": "Total",
      "investment": "Investment",
      "unit": "unit",
      "checksFailed": "checks failed",
      "rowUnitIssues": "row unit issues",
      "totalUnitIssues": "total unit issues",
      "rowInvestmentIssues": "row investment issues",
      "totalInvestmentIssues": "total investment issues",
      "orgIdRequired": "Organization ID is required",
      "fromToDatesRequired": "Both From and To dates are required for date range mode",
      "fromAfterTo": "From date cannot be after To date",
      "failedLoadPivot": "Failed to load pivot data",
      "byMonth": "by Month",
      "byYear": "by Year",
      "allTime": "All Time",
      "dateRange": "Date Range",
      "portfolioPivotReport": "Portfolio Pivot Report",
      "crossTab": "Cross-tab: rows = ",
      "columnsSeparator": ", columns = ",
      "rowsPivotBy": "Rows (Pivot by)",
      "columnsTime": "Columns (Time)",
      "reportValidationWarning": "Report validation warning:"
    },
    "sectionStatus": {
      "OK": "Available",
      "NO_DATA": "No Data",
      "PARTIAL": "Partial",
      "UNAVAILABLE": "Unavailable",
      "ERROR": "Error",
      "LOCKED": "Locked"
    },
    "sectionStatus_description": {
      "OK": "Section data loaded successfully.",
      "NO_DATA": "No data available for this section.",
      "PARTIAL": "Some data is unavailable. Results may be incomplete.",
      "UNAVAILABLE": "This section is temporarily unavailable.",
      "ERROR": "An error occurred loading this section.",
      "LOCKED": "Upgrade your plan to access this section."
    },
    "holdings": {
      "title": "Holdings by Asset Class",
      "allocation": "Allocation",
      "empty": "No holdings data available. Import transactions to see allocation.",
      "missingPrices": "Missing prices",
      "missingPricesAria": "Some holdings are missing current market prices",
      "marketPricesUnavailable": "Market prices unavailable for all positions",
      "updatePrices": "Update prices to view allocation chart",
      "viewReportAria": "View holdings report",
      "allocationOfKnownMarketValueOnly": "Allocation Of Known Market Value Only",
      "allocationOfTotalPortfolioMarketValue": "Allocation Of Total Portfolio Market Value",
      "excludedBecauseMarketValueUnavailable": "Excluded Because Market Value Unavailable",
      "excludedBecauseSectorMissing": "Excluded Because Sector Missing",
      "excludedMarketValueAmount": "Excluded Market Value Amount",
      "denominatorReconciliationNote": "Denominator Reconciliation Note"
    },
    "monthlyPnl": {
      "title": "Monthly P&L",
      "netRealized": "Net Realized"
    },
    "portfolioPerformanceCard": {
      "title": "Portfolio Value Over Time",
      "noHistoricalData": "No historical data available",
      "historicalDataNotAvailable": "Historical portfolio value data not available",
      "benchmarkNotConfiguredAria": "Market benchmark not configured",
      "benchmarkNotConfiguredTitle": "Set a benchmark index in investment settings to track outperformance",
      "benchmarkNA": "Benchmark N/A",
      "portfolioValue": "Portfolio Value",
      "ytd": "YTD",
      "benchmark": "Benchmark",
      "vsBenchmark": "vs Benchmark",
      "viewPerformanceReport": "View portfolio performance report",
      "valuationDate": "Valuation Date",
      "currentValuationMarker": "Current Valuation",
      "mismatchDefaultReason": "Latest chart value does not match the dashboard KPI for the current scope.",
      "currencyUnavailable": "Performance chart unavailable because valuation currency metadata is missing.",
      "transactionPolicyApprovedOnly": "Approved transactions only",
      "transactionPolicyIncludeDraft": "Draft transactions included",
      "transactionPolicyIncludeReversed": "Reversed transactions included",
      "stalePricePolicyRequireFresh": "Fresh prices required",
      "stalePricePolicyAllowStale": "Stale prices allowed",
      "mismatch": {
        "KPI_CHART_POINT_DIVERGENCE": "Chart and portfolio KPI diverge due to different valuation dates or transaction policies.",
        "KPI_NO_CHART_DATA": "No chart data is available to compare against the portfolio KPI.",
        "KPI_UNAVAILABLE_MISSING_FACTS": "Portfolio KPI cannot be computed — canonical position facts are missing.",
        "NO_CANONICAL_SNAPSHOTS": "No canonical portfolio snapshots are available for this scope."
      }
    },
    "nfrs": {
      "title": "Portfolio As per NFRS",
      "shortTitle": "Portfolio As per NFRS",
      "fullTitle": "Nepal Financial Reporting Standard",
      "cardAria": "Portfolio as per NFRS",
      "errorAria": "Portfolio as per NFRS error",
      "emptyAria": "Portfolio as per NFRS empty",
      "notAvailable": "NFRS data not available",
      "noData": "No NFRS data available",
      "noDataAsOf": "No NFRS portfolio data available as of {{date}}",
      "noDataHelp": "No NFRS portfolio data available. Check your portfolio holdings and try again.",
      "noHoldings": "No NFRS holdings",
      "holdingsCount": "{{count}} holdings",
      "generated": "Generated {{date}}",
      "fullReport": "Full report",
      "fullReportAria": "View full NFRS report",
      "learnMore": "Learn more",
      "learnMoreAria": "Learn how to enable NFRS access",
      "tierLocked": "Upgrade to Professional or Enterprise tier",
      "permissionLocked": "Contact administrator for access",
      "missingValuationFacts": "Import portfolio data to generate valuation facts",
      "missingMonthlyFacts": "Generate monthly movement facts from transactions",
      "status": {
        "AVAILABLE": "Available",
        "TIER_LOCKED": "Tier Locked",
        "PERMISSION_LOCKED": "Permission Required",
        "MISSING_VALUATION_FACTS": "Valuation Facts Missing",
        "MISSING_MONTHLY_FACTS": "Monthly Facts Missing",
        "DATA_STALE": "Data Stale",
        "UNAVAILABLE": "Unavailable"
      },
      "remediation": {
        "upgrade_tier": "Upgrade_tier",
        "upgrade_tierDesc": "Upgrade_tier",
        "contact_admin": "Contact_admin",
        "contact_adminDesc": "Contact_admin",
        "import_portfolio_data": "Import_portfolio_data",
        "import_portfolio_dataDesc": "Import_portfolio_data",
        "generate_monthly_facts": "Generate_monthly_facts",
        "generate_monthly_factsDesc": "Generate_monthly_facts",
        "update_market_prices": "Update_market_prices",
        "update_market_pricesDesc": "Update_market_prices",
        "fix_negative_holdings": "Fix_negative_holdings",
        "fix_negative_holdingsDesc": "Fix_negative_holdings",
        "run_reconciliation": "Run_reconciliation",
        "run_reconciliationDesc": "Run_reconciliation",
        "contact_support": "Contact_support",
        "contact_supportDesc": "Contact_support"
      }
    },
    "formulas": {
      "definition": "Formula Definition",
      "variables": "Variables:",
      "glossaryTitle": "NFRS Formula Glossary"
    },
    "attention": {
      "title": "Requires Attention",
      "monitoring": "Monitoring",
      "dataTrust": "Data Trust",
      "pending_approvals": {
        "title": "Pending Approvals",
        "description": "Transactions awaiting your review and approval"
      },
      "market_prices": {
        "synced": {
          "title": "Market Prices Synced",
          "description": "All holdings have current market prices"
        },
        "stale": {
          "title": "Stale Market Prices",
          "description": "Some holdings have outdated market prices"
        }
      },
      "imports": {
        "cost_basis": {
          "title": "Cost Basis Imports",
          "description": "Some holdings are valued using cost basis due to missing market prices."
        },
        "no_gaps": {
          "title": "Import Coverage Complete",
          "description": "No import data gaps detected for the current portfolio scope."
        }
      },
      "viewAll": "View all",
      "viewAllAria": "View all attention items",
      "checkingExceptions": "Checking exceptions…",
      "allClear": "All data sources operational. No issues detected.",
      "codeLabel": "Code:",
      "remediate": "Remediate →",
      "remediateAria": "Remediate {{title}}",
      "moreExceptions": "+{{count}} more exceptions →",
      "moreExceptionsAria": "View {{count}} more exceptions",
      "severity": {
        "error": "Error",
        "warning": "Warning",
        "info": "Info",
        "success": "Success",
        "critical": "Critical"
      }
    },
    "alert": {
      "import_failure": {
        "title": "Import failed",
        "description": "Recent import processing failed. Review the failure details and retry the workflow."
      },
      "stale_prices": {
        "title": "Stale market prices detected",
        "description": "One or more holdings are using stale market prices. Refresh prices to restore valuation trust."
      }
    },
    "recentActivity": {
      "title": "Recent Activity",
      "noRecentActivity": "No recent activity",
      "reasons": {
        "default": "Recent activity is temporarily unavailable.",
        "missingData": "Required data is missing",
        "staleData": "Data is stale",
        "serviceUnavailable": "Service is temporarily unavailable"
      },
      "columns": {
        "transactionDate": "Date",
        "transactionType": "Type",
        "instrumentSymbol": "Instrument",
        "quantity": "Quantity",
        "totalAmount": "Amount",
        "status": "Status"
      }
    },
    "sectionDegradation": {
      "partialFailures": "partial failure",
      "partialFailuresPlural": "partial failures",
      "traceLabel": "trace:",
      "dismiss": "Dismiss {{section}} notification",
      "section": {
        "canonical_facts": {
          "unavailable": "Portfolio valuation data is temporarily unavailable. Displayed figures may be incomplete."
        },
        "performance": {
          "unavailable": "Performance data is temporarily unavailable. Charts may not reflect the latest returns."
        },
        "monthly_pnl": {
          "unavailable": "Monthly P&L data is temporarily unavailable. Historical figures may be stale."
        },
        "monitoring": {
          "unavailable": "Monitoring alerts are temporarily unavailable. Some data quality issues may not be displayed."
        },
        "recent_activity": {
          "unavailable": "Recent activity feed is temporarily unavailable."
        },
        "approvals": {
          "unavailable": "Pending approvals count is temporarily unavailable."
        }
      }
    },
    "stateBanner": {
      "dismiss": "Dismiss notification",
      "dismissAria": "Dismiss notification"
    },
    "topBar": {
      "subtitle": "Portfolio dashboard",
      "subtitleWithDate": "Portfolio dashboard · As of {{date}}",
      "priceSyncedToday": "Prices synced today",
      "priceSyncedOn": "Prices synced {{date}}",
      "instruments": "{{count}} instruments",
      "failedImports": "{{count}} failed imports"
    },
    "errors": {
      "noData": "No dashboard data available",
      "unexpected": "An unexpected error occurred while loading the dashboard",
      "unauthorized": {
        "title": "Access Restricted",
        "message": "You do not have permission to view this portfolio dashboard. Contact your administrator if this is unexpected."
      }
    },
    "kpiAction": {
      "disabled_reason": {
        "TIER_LOCKED": "Upgrade your plan to access this feature.",
        "PERMISSION_DENIED": "You do not have permission to access this feature.",
        "NO_DATA": "No data available to display.",
        "UNAVAILABLE": "This feature is temporarily unavailable.",
        "NOT_CONFIGURED": "This feature has not been configured yet."
      }
    },
    "actions": {
      "resolveStalePrices": {
        "label": "Resolve stale prices",
        "description": "{{count}} holding(s) with stale market prices",
        "labelDesc": "Resolve Stale Prices"
      },
      "reviewPendingApprovals": {
        "label": "Review pending approvals",
        "description": "{{count}} transaction(s) awaiting approval",
        "labelDesc": "Review Pending Approvals"
      },
      "reviewMonitoringException": {
        "label": "Review monitoring exception",
        "description": "A monitoring alert requires your attention",
        "labelDesc": "Review Monitoring Exception"
      },
      "importMarketData": {
        "label": "Import latest market prices",
        "description": "Some holdings are priced from cost basis",
        "labelDesc": "Import Market Data"
      },
      "reviewPerformance": {
        "label": "Review performance",
        "description": "Open the portfolio performance report",
        "labelDesc": "Review Performance"
      },
      "status": {
        "critical": "Critical",
        "highPriority": "High priority",
        "suggested": "Suggested",
        "report": "Report"
      }
    },
    "action": {
      "importMarketData": {
        "label": "Import latest market prices",
        "description": "Some holdings are priced from cost basis"
      },
      "reviewPendingApprovals": {
        "label": "Review pending approvals",
        "description": "{{count}} transaction(s) awaiting approval"
      },
      "reviewPerformance": {
        "label": "Review performance",
        "description": "Open the portfolio performance report"
      }
    },
    "reconciliation": {
      "banner": {
        "title": "Data quality notice",
        "dismiss": "Dismiss reconciliation notice",
        "computedLabel": "Computed:",
        "qualityStatus": {
          "OK": "All data sources are canonical.",
          "EMPTY": "No canonical position facts found. Import transactions to build portfolio data.",
          "STALE_PRICES": "Some holdings use stale market prices. Update prices for accurate valuations.",
          "MISSING_PRICES": "Market prices are missing for one or more holdings. Cost basis is used as a fallback.",
          "MISSING_FACTS": "Canonical position facts are incomplete. Some report figures may be approximated.",
          "ERROR": "An error occurred loading canonical facts. Contact support if this persists."
        }
      },
      "strip": {
        "currentMarketAllMatch": "Portfolio values are reconciled.",
        "actionRequired": "Portfolio valuation needs attention.",
        "currentMarketLine": "Current market value: {{value}}",
        "holdingsLine": "Holdings total: {{value}}",
        "snapshotLine": "Official snapshot: {{value}} ({{status}})",
        "viewDiagnostics": "View diagnostics",
        "allMatch": "All comparisons match",
        "notAvailable": "Reconciliation not available",
        "mismatchDetected": "Mismatch detected",
        "partiallyAvailable": "Partially available",
        "status": {
          "match": "Match",
          "mismatch": "Mismatch",
          "notApplicable": "Not applicable",
          "notAvailable": "Not available"
        },
        "deltaLabel": "Delta: {{delta}}",
        "comparisonUnavailable": "Comparison unavailable",
        "ariaLabel": "Financial reconciliation summary",
        "asOfUnavailable": "As-of date unavailable"
      },
      "reason": {
        "staleSnapshot": "Official snapshot is older than current market valuation.",
        "staleSnapshotDesc": "Stale Snapshot"
      },
      "action": {
        "refreshValuation": "Refresh valuation",
        "reviewMarketData": "Review market data",
        "viewReconciliation": "View reconciliation",
        "reviewMarketDataDesc": "Review Market Data",
        "viewReconciliationDesc": "View Reconciliation",
        "refreshValuationDesc": "Refresh Valuation"
      },
      "parity": {
        "kpiVsChart": "Kpi Vs Chart",
        "kpiVsHoldings": "Kpi Vs Holdings",
        "kpiVsSnapshot": "Kpi Vs Snapshot",
        "kpiVsExportExpected": "Kpi Vs Export Expected"
      }
    },
    "sectionStatusList": {
      "title": "Section availability",
      "ariaLabel": "Dashboard section availability summary",
      "completeness": "{{pct}}% complete",
      "available": "Available",
      "unavailable": "Unavailable",
      "degraded": "Degraded",
      "error": "Error",
      "sectionHeader": "Section Header",
      "statusHeader": "Status Header",
      "completenessHeader": "Completeness Header"
    },
    "dataCompletenessBadge": {
      "ariaLabel": "Section data coverage: {{pct}}%",
      "complete": "Data complete",
      "partial": "{{pct}}% data coverage",
      "review": "Review",
      "help": "Indicates how much dashboard section data is currently usable."
    },
    "secondaryDisclosure": {
      "title": "Attention and next actions",
      "subtitle": "Collapsed by default so discovery and diagnostics stay available without competing with the report grid.",
      "titleNoAttention": "Recent activity",
      "subtitleNoAttention": "Recent activity and diagnostics information.",
      "showDiagnostics": "Show diagnostics"
    },
    "scope": {
      "clientScoped": "Showing data for client account {{clientAccountId}}.",
      "clientScopedWithName": "Client Scoped With Name"
    },
    "performance": {
      "title": "Portfolio Performance",
      "ytdReturn": "YTD Return",
      "oneYearReturn": "1-Year Return",
      "threeYearReturn": "3-Year Return",
      "fiveYearReturn": "5-Year Return",
      "sinceInception": "Since Inception",
      "degradedNotice": "Performance metrics may include approximations while canonical benchmark data is unavailable.",
      "missingBenchmark": "Benchmark not set",
      "configureBenchmark": "Configure benchmark",
      "toRestore": ".",
      "stalePrices": "Market prices are stale",
      "updateMarketData": "Update market data",
      "or": " or ",
      "degradedTitle": "Degraded",
      "reviewStaleCoverage": "Review Stale Coverage",
      "reviewDataQuality": "Review Data Quality",
      "reviewDataQualityDesc": "Review Data Quality",
      "updateMarketDataDesc": "Update Market Data"
    },
    "dataQuality": {
      "trustScore": "Trust Score",
      "priceIssues": "Price Issues",
      "marketData": "Market data",
      "reconIssues": "Recon Issues",
      "reconciliation": "Reconciliation",
      "lastChecked": "Last Checked",
      "trustStatus": {
        "excellent": "Excellent",
        "good": "Good",
        "needsAttention": "Needs Attention"
      },
      "today": "Today",
      "yesterday": "Yesterday",
      "justNow": "Just now",
      "minutesAgo": "{{minutes}}m ago",
      "hoursAgo": "{{hours}}h ago",
      "daysAgo": "{{days}}d ago",
      "trustStatusLabel": "Trust Status",
      "criticalIssues": "Critical Issues",
      "fixFirst": "Fix First",
      "notAvailable": "Not Available",
      "neverChecked": "Never Checked"
    },
    "priorityStatus": {
      "singleIssue": "1 issue requires attention",
      "multipleIssues": "{{count}} issues require attention",
      "breakdown": "{{actions}} actions · {{sections}} degraded sections · {{reconciliation}} reconciliation issue",
      "viewAction": "View action",
      "viewDetails": "View details",
      "reviewReconciliation": "Review reconciliation",
      "viewAll": "View all issues"
    },
    "nextActions": {
      "title": "Next Actions",
      "prioritizedCount": "{{count}} prioritized",
      "readOnlyHint": "View only"
    },
    "exceptionBanner": {
      "checkingExceptions": "Checking Exceptions",
      "unableToCheck": "Unable to check exceptions. Please refresh.",
      "allSystemsOperational": "All Systems Operational",
      "exception": "Exception",
      "exceptions": "Exceptions",
      "requiringAttention": "Requiring Attention",
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "viewAll": "View all",
      "viewAllExceptions": "View all {{count}} exceptions",
      "noExceptions": "No exceptions",
      "checking": "Checking...",
      "alert": "Alert",
      "alerts": "Alerts",
      "affected": "Affected: ",
      "value": "Value: ",
      "exceptionSeverityCounts": "Exception severity counts",
      "navigateTo": "Navigate to {{action}}"
    },
    "operationalSnapshot": {
      "title": "Operational Snapshot",
      "subtitle": "Critical trust and workflow signals from data, reports, and governance.",
      "cards": {
        "dataTrust": {
          "title": "Data Trust",
          "description": "Resolve data-quality exceptions before report export.",
          "exceptions": "Exceptions",
          "critical": "Critical"
        },
        "reports": {
          "title": "Reports Readiness",
          "description": "Review report availability and trust status before sharing outputs.",
          "status": "Status"
        },
        "approvals": {
          "title": "Pending Approvals",
          "description": "Clear pending approvals to keep posting and governance healthy.",
          "pending": "Pending"
        }
      }
    },
    "totalInvestment": "Total Investment",
    "closingUnits": "Closing Units",
    "noPivotRowsToDisplay": "No pivot rows to display",
    "complianceMonitor": {
      "title": "Compliance Monitor",
      "description": "Portfolio compliance, concentration limits, and regulatory requirements",
      "refresh": "Refresh",
      "criticalLabel": "Critical - Immediate Action Required",
      "warningLabel": "Warning - Attention Needed",
      "healthyLabel": "Healthy - All Compliant",
      "healthClaimsDisabled": "Health claims disabled: Portfolio is not valued using real market data ({{mode}} mode)",
      "complianceStatusLimited": "Compliance Status (Limited)",
      "healthClaimsUnavailable": "Health claims unavailable due to cost-basis or mixed valuation",
      "activeBreachesImmediate": "{{count}} active breaches require immediate resolution",
      "itemsNeedAttention": "{{count}} items need attention to maintain compliance",
      "fullyCompliant": "Portfolio is fully compliant with all regulatory requirements",
      "concentrationBreaches": "Concentration Breaches",
      "allWithinLimits": "All within limits",
      "requireRebalancing": "Require rebalancing",
      "activeBreaches": "Active Breaches",
      "totalComplianceViolations": "Total compliance violations",
      "documentationGaps": "Documentation Gaps",
      "missingIncompleteDocs": "Missing or incomplete docs",
      "upcomingDeadlines": "Upcoming Deadlines",
      "requireTimelyAction": "Require timely action",
      "concentrationAnalysis": "Concentration Analysis",
      "concentrationAnalysisDescription": "Sector and holding concentration relative to regulatory limits",
      "sectorConcentration": "Sector Concentration (30% limit per sector)",
      "critical": "Critical",
      "breached": "Breached",
      "limit": "Limit",
      "valueLabel": "Value:",
      "top10HoldingsConcentration": "Top 10 Holdings Concentration (40% limit)",
      "top10Holdings": "Top 10 Holdings",
      "exceedsLimit": "Exceeds limit",
      "withinLimit": "Within limit",
      "top10ExceedMessage": "Top 10 holdings exceed {{limit}}% of portfolio. Consider diversifying to reduce concentration risk.",
      "viewRebalancingRecommendations": "View Rebalancing Recommendations",
      "activeComplianceBreaches": "Active Compliance Breaches",
      "requireImmediateAttention": "These items require immediate attention to maintain regulatory compliance",
      "affected": "Affected",
      "current": "Current",
      "deadline": "Deadline",
      "regulatoryGuidelines": "Regulatory Guidelines",
      "regulatoryGuidelinesDescription": "Key compliance thresholds and limits monitored by the system",
      "sectorConcentrationDescription": "No single sector should exceed 30% of total portfolio value. Critical breach at 40%.",
      "top10HoldingsDescription": "Combined value of top 10 holdings should not exceed 40% of portfolio. Critical breach at 50%.",
      "singleHoldingLimit": "Single Holding Limit",
      "singleHoldingLimitDescription": "Individual security holdings should not exceed 10% of portfolio value.",
      "documentation": "Documentation",
      "documentationDescription": "All transactions and corporate actions must have complete documentation."
    },
    "issueTable": {
      "loadingIssues": "Loading issues...",
      "noIssuesFound": "No issues found",
      "everythingGoodShape": "Great! Everything is in good shape.",
      "severity": "Severity",
      "affectedItem": "Affected Item",
      "issue": "Issue",
      "impact": "Impact",
      "nextAction": "Next Action",
      "critical": "Critical",
      "warning": "Warning",
      "supportDetails": "Support Details",
      "copied": "Copied!",
      "copy": "Copy",
      "issueId": "Issue ID",
      "sourceCheck": "Source Check",
      "detected": "Detected",
      "reference": "Reference",
      "fix": "Fix"
    },
    "noPeriodsToDisplay": "No periods to display",
    "investmentVsPortfolioValue": "Investment vs Portfolio Value by",
    "month": "Month",
    "symbol": "Symbol",
    "sector": "Sector",
    "investment": "Investment",
    "portfolioValue": "Portfolio Value",
    "allTime": "All Time",
    "byYear": "By Year",
    "byMonth": "By Month",
    "dateRange": "Date Range",
    "year": "Year",
    "selectMonth": "Select Month",
    "from": "From",
    "to": "To",
    "pivotReportTable": {
      "beginningInvestment": "Beginning Investment",
      "beginningInvestmentHelp": "Cost basis carried into the selected period, as of the previous day close.",
      "beginningUnits": "Beginning Units",
      "beginningUnitsHelp": "Units carried into the selected period, as of the previous day close.",
      "endingInvestment": "Ending Investment",
      "endingInvestmentHelp": "Remaining cost basis at period end using {{costBasis}}.",
      "endingValue": "Ending Value",
      "endingValueHelp": "Market value of remaining holdings at period end.",
      "endingUnrealized": "Ending Unrealized",
      "endingUnrealizedHelp": "Unrealized gain or loss on remaining holdings at period end.",
      "endingTotalReturnPct": "Ending Total Return %",
      "endingTotalReturnPctHelp": "(Realized gain + ending unrealized gain) / ending investment. Shown as N/A when no ending investment remains.",
      "endingUnits": "Ending Units",
      "endingUnitsHelp": "Units still held at period end.",
      "soldCostBasis": "Sold Cost Basis",
      "soldCostBasisHelp": "Cost basis of the units sold during the selected period.",
      "realizedGain": "Realized Gain",
      "realizedGainHelp": "Profit or loss recognized from sales during the selected period after selling charges and tax.",
      "realizedReturnPct": "Realized Return %",
      "realizedReturnPctHelp": "Realized gain divided by sold cost basis for the units sold during the selected period.",
      "periodPurchQty": "Period Purch Qty",
      "periodPurchQtyHelp": "Units bought during the selected period.",
      "periodSalesQty": "Period Sales Qty",
      "periodSalesQtyHelp": "Units sold during the selected period, including units bought before this period.",
      "periodPurchAmt": "Period Purch Amt",
      "periodPurchAmtHelp": "Purchase amount booked during the selected period.",
      "periodSalesAmt": "Period Sales Amt",
      "periodSalesAmtHelp": "Gross sales amount booked during the selected period before fees and tax.",
      "capGainTax": "Cap Gain Tax",
      "capGainTaxHelp": "Capital gains tax recognized on sales during the selected period.",
      "noValidationData": "No validation data",
      "unitsOkInvestmentOk": "Units OK, investment OK",
      "unitDelta": "Unit delta ",
      "investmentDelta": "Investment delta ",
      "separator": " | ",
      "sector": "Sector",
      "symbol": "Symbol",
      "totalEndingInvestment": "Total - Ending Investment",
      "totalEndingTotalReturnPct": "Total - Ending Total Return %",
      "totalRealizedReturnPct": "Total - Realized Return %",
      "grandTotal": "GRAND TOTAL",
      "reportType": "Report Type",
      "pivotReport": "Pivot report",
      "pivotBy": "Pivot By",
      "dataQualityStatus": "Data Quality Status",
      "dataQualityIssueCount": "Data Quality Issue Count",
      "validationRowIssues": "Validation Row Issues",
      "validationTotalIssues": "Validation Total Issues",
      "pivotTimeAllMetrics": "{{pivot}} × time (all metrics)",
      "pivotTimeAllMetricsSuffix": " × time (all metrics)",
      "total": "Total",
      "beginningPosition": "Beginning Position",
      "beginningPositionLabel": "Beginning position:",
      "endingPosition": "Ending Position",
      "endingPositionLabel": "Ending position:",
      "periodActivity": "Period Activity",
      "periodActivityLabel": "Period activity:",
      "totals": "Totals",
      "unknown": "Unknown",
      "validation": "Validation",
      "validationSummaryApplies": "Validation summary applies to per-period columns above.",
      "pivotReportDataQualityIssue": "Pivot report data quality issue",
      "howToRead": "How to read this table:",
      "howToReadDescription": "start with Beginning Position, then Period Activity, then Ending Position. A correct unit bridge should generally follow: Beginning Units + Period Purch Qty - Period Sales Qty = Ending Units.",
      "beginningPositionDescription": "Beginning Investment and Beginning Units are computed from holdings as of the previous day before each selected period starts.",
      "endingPositionDescription": "Ending Investment, Ending Unrealized, Ending Total Return %, and Ending Units use only the holdings still open at period end.",
      "periodActivityDescription": "Sold Cost Basis, Realized Gain, Realized Return %, purchase and sales quantities/amounts, and Cap Gain Tax summarize transactions inside the selected period.",
      "zeroValuesShown": "Zero values are shown as 0.00 instead of a dash so closed positions remain explicit.",
      "endingTotalReturnPctDescription": "Ending Total Return % shows ",
      "endingTotalReturnPctDescriptionSuffix": " when a row has sales activity but no remaining ending investment, because dividing by zero would be misleading. Use Realized Return % for closed positions.",
      "continuityWarning": "Continuity warning:",
      "rowPeriodChecks": "row period check(s)",
      "and": "and ",
      "grandTotalPeriodChecks": "grand-total period check(s)",
      "doNotReconcile": "do not reconcile.",
      "unitIssues": "Unit issues:",
      "row": "row",
      "investmentIssues": "Investment issues:",
      "treatAsDiagnostic": "Treat this report as diagnostic until those deltas are resolved.",
      "totalLabel": "total",
      "csv": "CSV",
      "excel": "Excel"
    },
    "realizedGain": "Realized Gain",
    "unrealizedGain": "Unrealized Gain ({{costBasis}})",
    "profitLossLineChart": {
      "noData": "No Data",
      "realizedGain": "Realized Gain",
      "unrealizedGain": "Unrealized Gain"
    },
    "sectorPieChart": {
      "noSectors": "No Sectors",
      "total": "Total",
      "hoverForDetails": "Hover For Details"
    },
    "symbolDrilldownDrawer": {
      "title": "Symbol Drilldown Drawer",
      "noSymbols": "No Symbols",
      "symbol": "Symbol",
      "units": "Units",
      "price": "Price",
      "value": "Symbol Drilldown Drawer Value",
      "returnPct": "Return Pct",
      "trust": "Trust"
    },
    "unifiedDashboard": {
      "portfolioMarketValue": "Portfolio Market Value",
      "portfolioValueMixed": "Portfolio Value (mixed basis)",
      "portfolioValueCost": "Portfolio Value at Cost",
      "dashboardDataUnavailable": "Dashboard data unavailable",
      "refreshDashboard": "Refresh Dashboard",
      "addTransaction": "Add Transaction",
      "viewHoldings": "View Holdings",
      "performance": "Performance",
      "overview": "Overview",
      "portfolioSnapshotLive": "Your portfolio snapshot with live market data",
      "portfolioAtGlanceCost": "Your portfolio at a glance using cost basis valuation",
      "quotesAsOf": "Quotes as of {{date}}",
      "noQuoteTimestamp": "No quote timestamp available",
      "readModelRefreshed": " • Read model refreshed ",
      "liveQuotesConnected": "Live quotes connected",
      "partialQuoteCoverage": "Partial quote coverage",
      "costBasisValuation": "Cost-basis valuation",
      "lastUpdated": "Last updated: ",
      "notAvailable": "Not available",
      "refresh": "Refresh",
      "mixedValuation": "Mixed valuation: {{stale}} stale quote{{stalePlural}} and {{cost}} cost-basis holding{{costPlural}}",
      "and": " and ",
      "costBasisHolding": " cost-basis holding",
      "costBasisValuationDescription": "Cost-basis valuation: All holdings valued at cost, not market price",
      "checking": "Checking...",
      "importing": "Importing...",
      "importMarketData": "Import Market Data",
      "marketValuation": "Market valuation",
      "totalInvestment": "Total Investment",
      "costBasisAcrossHoldings": "Cost basis across all holdings",
      "unrealizedPL": "Unrealized P&L",
      "onQuotedHoldings": " on quoted holdings",
      "zeroUntilQuotes": "Zero until trusted quotes are configured",
      "coverage": "Coverage",
      "quoteCoverageHoldings": "Quote coverage across current holdings",
      "transactionActivity": "Transaction Activity",
      "viewAll": "View All",
      "recentTransactionSummary": "Recent transaction summary and activity split",
      "totalTransactions": "Total Transactions",
      "buyTransactions": "Buy Transactions",
      "sellTransactions": "Sell Transactions",
      "topHoldings": "Top Holdings",
      "largestPositions": "Largest current positions by value",
      "units": "Units",
      "quoted": "Quoted",
      "costBasis": "Cost basis",
      "noHoldingsYet": "No holdings yet.",
      "addFirstTransaction": "Add First Transaction",
      "sectorDistribution": "Sector Distribution",
      "viewAnalysis": "View Analysis",
      "portfolioAllocationSector": "Portfolio allocation by sector"
    },
    "trustBadge": {
      "warning": "Trust Badge Warning",
      "error": "Trust Badge Error"
    },
    "explanations": {
      "qualityStatus": {
        "ok": "Ok",
        "empty": "Empty",
        "stalePrices": "Stale Prices",
        "missingPrices": "Missing Prices",
        "missingFacts": "Missing Facts",
        "error": "Error"
      },
      "currencyUnconfigured": "Currency Unconfigured",
      "hideDebug": "Hide Debug",
      "showDebug": "Show Debug",
      "label": {
        "portfolioMarketValue": "Portfolio Market Value",
        "portfolioMarketValueDesc": "Portfolio Market Value",
        "ytdReturnPct": "Ytd Return Pct",
        "ytdReturnPctDesc": "Ytd Return Pct",
        "unrealizedGain": "Unrealized Gain",
        "unrealizedGainDesc": "Unrealized Gain",
        "benchmarkReturnPct": "Benchmark Return Pct",
        "benchmarkReturnPctDesc": "Benchmark Return Pct",
        "targetReturnPct": "Target Return Pct",
        "targetReturnPctDesc": "Target Return Pct",
        "outperformanceVsBenchmarkPct": "Outperformance Vs Benchmark Pct",
        "outperformanceVsBenchmarkPctDesc": "Outperformance Vs Benchmark Pct",
        "gapVsTargetPct": "Gap Vs Target Pct",
        "gapVsTargetPctDesc": "Gap Vs Target Pct",
        "unrealizedGainPctVsCost": "Unrealized Gain Pct Vs Cost",
        "unrealizedGainPctVsCostDesc": "Unrealized Gain Pct Vs Cost",
        "costBasis": "Cost Basis",
        "costBasisDesc": "Cost Basis",
        "pendingApprovalsCount": "Pending Approvals Count",
        "pendingApprovalsCountDesc": "Pending Approvals Count"
      }
    },
    "empty": {
      "addFirstTransaction": "Add First Transaction",
      "addFirstTransactionDesc": "Add First Transaction"
    },
    "admin": {
      "approvals": "Approvals",
      "approvalsDesc": "Approvals"
    },
    "kpiActions": {
      "holdings": {
        "label": "Holdings",
        "labelDesc": "Holdings"
      },
      "performance": {
        "label": "Performance",
        "labelDesc": "Performance"
      },
      "gainLoss": {
        "label": "Gain Loss",
        "labelDesc": "Gain Loss"
      },
      "quality": {
        "label": "Quality",
        "labelDesc": "Quality"
      }
    },
    "persona": {
      "title": "Persona",
      "currentContext": "Current Context",
      "availableContexts": "Available Contexts",
      "welcome": "Welcome, {{name}}"
    },
    "recentActivityUnavailable": "Recent transaction activity is temporarily unavailable. Portfolio values and other dashboard data are unaffected.",
    "viewAllTransactions": "View all transactions"
  },
  "transactions": {
    "status": {
      "draft": "Draft",
      "pendingApproval": "Pending Approval",
      "approved": "Approved",
      "rejected": "Rejected",
      "posted": "Posted",
      "void": "Void"
    },
    "type": {
      "purchase": "Purchase",
      "sale": "Sale",
      "bonusShare": "Bonus Share",
      "rightShare": "Right Share",
      "openingBalance": "Opening Balance"
    },
    "lifecycle": {
      "createDraft": "Create Draft",
      "submitForApproval": "Submit for Approval",
      "approve": "Approve",
      "reject": "Reject",
      "post": "Post",
      "void": "Void",
      "repair": "Repair & Repost",
      "bulkSubmit": "Submit All",
      "bulkApprove": "Approve All"
    },
    "lifecycleState": {
      "DRAFT": "Draft",
      "PENDING_APPROVAL": "Pending Approval",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "POSTED": "Posted",
      "VOID": "Void",
      "REPAIR_PENDING": "Repair Pending"
    },
    "actions": {
      "viewDetails": "View Details",
      "editDraft": "Edit Draft",
      "deleteDraft": "Delete Draft",
      "submitDraft": "Submit for Approval",
      "approveTransaction": "Approve Transaction",
      "rejectTransaction": "Reject Transaction",
      "voidTransaction": "Void Transaction",
      "repairTransaction": "Repair Transaction",
      "reverse": "Reverse",
      "repair": "Repair",
      "bulkReverse": "Bulk Reverse",
      "reverseDesc": "Reverse",
      "repairDesc": "Repair",
      "create": "Create",
      "createDesc": "Create",
      "view": "View",
      "viewDesc": "View",
      "import": "Import",
      "importDesc": "Import"
    },
    "errors": {
      "invalidTransition": "This action cannot be performed because the transaction is in an incompatible state ({{status}}).",
      "optimisticConflict": "The transaction was modified by another user. Please refresh and try again.",
      "makerCheckerViolation": "The same user cannot both create and approve a transaction (maker-checker policy).",
      "clientUserForbidden": "Client users are not permitted to perform this action.",
      "versionMismatch": "Transaction version mismatch. Please reload the transaction.",
      "bulkPartialFailure": "{{failed}} of {{total}} transactions could not be processed."
    },
    "list": {
      "title": "Transaction History",
      "description": "View and manage buy/sell transactions",
      "ariaLabel": "Transaction history",
      "actions": {
        "addTransaction": "Add Transaction",
        "importTransactions": "Import Transactions"
      },
      "pagination": {
        "previous": "Previous",
        "next": "Next",
        "pageOf": "Page {{currentPage}} of {{totalPages}}"
      },
      "statement": {
        "selectCompanyLabel": "Select Company:",
        "placeholder": "Type symbol or company name...",
        "noMatchingCompanies": "No matching companies",
        "noCompanyStatementsAvailable": "No company statements available",
        "selectCompanyInstruction": "Select a company to view its statement",
        "selectCompanyDescription": "View transaction history, WACC, returns, and market data",
        "noStatementsInstruction": "Company statements are shown only for companies with transactions."
      },
      "groupBy": {
        "none": "None",
        "company": "Company",
        "type": "Type",
        "status": "Status"
      },
      "columns": {
        "date": "Date",
        "symbol": "Symbol",
        "type": "Type",
        "quantity": "Quantity",
        "amount": "Amount",
        "status": "Columns Status"
      }
    },
    "filters": {
      "company": "Company",
      "type": "Type",
      "searchPlaceholder": "Search",
      "lessFilters": "Less Filters",
      "moreFilters": "More Filters",
      "clearAll": "Clear All",
      "allCompanies": "All Companies",
      "transactionType": "Transaction Type",
      "allTypes": "All Types",
      "dateRange": "Date Range",
      "amountRange": "Amount Range",
      "sortBy": "Sort By",
      "sortOrder": "Sort Order"
    },
    "types": {
      "purchase": "Purchase",
      "sale": "Sale",
      "bonusShare": "Bonus Share",
      "rightShare": "Right Share"
    },
    "sort": {
      "date": "Date",
      "company": "Company",
      "type": "Type",
      "amount": "Amount",
      "descending": "Descending",
      "ascending": "Ascending"
    },
    "modeLabels": {
      "list": "List",
      "bulk": "Bulk",
      "statement": "Statement",
      "reversals": "Reversals"
    },
    "reversals": {
      "reasons": {
        "approved": "Approved",
        "pending": "Pending",
        "repair": "Repair"
      },
      "errors": {
        "reversePermission": "Reverse Permission",
        "approvePermission": "Approve Permission",
        "rejectPermission": "Reject Permission",
        "repairPermission": "Repair Permission"
      },
      "reversePrompt": "Reverse Prompt",
      "reversePromptPlaceholder": "Reverse Prompt",
      "success": {
        "requested": "Requested",
        "approved": "Approved",
        "rejected": "Rejected",
        "repaired": "Repaired"
      },
      "actions": {
        "approve": "Approve",
        "approveConfirm": "Approve Confirm",
        "reject": "Reject",
        "rejectPrompt": "Reject Prompt",
        "rejectPlaceholder": "Reject",
        "approveDesc": "Approve",
        "rejectDesc": "Reject"
      },
      "repairPrompt": "Repair Prompt",
      "repairPlaceholder": "Repair",
      "bulk": {
        "reverseNotSupported": "Reverse Not Supported",
        "repairNotSupported": "Repair Not Supported"
      },
      "empty": {
        "title": "Empty",
        "description": "Reversals description"
      },
      "filter": {
        "status": "Filter Status",
        "all": "All",
        "eligible": "Eligible",
        "pending": "Pending",
        "repair": "Repair",
        "reversed": "Reversed"
      },
      "selected": "Selected",
      "tableTitle": "Table",
      "submitting": "Submitting",
      "title": "Reversals"
    },
    "mode": {
      "corporateAction": "Corporate Action"
    },
    "view": {
      "invalidFallback": "Invalid Fallback"
    },
    "bulk": {
      "title": "Bulk"
    },
    "statement": {
      "title": "Statement"
    }
  },
  "imports": {
    "preview": {
      "title": "Import Preview"
    },
    "validation": {
      "rowError": "Row error"
    },
    "workflow": {
      "title": "Import Data",
      "description": {
        "allFormats": "Import transactions from NEPSE portfolio statements, contract notes, or scanned bills",
        "pdfAndStatements": "Import transactions from NEPSE portfolio statements and contract notes",
        "statementAndScans": "Import transactions from NEPSE portfolio statements or scanned bills",
        "statementsOnly": "Import transactions from NEPSE portfolio statements"
      },
      "formats": {
        "excel": "Excel",
        "csv": "CSV",
        "excelShort": ".xlsx .xls",
        "csvShort": ".csv",
        "pdfContract": "PDF Contract",
        "imageOcr": "Image (OCR)",
        "pdfContractNotes": "PDF contract notes",
        "scannedImages": "scanned images",
        "pdfShort": "Contract Notes",
        "imageShort": "JPG PNG HEIC"
      },
      "supportedFormats": {
        "title": "Supported Formats",
        "single": "Supports {{format}}",
        "double": "Supports {{first}} and {{second}}",
        "multi": "Supports {{prefix}}, and {{last}}"
      },
      "dragDrop": {
        "dropFilesHere": "Drop files here",
        "dragOrClick": "Drag & drop files here or click to browse",
        "ariaLabel": "Aria"
      },
      "clientAccount": {
        "requiredLabel": "Client Account (required)",
        "selectPlaceholder": "Select a client account",
        "loading": "Loading client accounts...",
        "scopedHint": "Imports are scoped to the selected client account.",
        "optionalLabel": "Optional",
        "scopedTo": "Scoped To"
      },
      "selectClientAccountBeforeUploadHint": "Select a client account before uploading.",
      "scanFromImage": {
        "label": "Scan from Image (OCR)",
        "hint": "- Import from photo or screenshot of broker bill"
      },
      "processingTitle": "Processing:",
      "processing": {
        "uploadingFile": "Uploading file...",
        "parsingContent": "Parsing content...",
        "preparingReview": "Preparing review..."
      },
      "reviewReady": {
        "title": "Import Job Ready for Review",
        "subtitle": "{{count}} row(s) parsed - job #{{jobId}}",
        "openReview": "Open Review"
      },
      "ocr": {
        "uploadingToServer": "Uploading for server-side OCR..."
      },
      "sources": {
        "ocrImport": "OCR import",
        "pdfImport": "PDF import",
        "csvImport": "CSV import",
        "excelImport": "Excel import"
      },
      "actions": {
        "downloadCsvTemplate": "Download CSV Template",
        "advancedImportOptions": "Advanced Import Options",
        "cancelOcrNow": "Cancel OCR now",
        "cancelNow": "Cancel now",
        "remove": "Remove"
      },
      "aria": {
        "cancelFile": "Cancel {{fileName}}",
        "removeFile": "Remove {{fileName}}",
        "uploadProgress": "Upload Progress"
      },
      "settings": {
        "title": "Import Settings",
        "autoConfirmHighCertainty": "Auto-confirm high certainty entries",
        "createShellInstruments": "Create shell instruments for unknown symbols",
        "autoSkipInvalidEntries": "Auto-skip invalid entries",
        "defaultExchange": "Default Exchange:"
      },
      "guide": {
        "title": "Import Workflow:",
        "step1": "Select format or drag & drop your file (Excel, PDF contract notes, or scanned bills)",
        "step2": "For images/PDFs, OCR extracts transaction details automatically",
        "step3": "Review entries categorized by certainty level (High/Medium/Low/Invalid)",
        "step4": "Confirm, edit, or skip individual entries",
        "step5": "Finalize to create transactions - shell instruments auto-created for unknown symbols",
        "disclosureTitle": "Disclosure",
        "disclosureSubtitle": "Disclosure Subtitle"
      },
      "errors": {
        "unableToLoadClientAccounts": "Unable to load client accounts for import scope.",
        "unsupportedFileType": "Unsupported file type: {{fileName}}",
        "fileEmpty": "{{fileName}} is empty.",
        "fileTooLarge": "{{fileName}} is larger than the 25 MB import limit.",
        "uploadCancelled": "Upload cancelled",
        "failedToProcessFile": "Failed to process {{format}} file",
        "ocrProcessingFailed": "OCR processing failed",
        "pdfProcessingFailed": "PDF processing failed",
        "uploadFailed": "Upload failed",
        "selectClientAccountBeforeUpload": "Select a client account before uploading files.",
        "failedToLoadTemplate": "Failed to load template",
        "failedToDownloadTemplate": "Failed to download template. Please try again."
      },
      "success": {
        "ocrCancelledRemoved": "OCR processing cancelled. The item was removed from the queue.",
        "importFinalized": "Import finalized successfully",
        "templateDownloaded": "Template downloaded successfully"
      },
      "status": {
        "pending": "Pending",
        "processing": "Processing",
        "completed": "Completed",
        "failed": "Failed",
        "cancelled": "Cancelled",
        "partial": "Partial"
      }
    },
    "status": {
      "queued": "Queued",
      "processing": "Processing",
      "uploading": "Uploading",
      "parsing": "Parsing",
      "ocr": "OCR",
      "review": "Review",
      "finalizing": "Finalizing",
      "completed": "Completed",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "certainty": {
      "high": "High",
      "medium": "Medium",
      "low": "Low",
      "invalid": "Invalid"
    },
    "rowStatus": {
      "PENDING": "Pending",
      "SKIPPED": "Skipped",
      "POSTED": "Posted",
      "DUPLICATE": "Duplicate",
      "ERROR": "Error",
      "REMEDIATED": "Remediated"
    },
    "rowError": {
      "MISSING_SYMBOL": "Missing instrument symbol",
      "INVALID_DATE": "Invalid transaction date",
      "INVALID_QUANTITY": "Invalid quantity value",
      "INVALID_PRICE": "Invalid price value",
      "DUPLICATE_TRANSACTION": "Duplicate transaction detected",
      "UNKNOWN_INSTRUMENT": "Unknown instrument symbol",
      "MISSING_REQUIRED_FIELD": "Required field is missing",
      "PARSE_ERROR": "Row could not be parsed",
      "VALIDATION_FAILED": "Row failed validation rules"
    },
    "errors": {
      "rowValidation": "One or more rows contain validation errors. Correct them before finalizing.",
      "duplicateRow": "This row appears to be a duplicate of an existing transaction and was skipped.",
      "branchBindingRequired": "Branch context is required for this import. Ensure you are importing into a valid branch.",
      "traceUnavailable": "Import trace data is not available for this job. It may have been archived or deleted.",
      "finalizationFailed": "Import finalization failed. Transactions may be in an inconsistent state.",
      "rowCount": "{{count}} row error",
      "rowCountPlural": "{{count}} row errors",
      "evidenceDisabled": "Import evidence feature is disabled. Contact your administrator to enable this feature."
    },
    "modeLabels": {
      "list": "Transaction history",
      "create": "Create transaction",
      "bulk": "Bulk entry",
      "statement": "Company statement",
      "reversals": "Reversals and repairs"
    },
    "evidence": {
      "actions": {
        "finalize": "Finalize",
        "finalizeDesc": "Finalize",
        "retry": "Retry",
        "retryDesc": "Retry",
        "retryFailedRows": "Retry Failed Rows",
        "retryFailedRowsDesc": "Retry Failed Rows",
        "remediateRow": "Remediate Row",
        "remediateRowDesc": "Remediate Row",
        "traceRow": "Trace Row",
        "traceRowDesc": "Trace Row",
        "skipRow": "Skip Row",
        "skipRowDesc": "Skip Row"
      }
    },
    "actions": {
      "upload": "Upload",
      "uploadDesc": "Upload",
      "commit": "Commit",
      "commitDesc": "Commit"
    }
  },
  "companyStatement": {
    "title": "Company Statement",
    "description": "Per-instrument transaction timeline and valuation context.",
    "helperDescription": "Enter a listed company symbol to view holdings, buys, sells, cost basis, and statement evidence.",
    "symbol": {
      "label": "Instrument symbol",
      "placeholder": "Enter instrument symbol...",
      "error": "Enter a valid instrument symbol."
    },
    "viewButton": "View Statement",
    "actions": {
      "generate": "Generate",
      "generateDesc": "Generate",
      "export": "Export",
      "exportDesc": "Export"
    }
  },
  "filters": {
    "min": "Min",
    "max": "Max",
    "from": "From",
    "to": "To",
    "field": "Field",
    "operator": "Operator",
    "value": "Value",
    "operators": {
      "contains": "Contains",
      "equals": "Equals",
      "notEquals": "Not equals",
      "startsWith": "Starts with",
      "endsWith": "Ends with",
      "gt": "Greater than",
      "gte": "Greater than or equal",
      "lt": "Less than",
      "lte": "Less than or equal",
      "between": "Between",
      "on": "On",
      "before": "Before",
      "after": "After",
      "isNull": "Is empty",
      "isNotNull": "Is not empty",
      "in": "Is any of",
      "notIn": "Is none of"
    }
  },
  "transaction": {
    "new": "New Transaction",
    "action": {
      "success": "Transaction action completed successfully",
      "submitSuccess": "Transaction submitted for approval",
      "approveSuccess": "Transaction approved and ready for posting",
      "postSuccess": "Transaction posted successfully",
      "reverseSuccess": "Transaction reversed successfully"
    },
    "approvals": {
      "title": "Transaction Approvals"
    },
    "reversals": {
      "title": "Transaction Reversals"
    },
    "detail": {
      "notFound": "Transaction not found",
      "title": "Transaction Details",
      "closeAriaLabel": "Close transaction details",
      "basicInformation": "Basic Information",
      "financialBreakdown": "Financial Breakdown",
      "baseAmount": "Base Amount",
      "taxInformation": "Tax Information",
      "capitalGainsTax": "Capital Gains Tax",
      "taxBasis": "Tax Basis",
      "taxBasisFifo": "First-In-First-Out (FIFO)",
      "realizedPnl": "Realized P&L",
      "auditTrail": "Audit Trail",
      "createdAt": "Created:",
      "approvedBy": "Approved By:",
      "approvedAt": "At:",
      "submitForApproval": "Submit for Approval",
      "requestReversal": "Request Reversal",
      "labels": {
        "symbol": "Symbol:",
        "transactionId": "Transaction ID:",
        "billNumber": "Bill Number:",
        "date": "Date:",
        "type": "Type:"
      },
      "transactionNumber": "Transaction Number",
      "clientAccount": "Client Account",
      "portfolioAccount": "Portfolio Account",
      "quantity": "Quantity",
      "pricePerUnit": "Price/Unit",
      "amounts": "Amounts",
      "grossAmount": "Gross Amount",
      "charges": "Charges",
      "total": "Total",
      "settlement": "Settlement",
      "idempotencyKey": "Idempotency Key",
      "actions": "Actions",
      "approve": "Approve",
      "post": "Post",
      "exportPdf": "Export PDF",
      "exportExcel": "Export Excel",
      "noDisposals": "No disposals",
      "noFacts": "No facts generated",
      "historyPlaceholder": "Audit history would be displayed here",
      "actionFailed": "The transaction action could not be completed. Review the current status and try again.",
      "enterReversalReason": "Enter reversal reason:",
      "tabs": {
        "lots": "Lots ({{count}})",
        "disposals": "Disposals ({{count}})",
        "facts": "Facts ({{count}})",
        "history": "History"
      },
      "disposalsTable": {
        "lot": "Lot",
        "acquired": "Acquired",
        "qty": "Qty",
        "costPerUnit": "Cost/Unit",
        "holdingDays": "Holding Days",
        "realizedPnl": "Capital-gains tax"
      },
      "factsTable": {
        "factType": "Fact Type",
        "asOf": "As Of",
        "qty": "Qty",
        "costBase": "Cost Base",
        "marketValue": "Market Value",
        "unrealizedPnl": "Unrealized P&L",
        "averageCostPerUnit": "Average cost per unit",
        "totalCost": "Total cost",
        "saleProceeds": "Sale proceeds",
        "costBasis": "Cost basis",
        "realizedGain": "Realized gain/loss",
        "taxableGain": "Taxable gain",
        "cgtRate": "CGT rate",
        "capitalGainTax": "Capital gains tax",
        "holdingPeriodDays": "Holding period (days)"
      },
      "factsSections": {
        "position": "Position facts",
        "realized": "Realized gain/loss facts",
        "cgt": "Capital gains tax facts"
      }
    },
    "form": {
      "error": {
        "noEditPermission": "You do not have permission to edit transactions",
        "noCreatePermission": "You do not have permission to create transactions",
        "clientAccountRequired": "Client account is required",
        "updateFailed": "Failed to update transaction",
        "createFailed": "Failed to create transaction"
      },
      "title": {
        "edit": "Edit Transaction",
        "create": "Add New Transaction"
      },
      "description": {
        "edit": "Update transaction details",
        "create": "Record a buy or sell transaction"
      },
      "field": {
        "clientAccount": "Client Account",
        "company": "Company",
        "transactionType": "Transaction Type",
        "transactionDate": "Transaction Date",
        "billNumber": "Bill Number",
        "quantity": "Quantity",
        "pricePerUnit": "Price per Unit",
        "totalAmount": "Total Amount",
        "commissionBrokerage": "Commission (Brokerage)",
        "dpCharges": "DP Charges",
        "sebonFee": "SEBON Fee",
        "otherCharges": "Other Charges",
        "capitalGainTax": "Capital Gain Tax"
      },
      "placeholder": {
        "clientAccount": "Select client account",
        "company": "Select company",
        "billNumber": "Bill number",
        "pricePerUnit": "Price per unit",
        "autoCalculated": "Auto-calculated",
        "zeroAmount": "0.00"
      },
      "type": {
        "purchase": "Purchase",
        "sale": "Sale",
        "bonusShare": "Bonus Share",
        "rightShare": "Right Share",
        "openingBalance": "Opening Balance"
      },
      "section": {
        "openingBalance": "Opening Balance Lifecycle Fields",
        "transactionDetails": "Transaction Details",
        "allocation": "Allocation",
        "charges": "Charges and Taxes",
        "source": "Source and Reference"
      },
      "openingBalance": {
        "description": "These fields are used for NFRS/Tax compliance and represent the opening position of the portfolio.",
        "fields": {
          "principalCostNfrs": "Principal Cost (NFRS)",
          "transactionCostNfrs": "Transaction Cost (NFRS)",
          "unitSum": "Unit Sum",
          "waccNfrs": "WACC (NFRS)",
          "profitLossNfrs": "Profit/Loss (NFRS)",
          "principalAmountTax": "Principal Amount (Tax)",
          "tcTax": "TC Tax",
          "waccTax": "WACC (Tax)",
          "profitLossTax": "Profit/Loss (Tax)"
        }
      },
      "fields": {
        "quantityPlaceholder": "Enter quantity"
      },
      "imports": {
        "cost_basis": {
          "title": "Cost-basis pricing detected",
          "description": "Some holdings are valued using cost basis due to missing market prices."
        }
      },
      "chargePreview": {
        "title": "Charge Preview",
        "brokerage": "Brokerage",
        "dpCharges": "DP Charges",
        "sebonFee": "SEBON Fee",
        "totalCharges": "Total Charges",
        "totalCost": "Total Cost",
        "netReceivable": "Net Receivable"
      },
      "chargeDifferences": {
        "title": "Values differ from calculated:",
        "description": "Your entered values will be used (priority given to user input)."
      },
      "charges": {
        "title": "Charges & Fees (Optional)",
        "subtitle": "Override auto-calculated values",
        "taxTitle": "Charges, Fees & Tax (Optional)"
      },
      "action": {
        "updating": "Updating...",
        "creating": "Creating...",
        "updateTransaction": "Update Transaction",
        "previewTransaction": "Preview Transaction",
        "backToEdit": "Back to Edit",
        "confirmAndSubmit": "Confirm & Submit",
        "processing": "Processing..."
      },
      "preview": {
        "title": "Transaction Preview",
        "stateActions": "State & Actions",
        "action": "Action",
        "type": "Type",
        "symbol": "Symbol",
        "quantity": "Quantity",
        "price": "Price",
        "total": "Total",
        "chargesSummary": "Charges Summary",
        "approvalWorkflow": "Approval Workflow",
        "approvalWorkflowEditDescription": "This transaction will require re-approval after editing.",
        "approvalWorkflowCreateDescription": "This transaction will be created in PENDING_APPROVAL status and will require approval before posting."
      },
      "confirmation": {
        "title": "Confirm Transaction",
        "updatePrompt": "Are you sure you want to update this transaction?",
        "createPrompt": "Are you sure you want to create this transaction?"
      }
    },
    "list": {
      "title": "Transactions",
      "empty": "No transactions found"
    },
    "create": {
      "title": "New Transaction",
      "buy": "Buy",
      "sell": "Sell"
    },
    "status": {
      "draft": "Draft",
      "submitted": "Submitted",
      "approved": "Approved",
      "posted": "Posted",
      "rejected": "Rejected",
      "reversed": "Reversed"
    },
    "approve": {
      "confirm": "Approve this transaction?"
    },
    "reject": {
      "reason": "Reason for rejection"
    },
    "post": {
      "success": "Transaction posted successfully"
    },
    "reverse": {
      "confirm": "Reverse this transaction?",
      "title": "Reverse Transaction",
      "reasonPrompt": "Please provide a reason for reversing this transaction.",
      "reasonLabel": "Reversal Reason",
      "reasonRequired": "A reversal reason is required."
    },
    "export": "Export"
  },
  "form": {
    "unsavedChanges": "Unsaved changes",
    "saved": "Saved",
    "saveFailed": "Save failed",
    "unknownFieldType": "Unknown field type: {{fieldType}} (field: {{fieldId}})",
    "noOptionsAvailable": "No options available",
    "optionsLoadError": "Failed to load options",
    "typeToSearch": "Type at least {{count}} character(s) to search",
    "role": {
      "title": "Role",
      "createTitle": "Create Role",
      "editTitle": "Edit Role",
      "viewTitle": "Role Details",
      "success": "Role saved successfully",
      "error": "Failed to save role"
    },
    "reconciliationRun": {
      "title": "Start Reconciliation Run",
      "success": "Reconciliation run started successfully",
      "error": "Failed to start reconciliation run"
    },
    "importJob": {
      "title": "Upload Import",
      "success": "Import job created successfully",
      "error": "Failed to create import job"
    },
    "user": {
      "title": "Create User",
      "createTitle": "Create User",
      "editTitle": "Edit User",
      "viewTitle": "User Details",
      "createDescription": "Create a new organization user",
      "success": "User saved successfully",
      "error": "Failed to save user"
    },
    "branch": {
      "createTitle": "Create Branch",
      "editTitle": "Edit Branch",
      "viewTitle": "Branch Details"
    },
    "platformOrganization": {
      "createTitle": "Create Platform Organization",
      "editTitle": "Edit Platform Organization",
      "viewTitle": "Platform Organization Details",
      "disableReason": "Reason for disabling this organization",
      "disableApproval": "I approve disabling this organization and revoking its active access",
      "filingProfile": {
        "title": "Regulatory filing identity",
        "description": "Legal identity used for governed SEBON and IRD artifacts. PAN is stored in the canonical organization profile and masked in the UI."
      }
    },
    "client": {
      "createTitle": "Create Client",
      "editTitle": "Edit Client",
      "viewTitle": "Client Details",
      "createDescription": "Set up the investor profile and account details.",
      "success": "Client saved successfully",
      "error": "Failed to save client"
    },
    "transaction": {
      "title": "New Transaction",
      "createTitle": "New Transaction",
      "editTitle": "Edit Transaction",
      "viewTitle": "Transaction Details",
      "success": "Transaction saved successfully",
      "error": "Failed to save transaction"
    },
    "instrument": {
      "createTitle": "Create Instrument",
      "editTitle": "Edit Instrument",
      "viewTitle": "Instrument Details",
      "success": "Instrument saved successfully",
      "error": "Failed to save instrument",
      "section": {
        "identity": "Identity",
        "details": "Reference Details",
        "status": "Status"
      }
    },
    "clientAccount": {
      "createTitle": "Create Client Account",
      "editTitle": "Edit Client Account",
      "viewTitle": "Client Account Details",
      "success": "Client account saved successfully",
      "error": "Failed to save client account"
    },
    "portfolio": {
      "createTitle": "Create Portfolio",
      "editTitle": "Edit Portfolio",
      "viewTitle": "Portfolio Details",
      "createDescription": "Link a portfolio account to an existing investor client.",
      "success": "Portfolio saved successfully",
      "error": "Failed to save portfolio"
    },
    "moduleAssignments": {
      "createTitle": "Enable Module",
      "editTitle": "Configure Module Assignment",
      "viewTitle": "Module Assignment Details"
    },
    "portfolioAccount": {
      "createTitle": "Create Portfolio Account",
      "editTitle": "Edit Portfolio Account",
      "viewTitle": "Portfolio Account Details",
      "success": "Portfolio account saved successfully",
      "error": "Failed to save portfolio account"
    },
    "collection": {
      "missingConfiguration": "This structured field is not configured correctly.",
      "invalid": "Enter rows using the structured editor.",
      "minimumRows": "Add at least {{count}} row.",
      "maximumRows": "No more than {{count}} row is allowed.",
      "invalidRow": "Row {{index}} is invalid.",
      "requiredCell": "Row {{index}} requires {{field}}.",
      "invalidDecimal": "Row {{index}} has an invalid value for {{field}}.",
      "journalUnbalanced": "Total debits and credits must balance before preview.",
      "journalSummary": "Debits: {{debit}} · Credits: {{credit}}",
      "count": "{{count}} row",
      "row": "Row {{index}}",
      "count_other": "{{count}} rows",
      "minimumRows_other": "Add at least {{count}} rows.",
      "maximumRows_other": "No more than {{count}} rows are allowed.",
      "journalLineInvalid": "Row {{index}} must contain one positive debit or credit amount, not both.",
      "journalAmountInvalid": "Row {{index}} contains an invalid or negative journal amount.",
      "journalTotalRequired": "Journal totals must be greater than zero before submission."
    },
    "corporateAction": {
      "createTitle": "Create Corporate Action",
      "editTitle": "Edit Corporate Action",
      "viewTitle": "Corporate Action Details",
      "section": {
        "identity": "Identity",
        "dates": "Dates",
        "terms": "Terms & Rates"
      },
      "success": "Corporate action saved successfully.",
      "error": "Failed to save corporate action."
    },
    "organizationProfile": {
      "editTitle": "Edit Organization Profile",
      "viewTitle": "Organization Profile",
      "section": {
        "identity": "Organization Details"
      },
      "success": "Organization profile updated successfully.",
      "error": "Failed to update organization profile."
    },
    "platformModuleAssignment": {
      "createTitle": "Assign module"
    },
    "platformUser": {
      "createTitle": "Create platform user",
      "editTitle": "Edit platform user",
      "viewTitle": "View platform user"
    },
    "chooseFile": "Choose file",
    "removeFile": "Remove file"
  },
  "openingCutover": {
    "history": {
      "title": "Opening Cutover History"
    },
    "fields": {
      "journalLines": "Opening journal lines",
      "cutoverDate": "Cutover date",
      "supersedesBatchId": "Batch being replaced",
      "lots": "Opening position lots",
      "cash": "Opening cash balances",
      "receivables": "Opening receivables",
      "status": "Status",
      "version": "Version",
      "manifestHash": "Manifest hash",
      "journalEntryId": "Journal entry",
      "supersededByBatchId": "Replacement batch",
      "previewedBy": "Previewed by",
      "approvedBy": "Approved by",
      "approvedAt": "Approved at",
      "createdAt": "Created at",
      "updatedAt": "Updated at"
    },
    "help": {
      "journalLines": "Add at least two opening journal lines. Enter zero on the unused side of each line; total debits and credits must match.",
      "cutoverDate": "The effective opening date. It must belong to an available accounting period.",
      "supersedesBatchId": "Optional approved batch to reverse when this replacement is approved.",
      "lots": "Add each opening position as a separate row with its client, optional portfolio, instrument, exact quantity, total cost, and acquisition date.",
      "cash": "Add each client or portfolio cash balance as a separate row with its currency and exact amount.",
      "receivables": "Add each opening receivable with its client, optional portfolio, receivable type, currency, exact amount, and optional due date.",
      "status": "Current preview, approval, or reversal state.",
      "version": "Optimistic-lock version for the immutable lifecycle record.",
      "manifestHash": "Deterministic fingerprint of the validated opening manifest.",
      "journalEntryId": "Accounting journal created when the cutover was approved.",
      "supersededByBatchId": "Approved replacement that superseded this batch.",
      "previewedBy": "User who validated and previewed the manifest.",
      "approvedBy": "Different authorized user who approved the cutover.",
      "approvedAt": "Time the cutover was atomically materialized.",
      "createdAt": "Time the preview batch was created.",
      "updatedAt": "Time the lifecycle record last changed."
    },
    "columns": {
      "ledgerAccountId": "Ledger account",
      "debit": "Debit",
      "credit": "Credit",
      "clientAccountId": "Client account",
      "portfolioAccountId": "Portfolio account",
      "instrumentSymbol": "Instrument",
      "quantity": "Quantity",
      "totalCost": "Total cost",
      "acquisitionDate": "Acquisition date",
      "currency": "Currency",
      "amount": "Amount",
      "receivableType": "Receivable type",
      "dueDate": "Due date",
      "narration": "Narration"
    },
    "collections": {
      "journalLines": {
        "add": "Add journal line",
        "empty": "No opening journal lines have been added.",
        "item": "Journal line {{index}}"
      },
      "remove": "Remove row",
      "lots": {
        "add": "Add position",
        "empty": "No opening positions have been added.",
        "item": "Position {{index}}"
      },
      "cash": {
        "add": "Add cash balance",
        "empty": "No opening cash balances have been added.",
        "item": "Cash balance {{index}}"
      },
      "receivables": {
        "add": "Add receivable",
        "empty": "No opening receivables have been added.",
        "item": "Receivable {{index}}"
      }
    },
    "actions": {
      "restate": "Restate opening cutover",
      "reverse": "Reverse opening cutover",
      "history": "View cutover history",
      "preview": "Validate and preview",
      "approve": "Approve cutover"
    },
    "messages": {
      "restateSuccess": "Opening cutover restated successfully.",
      "reverseSuccess": "Opening cutover reversed successfully.",
      "previewSuccess": "Opening cutover validated and previewed.",
      "approveSuccess": "Opening cutover approved and materialized."
    },
    "restate": {
      "message": "Are you sure you want to restate this opening cutover?",
      "title": "Restate opening cutover"
    },
    "reverse": {
      "message": "Are you sure you want to reverse this opening cutover?",
      "title": "Reverse opening cutover"
    },
    "create": {
      "title": "Preview opening cutover",
      "description": "Validate opening holdings, cash, receivables, and the balanced opening journal before approval. Previewing never changes authoritative balances."
    },
    "replace": {
      "title": "Replace opening cutover",
      "description": "Create an immutable replacement for this batch. Approval reverses the superseded batch and applies the replacement atomically."
    },
    "view": {
      "title": "Opening cutover details",
      "description": "Review the governed manifest, approval state, journal linkage, lineage, and audit timestamps."
    },
    "approve": {
      "title": "Approve opening cutover?",
      "message": "This atomically creates opening holdings, cash, receivables, and the balanced journal. The approver must be different from the previewing user."
    },
    "sections": {
      "scope": {
        "title": "Cutover scope",
        "description": "Choose the accounting date and identify any preview this batch replaces."
      },
      "positions": {
        "title": "Opening positions",
        "description": "Enter each client and portfolio lot with its exact quantity, cost, and acquisition date."
      },
      "cash": {
        "title": "Cash and receivables",
        "description": "Record opening cash balances and receivables separately so their evidence remains clear."
      },
      "journal": {
        "title": "Opening journal",
        "description": "Enter at least two journal lines. Total debits and credits must balance before preview."
      }
    },
    "columnHelp": {
      "clientAccountId": "Use the authorized client account reference.",
      "portfolioAccountId": "Optional portfolio scope within the client account.",
      "instrumentSymbol": "Canonical instrument symbol.",
      "quantity": "Exact opening quantity; decimal precision is preserved.",
      "totalCost": "Total acquisition cost for this opening lot.",
      "acquisitionDate": "Original acquisition date for holding-period evidence.",
      "currency": "Three-letter ISO currency code.",
      "amount": "Exact opening amount.",
      "receivableType": "Canonical receivable classification used by accounting.",
      "dueDate": "Optional expected settlement date.",
      "ledgerAccountId": "Authorized ledger account receiving this journal line.",
      "debit": "Debit amount; enter zero when this is a credit line.",
      "credit": "Credit amount; enter zero when this is a debit line.",
      "narration": "Optional line-level explanation."
    }
  },
  "common": {
    "loading": "Loading...",
    "amount": "Amount",
    "AAL_INSUFFICIENT": "Additional authentication is required.",
    "planned": "This feature is planned and not yet available.",
    "locked": "Access restricted",
    "maintenance": "Temporarily unavailable",
    "error": {
      "unexpected": "An unexpected error occurred",
      "description": "Error description",
      "title": "Error",
      "stackTrace": "Stack trace",
      "tryAgain": "Try again",
      "contactSupport": "Contact support",
      "reportDisplayError": "Report Display Error",
      "insufficientPermission": "You do not have sufficient permission to perform this action.",
      "fetchFailed": "Failed to fetch data",
      "fetchProfileFailed": "Failed to fetch profile",
      "fetchNavigationFailed": "Failed to fetch navigation"
    },
    "errorTitle": "Something went wrong",
    "retry": "Retry",
    "emptyTitle": "Nothing to show yet",
    "permissionDeniedTitle": "Access unavailable",
    "permissionDeniedDescription": "You do not have permission to view this finance surface.",
    "staleDataTitle": "Data may be stale",
    "staleDataDescription": "Refresh or import updated prices before relying on this valuation.",
    "unsavedChangesPrompt": "You have unsaved changes. Are you sure you want to leave this page?",
    "sectionUnavailable": "Section unavailable",
    "section": {
      "user": {
        "identity": "Identity",
        "assignment": "Assignment"
      },
      "role": {
        "definition": "Definition",
        "permissions": "Permissions"
      }
    },
    "field": {
      "role": {
        "name": "Name",
        "code": "Code",
        "status": "Status"
      }
    },
    "errorBoundary": {
      "unexpectedError": "Unexpected error",
      "errorInSection": "An error occurred in the {{section}} section.",
      "application": "Application",
      "errorDetails": "Error details",
      "tryAgain": "Try Again",
      "authError": "Authentication Error",
      "authErrorDescription": "Unable to load the authentication system. Please refresh the page.",
      "refreshPage": "Refresh Page",
      "dashboardError": "Dashboard Error",
      "unableToLoadDashboard": "Unable to load dashboard data.",
      "reloadDashboard": "Reload Dashboard",
      "portfolioError": "Portfolio Error",
      "unableToLoadPortfolio": "Unable to load portfolio data.",
      "reloadPortfolio": "Reload Portfolio",
      "transactionError": "Transaction Error",
      "unableToLoadTransactions": "Unable to load transactions.",
      "reloadTransactions": "Reload Transactions",
      "adminError": "Admin Panel Error",
      "unableToLoadAdmin": "Unable to load admin panel.",
      "reloadAdmin": "Reload Admin Panel",
      "reportsError": "Reports Error",
      "unableToLoadReports": "Unable to load reports.",
      "reloadReports": "Reload Reports"
    },
    "dataTable": {
      "noRowsToDisplay": "No rows to display"
    },
    "financeHelpPanel": {
      "howItWorks": "How it works"
    },
    "dashboard": {
      "widgets": {
        "marketValue": "Market value",
        "costBasis": "Cost basis",
        "unrealizedGain": "Unrealized gain/loss",
        "realizedGain": "Realized gain/loss",
        "totalGainLoss": "Total gain/loss",
        "capitalGainTax": "Capital gains tax",
        "returnOnCost": "Return on cost",
        "taxProvenanceCoverage": "Tax provenance coverage",
        "nfrsEvidence": "NFRS evidence"
      }
    },
    "accountNumber": "Account Number",
    "actionType": "Action Type",
    "asOfDate": "As Of Date",
    "availableQuantity": "Available Quantity",
    "avgCost": "Average Cost",
    "boId": "BO ID",
    "breachType": "Breach Type",
    "breachValue": "Breach Value",
    "severity": "Severity",
    "calculationVersion": "Calculation Version",
    "capitalGain": "Capital Gain",
    "change": "Change",
    "clientAccountId": "Client Account",
    "clientCode": "Client Code",
    "clientName": "Client Name",
    "clientType": "Client Type",
    "completedAt": "Completed At",
    "concentrationPct": "Concentration %",
    "costBasis": "Cost Basis",
    "createdAt": "Created At",
    "currency": "Currency",
    "detectedAt": "Detected At",
    "displayName": "Name",
    "dpCode": "DP Code",
    "endDate": "End Date",
    "entityId": "Entity ID",
    "entityType": "Entity Type",
    "errorCount": "Errors",
    "exDate": "Ex-Date",
    "exchange": "Exchange",
    "fiscalYear": "Fiscal Year",
    "fiscalYearName": "Fiscal Year",
    "holdingPeriodDays": "Holding Period Days",
    "id": "ID",
    "importType": "Import Type",
    "instrumentId": "Instrument ID",
    "instrumentName": "Instrument Name",
    "instrumentSymbol": "Instrument Symbol",
    "instrumentType": "Instrument Type",
    "isActive": "Active",
    "isDefault": "Default",
    "isLocked": "Locked",
    "isSystem": "System",
    "isin": "ISIN",
    "journalDate": "Journal Date",
    "kind": "Kind",
    "lastUpdated": "Last Updated",
    "limitValue": "Limit Value",
    "marketPrice": "Market Price",
    "valuationAsOf": "Valuation As Of",
    "valuationFreshness": "Freshness",
    "valuationSource": "Valuation Source",
    "unrealizedGainLoss": "Unrealized Gain/Loss",
    "marketValue": "Market Value",
    "marketValueCurrency": "Currency",
    "matchedRecords": "Matched",
    "membershipStatus": "Membership Status",
    "mfaEnabled": "MFA Enabled",
    "ownerType": "Owner Type",
    "payDate": "Pay Date",
    "periodNumber": "Period Number",
    "portfolioAccountId": "Portfolio Account",
    "quantity": "Quantity",
    "realizedGain": "Realized Gain",
    "recordCount": "Records",
    "recordDate": "Record Date",
    "reference": "Reference",
    "riskMeasure": "Risk Measure",
    "roles": "Roles",
    "ruleId": "Rule ID",
    "ruleVersion": "Rule Version",
    "runId": "Run ID",
    "saleDate": "Sale Date",
    "sector": "Sector",
    "securityName": "Security Name",
    "sourceAuthority": "Source Authority",
    "sourceBatchId": "Source Batch",
    "sourceBook": "Source Book",
    "sourceFileName": "Source File",
    "sourceState": "Source State",
    "startDate": "Start Date",
    "startedAt": "Started At",
    "symbol": "Symbol",
    "taxAmount": "Tax Amount",
    "taxDomain": "Tax Domain",
    "taxRate": "Tax Rate",
    "branchId": "Branch ID",
    "totalCost": "Total Cost",
    "totalCredit": "Total Credit",
    "totalDebit": "Total Debit",
    "totalQuantity": "Total Quantity",
    "totalRecords": "Total",
    "unmatchedRecords": "Unmatched",
    "unrealizedGain": "Unrealized Gain",
    "unrealizedPnl": "Unrealized P&L",
    "userEmail": "User Email",
    "userTypeId": "User Type",
    "warningCount": "Warnings",
    "weightedAverageCost": "Weighted Average Cost",
    "commission": "Commission",
    "dpCharge": "DP Charge",
    "otherCharges": "Other Charges",
    "price": "Price",
    "sebonFee": "SEBON Fee",
    "tradeDate": "Trade Date",
    "transactionType": "Transaction Type",
    "success": "Success",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "create": "Create",
    "update": "Update",
    "submit": "Submit",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "search": "Search",
    "clearSearch": "Clear search",
    "show": "Show",
    "hide": "Hide",
    "bullet": "•",
    "name": "Name",
    "description": "Common description",
    "module": "Module",
    "filter": "Filter",
    "sort": "Sort",
    "export": "Export",
    "import": "Import",
    "download": "Download",
    "upload": "Upload",
    "refresh": "Refresh",
    "actions": {
      "label": "Actions",
      "export": "Export",
      "exportDesc": "Export",
      "viewDetails": "View Details",
      "available": "Available actions"
    },
    "details": "Details",
    "settings": "Settings",
    "unknown": "Unknown",
    "notAvailable": "N/A",
    "help": "Help",
    "about": "About",
    "version": "Version",
    "language": "Language",
    "theme": "Theme",
    "logout": "Logout",
    "login": "Login",
    "signup": "Sign Up",
    "forgotPassword": "Forgot Password?",
    "resetPassword": "Reset Password",
    "changePassword": "Change Password",
    "profile": "Profile",
    "account": "Account",
    "preferences": "Preferences",
    "notifications": "Notifications",
    "security": "Security",
    "privacy": "Privacy",
    "hubCatalog": {
      "emptyTitle": "No hubs available",
      "labelUnavailable": "Label unavailable"
    },
    "unifiedTable": {
      "of": "of",
      "records": "Records",
      "items": "Items",
      "searchPlaceholder": "Search...",
      "pageOf": "Page {{page}} of {{totalPages}}",
      "noRowsToDisplay": "No Rows To Display",
      "selectAllRows": "Select All Rows",
      "filterByColumn": "Filter By Column",
      "selectRowNumber": "Select Row Number",
      "total": "Total",
      "previousPage": "Previous Page",
      "nextPage": "Next Page",
      "editRecord": "Edit record",
      "openRecordDetails": "Open record details"
    },
    "terms": "Terms",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service",
    "cookiePolicy": "Cookie Policy",
    "accessDenied": "Access Denied",
    "unauthorizedAccess": "Unauthorized Access",
    "noPermission": "You don't have permission to access this page. Please contact your administrator if you believe this is an error.",
    "goToHome": "Go to Home",
    "goBack": "Go Back",
    "pageNotFound": "Page Not Found",
    "pageNotFoundDescription": "The page you're looking for doesn't exist or may have been moved.",
    "errorState": {
      "authenticationRequired": "Authentication Required",
      "pleaseLogin": "Please log in to access this resource.",
      "refreshPage": "Refresh Page",
      "serviceUnavailable": "Service Unavailable",
      "serviceUnavailableDescription": "The service is temporarily unavailable. Please try again later.",
      "noResults": "No results to display",
      "noResultsDescription": "There is no data to display for this view.",
      "partialDataFailure": "Partial Data Failure",
      "partialDataFailureDescription": "Some data failed to load. The page is partially functional.",
      "dataQualityWarning": "Data Quality Warning",
      "dataQualityWarningDescription": "Data quality issues detected. Results may be incomplete.",
      "systemError": "System Error",
      "systemErrorDescription": "An unexpected error occurred. Please try again.",
      "networkError": "Network error - unable to connect to server",
      "authenticationRequiredShort": "Authentication required",
      "accessDeniedShort": "Access denied",
      "serviceUnavailableShort": "Service temporarily unavailable",
      "unexpectedError": "An unexpected error occurred"
    },
    "available": "Available",
    "checking": "Checking",
    "live": "Live",
    "home": "Home",
    "data": "Data",
    "operations": "Operations",
    "reports": "Reports",
    "admin": "Admin",
    "saving": "Saving",
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "warning": "Warning",
      "error": "Error",
      "success": "Success"
    },
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "notes": "Notes",
    "optional": "Optional",
    "dismissNotification": "Dismiss Notification",
    "dismiss": "Dismiss",
    "prompt": {
      "enterValue": "Enter Value",
      "enterReason": "Enter Reason"
    },
    "filters": {
      "field": "Field",
      "operator": "Operator",
      "min": "Min",
      "max": "Max",
      "value": "Value"
    },
    "conditionBuilder": {
      "condition": "Condition",
      "conditions": "Conditions",
      "addCondition": "Add Condition",
      "noConditionsAdded": "No Conditions Added"
    },
    "dataFreshness": {
      "ariaLabel": "Aria"
    },
    "degradedState": {
      "dataQuality": "Data Quality",
      "error": "Degraded State Error",
      "warning": "Degraded State Warning",
      "issue": "Issue",
      "issues": "Issues",
      "detected": "Detected",
      "treatAsDiagnostic": "Treat As Diagnostic",
      "hideDetails": "Hide Details",
      "showDetails": "Show Details",
      "dataQualityOk": "Data Quality Ok"
    },
    "drawers": {
      "closeDrawer": "Close Drawer",
      "auditLog": "Audit Log",
      "loadingAuditEntries": "Loading Audit Entries",
      "noAuditEntries": "No Audit Entries",
      "by": "By",
      "evidence": "Evidence",
      "evidenceDescription": "Evidence description",
      "loadingEvidence": "Loading Evidence",
      "noEvidenceItems": "No Evidence Items",
      "openEvidence": "Open Evidence",
      "dataLineage": "Data Lineage",
      "lineageForField": "Lineage For Field",
      "lineageDescription": "Lineage description",
      "loadingLineage": "Loading Lineage",
      "noLineageInfo": "No Lineage Info",
      "produces": "Produces",
      "rowDetailTitle": "Row Details",
      "rowDetail": "Row Detail",
      "primaryFields": "Primary Fields",
      "secondaryFields": "Secondary Fields",
      "technicalFields": "Technical Fields"
    },
    "groupedTable": {
      "noRowsToDisplay": "No Rows To Display",
      "expandAll": "Expand All",
      "collapseAll": "Collapse All",
      "group": "Group",
      "groups": "Groups",
      "totalItems": "Total Items"
    },
    "hubTabs": {
      "noContentAvailable": "No Content Available"
    },
    "marketFreshness": {
      "quotedTitle": "Quoted",
      "pricesAsOf": "Prices As Of",
      "marketPricesCurrent": "Market Prices Current",
      "mixedTitle": "Mixed",
      "partialQuotesAsOf": "Partial Quotes As Of",
      "partialMarketCoverage": "Partial Market Coverage",
      "costBasisTitle": "Cost Basis",
      "costBasisOnly": "Cost Basis Only",
      "partialMarketData": "Partial Market Data"
    },
    "moduleGuard": {
      "moduleNotAvailable": "Module Not Available",
      "moduleNotEnabled": "Module Not Enabled"
    },
    "networkStatus": {
      "offlineMessage": "Offline Message",
      "connection": "Connection"
    },
    "tableToolbar": {
      "filter": "Filter",
      "filters": "Filters",
      "filterPlaceholder": "Filter",
      "clearFilters": "Clear Filters",
      "clearSearch": "Clear Search",
      "activeFilters": "Active Filters",
      "clearAll": "Clear All",
      "compact": "Compact",
      "comfortable": "Comfortable",
      "groupBy": "Group By",
      "sort": "Sort",
      "sortBy": "Sort By",
      "columns": "Columns",
      "visibleColumns": "Visible Columns",
      "none": "None",
      "export": "Export",
      "clearFilter": "Clear Filter"
    },
    "all": "All",
    "table": {
      "resizeColumn": "Resize column",
      "actions": "Actions",
      "moreActions": "More actions",
      "selectRow": "Select row",
      "collapseDetails": "Collapse details",
      "expandDetails": "Expand details",
      "showLess": "Show less",
      "showMore": "Show more",
      "globalSearch": {
        "placeholder": "Search..."
      },
      "clearFilters": "Clear filters",
      "groupBy": "Group and totals",
      "sum": "Total",
      "showFilterRow": "Show filter row",
      "hideFilterRow": "Hide filter row",
      "showFilters": "Show filters",
      "hideFilters": "Hide filters",
      "columns": "Columns",
      "searchColumns": "Search columns",
      "pinnedLeft": "Pinned left",
      "pinnedRight": "Pinned right",
      "showAll": "Show all",
      "hideOptional": "Hide optional",
      "resetLayout": "Reset layout",
      "densityLabel": "Density",
      "density": {
        "compact": "Compact",
        "standard": "Standard",
        "comfortable": "Comfortable"
      },
      "refresh": "Refresh",
      "exportLabel": "Export",
      "export": {
        "scope": "Export scope",
        "currentPage": "Current page",
        "selectedRows": "Selected rows",
        "allMatching": "All matching",
        "configureSchema": "Define schema",
        "availableFields": "Available fields",
        "schemaFields": "Export schema",
        "schemaHelp": "Drag fields from the available list into export positions and reorder them by dragging between slots.",
        "position": "Export column {{position}}",
        "dropField": "Drop a field here",
        "included": "Included",
        "available": "Available",
        "resetSchema": "Reset schema",
        "applySchema": "Apply schema",
        "selectAll": "Select all",
        "deselectAll": "Deselect all",
        "fieldsSelected": "{{selected}} of {{total}} fields selected",
        "help": "Choose the fields to include in the export.",
        "visibleFields": "Visible fields"
      },
      "bulkActions": "Bulk actions",
      "rowSelected": "row selected",
      "rowsSelected": "rows selected",
      "savedViews": "Saved views",
      "saveViewAs": "Save view as",
      "unsavedChanges": "unsaved changes",
      "resetFilters": "Reset filters",
      "resetAll": "Reset all",
      "resultsCount": "{{count}} results",
      "perPage": "per page",
      "rowsPerPage": "Rows per page",
      "pageInfo": "{{start}}–{{end}} of {{total}}",
      "pageOf": "Page {{current}} of {{total}}",
      "firstPage": "First page",
      "previousPage": "Previous page",
      "nextPage": "Next page",
      "lastPage": "Last page",
      "collapseGroup": "Collapse group",
      "expandGroup": "Expand group",
      "aggregates": "Total: {{value}}",
      "row": "row",
      "rows": "rows",
      "group": {
        "nullValue": "None"
      },
      "loading": "Loading",
      "viewOptions": "View options",
      "emptyState": {
        "readOnlyHint": "This data is derived from transactions and opening balances. Post a transaction or import an opening cutover to populate it."
      }
    },
    "upgradePrompt": {
      "featureNotAvailable": "Feature Not Available",
      "featureNotAvailableInPlan": "Feature Not Available In Plan",
      "feature": "Feature"
    },
    "errorLabel": "Error",
    "failedToLoadData": "Failed To Load Data",
    "unknownError": "Unknown Error",
    "clear": "Clear",
    "apply": "Apply",
    "yes": "Yes",
    "no": "No",
    "listSeparator": "List Separator",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "ok": "OK",
    "unavailable": "Unavailable",
    "configurationMismatchTitle": "Configuration Mismatch",
    "configurationMismatchShort": "Config Mismatch",
    "configurationMismatchDescription": "The current configuration does not match the expected settings. Please review and update your configuration.",
    "unexpectedError": "Unexpected Error",
    "remove": "Remove",
    "notAvailableShort": "N/A",
    "system": "System",
    "partialData": "Partial Data",
    "noDataAvailable": "No Data Available",
    "copy": "Copy",
    "copied": "Copied",
    "done": "Done",
    "clearFilter": "Clear Filter",
    "general": "General",
    "organization": "Organization",
    "modules": "Modules",
    "importing": "Importing",
    "none": "None",
    "space": "Space",
    "redacted": "Redacted",
    "cancelDesc": "Cancel",
    "nextDesc": "Next",
    "submitDesc": "Submit",
    "empty": "Empty",
    "action": {
      "save": "Save",
      "edit": "Edit",
      "delete": "Deactivate",
      "suspend": "Suspend",
      "reactivate": "Reactivate"
    },
    "assign": "Assign",
    "confirmAction": "Confirm Action",
    "enterReason": "Enter Reason",
    "reasonRequiredForAction": "Reason Required For Action",
    "reasonPlaceholder": "Reason",
    "loadMore": "Load More",
    "form": {
      "noOptionsAvailable": "No options available",
      "jsonParseError": "Invalid JSON format",
      "requiredField": "Required field",
      "validationSummary": "Please fix the following errors before submitting:",
      "reviewTitle": "Review your changes",
      "reviewDescription": "Please review the information below before submitting.",
      "edit": "Edit",
      "confirmSubmit": "Confirm Submit"
    },
    "file": {
      "selected": "Selected"
    },
    "breadcrumb": "Breadcrumb",
    "jobs": "Jobs",
    "branches": "Branches",
    "errorShort": "Error",
    "appName": "Finance Platform",
    "welcome": "Welcome",
    "states": {
      "empty": {
        "title": "Nothing to show",
        "message": "No data available."
      },
      "error": {
        "title": "Something went wrong",
        "message": "An unexpected error occurred."
      },
      "forbidden": {
        "title": "Access unavailable",
        "message": "You do not have permission to view this resource."
      },
      "notFound": {
        "title": "Not found",
        "message": "The requested resource or route does not exist."
      },
      "degraded": {
        "title": "Partial data",
        "message": "Showing partial data due to degraded service."
      },
      "stale": {
        "title": "Data may be stale",
        "message": "Data may be stale."
      },
      "planned": {
        "message": "The destination is part of the product roadmap but is not available yet.",
        "title": "This feature is being prepared"
      },
      "noResults": {
        "message": "No results matched your filters."
      },
      "permissionLimited": {
        "message": "You have limited permission to view this data."
      },
      "offline": {
        "message": "You are offline. Data may be stale."
      },
      "maintenance": {
        "title": "Temporarily unavailable",
        "message": "This destination is undergoing maintenance. Please return later."
      },
      "unavailable": {
        "title": "Feature unavailable",
        "message": "This destination is not enabled for the current organization or product configuration."
      }
    },
    "validation": {
      "required": "This field is required",
      "accepted": "Must be accepted",
      "min": "Must be at least {{min}}",
      "max": "Must be at most {{max}}",
      "minLength": "Must be at least {{min}} characters",
      "maxLength": "Must be at most {{max}} characters",
      "integer": "Must be an integer",
      "decimalPrecision": "Must have at most {{precision}} decimal places",
      "email": "Must be a valid email address",
      "stepIncomplete": "Please complete all required fields before continuing.",
      "url": "Must be a valid URL",
      "pattern": "Must match pattern {{pattern}}",
      "invalidPattern": "Invalid pattern: {{pattern}}",
      "allowedValues": "Must be one of: {{values}}",
      "dateMin": "Must be on or after {{minDate}}",
      "dateMax": "Must be on or before {{maxDate}}",
      "fileType": "File type must be: {{accepted}}",
      "fileSize": "File must be smaller than {{maxBytes}} bytes",
      "crossField": "Must match {{field}}",
      "registeredDomain": "Domain must be one of: {{domains}}",
      "unknownValidator": "Unknown validator: {{ruleId}}"
    },
    "permissions": {
      "data": {
        "hub": "Access data hub entrypoint"
      },
      "admin": {
        "hub": "Access admin hub entrypoint",
        "users": {
          "view": "View users admin list page"
        },
        "user": {
          "create": "Create user via admin",
          "update": "Update user via admin",
          "delete": "Delete user via admin"
        },
        "roles": {
          "view": "View roles admin list page"
        },
        "role": {
          "create": "Create role via admin",
          "update": "Update role via admin",
          "delete": "Delete role via admin"
        },
        "organization": {
          "view": "View organization admin page"
        },
        "audit": {
          "view": "View audit explorer"
        },
        "auditLog": {
          "view": "List audit log entries"
        }
      },
      "access": {
        "members": {
          "read": "Read Members"
        },
        "roles": {
          "read": "Read Roles",
          "manage": "Manage Roles"
        },
        "permissions": {
          "read": "Read Permissions",
          "manage": "Manage Permissions"
        },
        "membership": {
          "manage": "Manage Memberships"
        }
      },
      "auth": {
        "context": {
          "switch": "Switch authorization context"
        },
        "logout": "Sign out",
        "profile": {
          "read": "Read own profile"
        },
        "password": {
          "change": "Change own password"
        },
        "sessions": "View and manage own sessions"
      },
      "navigation": {
        "read": "Read navigation shell, routes, and hubs"
      },
      "platform": {
        "organizations": {
          "list": "List platform organizations metadata",
          "read": "Read platform organization metadata",
          "create": "Create platform organizations",
          "update": "Update platform organizations",
          "disable": "Disable platform organizations"
        },
        "modules": {
          "list": "List platform modules",
          "read": "Read platform modules",
          "assign": "Assign platform modules to organizations",
          "revoke": "Revoke platform modules from organizations"
        },
        "users": {
          "list": "List platform users",
          "read": "Read platform users",
          "create": "Create platform users",
          "update": "Update platform users",
          "disable": "Disable platform users"
        },
        "audit": {
          "read": "Read platform audit logs",
          "list": "List platform audit logs",
          "export": "Export platform audit logs"
        },
        "health": {
          "read": "Read platform health"
        },
        "support-delegations": {
          "list": "List support delegations",
          "read": "Read support delegation",
          "create": "Create support delegation",
          "update": "Update support delegation",
          "revoke": "Revoke support delegation",
          "enter": "Enter support delegation context",
          "exit": "Exit support delegation context"
        }
      },
      "organization": {
        "accounting": {
          "manage": "Manage organization accounting",
          "read": "Read organization accounting"
        },
        "profile": {
          "read": "Read organization profile",
          "update": "Update organization profile"
        },
        "branches": {
          "list": "List organization branches",
          "read": "Read organization branch",
          "create": "Create organization branch",
          "update": "Update organization branch",
          "disable": "Disable organization branch"
        },
        "modules": {
          "list": "List organization modules",
          "enable": "Enable organization module",
          "disable": "Disable organization module",
          "configure": "Configure organization module"
        },
        "users": {
          "list": "List organization users",
          "read": "Read organization user",
          "create": "Create organization user",
          "update": "Update organization user",
          "disable": "Disable organization user"
        },
        "roles": {
          "list": "List organization roles",
          "read": "Read organization role",
          "create": "Create organization role",
          "update": "Update organization role",
          "disable": "Disable organization role"
        },
        "permissions": {
          "list": "List organization permissions",
          "assign": "Assign organization permissions",
          "revoke": "Revoke organization permissions"
        },
        "permission-assignments": {
          "list": "List organization permission assignments",
          "edit": "Edit organization permission assignments"
        },
        "clients": {
          "list": "List clients in organization",
          "read": "Read client in organization",
          "create": "Create client in organization",
          "update": "Update client in organization",
          "disable": "Disable client in organization"
        },
        "client-accounts": {
          "list": "List client accounts",
          "read": "Read client account",
          "create": "Create client account",
          "update": "Update client account"
        },
        "portfolios": {
          "list": "List portfolios",
          "read": "Read portfolio",
          "create": "Create portfolio",
          "update": "Update portfolio"
        },
        "audit": {
          "read": "Read organization audit",
          "list": "List organization audit entries",
          "export": "Export organization audit entries"
        },
        "access-inspector": {
          "read": "Read organization access inspector diagnostics"
        },
        "dashboard": {
          "read": "Read dashboard"
        },
        "transactions": {
          "list": "List transactions",
          "read": "Read transaction",
          "create": "Create transaction",
          "update": "Update transaction",
          "approve": "Approve transaction",
          "post": "Post transaction",
          "submit": "Submit transaction",
          "reject": "Reject transaction",
          "withdraw": "Withdraw transaction",
          "repair": "Repair transaction",
          "repost": "Repost transaction",
          "reverse": "Reverse transaction"
        },
        "holdings": {
          "read": "Read holdings"
        },
        "reports": {
          "read": "Read reports",
          "export": "Export reports",
          "list": "List reports",
          "run": "Run reports",
          "schedule": "Schedule reports"
        },
        "imports": {
          "list": "List imports",
          "upload": "Upload imports",
          "commit": "Commit imports",
          "validate": "Validate imports",
          "preview": "Preview imports",
          "cancel": "Cancel imports",
          "retry": "Retry imports"
        },
        "reconciliation": {
          "list": "List reconciliation runs",
          "manage": "Manage reconciliation",
          "read": "Read reconciliation run",
          "create": "Create reconciliation run",
          "match": "Match reconciliation items",
          "resolve": "Resolve reconciliation exceptions",
          "complete": "Complete reconciliation run",
          "reopen": "Reopen reconciliation run",
          "export": "Export reconciliation results"
        },
        "instruments": {
          "read": "Read instruments",
          "manage": "Manage instruments"
        },
        "corporate-actions": {
          "read": "Read corporate actions",
          "manage": "Manage corporate actions"
        },
        "facts": {
          "read": "Read facts",
          "manage": "Manage facts"
        }
      },
      "client": {
        "dashboard": {
          "read": "Read own dashboard"
        },
        "holdings": {
          "list-own": "List own holdings",
          "read-own": "Read own holdings"
        },
        "transactions": {
          "list-own": "List own transactions",
          "read-own": "Read own transactions"
        },
        "reports": {
          "list-own": "List own reports",
          "read-own": "Read own reports",
          "export-own": "Export own reports"
        },
        "profile": {
          "read": "Read own client profile",
          "limited-update": "Update own client profile (limited)"
        },
        "documents": {
          "read-own": "Read own documents"
        }
      },
      "settings": {
        "view": "View settings hub",
        "profile": {
          "update": "Update own profile settings"
        },
        "preferences": {
          "update": "Update own preferences"
        },
        "mfa": "View MFA settings",
        "password": {
          "change": "Change own password"
        },
        "sessions": "Manage own active sessions"
      }
    },
    "inDevelopment": "In development",
    "unsaved": "unsaved",
    "reason": "Reason",
    "noData": "No data",
    "processing": "Processing...",
    "warning": "Warning",
    "i18n": {
      "contentUnavailable": "Content unavailable"
    },
    "unsavedChanges": "Unsaved changes",
    "isMarginEligible": "Margin eligible",
    "capitalGainTax": "Capital gain tax",
    "sourceReference": "Source reference"
  },
  "investment": {
    "holdings": {
      "title": "Holdings",
      "description": "Aggregated portfolio holdings showing current quantities, cost basis, and market value per instrument. Holdings are derived from posted transactions and opening balances.",
      "empty": {
        "title": "No Holdings",
        "description": "Holdings appear here once transactions are posted or opening balances are committed. Post a transaction or import an opening cutover to get started."
      },
      "error": {
        "title": "Error Loading Holdings"
      }
    },
    "dataQuality": {
      "title": "Data Quality",
      "description": "View data quality metrics and validation status."
    },
    "instruments": {
      "title": "Instruments",
      "description": "Manage company and instrument reference data for your portfolio."
    },
    "marketData": {
      "title": "Market Data",
      "description": "View market data for instruments in your portfolio.",
      "marketDataView": {
        "importMarketData": "Import Market Data",
        "import": "Import",
        "importHelpText": "Import latest market prices from NEPSE or other sources"
      },
      "pricesView": {
        "title": "Prices"
      }
    },
    "transactions": {
      "title": "Transactions",
      "description": "Review, filter, create, import, and export investment transactions.",
      "reversalsView": {
        "title": "Transaction Reversals"
      },
      "create": {
        "title": "Create Transaction",
        "page": {
          "title": "Page",
          "description": "Page description"
        }
      },
      "bulk": {
        "title": "Bulk Transactions"
      },
      "page": {
        "title": "Page",
        "description": "Page description"
      },
      "empty": {
        "title": "Empty",
        "description": "Transactions description"
      },
      "error": {
        "title": "Error"
      },
      "actions": {
        "delete": "Delete",
        "deleteDesc": "Delete",
        "submit": "Submit",
        "submitDesc": "Submit",
        "requestReversal": "Request Reversal",
        "requestReversalDesc": "Request Reversal"
      }
    },
    "reports": {
      "page": {
        "title": "Investment Reports",
        "description": "Find trusted portfolio, performance, tax, accounting, and NFRS reports. Availability depends on your role, tier, and data readiness.",
        "descriptionWithDataQuality": "Find trusted portfolio, performance, tax, accounting, NFRS, and data-quality reports. Availability depends on your role, tier, and data readiness."
      },
      "error": {
        "title": "Failed to load reports",
        "description": "An unexpected error occurred"
      },
      "empty": {
        "title": "No reports available",
        "description": "No investment report surfaces are currently available for this account."
      },
      "availability": {
        "ariaLabel": "Filter by availability",
        "all": "All",
        "available": "Available",
        "unavailable": "Unavailable"
      },
      "hub": {
        "title": "Reports Hub",
        "description": "Reports Hub report",
        "searchPlaceholder": "Search reports...",
        "searchAriaLabel": "Search reports",
        "refineFiltersTitle": "Refine Filters",
        "refineFiltersSubtitle": "Filter reports by availability and data quality",
        "secondaryDisclosureTitle": "Secondary Disclosure",
        "secondaryDisclosureSubtitle": "Additional context and metadata",
        "contextTitle": "Context",
        "contextSubtitle": "Report context information",
        "totalReports": "Total Reports",
        "availableLocked": "Available / Locked",
        "dataQualityAvailability": "Data Quality Availability"
      },
      "profitLoss": {
        "title": "Profit & Loss",
        "description": "Profit & Loss report"
      },
      "realizedPnl": {
        "title": "Realized Profit & Loss",
        "description": "Realized Profit & Loss report"
      },
      "transactions": {
        "title": "Transactions Report",
        "description": "Transactions Report report"
      },
      "cgt": {
        "title": "Capital Gains Tax",
        "description": "Capital Gains Tax report"
      },
      "monthlyMovement": {
        "title": "Monthly Movement",
        "description": "Monthly Movement report"
      },
      "nfrsDashboard": {
        "title": "NFRS Dashboard",
        "description": "NFRS Dashboard report"
      },
      "nfrsMonthly": {
        "title": "NFRS Monthly",
        "description": "NFRS Monthly report"
      },
      "fifoNfrsReconciliation": {
        "title": "FIFO-NFRS Reconciliation",
        "description": "FIFO-NFRS Reconciliation report"
      },
      "dataQuality": {
        "title": "Data Quality Report",
        "description": "Data Quality Report report"
      },
      "pivotAnalysis": {
        "title": "Pivot Analysis",
        "description": "Pivot Analysis report"
      },
      "portfolioSummary": {
        "title": "Portfolio Summary",
        "description": "View comprehensive portfolio summary and metrics."
      },
      "concentration": {
        "title": "Concentration",
        "description": "Concentration report"
      },
      "performanceDrivers": {
        "title": "Performance Drivers",
        "description": "Performance Drivers report"
      },
      "performanceBenchmark": {
        "title": "Performance Benchmark",
        "description": "Performance Benchmark report"
      },
      "performanceRisk": {
        "title": "Performance Risk",
        "description": "Performance Risk report"
      },
      "allocation": {
        "title": "Sector Allocation",
        "description": "Sector Allocation report"
      },
      "holdings": {
        "title": "Holdings Statement",
        "description": "Holdings statement report"
      },
      "companyStatement": {
        "title": "Company Statement",
        "description": "Company Statement report"
      },
      "performanceHub": {
        "title": "Performance Hub",
        "description": "Performance Hub report"
      },
      "rebalancing": {
        "title": "Rebalancing",
        "description": "Rebalancing report"
      },
      "qualityIssues": {
        "title": "Report {{reportId}} has data quality issues"
      },
      "stalePrices": {
        "title": "{{count}} valuations have stale prices (>7 days)"
      },
      "missingPrices": {
        "title": "{{count}} recent valuations have missing prices"
      },
      "category": {
        "overview": {
          "description": "Overview reports"
        },
        "portfolio-holdings": {
          "description": "Portfolio holdings reports"
        },
        "portfolio": {
          "description": "Portfolio reports"
        },
        "transactions-lots": {
          "description": "Transaction and lot reports"
        },
        "transactions": {
          "description": "Transactions reports"
        },
        "gain-loss-tax": {
          "description": "Gain/loss and tax reports"
        },
        "monthly-analytics": {
          "description": "Monthly analytics reports"
        },
        "quality-audit-exports": {
          "description": "Quality audit and export reports"
        },
        "performance": {
          "description": "Performance reports"
        },
        "tax": {
          "description": "Tax reports"
        },
        "nfrs": {
          "description": "NFRS reports"
        },
        "compliance": {
          "description": "Compliance reports"
        }
      },
      "audit": {
        "title": "Audit Reports",
        "lineageView": {
          "title": "Lineage"
        },
        "diagnosticsView": {
          "title": "Diagnostics"
        }
      },
      "actions": {
        "openFilter": "Open Filter",
        "openFilterDesc": "Open Filter",
        "applyFilter": "Apply Filter",
        "applyFilterDesc": "Apply Filter",
        "resetFilter": "Reset Filter",
        "resetFilterDesc": "Reset Filter",
        "copyLink": "Copy Link",
        "copyLinkDesc": "Copy Link"
      }
    },
    "approvals": {
      "page": {
        "title": "Approvals",
        "description": "Review pending investment transaction approvals and exceptions."
      },
      "title": "Approvals",
      "actions": {
        "approve": "Approve",
        "approveDesc": "Approve",
        "reject": "Reject",
        "rejectDesc": "Reject"
      }
    },
    "portfolio": {
      "page": {
        "title": "Holdings",
        "description": "Portfolio holdings, valuation, cost basis, and pricing status"
      },
      "positive": "Positive",
      "negative": "Negative",
      "totalValue": "Total Value",
      "totalValueDesc": "Total Value",
      "unrealizedGain": "Unrealized Gain",
      "unrealizedGainDesc": "Unrealized Gain",
      "unrealizedReturn": "Unrealized Return",
      "unrealizedReturnDesc": "Unrealized Return"
    },
    "overview": {
      "page": {
        "title": "Portfolio Overview",
        "description": "Portfolio value, data trust, and the most important navigation shortcuts."
      },
      "loading": "Loading dashboard data...",
      "errorTitle": "Dashboard unavailable",
      "error": "Error loading dashboard",
      "metrics": {
        "unavailable": "Unavailable",
        "ariaLabel": "Portfolio summary metrics",
        "portfolioValue": "Portfolio Value",
        "unrealizedGain": "Unrealized Gain",
        "unrealizedLoss": "Unrealized Loss",
        "holdings": "Holdings",
        "dataTrust": "Data Trust"
      },
      "dataTrust": {
        "ok": "OK",
        "warning": "Warning",
        "stale": "Stale",
        "alerts": "Alerts",
        "pendingApprovals": "pending approvals"
      },
      "dataQuality": {
        "approximated": "Dashboard data is approximated. Some metrics may be incomplete.",
        "unavailable": "Dashboard data is unavailable. Some metrics may be incomplete.",
        "holding": "Holding",
        "staleMarketPrices": "with stale market prices.",
        "failedImport": "failed import",
        "monitoringException": "monitoring exception",
        "review": "Review"
      },
      "quickActions": {
        "ariaLabel": "Quick actions",
        "title": "Quick Actions"
      },
      "operational": {
        "requestId": "Request ID",
        "scope": "Scope",
        "scopeOrg": "Organization",
        "dataQuality": "Data Quality",
        "trustStatus": "Trust"
      },
      "recentActivity": {
        "title": "Recent Activity"
      },
      "attention": {
        "title": "Attention Items",
        "description": "Items requiring action before data quality or workflow impact increases."
      },
      "monthlyPnl": {
        "title": "Monthly P&L Snapshot",
        "description": "Recent monthly trend from canonical fact snapshots."
      },
      "kpiActions": {
        "title": "KPI Drilldowns",
        "description": "Direct report links mapped from KPI actions.",
        "open": "Open",
        "unavailable": "Unavailable"
      },
      "adminLinks": {
        "title": "Administrative Links"
      },
      "performance": {
        "title": "Performance Trend",
        "description": "Recent portfolio value points from canonical performance facts."
      },
      "holdingsBySector": {
        "title": "Holdings by Sector",
        "description": "Sector allocation with canonical market-value weights."
      },
      "monitoring": {
        "title": "Monitoring Alerts",
        "description": "Current exceptions surfaced by investment monitoring.",
        "severity": "Severity"
      },
      "sectionStatus": {
        "title": "Section Availability"
      }
    },
    "dashboard": {
      "title": "Dashboard"
    },
    "import": {
      "title": "Import",
      "actions": {
        "preview": "Preview",
        "previewDesc": "Preview",
        "commit": "Commit",
        "commitDesc": "Commit",
        "cancel": "Cancel",
        "cancelDesc": "Cancel",
        "copyEvidenceLink": "Copy Evidence Link",
        "copyEvidenceLinkDesc": "Copy Evidence Link",
        "openLineage": "Open Lineage",
        "openLineageDesc": "Open Lineage",
        "retryJob": "Retry Job",
        "retryJobDesc": "Retry Job"
      }
    },
    "settings": {
      "title": "Settings",
      "marketData": {
        "title": "Market Data Settings"
      },
      "benchmark": {
        "title": "Benchmark Settings",
        "description": "Configure benchmark performance targets and concentration limits for portfolio comparison",
        "fields": {
          "symbol": "Benchmark Symbol",
          "period": "Comparison Period",
          "manualTarget": "Manual Target Return (%)",
          "sectorLimit": "Sector Concentration Limit (%)",
          "top10Limit": "Top 10 Holdings Limit (%)"
        },
        "placeholders": {
          "symbol": "Enter benchmark symbol (e.g., NEPSE)",
          "period": "Select comparison period",
          "manualTarget": "e.g., 15",
          "sectorLimit": "e.g., 30",
          "top10Limit": "e.g., 40"
        },
        "periods": {
          "oneMonth": "1 Month",
          "threeMonths": "3 Months",
          "sixMonths": "6 Months",
          "oneYear": "1 Year",
          "threeYears": "3 Years"
        },
        "descriptions": {
          "manualTarget": "Set a manual target return percentage for benchmark comparison",
          "sectorLimit": "Maximum percentage of portfolio value allowed in any single sector",
          "top10Limit": "Maximum percentage of portfolio value allowed in top 10 holdings"
        },
        "notes": {
          "dataSourceLabel": "Data Source",
          "dataSource": "Benchmark data is sourced from market price feeds",
          "manualTargetLabel": "Manual Target",
          "manualTarget": "Override calculated benchmark with a manual target return",
          "concentrationLimitsLabel": "Concentration Limits",
          "concentrationLimits": "Limits to control portfolio concentration risk"
        }
      },
      "actions": {
        "saveProfile": "Save Profile",
        "saveProfileDesc": "Save Profile",
        "saveSecurity": "Save Security",
        "saveSecurityDesc": "Save Security",
        "saveNotifications": "Save Notifications",
        "saveNotificationsDesc": "Save Notifications",
        "saveInvestment": "Save Investment",
        "saveInvestmentDesc": "Save Investment",
        "restore": "Restore",
        "restoreDesc": "Restore",
        "saveMarketData": "Save Market Data",
        "saveMarketDataDesc": "Save Market Data",
        "saveBenchmarks": "Save Benchmarks",
        "saveBenchmarksDesc": "Save Benchmarks"
      }
    },
    "rebalancing": {
      "title": "Rebalancing",
      "description": "Review portfolio drift and prepare approved rebalancing actions."
    },
    "marketDataSettings": {
      "title": "Market Data Settings",
      "description": "Market Data Settings description",
      "feedSource": "Feed Source",
      "actions": {
        "openDataQuality": "Open Data Quality",
        "openOperationalPage": "Open Operational Page"
      },
      "policyTitle": "Policy",
      "policyDescription": "Policy description",
      "operationalBoundary": {
        "title": "Operational Boundary",
        "description": "Operational Boundary description"
      },
      "governance": {
        "title": "Governance",
        "subtitlePrefix": "Subtitle Prefix",
        "subtitleSuffix": "Subtitle Suffix",
        "items": {
          "provider": "Provider",
          "freshness": "Freshness",
          "remediation": "Remediation"
        }
      }
    },
    "workflow": {
      "actions": {
        "submit": "Submit",
        "submitDesc": "Submit",
        "approve": "Approve",
        "approveDesc": "Approve",
        "post": "Post",
        "postDesc": "Post",
        "reject": "Reject",
        "rejectDesc": "Reject",
        "withdraw": "Withdraw",
        "withdrawDesc": "Withdraw",
        "requestReversal": "Request Reversal",
        "requestReversalDesc": "Request Reversal",
        "approveReversal": "Approve Reversal",
        "approveReversalDesc": "Approve Reversal",
        "rejectReversal": "Reject Reversal",
        "rejectReversalDesc": "Reject Reversal",
        "repair": "Repair",
        "repairDesc": "Repair",
        "repost": "Repost",
        "repostDesc": "Repost"
      }
    },
    "data": {
      "instruments": {
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "save": "Save",
          "saveDesc": "Save"
        }
      },
      "marketData": {
        "actions": {
          "createPrice": "Create Price",
          "createPriceDesc": "Create Price",
          "savePrice": "Save Price",
          "savePriceDesc": "Save Price"
        }
      },
      "taxRules": {
        "title": "Tax Rules",
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "save": "Save",
          "saveDesc": "Save",
          "createVersion": "Create tax-rule version",
          "view": "View tax-rule version"
        },
        "fields": {
          "jurisdiction": "Jurisdiction",
          "ruleType": "Rule Type",
          "investorCategory": "Investor Category",
          "instrumentType": "Instrument Type",
          "holdingPeriodClassification": "Holding Period Classification",
          "holdingPeriodMinimumDays": "Minimum Holding Period (Days)",
          "effectiveFrom": "Effective From",
          "effectiveTo": "Effective To",
          "capitalGainsTaxRate": "Capital Gains Tax Rate (%)",
          "withholdingTaxRate": "Withholding Tax Rate (%)",
          "roundingPolicy": "Rounding Policy",
          "sourceReference": "Source Reference",
          "status": "Status",
          "version": "Version"
        },
        "holdingPeriodOptions": {
          "shortTerm": "Short Term",
          "longTerm": "Long Term"
        },
        "section": {
          "scope": "Scope",
          "holdingPeriod": "Holding Period",
          "rates": "Tax Rates",
          "effectiveDates": "Effective Dates",
          "reference": "Reference"
        },
        "description": "Manage tax rules for investment operations.",
        "help": {
          "jurisdictionNepal": "This release uses Nepal (NP) tax rules.",
          "ratePercent": "Enter the rate as a percentage, for example 7.5 for 7.5%.",
          "roundingPolicy": "Choose how calculated tax amounts are rounded before posting."
        },
        "roundingOptions": {
          "halfUp2": "Nearest paisa — half up",
          "halfEven2": "Nearest paisa — half even",
          "down2": "Down to paisa",
          "up2": "Up to paisa",
          "halfUp0": "Nearest rupee — half up",
          "halfEven0": "Nearest rupee — half even"
        }
      },
      "issuers": {
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "save": "Save",
          "saveDesc": "Save"
        }
      },
      "openingBalances": {
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "save": "Save",
          "saveDesc": "Save"
        }
      },
      "feeRules": {
        "title": "Fees and Charges",
        "description": "Configure brokerage, SEBON, DP, and other charge rules for the organization.",
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "save": "Save",
          "saveDesc": "Save"
        },
        "fields": {
          "jurisdiction": "Jurisdiction",
          "ruleType": "Rule Type",
          "deductibleClassification": "Deductible Classification",
          "effectiveFrom": "Effective From",
          "effectiveTo": "Effective To",
          "roundingPolicy": "Rounding Policy",
          "components": "Fee Components (JSON)",
          "componentSummary": "Fee Components",
          "sourceReference": "Source Reference",
          "status": "Status",
          "version": "Version"
        },
        "ruleTypeOptions": {
          "brokerageSebonDp": "Brokerage + SEBON + DP",
          "standardSecurities": "Standard Securities",
          "brokerage": "Brokerage"
        },
        "deductibleOptions": {
          "deductible": "Deductible",
          "nonDeductible": "Non-Deductible",
          "partial": "Partial"
        },
        "roundingOptions": {
          "halfUp2": "Half Up (2 decimals)",
          "halfEven2": "Half Even (2 decimals)",
          "down2": "Down (2 decimals)",
          "up2": "Up (2 decimals)",
          "halfUp0": "Half Up (0 decimals)",
          "halfEven0": "Half Even (0 decimals)"
        },
        "section": {
          "scope": "Scope",
          "classification": "Classification",
          "effectiveDates": "Effective Dates",
          "components": "Fee Components",
          "reference": "Reference"
        },
        "help": {
          "jurisdictionNepal": "Two-letter jurisdiction code, e.g. NP for Nepal.",
          "ruleType": "Select the fee rule type that defines which charges this rule configures.",
          "deductibleClassification": "Select whether the total fees are deductible, non-deductible, or partially deductible.",
          "roundingPolicy": "Select the rounding policy applied to each calculated fee component.",
          "components": "Enter fee components as a JSON array. Each component requires: component, kind, base, rate/fixedAmount, rounding options, appliesTo, and deductible."
        }
      },
      "corporateActions": {
        "actions": {
          "create": "Create",
          "createDesc": "Create",
          "save": "Save",
          "saveDesc": "Save",
          "submit": "Submit",
          "submitDesc": "Submit",
          "approve": "Approve",
          "approveDesc": "Approve",
          "reject": "Reject",
          "rejectDesc": "Reject"
        }
      }
    }
  },
  "platform": {
    "accounting": {
      "overview": {
        "title": "Accounting Overview",
        "description": "Operational accounting status, controls, and posting activity."
      },
      "chartOfAccounts": {
        "title": "Chart of Accounts",
        "description": "Review and maintain ledger accounts used for journal posting."
      },
      "journalReview": {
        "title": "Journal Review",
        "description": "Inspect draft and posted journal entries with audit traceability."
      },
      "bankReconciliation": {
        "title": "Bank Reconciliation",
        "description": "Reconcile ledger balances against bank statements and resolve exceptions."
      }
    },
    "tax": {
      "overview": {
        "title": "Tax Overview",
        "description": "Tax compliance posture, filings status, and key deadlines."
      },
      "vat": {
        "title": "VAT",
        "description": "VAT computations, filing support, and reconciliation signals."
      },
      "ird": {
        "title": "IRD Exports",
        "description": "Generate and review IRD-ready tax outputs."
      },
      "irdExports": {
        "title": "IRD Exports",
        "description": "Generate and review IRD-ready tax outputs."
      },
      "filings": {
        "title": "Tax Filings",
        "healthyFallback": "Healthy"
      }
    },
    "data": {
      "pages": {
        "instruments": {
          "columns": {
            "symbol": "Symbol",
            "name": "Name",
            "securityType": "Security Type",
            "sector": "Sector",
            "status": "Status"
          },
          "cards": {
            "total": {
              "label": "Total",
              "hint": "Total number of instruments"
            },
            "active": {
              "label": "Active",
              "hint": "Active instruments"
            },
            "verification": {
              "label": "Verification",
              "hint": "Instruments pending verification"
            }
          },
          "tableTitle": "Instruments",
          "empty": "No instruments found",
          "emptyFiltered": "No instruments match your filters",
          "status": {
            "active": "Active",
            "watchlist": "Watchlist"
          },
          "referenceReadOnlyMessage": "Reference Read Only Message",
          "settingsWorkflowMessage": "Workflow Message",
          "actions": {
            "openCompanyStatement": "Open Company Statement",
            "verifyInstrumentMapping": "Verify Instrument Mapping",
            "openInstrumentSettings": "Open Instrument Settings",
            "openCompanyStatementDesc": "Open Company Statement",
            "viewDetails": "View Details",
            "viewDetailsDesc": "View Details",
            "create": "Create",
            "createDesc": "Create",
            "edit": "Edit",
            "editDesc": "Edit",
            "delete": "Delete",
            "deleteDesc": "Delete",
            "import": "Import",
            "importDesc": "Import"
          },
          "disabledReasons": {
            "openCompanyStatement": "No symbol available for this instrument"
          }
        },
        "reportRuns": {
          "columns": {
            "completedAt": "Completed At",
            "report": "Report",
            "runId": "Run ID",
            "startedAt": "Started At",
            "duration": "Duration",
            "status": "Columns Status"
          },
          "cards": {
            "runsToday": {
              "label": "Runs Today",
              "hint": "Report runs completed today"
            },
            "successful": {
              "label": "Successful",
              "hint": "Successfully completed report runs"
            },
            "failed": {
              "label": "Failed",
              "hint": "Failed report runs"
            }
          },
          "status": {
            "success": "Status Success",
            "failed": "Failed",
            "running": "Running",
            "unknown": "Unknown"
          },
          "title": "Report Runs",
          "description": "Report Runs description",
          "tableTitle": "Table",
          "empty": "Report Runs Empty",
          "actions": {
            "exportLogs": "Export Logs",
            "openDetail": "View Details",
            "openDetailDesc": "Open Detail",
            "exportLogsDesc": "Export Logs"
          }
        },
        "corporateActions": {
          "columns": {
            "symbol": "Symbol",
            "actionType": "Action Type",
            "effectiveDate": "Effective Date",
            "ratio": "Ratio",
            "status": "Status"
          },
          "cards": {
            "recentActions": {
              "label": "Recent Actions",
              "hint": "Total corporate actions available",
              "labelDesc": "Recent Actions"
            },
            "applied": {
              "label": "Applied",
              "hint": "Actions already applied to portfolio",
              "labelDesc": "Applied"
            },
            "pendingReview": {
              "label": "Pending Review",
              "hint": "Actions awaiting review",
              "labelDesc": "Pending Review"
            }
          },
          "tableTitle": "Corporate Actions",
          "empty": "No corporate actions available",
          "filteredEmpty": "No corporate actions match the filter",
          "types": {
            "bonus": "Bonus",
            "right": "Right Share",
            "split": "Split",
            "dividend": "Dividend",
            "cash": "Cash Dividend"
          },
          "status": {
            "pending": "Pending",
            "applied": "Applied",
            "skipped": "Skipped"
          },
          "ratio": {
            "cashRate": "Cash Rate",
            "ratio": "Ratio",
            "none": "None"
          },
          "actions": {
            "reviewAuditTrail": "Review Audit Trail",
            "apply": "Apply",
            "holdingsImpact": "View Holdings Impact",
            "reviewAuditTrailDesc": "Review Audit Trail",
            "applyDesc": "Apply",
            "holdingsImpactDesc": "Holdings Impact"
          },
          "disabledReasons": {
            "apply": {
              "applied": "This action has already been applied"
            },
            "holdingsImpact": {
              "noSymbol": "No symbol available for this action"
            }
          }
        },
        "feeChargeRules": {
          "columns": {
            "rule": "Rule",
            "scope": "Scope",
            "basis": "Basis",
            "rate": "Rate",
            "status": "Columns Status"
          },
          "scopes": {
            "allPortfolios": "All Portfolios"
          },
          "status": {
            "draft": "Draft",
            "active": "Active"
          },
          "title": "Fee Charge Rules",
          "description": "Fee Charge Rules description",
          "cards": {
            "configuredRules": {
              "label": "Configured Rules",
              "hint": "Configured Rules hint",
              "labelDesc": "Configured Rules"
            },
            "active": {
              "label": "Active",
              "hint": "Active hint",
              "labelDesc": "Active"
            },
            "draft": {
              "label": "Draft",
              "hint": "Draft hint",
              "labelDesc": "Draft"
            }
          },
          "tableTitle": "Table",
          "empty": "Fee Charge Rules Empty",
          "actions": {
            "viewDetail": "View Detail",
            "editRule": "Edit Rule",
            "edit": "Edit Fee Rule",
            "viewDetailDesc": "View Detail",
            "editDesc": "Edit"
          }
        },
        "issuers": {
          "columns": {
            "symbol": "Symbol",
            "issuer": "Issuer",
            "sector": "Sector",
            "status": "Status"
          },
          "status": {
            "active": "Active",
            "watchlist": "Watchlist"
          },
          "cards": {
            "totalIssuers": {
              "label": "Total Issuers",
              "hint": "Total number of issuers"
            },
            "activeListings": {
              "label": "Active Listings",
              "hint": "Number of active listings"
            },
            "needsReview": {
              "label": "Needs Review",
              "hint": "Issuers requiring review"
            }
          },
          "tableTitle": "Issuers",
          "empty": "No issuers available",
          "issuerSurfaceDescription": "Issuer Surface description",
          "referenceReadOnlyMessage": "Reference Read Only Message",
          "settingsWorkflowMessage": "Workflow Message",
          "actions": {
            "openIssuerStatement": "Open Issuer Statement",
            "openIssuerStatementDesc": "Open Issuer Statement"
          },
          "actionsDisabledReasons": {
            "openIssuerStatement": "No symbol available for this issuer"
          }
        },
        "openingBalances": {
          "columns": {
            "account": "Account",
            "symbol": "Symbol",
            "quantity": "Quantity",
            "cost": "Cost",
            "asOf": "As Of",
            "status": "Columns Status"
          },
          "status": {
            "posted": "Posted",
            "review": "Review"
          },
          "cards": {
            "openRows": {
              "label": "Open Rows",
              "hint": "Open Rows hint",
              "labelDesc": "Open Rows"
            },
            "readyToPost": {
              "label": "Ready To Post",
              "hint": "Ready To Post hint",
              "labelDesc": "Ready To Post"
            },
            "needsRemediation": {
              "label": "Needs Remediation",
              "hint": "Needs Remediation hint",
              "labelDesc": "Needs Remediation"
            }
          },
          "readinessTableTitle": "Readiness Table",
          "tableTitle": "Table",
          "empty": "Opening Balances Empty",
          "invalidViewFallback": "Invalid View Fallback",
          "actions": {
            "reviewTransactionRepairs": "Review Transaction Repairs",
            "remediateBalance": "Remediate Balance",
            "viewSourceEvidence": "View Source Evidence",
            "postOpeningBalance": "Post Opening Balance",
            "repairOpeningBalance": "Repair Opening Balance",
            "repostOpeningBalance": "Repost Opening Balance",
            "viewSourceEvidenceDesc": "View Source Evidence",
            "reviewTransactionRepairsDesc": "Review Transaction Repairs",
            "postOpeningBalanceDesc": "Post Opening Balance",
            "remediateBalanceDesc": "Remediate Balance",
            "repairOpeningBalanceDesc": "Repair Opening Balance",
            "repostOpeningBalanceDesc": "Repost Opening Balance"
          },
          "confirmPostOpeningBalance": "Are you sure you want to post this opening balance?",
          "confirmRepairOpeningBalance": "Are you sure you want to repair this opening balance?",
          "confirmRepostOpeningBalance": "Are you sure you want to repost this opening balance?"
        },
        "reportReadiness": {
          "columns": {
            "report": "Report",
            "asOf": "As Of",
            "coverage": "Coverage",
            "freshness": "Freshness",
            "status": "Columns Status"
          },
          "status": {
            "review": "Review",
            "ready": "Ready",
            "blocked": "Blocked"
          },
          "issueCount": "Issue Count",
          "title": "Report Readiness",
          "description": "Report Readiness description",
          "cards": {
            "readyReports": {
              "label": "Ready Reports",
              "hint": "Ready Reports hint"
            },
            "needsReview": {
              "label": "Needs Review",
              "hint": "Needs Review hint"
            },
            "blocked": {
              "label": "Blocked",
              "hint": "Blocked hint"
            }
          },
          "tableTitle": "Table",
          "empty": "Report Readiness Empty",
          "actions": {
            "openRemediation": "Open Remediation",
            "openReport": "Open Report",
            "openReportDesc": "Open Report",
            "openRemediationDesc": "Open Remediation"
          }
        }
      },
      "instruments": {
        "title": "Instruments",
        "description": "Reference instruments used for transactions, holdings, and valuation."
      },
      "marketPrices": {
        "title": "Market Prices",
        "description": "Maintain market price records, uploads, and freshness coverage used by valuation and reports.",
        "viewAction": "View market price coverage",
        "manageAction": "Manage market prices"
      },
      "imports": {
        "title": "Data Imports",
        "description": "Import and validate market reference data updates."
      },
      "lineage": {
        "title": "Data Lineage",
        "description": "Track data changes and audit trail across the system.",
        "columns": {
          "action": "Action",
          "entityType": "Entity Type",
          "entityId": "Entity ID",
          "occurredAt": "Occurred At",
          "actor": "Actor"
        },
        "cards": {
          "total": {
            "label": "Total Events"
          },
          "latestAction": {
            "label": "Latest Action",
            "hint": "Most recent data change",
            "labelDesc": "Latest Action"
          },
          "latestActor": {
            "label": "Latest Actor",
            "hint": "Latest Actor hint"
          }
        },
        "table": {
          "title": "Data Lineage Events"
        },
        "empty": {
          "description": "No data lineage events found"
        },
        "actions": {
          "redacted": "This entry contains redacted information",
          "auditDetail": "View Audit Details",
          "lineageReport": "View Lineage Report",
          "auditDetailDesc": "Audit Detail",
          "lineageReportDesc": "Lineage Report"
        }
      },
      "reconciliation": {
        "title": "Data Reconciliation",
        "description": "Monitor and resolve data reconciliation exceptions between accounting and portfolio systems.",
        "columns": {
          "account": "Account",
          "exceptionType": "Exception Type",
          "lastAttempt": "Last Attempt",
          "amount": "Amount"
        },
        "cards": {
          "failed": {
            "label": "Failed"
          },
          "pending": {
            "label": "Pending"
          },
          "overdue": {
            "label": "Overdue"
          }
        },
        "table": {
          "title": "Reconciliation Exceptions"
        },
        "empty": "No reconciliation exceptions found",
        "partialError": "Partial Error",
        "actions": {
          "exceptionDetail": "View Exception Details",
          "openTransaction": "Open Transaction",
          "exceptionDetailDesc": "Exception Detail",
          "openTransactionDesc": "Open Transaction"
        }
      },
      "taxRules": {
        "title": "Tax Rules",
        "description": "Tax Rules description",
        "actions": {
          "openFeeChargeRules": "Open Fee Charge Rules",
          "openFeeRules": "View Fee Rules",
          "review": "Review Tax Rule",
          "reviewDesc": "Review",
          "openFeeRulesDesc": "Open Fee Rules"
        },
        "cards": {
          "shortTerm": {
            "label": "Short Term",
            "labelDesc": "Short Term"
          },
          "longTerm": {
            "label": "Long Term",
            "labelDesc": "Long Term"
          },
          "institutional": {
            "label": "Institutional"
          },
          "sebon": {
            "label": "SEBON"
          },
          "dpCharge": {
            "label": "Dp Charge"
          },
          "brokerageBands": {
            "label": "Brokerage Bands",
            "hint": "Brokerage Bands hint",
            "labelDesc": "Brokerage Bands"
          }
        },
        "rows": {
          "brokerageBand": "Brokerage Band"
        },
        "categories": {
          "brokerage": "Brokerage",
          "cgt": "CGT",
          "regulatory": "Regulatory",
          "depository": "Depository"
        },
        "status": {
          "active": "Active"
        },
        "table": {
          "columns": {
            "rule": "Rule",
            "category": "Category",
            "rate": "Rate",
            "minimum": "Minimum",
            "status": "Status"
          },
          "title": "Tax Rules"
        },
        "empty": "Empty"
      },
      "feeRules": {
        "title": "Fee Rules",
        "description": "Configure brokerage, SEBON, DP, and other charge rules.",
        "table": {
          "title": "Fee Rules"
        },
        "empty": "No fee rules found"
      }
    },
    "hubs": {
      "data": {
        "title": "Investment Data",
        "description": "Maintain reference records, prices, opening balances, transactions, and configuration data used by investment workflows.",
        "actionLabels": {
          "instruments": "Manage instruments",
          "marketData": "Update prices",
          "imports": "Import transactions",
          "dataQuality": "Review issues",
          "lineage": "Trace records",
          "reconciliation": "Reconcile data",
          "referenceImports": "Import reference data",
          "marketPriceImports": "Import market prices"
        },
        "emptyStates": {
          "admin": {
            "title": "No data sources configured",
            "description": "Start by importing reference data or setting up market price feeds."
          },
          "nonAdmin": {
            "title": "No data available",
            "description": "Contact your administrator to configure data sources."
          }
        },
        "groups": {
          "reference": {
            "title": "Maintain reference data",
            "description": "Reference records and setup data used by investment workflows."
          },
          "operational": {
            "title": "Add or import activity",
            "description": "Create, import, and approve operational investment activity."
          },
          "trust": {
            "title": "Verify data readiness",
            "description": "Readiness, quality, and reconciliation checks before reporting."
          },
          "generated": {
            "title": "Generated data and evidence",
            "description": "Review generated holdings and report run history."
          },
          "support": {
            "title": "Delegated support tools",
            "description": "Delegated diagnostics and traceability for support workflows."
          },
          "configuration": {
            "title": "Rules and configuration",
            "description": "Tax rules, fee rules, and other configuration records used by calculations."
          },
          "orgSupport": {
            "title": "Organization diagnostics",
            "description": "Organization-scoped diagnostics, lineage, and audit evidence for safe investigation."
          }
        },
        "cards": {
          "actions": {
            "open": "Open",
            "view": "View details",
            "openSupport": "Open support view"
          },
          "instruments": {
            "title": "Instruments",
            "description": "Maintain instrument masters and classification attributes.",
            "action": "Manage"
          },
          "issuers": {
            "title": "Companies and Issuers",
            "description": "Maintain issuer and company reference details.",
            "action": "Manage"
          },
          "marketPrices": {
            "title": "Market Prices",
            "description": "Manage price source records, uploads, corrections, and stale/missing coverage that feed valuation facts.",
            "action": "Update",
            "viewAction": "View market price coverage",
            "manageAction": "Manage market prices"
          },
          "benchmarks": {
            "title": "Benchmarks",
            "description": "Configure benchmark instruments and comparison sets.",
            "action": "Manage"
          },
          "openingBalances": {
            "title": "Opening Balances",
            "description": "Create and maintain opening balance source records used to seed positions.",
            "action": "Manage"
          },
          "openingBalanceReadiness": {
            "description": "Review opening balance rows that still require remediation before posting."
          },
          "taxRules": {
            "title": "VAT",
            "description": "Review VAT calculations, filing support, and reconciliation diagnostics.",
            "action": "Review"
          },
          "feeRules": {
            "title": "Fees and Charges",
            "description": "Configure brokerage, fee, and charge rule definitions.",
            "action": "Manage"
          },
          "corporateActions": {
            "title": "Corporate Actions",
            "description": "Maintain corporate action records and processing rules.",
            "action": "Manage"
          },
          "transactions": {
            "title": "Transactions",
            "description": "Review and act on transaction activity in your current scope.",
            "action": "Review"
          },
          "createTransaction": {
            "title": "Create Transaction",
            "description": "Create a new transaction for an eligible portfolio or client.",
            "action": "Create"
          },
          "bulkTransactions": {
            "title": "Bulk Transactions",
            "description": "Create many transactions in one operation.",
            "action": "Bulk create"
          },
          "importTransactions": {
            "title": "Import Transactions",
            "description": "Import transaction files and run validation workflows.",
            "action": "Import"
          },
          "importEvidence": {
            "title": "Import Evidence Review",
            "description": "Review import job evidence, failures, and remediation traces.",
            "action": "Review"
          },
          "importMarketPrices": {
            "title": "Import Market Prices",
            "description": "Import market price files for valuation updates.",
            "action": "Import"
          },
          "importReferenceData": {
            "title": "Import Reference Data",
            "description": "Import reference entities used by investment workflows.",
            "action": "Import"
          },
          "approvals": {
            "title": "Transaction Workflow Approvals",
            "description": "Review and approve pending workflow submissions.",
            "action": "Review"
          },
          "reversalsRepairs": {
            "title": "Reversals & Repairs",
            "description": "Review eligible reversal cases and repair workflows.",
            "action": "Review"
          },
          "dataQuality": {
            "title": "Data Quality",
            "description": "Review trust exceptions and policy violations across posted investment data.",
            "action": "Review"
          },
          "reconciliation": {
            "title": "Reconciliation",
            "description": "Review reconciliation status, exceptions, and evidence before reporting.",
            "action": "Review"
          },
          "lineage": {
            "title": "Data Lineage",
            "description": "Trace data lineage from source records to report outputs.",
            "action": "View"
          },
          "reportReadiness": {
            "title": "Report Readiness",
            "description": "Review readiness of report inputs and blockers.",
            "action": "View"
          },
          "holdingsSnapshot": {
            "title": "Holdings",
            "description": "View holdings data generated from posted transactions and market prices.",
            "action": "View"
          },
          "reportRuns": {
            "title": "Report Runs",
            "description": "View report generation history and run status.",
            "action": "View"
          },
          "supportTechnicalLineage": {
            "title": "Technical Lineage References",
            "description": "Support-only lineage references for incident review.",
            "action": "Open"
          },
          "supportDiagnostics": {
            "title": "Support Diagnostics",
            "description": "Support-only diagnostics for delegated investigation.",
            "action": "Open"
          },
          "supportAuditTraces": {
            "title": "Audit/Support Traces",
            "description": "Support-only audit and traceability references.",
            "action": "Open"
          },
          "orgSupportTechnicalLineage": {
            "title": "Data Lineage Diagnostics",
            "description": "Review organization-safe technical lineage references for investigations.",
            "action": "Open"
          },
          "orgSupportDiagnostics": {
            "title": "Data Health Diagnostics",
            "description": "Review organization-safe diagnostics for data operations and governance workflows.",
            "action": "Open"
          },
          "orgSupportAuditTraces": {
            "title": "Audit Evidence Traces",
            "description": "Review organization-scoped audit traces and evidence references.",
            "action": "Open"
          }
        },
        "badges": {
          "locked": "Locked",
          "readOnly": "Read only",
          "unavailable": "No data"
        },
        "trustBanner": {
          "title": "Data quality needs review",
          "detail": "{{count}} issue(s) may affect dashboard values and reports.",
          "action": "Review data quality",
          "detailSingle": "1 issue may affect dashboard values and reports.",
          "detailPlural": "{{count}} issues may affect dashboard values and reports.",
          "readinessTitle": "Readiness"
        },
        "supportSection": {
          "subtitle": "Delegated diagnostics and traceability for support workflows"
        },
        "snapshots": {
          "exceptions": "Exceptions",
          "critical": "Critical",
          "staleCoverage": "stale or missing prices",
          "failedReconciliation": "failed",
          "exceptionsDesc": "Exceptions",
          "criticalDesc": "Critical",
          "staleCoverageDesc": "Stale Coverage",
          "failedReconciliationDesc": "Failed Reconciliation"
        }
      },
      "reports": {
        "title": "Reports",
        "description": "Find trusted portfolio, performance, tax, accounting, and NFRS reports.",
        "descriptionWithDataQuality": "Find trusted portfolio, performance, tax, accounting, NFRS, and data-quality reports."
      },
      "admin": {
        "title": "Admin",
        "description": "Manage organization access, governance, client administration, and enabled control surfaces.",
        "clientAdminSection": {
          "title": "Client administration",
          "description": "Manage client accounts"
        }
      },
      "generatedSection": {
        "title": "Generated data and evidence",
        "subtitle": "Generated holdings and report run history"
      },
      "supportSection": {
        "title": "Support Section",
        "subtitle": "Subtitle"
      }
    },
    "settings": {
      "title": "Settings"
    },
    "investment": {
      "imports": {
        "title": "Imports",
        "description": "Upload, validate, and trace investment transaction imports.",
        "loadingTitle": "Loading instruments",
        "loadingDescription": "Preparing import validation data.",
        "errorTitle": "Unable to load instruments",
        "errorDescription": "Unable to load import validation data. Retry to continue.",
        "helperTitle": "Before you import",
        "helperSubtitle": "Supported formats, validation behavior, and evidence traceability.",
        "helperFormats": "Supported sources include CSV/Excel portfolio exports and contract-note documents where configured.",
        "helperScope": "Imports are posted in the selected client/account scope to preserve audit ownership.",
        "helperValidation": "Each file is validated before posting; failed rows remain traceable with remediation details.",
        "helperEvidence": "Every import creates an evidence trail with timestamps, actor, row outcomes, and source metadata.",
        "transactionsContext": "Transaction import context enabled.",
        "backToTransactions": "Back to transactions",
        "viewImportEvidence": "View import audit trail",
        "openAuditHub": "Open audit reports hub",
        "startAnotherTitle": "Start another import",
        "startAnotherSubtitle": "Open a new workflow while keeping this evidence context visible.",
        "jobEvidenceTitle": "Import Job Evidence",
        "rowsTitle": "Imported rows",
        "copySuccess": "Link copied",
        "copySuccessDescription": "Evidence link copied to clipboard",
        "copyError": "Copy failed",
        "copyErrorDescription": "Unable to copy link to clipboard",
        "copyEvidenceLink": "Copy evidence link",
        "evidenceMissingTitle": "No recent import jobs found",
        "evidenceMissingDescription": "Run an import workflow to generate evidence you can review here.",
        "evidenceMissingAction": "Start import workflow",
        "evidenceQueueTitle": "Recent import evidence",
        "evidenceQueueDescription": "Select a job to review row outcomes, remediation steps, and lineage evidence.",
        "evidenceQueueLoadingTitle": "Loading recent import evidence",
        "evidenceQueueLoadingDescription": "Fetching recent import jobs in your current scope.",
        "evidenceQueueErrorTitle": "Unable to load import evidence queue",
        "evidenceQueueError": "Unable to load recent import evidence. Please retry.",
        "unknownSourceFile": "Imported file",
        "rowsProcessedSummary": "{{processed}}/{{total}} rows processed",
        "evidenceDisabledTitle": "Import evidence review is unavailable",
        "evidenceDisabledDescription": "Evidence review is disabled for this organization. Remove the evidence view filter to continue with the import workflow.",
        "status": "Imports Status",
        "openDataQualityPage": "Open Data Quality Page",
        "evidenceModeActive": "Evidence Mode Active",
        "importReference": "Import Reference",
        "copyFullReference": "Copy Full Reference",
        "retryFailedRows": "Retry Failed Rows",
        "rows": "Rows",
        "failed": "Failed",
        "retries": "Retries",
        "loadingJobTitle": "Loading Job",
        "loadingJobDescription": "Loading Job description",
        "rowsDescription": "Rows description",
        "rowHeader": "Row Header",
        "statusHeader": "Status Header",
        "resultHeader": "Result Header",
        "createdHeader": "Created Header",
        "errorHeader": "Error Header",
        "actionsHeader": "Header",
        "editRowTitle": "Edit Row",
        "traceRowTitle": "Trace Row",
        "noRowsTitle": "No Rows",
        "noRowsDescription": "No Rows description",
        "rowTraceDetails": "Row Trace Details",
        "rowTraceTitle": "Row Trace",
        "hideSupportReferences": "Hide Support References",
        "showSupportReferences": "Show Support References",
        "postedRecordLabel": "Posted Record",
        "transactionLabel": "Transaction",
        "available": "Available",
        "notCreated": "Not Created",
        "lotsLabel": "Lots",
        "realizedFactsLabel": "Realized Facts",
        "supportReferences": "Support References",
        "createdRecordReference": "Created Record Reference",
        "copyCreatedRecordReference": "Copy Created Record Reference",
        "transactionReference": "Transaction Reference",
        "copyTransactionReference": "Copy Transaction Reference",
        "editRowRegion": "Edit Row Region",
        "editRowHeading": "Edit Row Heading",
        "hideTechnicalRowData": "Hide Technical Row Data",
        "showTechnicalRowData": "Show Technical Row Data",
        "technicalRowPayload": "Technical Row Payload",
        "cancelEditing": "Cancel Editing",
        "rowDataJson": "Row Data (JSON)",
        "rowDataJsonDescription": "Row Data (JSON) description",
        "technicalPayloadHidden": "Technical Payload Hidden",
        "rowStatus": {
          "pending": "Pending",
          "processed": "Processed",
          "failed": "Failed",
          "success": "Success",
          "skipped": "Skipped",
          "retrying": "Retrying",
          "unknown": "Unknown status"
        },
        "postingResult": {
          "posted": "Posted",
          "failed": "Posting failed",
          "skipped": "Skipped",
          "partial": "Partial",
          "unknown": "Unknown result"
        },
        "jobStatus": {
          "pending": "Pending",
          "processing": "Processing",
          "completed": "Completed",
          "failed": "Failed",
          "cancelled": "Cancelled",
          "partial": "Partial",
          "unknown": "Unknown status"
        },
        "entityCreation": {
          "created": "Created",
          "notCreated": "Not created"
        },
        "errors": {
          "duplicate": "Duplicate entry — record already exists",
          "notFound": "Required reference not found",
          "invalid": "Invalid data format",
          "permission": "Permission denied",
          "unknown": "Processing failed"
        },
        "invalidViewFallback": "Invalid View Fallback"
      },
      "settings": {
        "validation": {
          "benchmarkSymbol": "Use 1-20 letters, numbers, dots, underscores, or hyphens.",
          "benchmarkPeriod": "Choose a supported comparison period.",
          "percentRange": "Enter a percentage from 0 to 100.",
          "fixBeforeSave": "Fix validation errors before saving."
        },
        "saveSuccess": "Investment settings saved.",
        "saveError": "Unable to save settings. Please retry.",
        "saveErrorPermission": "You do not have permission to save these settings.",
        "saveErrorValidation": "Settings could not be validated. Please check your inputs.",
        "saveErrorNetwork": "Network error occurred. Please check your connection and retry.",
        "saveErrorConflict": "Settings were modified by another user. Refresh and try again.",
        "loadError": {
          "title": "Unable to load settings",
          "description": "Settings could not be loaded. Please retry."
        },
        "accessDenied": {
          "title": "Access Restricted",
          "message": "You do not have permission to access investment settings."
        },
        "moduleUnavailable": {
          "title": "Investment module not enabled",
          "message": "The investment module is not enabled for your organization. Contact your administrator to enable it."
        },
        "moduleStatusTitle": "Investment module status",
        "moduleStatusSubtitle": "Current module entitlement and capability status",
        "moduleStatusState": "Investment active",
        "rebalancingEnabled": "Rebalancing enabled",
        "rebalancingDisabled": "Rebalancing not enabled",
        "group": {
          "ownership": "Ownership",
          "benchmarkAndRisk": "Benchmark and risk limits"
        },
        "approvalWorkflowInline": "Approval workflows are managed in Organization settings.",
        "openOrgSettings": "Open Organization settings",
        "approvalWorkflowNoAccess": "Organization-level approval workflows are managed by administrators.",
        "secondaryConfigTitle": "Secondary configuration context",
        "secondaryConfigSubtitle": "Status details are available on demand to keep primary controls focused.",
        "secondaryConfigTier": "Tier entitlement: {{tier}}",
        "secondaryConfigRebalancing": "Rebalancing capability: {{state}}",
        "page": {
          "title": "Investment Settings",
          "description": "Configure investment module settings and preferences."
        },
        "loading": {
          "title": "Loading",
          "description": "Loading description"
        },
        "reset": "Reset",
        "save": "Save"
      },
      "rebalancing": {
        "title": "Rebalancing",
        "description": "Review portfolio drift and prepare approved rebalancing actions."
      }
    },
    "workflows": {
      "imports": {
        "title": "Imports"
      }
    },
    "admin": {
      "clientAccounts": {
        "searchUnavailable": "Search Unavailable",
        "selectedOrganization": "Selected Organization",
        "clearOrganization": "Clear Organization",
        "changeOrganization": "Change Organization",
        "selectOrganizationTitle": "Select Organization",
        "selectOrganizationDescription": "Select Organization description",
        "organizationSearchPlaceholder": "Organization Search",
        "noOrganizationsFound": "No Organizations Found"
      }
    },
    "role": {
      "platformadmin": "Platform Admin",
      "platformroot": "Platform Root",
      "platformuser": "Platform User"
    }
  },
  "shell": {
    "skipToMainContent": "Skip to main content",
    "mainContentLabel": "Main content",
    "defaultOrganizationName": "Investment Portfolio",
    "delegationBanner": {
      "ariaLabel": "Delegated support session",
      "title": "Delegated support",
      "organizationLabel": "Organization",
      "exitAriaLabel": "Exit delegated support",
      "exitLabel": "Exit delegation"
    },
    "search": {
      "ariaLabel": "Search or jump to page",
      "label": "Search",
      "keyboardShortcut": "Ctrl K",
      "macShortcut": "⌘K",
      "windowsShortcut": "Ctrl+K"
    },
    "globalNav": {
      "primaryAriaLabel": "Primary navigation",
      "moreNavigationItemsAriaLabel": "More navigation items"
    },
    "mobileNav": {
      "ariaLabel": "Mobile navigation"
    },
    "breadcrumbs": {
      "ariaLabel": "Breadcrumb"
    },
    "commandPalette": {
      "dialogAria": "Finance command palette",
      "searchPlaceholder": "Jump to a finance page...",
      "searchAria": "Search finance pages",
      "closeAria": "Close command palette",
      "destinationsAria": "Accessible finance destinations",
      "noMatches": "No accessible routes match your search.",
      "noDestinations": "No accessible pages or commands are available for your current context.",
      "typeToSearch": "Type to search records, transactions, and more",
      "categories": {
        "pinned": "Pinned",
        "navigation": "Navigation",
        "records": "Records",
        "actions": "Actions",
        "reports": "Reports",
        "data": "Data",
        "settings": "Settings",
        "admin": "Administration",
        "other": "More destinations",
        "recent": "Recent",
        "suggested": "Suggested",
        "operations": "Operations",
        "portfolio": "Clients, portfolios & market data",
        "administration": "Administration",
        "results": "Best matches"
      },
      "pinned": {
        "dashboard": "Home",
        "holdings": "Holdings",
        "transactions": "Transactions",
        "imports": "Imports",
        "approvals": "Approvals",
        "reports": "Reports",
        "dataQuality": "Data Quality",
        "marketData": "Market Data",
        "settings": "Settings",
        "security": "Security",
        "updateMarketData": "Update Market Data",
        "viewTransactions": "View Transactions",
        "viewHoldings": "View Holdings",
        "openDashboard": "Open Dashboard",
        "reviewDataQuality": "Review Data Quality",
        "openReports": "Open Reports",
        "manageUsersRoles": "Manage Users & Roles",
        "openSettings": "Open Settings"
      },
      "actions": {
        "addTransaction": "Add Transaction",
        "addTransactionDesc": "Create a new transaction",
        "bulkTransactions": "Bulk Transactions",
        "bulkTransactionsDesc": "Import multiple transactions at once",
        "importTransactions": "Import Transactions",
        "importTransactionsDesc": "Import transactions from CSV or Excel",
        "importReferenceData": "Import Reference Data",
        "importReferenceDataDesc": "Import market data and reference information",
        "importMarketPrices": "Import Market Prices",
        "importMarketPricesDesc": "Import market prices from NEPSE",
        "reviewApprovals": "Review Approvals",
        "reviewApprovalsDesc": "Review pending approval requests",
        "reviewFailedImports": "Review Failed Imports",
        "reviewFailedImportsDesc": "Review and fix failed import operations",
        "reverseRepairTransaction": "Reverse/Repair Transaction",
        "reverseRepairTransactionDesc": "Reverse or repair a transaction",
        "configureBenchmarks": "Configure Benchmarks",
        "configureBenchmarksDesc": "Set up performance benchmarks",
        "configureTaxRules": "Configure Tax Rules",
        "configureTaxRulesDesc": "Review investment tax-rule configuration used by valuation and reporting",
        "exportReportTable": "Export Report Table",
        "exportReportTableDesc": "Export current report as Excel or PDF"
      },
      "untitledAction": "Untitled Action",
      "untitledDestination": "Untitled Destination",
      "refreshing": "Refreshing search results",
      "retry": "Retry",
      "staleResults": "Live results could not be refreshed. Available matching destinations are still shown.",
      "browseHint": "Type to search records, reports, workspaces, and actions.",
      "resultKinds": {
        "navigation": "Workspace",
        "record": "Record",
        "action": "Action"
      },
      "resultLimitHint": "Showing top 24 results — refine your search for more specific matches."
    },
    "userMenu": {
      "userFallback": "User",
      "organizationFallback": "Organization",
      "initialFallback": "U",
      "roleLabel": "Role",
      "tierLabel": "Tier",
      "profilePreferences": "Profile & preferences",
      "profilePreferencesDescription": "Manage your personal details, language, formats, and appearance.",
      "security": "Security & sessions",
      "securityDescription": "Manage your password, multi-factor authentication, recovery codes, and active sessions.",
      "scope": {
        "organization": "Organization scope",
        "client": "Client scope"
      },
      "triggerLabel": "Open user account menu",
      "context": {
        "organization": "Organization",
        "scope": "Scope",
        "branch": "Branch"
      },
      "role": {
        "ORG_ADMIN": "Admin",
        "ORGANIZATION_ADMIN": "Admin",
        "ORG_CLIENT": "Client",
        "CLIENT_USER": "Client",
        "ADMIN": "Administrator",
        "USER": "User",
        "UNKNOWN": "User",
        "PLATFORM_ROOT": "Platform Root",
        "PLATFORM_ADMIN": "Platform Admin",
        "PLATFORM_USER": "Platform User"
      },
      "fallback": {
        "settingsDescription": "Settings hub",
        "profileDescription": "User profile and preferences",
        "securityDescription": "Password, MFA, and sessions",
        "notificationsDescription": "Notification preferences"
      },
      "contextLabel": "User context",
      "moreRolesTooltip": "More roles",
      "switchContext": "Switch context",
      "accountActions": "Account",
      "actionsUnavailable": "Account menu actions are unavailable",
      "navigationRequestFailed": "Account navigation could not be loaded",
      "retryNavigation": "Retry account navigation",
      "logoutError": "Sign out failed",
      "delegated": "Delegated mode",
      "tier": {
        "BASIC": "Basic",
        "PROFESSIONAL": "Professional",
        "ENTERPRISE": "Enterprise",
        "UNKNOWN": "Unknown"
      },
      "actionsConfiguredUnavailable": "No actions configured",
      "switchContextFailed": "Could not switch workspace. Your current access was reconciled safely; try again."
    },
    "trustBadge": {
      "error": "Data Error",
      "warning": "Data Warning"
    },
    "moduleSelector": {
      "ariaLabel": "Switch module",
      "fallback": "Modules"
    },
    "contextSelector": {
      "ariaLabel": "Switch context",
      "fallback": "Select context",
      "switchSuccess": "Context switched successfully",
      "switchError": "Failed to switch context"
    },
    "navigation": {
      "open": "Open navigation",
      "homeTitle": "Home",
      "dataTitle": "Data",
      "reportsTitle": "Reports",
      "adminTitle": "Admin",
      "homeDescription": "Active module dashboard",
      "dataDescription": "Records and quality",
      "reportsDescription": "Certified outputs",
      "adminDescription": "Users and audit"
    },
    "settingsNav": {
      "investment": {
        "title": "Investment Settings",
        "description": "Investment module settings"
      },
      "accounting": {
        "title": "Accounting Settings",
        "description": "Accounting module settings"
      },
      "tax": {
        "title": "Tax Settings",
        "description": "Tax module settings"
      },
      "organization": {
        "description": "Organization settings"
      },
      "modules": {
        "description": "Module management and configuration"
      }
    },
    "activeModule": {
      "resolving": "Resolving"
    },
    "topBar": {
      "dataTrust": {
        "error": "Data Trust Error",
        "warning": "Data Trust Warning",
        "ok": "Data Trust Ok",
        "syncedToday": "Synced Today",
        "syncedYesterday": "Synced Yesterday",
        "syncedDaysAgo": "Synced Days Ago",
        "instruments": "Instruments",
        "unknown": "Unknown"
      }
    },
    "primaryNavigationLabel": "Primary navigation"
  },
  "workflow": {
    "transactions": {
      "title": "Transactions",
      "description": "Review, filter, create, import, and export investment transactions."
    },
    "createTransaction": {
      "title": "Create Transaction",
      "description": "Record a new investment transaction with validation and approval routing."
    },
    "approvals": {
      "title": "Approvals",
      "description": "Review pending investment transaction approvals and exceptions."
    },
    "imports": {
      "title": "Import Transactions",
      "description": "Import investment transactions from CSV or Excel files."
    },
    "rebalancing": {
      "title": "Portfolio Rebalancing",
      "description": "Analyze and execute portfolio rebalancing strategies."
    },
    "settings": {
      "title": "Investment Settings",
      "description": "Configure investment module settings and preferences.",
      "validation": {
        "benchmarkSymbol": "Use 1-20 letters, numbers, dots, underscores, or hyphens.",
        "benchmarkPeriod": "Choose a supported comparison period.",
        "percentRange": "Enter a percentage from 0 to 100.",
        "fixBeforeSave": "Fix validation errors before saving."
      },
      "saveSuccess": "Investment settings saved.",
      "saveError": "Failed to save settings.",
      "moduleStatusTitle": "Investment module status",
      "moduleStatusSubtitle": "Tier: {{tier}} · Rebalancing: {{state}}",
      "moduleStatusState": "Active",
      "approvalWorkflowInline": "Approval workflows are managed in Organization settings.",
      "openOrgSettings": "Open Organization settings",
      "group": {
        "ownership": "Ownership",
        "benchmarkAndRisk": "Benchmark and risk limits"
      },
      "secondaryConfigTitle": "Secondary configuration context",
      "secondaryConfigSubtitle": "Status details are available on demand to keep primary controls focused.",
      "secondaryConfigTier": "Tier entitlement: {{tier}}",
      "secondaryConfigRebalancing": "Rebalancing capability: {{state}}"
    },
    "marketDataSettings": {
      "title": "Market Data Settings",
      "description": "Configure market data sources and price synchronization.",
      "feedSource": "Market price feed",
      "policyTitle": "Provider and freshness policy",
      "policyDescription": "Use this page to manage provider policy and governance controls. Operational import and price correction happen in the Market Data workspace.",
      "operationalBoundary": {
        "title": "Operational workflows live under Data > Market Data.",
        "description": "Use the operational page for importing prices, reviewing symbol-level freshness, and correcting stale quotes."
      },
      "actions": {
        "openDataQuality": "Data Quality",
        "openOperationalPage": "Open Market Data Operations"
      },
      "governance": {
        "title": "Governance checks",
        "subtitlePrefix": "Review stale-data exceptions and reconciliation signals in",
        "subtitleSuffix": ".",
        "items": {
          "provider": "Define approved market-data providers and incident escalation ownership.",
          "freshness": "Set freshness policy for symbols that block valuation or export workflows.",
          "remediation": "Direct operators to the operational market-data page for data repair and import execution."
        }
      }
    }
  },
  "auth": {
    "username": "Username",
    "usernamePlaceholder": "Enter your username",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "passwordRequirement": "Use an 8+ character password.",
    "forgotPassword": {
      "title": "Forgot Password",
      "instructions": "Enter your email address and we will send password reset instructions if the account is eligible.",
      "email": "Email Address",
      "submit": "Send Reset Link",
      "sending": "Sending…",
      "error": "Reset instructions could not be sent. Try again.",
      "successTitle": "Check Your Email",
      "successMessage": "If an eligible account exists, password reset instructions have been sent. The link expires after one hour.",
      "sendAnother": "Send Another Email",
      "backToLogin": "Back to Login"
    },
    "resetPassword": {
      "title": "Reset Password",
      "tokenRequired": "A reset token is required",
      "invalidTitle": "Invalid Reset Link",
      "invalidMessage": "This password reset link is invalid or has expired.",
      "requestNew": "Request New Reset Link",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "submit": "Reset Password",
      "resetting": "Resetting…",
      "error": "The password could not be reset. Request a new link and try again.",
      "successTitle": "Password Reset Successful",
      "successMessage": "Your password has been updated. You can now sign in with the new password.",
      "signIn": "Sign In"
    },
    "contactAdminUnlock": "Please contact your system administrator to unlock your account.",
    "awaitingApproval": "Your account is awaiting administrator approval. You will be notified once approved.",
    "signingIn": "Signing in...",
    "signIn": "Sign in",
    "loginHeadline": "Sign in to your account",
    "setupHeadline": "Set up the first administrator and organization",
    "termsOfService": "Terms of Service",
    "privacyPolicy": "Privacy Policy",
    "loginForm": {
      "usernameRequired": "Please enter a username (min 3 characters)",
      "passwordRequired": "Please enter a password (min 8 characters)"
    },
    "apiErrors": {
      "loginFailed": "Login failed",
      "contextSelectionFailed": "Context selection failed",
      "mfaVerificationFailed": "MFA verification failed",
      "mfaEnrollmentFailed": "MFA enrollment failed",
      "mfaConfirmationFailed": "MFA confirmation failed",
      "mfaDisableFailed": "MFA disable failed",
      "backupCodesRegenerationFailed": "Failed to regenerate backup codes",
      "passwordResetEmailFailed": "Failed to send reset email",
      "passwordResetFailed": "Password reset failed",
      "tokenRefreshFailed": "Token refresh failed",
      "profileLoadFailed": "Failed to load profile",
      "logoutFailed": "Logout failed",
      "noMfaChallengeToken": "No MFA challenge token",
      "recentAuthRequired": "Recent authentication required. Please verify your credentials to continue."
    },
    "setupWizard": {
      "errors": {
        "organizationNameRequired": "Organization name is required",
        "organizationCodeRequired": "Organization code is required",
        "usernameRequired": "Username is required",
        "usernameTooShort": "Username must be at least 3 characters",
        "adminEmailRequired": "Administrator email is required",
        "invalidEmail": "Please enter a valid email address",
        "passwordRequirements": "Password must be at least 8 characters and include letters and numbers",
        "passwordMismatch": "Passwords do not match",
        "invalidPan": "PAN number must be exactly 9 alphanumeric characters",
        "invalidVat": "VAT number must be 9-12 digits",
        "registrationFailed": "Registration failed",
        "noOrganizationId": "No organization ID found",
        "importWithWarnings": "Import completed with warnings",
        "importFailed": "Failed to import file"
      },
      "defaults": {
        "adminUser": "ADMIN_USER",
        "adminSurname": "Admin"
      },
      "progress": {
        "readingExcel": "Reading Excel file...",
        "importComplete": "Done. Imported"
      },
      "checkmark": "✓",
      "separator": "›",
      "steps": {
        "createAdmin": "Create Admin",
        "importData": "Import Data",
        "done": "Done"
      },
      "labels": {
        "organizationName": "Organization Name",
        "organizationCode": "Organization Code",
        "adminUsername": "Administrator Username",
        "adminEmail": "Administrator Email",
        "panNumber": "PAN Number",
        "vatNumber": "VAT Number",
        "address": "Address",
        "phone": "Phone",
        "password": "Password",
        "confirmPassword": "Confirm Password",
        "enabledModules": "Enabled Modules",
        "initialFiscalYear": "Initial Fiscal Year",
        "fiscalYearLabel": "Fiscal year label",
        "fiscalYearStart": "Fiscal year start date",
        "fiscalYearEnd": "Fiscal year end date"
      },
      "placeholders": {
        "organizationName": "Example Capital Markets Pvt Ltd",
        "organizationCode": "ORG_CODE",
        "username": "admin_user",
        "email": "admin@example.com",
        "address": "Registered address",
        "password": "At least 8 characters",
        "confirmPassword": "Repeat the password",
        "fiscalYearLabel": "Fiscal year label"
      },
      "modules": {
        "investment": "Investment",
        "accounting": "Accounting",
        "inventory": "Inventory"
      },
      "info": {
        "firstRunRequired": "First-run setup cannot be skipped because the application has no operator account yet.",
        "selectWorkbook": "Select the workbook that contains the listed companies sheet plus the per-company transaction sheets."
      },
      "buttons": {
        "creatingAccount": "Creating account…",
        "createOrganizationAndAdmin": "Create Organization and Admin",
        "goToDashboard": "Go to Dashboard"
      },
      "titles": {
        "importExistingData": "Import Existing Data",
        "setupComplete": "Setup Complete"
      },
      "descriptions": {
        "importOption": "Optionally load your company master and transaction history from an Excel file. You can start empty and import later.",
        "workspaceReady": "Your portfolio workspace is ready."
      }
    },
    "forcedPasswordChange": {
      "successMessage": "Password updated. You can continue into the application.",
      "title": "Change your bootstrap password",
      "description": "{{username}} is using an initial privileged credential. Rotate it before accessing the rest of the product.",
      "thisAccount": "This account",
      "labels": {
        "currentPassword": "Current password",
        "newPassword": "New password",
        "confirmPassword": "Confirm new password"
      },
      "passwordRequirements": "Use 8-128 characters with at least one letter and one number.",
      "errors": {
        "title": "Password change failed"
      },
      "successTitle": "Success",
      "buttons": {
        "updating": "Updating password...",
        "update": "Update password",
        "signOut": "Sign out"
      }
    },
    "initialSetup": {
      "errors": {
        "emailRequired": "Valid email address is required",
        "firstNameRequired": "First name is required",
        "surnameRequired": "Surname is required",
        "passwordTooShort": "Password must be at least 8 characters",
        "passwordRequirements": "Password must contain uppercase, lowercase, and numbers",
        "passwordMismatch": "Passwords do not match",
        "creationFailed": "Failed to create root user"
      },
      "creating": "Creating Platform Root...",
      "creatingDescription": "Please wait while we set up the initial administrator",
      "successTitle": "Platform Root Created!",
      "redirecting": "Redirecting to login...",
      "firstNamePlaceholder": "First Name",
      "lastNamePlaceholder": "Last Name",
      "title": "Initial Setup",
      "subtitle": "Subtitle",
      "labels": {
        "firstName": "First Name",
        "surname": "Surname",
        "email": "Email",
        "password": "Password",
        "confirmPassword": "Confirm Password"
      },
      "placeholders": {
        "email": "Email",
        "password": "Password",
        "confirmPassword": "Confirm Password"
      },
      "showPassword": "Show Password",
      "createButton": "Create Button",
      "info": "Info"
    },
    "login": {
      "title": "Sign In",
      "email": "Email",
      "password": "Password",
      "submit": "Sign In",
      "invalidCredentials": "Invalid email or password",
      "localSignOutWarning": "You have been signed out on this device. The remote session could not be revoked — it will expire automatically. If you are concerned, revoke your sessions from another device.",
      "signingIn": "Signing in…"
    },
    "mfa": {
      "title": "Multi-Factor Authentication",
      "enterCode": "Enter your authentication code",
      "useRecoveryCode": "Use recovery code",
      "invalidCode": "Invalid authentication code",
      "enroll": "Enroll MFA",
      "stepUp": {
        "title": "Verify Your Identity",
        "description": "Higher privileges required",
        "privilegesRequired": "This action requires multi-factor authentication. Please enroll or verify your MFA to continue.",
        "notEnrolled": "You need to enroll in multi-factor authentication to perform this action.",
        "alreadyEnrolled": "Multi-factor authentication is enabled on your account. Please sign out and sign back in with your MFA code to elevate your session, or contact your administrator."
      }
    },
    "logout": {
      "success": "You have been signed out"
    },
    "context": {
      "switch": "Switch Context",
      "organization": "Organization",
      "branch": "Branch"
    },
    "validation": {
      "invalidEmail": "Invalid email address",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 8 characters",
      "passwordsMismatch": "Passwords do not match",
      "passwordTooShort": "Password must be at least 8 characters",
      "passwordMismatch": "Passwords do not match"
    },
    "contextSelection": {
      "title": "Choose Your Workspace",
      "description": "Select the organization and branch you want to use for this session.",
      "continue": "Continue",
      "back": "Use Another Account",
      "error": "The selected workspace could not be opened. Try again."
    },
    "mfaChallenge": {
      "title": "Two-Factor Authentication",
      "description": "Verify your identity to continue.",
      "instructions": "Enter the 6-digit code from your authenticator app.",
      "codeLabel": "Authentication code",
      "codeError": "Enter a valid 6-digit code",
      "verify": "Verify",
      "verifying": "Verifying…",
      "invalid": "The authentication code could not be verified. Try again.",
      "expired": "This authentication challenge has expired. Return to login and try again."
    },
    "initialPasswordChange": {
      "title": "Change Your Password",
      "description": "You must set a new password before continuing.",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "submit": "Change password",
      "submitting": "Changing password…",
      "backToLogin": "Back to login"
    }
  },
  "settings": {
    "title": "Settings",
    "summary": {
      "title": "Account Summary"
    },
    "hub": {
      "title": "Settings Hub"
    },
    "profile": {
      "title": "Profile",
      "description": "Your profile information",
      "name": "Name",
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "phone": "Phone",
      "mfa": "MFA",
      "mfaEnabled": "Enabled",
      "mfaDisabled": "Disabled",
      "status": "Status",
      "credentialSource": "Credential Source",
      "localPassword": "Local Password",
      "sso": "SSO",
      "emailReadOnly": "Email is managed by your organization and cannot be changed here.",
      "mfaReadOnly": "Manage MFA on the Security settings page.",
      "statusReadOnly": "Account status is managed by your administrator.",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "phoneInvalid": "Phone number is invalid",
      "saved": "Profile saved successfully",
      "helpText": {
        "firstName": "Your legal first name as it appears in regulatory documentation.",
        "lastName": "Your legal last name as it appears in regulatory documentation.",
        "email": "Your primary email address used for account login and communications. Verify after changes.",
        "phone": "Optional contact phone number for account recovery and support purposes.",
        "status": "Your account status. Contact support if you need assistance with account activation."
      },
      "saveError": "The profile could not be saved. Review the information and try again.",
      "sectionNavigation": "Profile and preferences"
    },
    "organization": {
      "title": "Organization & Branch",
      "organization": "Organization",
      "branch": "Branch",
      "selectOrganization": "Select organization",
      "selectTenant": "Select branch"
    },
    "security": {
      "title": "Security",
      "manageMfa": "Manage MFA",
      "changePassword": "Change Password",
      "manageSessions": "Manage Sessions",
      "logout": "Logout",
      "ssoPasswordNote": "Your account uses single sign-on (SSO). Password changes are managed by your identity provider.",
      "overviewTitle": "Security Overview",
      "overviewLoadError": "Failed to load security overview",
      "manageSecurity": "Manage Security",
      "manageSecurityDescription": "Review and update your authentication settings",
      "mfaStatus": "Multi-Factor Authentication",
      "mfaEnabled": "Enabled",
      "mfaNotEnabled": "Not enabled",
      "activeSessionsCount": "{{count}} active session(s)",
      "passwordCardDescription": "Change your account password",
      "mfaCardDescription": "Manage two-factor authentication and recovery codes",
      "sessionsCardDescription": "View and revoke active sessions",
      "sectionNavigation": "Security and sessions",
      "helpText": {
        "currentPassword": "Enter your current password to verify your identity before making security changes.",
        "newPassword": "Create a strong password with at least 12 characters including uppercase, numbers, and symbols.",
        "confirmPassword": "Re-enter your new password to confirm it matches exactly.",
        "totpCode": "Enter the current 6-digit code from your authenticator to confirm this sensitive password change.",
        "mfaMethod": "Multi-factor authentication adds an extra security layer to protect your account from unauthorized access.",
        "backupCodes": "Save these recovery codes in a secure location. Use them to access your account if you lose your MFA device.",
        "recoveryEmail": "Designate an alternate email for account recovery if your primary email becomes inaccessible."
      }
    },
    "password": {
      "title": "Change Password",
      "description": "Update your account password",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "totpCode": "Authentication Code",
      "submit": "Change Password",
      "success": "Password changed successfully",
      "mismatch": "New passwords do not match",
      "currentRequired": "Current password is required",
      "newRequired": "New password is required",
      "strength": "Password must be at least 8 characters and include mixed case, numbers, and symbols",
      "sameAsCurrent": "New password must differ from current",
      "ssoNote": "Your account uses single sign-on (SSO). Password changes are managed by your identity provider.",
      "sessionsRevoked": "All other active sessions have been revoked.",
      "capsLock": "Caps Lock is on",
      "strengthMeter": {
        "label": "Password strength",
        "weak": "Weak",
        "fair": "Fair",
        "good": "Good",
        "strong": "Strong"
      },
      "error": "The password could not be changed. Review the requirements and try again."
    },
    "sessions": {
      "title": "Active Sessions",
      "description": "View and manage your signed-in sessions",
      "device": "Device",
      "ipAddress": "IP Address",
      "createdAt": "Signed in",
      "current": "Current session",
      "revoke": "Sign out",
      "revokeSuccess": "Session ended",
      "revokeConfirm": "End this session?",
      "empty": "No active sessions found",
      "summary": "Review and revoke active sessions.",
      "revokeAllOthers": "Sign out all other devices",
      "revokeAllSuccess": "All other devices have been signed out.",
      "currentDeviceFallback": "This browser",
      "otherDeviceFallback": "Other signed-in session",
      "lastActivityAt": "Last session refreshed",
      "expiresAt": "Expires",
      "strongAuthentication": "Strong authentication (MFA verified)",
      "standardAuthentication": "Standard authentication",
      "helpText": {
        "sessions": "Review all active sessions. You can sign out from other devices if you suspect unauthorized access.",
        "signOut": "Sign out this device immediately. Your session data will be cleared."
      },
      "unknownDevice": "Unknown device",
      "aal": "Authentication level",
      "revokeError": "The session could not be revoked. Try again.",
      "revokeAllError": "Other sessions could not be revoked. Try again.",
      "confirmAllTitle": "Revoke all other sessions?",
      "confirmAllMessage": "This will sign out {{count}} other session. Your current session will remain active.",
      "confirmAllMessage_other": "This will sign out {{count}} other sessions. Your current session will remain active."
    },
    "preferences": {
      "title": "Preferences",
      "saved": "Preferences saved successfully",
      "save": "Save Preferences",
      "description": "Configure your application preferences",
      "theme": {
        "label": "Theme",
        "description": "Choose your preferred color scheme"
      },
      "language": {
        "label": "Language",
        "description": "Application language"
      },
      "dateFormat": {
        "label": "Date Format",
        "description": "How dates are displayed throughout the app"
      },
      "numberFormat": {
        "label": "Number Format",
        "description": "Number formatting style"
      },
      "timeZone": {
        "label": "Time Zone",
        "kathmandu": "Kathmandu (UTC+05:45)",
        "kolkata": "Kolkata (UTC+05:30)",
        "utc": "Coordinated Universal Time (UTC)",
        "losAngeles": "Los Angeles (Pacific Time)",
        "london": "London (United Kingdom)"
      },
      "selectTheme": "Select theme",
      "selectLanguage": "Select language",
      "selectDateFormat": "Select format",
      "themeLight": "Light",
      "themeDark": "Dark",
      "themeAuto": "System",
      "languageEn": "English",
      "languageNe": "नेपाली",
      "dateFormatAD": "AD (Gregorian)",
      "dateFormatBS": "BS (Bikram Sambat)",
      "dateFormatDual": "Dual (AD / BS)",
      "numberFormatEnNP": "Nepali (1,23,456.78)",
      "numberFormatEnUS": "US (1,234,567.89)",
      "sidebarCollapsed": "Sidebar Collapsed — Keep navigation sidebar collapsed by default",
      "notifications": "Notifications",
      "tableData": "Table & Data",
      "emailNotifications": "Email Notifications — Receive email alerts for important events",
      "inAppNotifications": "In-App Notifications — Show notifications within the application",
      "pushNotifications": "Push Notifications — Receive browser push notifications",
      "defaultPageSize": {
        "label": "Default Page Size",
        "description": "Number of rows per page in tables",
        "error": "Page size must be an integer between {{min}} and {{max}}"
      },
      "resetDefaults": "Reset to defaults",
      "loadError": "Preferences could not be loaded",
      "notificationsDisabled": "Notification preferences are managed centrally.",
      "numberFormatEnIN": "India (English)",
      "helpText": {
        "locale": "Select your preferred language for the user interface and date/time formats.",
        "theme": "Choose between light and dark appearance. Your preference will be saved automatically.",
        "timezone": "Set your timezone for accurate scheduling, transaction timestamps, and reporting dates.",
        "emailNotifications": "Receive email summaries of important account activities and alerts.",
        "pushNotifications": "Get browser notifications for time-sensitive actions and approvals."
      },
      "saveError": "Preferences could not be saved. Review the values and try again.",
      "defaultContext": {
        "label": "Default branch"
      }
    },
    "mfa": {
      "title": "MFA Settings",
      "description": "Manage multi-factor authentication",
      "enrollment": {
        "title": "MFA Enrollment",
        "description": "Enroll in Multi-Factor Authentication to add an extra layer of security to your account.",
        "button": "Enroll MFA",
        "supports": "Supports Google Authenticator, Authy, Microsoft Authenticator, and other TOTP apps."
      },
      "status": {
        "label": "MFA Status",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "enable": "Enable MFA"
      },
      "backupCodes": {
        "title": "Backup Codes",
        "remaining": "{{count}} code(s) remaining. Each code can be used once.",
        "regenerate": "Regenerate Codes",
        "disableMfa": "Disable MFA",
        "important": "Important:",
        "warning": "Save these backup codes in a secure location. Each code can only be used once.",
        "copyImmediately": "Save these recovery codes in a secure place. They will not be shown again.",
        "description": "You have {{count}} recovery codes. Store them somewhere secure. If your authenticator app is unavailable, use one to sign in. Each code works exactly once, so keep the rest for future emergencies. You can generate a new set at any time if you lose these.",
        "done": "I have saved my codes"
      },
      "enroll": {
        "scanQr": "Scan the QR code with your authenticator app",
        "manualKey": "Manual Entry Key",
        "manualKeyHelp": "If you can't scan the QR code, open your authenticator app and choose \"Enter setup key,\" then paste this key.",
        "backupCodesTitle": "Backup Codes (Save These!)",
        "cancel": "Cancel",
        "scanned": "I've Scanned the Code",
        "qrAlt": "MFA QR Code"
      },
      "verify": {
        "title": "Verify Your Code",
        "description": "Enter the 6-digit code from your authenticator app",
        "placeholder": "000000",
        "back": "Back",
        "button": "Verify & Enable",
        "enterCode": "Enter 6-digit code"
      },
      "disable": {
        "title": "Disable MFA",
        "warning": "Disabling MFA will remove the extra layer of security from your account.",
        "description": "Enter a 6-digit code from your authenticator app or a backup code to confirm",
        "placeholder": "000000",
        "cancel": "Cancel",
        "button": "Disable MFA",
        "enterCode": "Enter 6-digit code",
        "confirmTitle": "Disable MFA?",
        "confirmBody": "Disabling MFA will remove your second factor. You must enter a valid 6-digit code to proceed."
      },
      "regenerate": {
        "confirmTitle": "Regenerate recovery codes?",
        "confirmBody": "Regenerating recovery codes will invalidate all previously issued codes. Continue?"
      },
      "success": {
        "enabled": "MFA enabled successfully",
        "disabled": "MFA disabled",
        "regenerated": "Backup codes regenerated"
      },
      "errors": {
        "invalidCode": "Invalid code",
        "enrollmentFailed": "Enrollment failed",
        "regenerateFailed": "Failed to regenerate",
        "clipboardFailed": "Could not copy to clipboard",
        "invalidSetup": "Invalid MFA setup response",
        "setupExpired": "MFA setup expired. Please start again."
      },
      "copyCode": "Copy code"
    }
  },
  "companies": {
    "companyList": {
      "deleteCompany": "Delete company",
      "deleteConfirmation": "Delete {{symbol}}? This action cannot be undone.",
      "deleteFailed": "Delete failed",
      "failedToDeleteCompany": "Failed to delete company",
      "companyDeleted": "Company deleted",
      "companyRemoved": "{{symbol}} was removed successfully.",
      "loadingCompanies": "Loading companies...",
      "totalInstruments": "Total Instruments",
      "groupsCount": "{{count}} groups",
      "companyDetails": "Company Details",
      "reviewProfile": "Review profile information for {{name}}",
      "closeDetails": "Close Details",
      "company": "Company",
      "symbol": "Symbol",
      "sector": "Sector",
      "notAssigned": "Not assigned",
      "securityType": "Security Type",
      "alternateSymbol2": "Alternate Symbol 2",
      "alternateSymbol3": "Alternate Symbol 3",
      "notSet": "Not set",
      "companyList": "Company List",
      "companiesInSystem": "{{count}} companies in the system",
      "bulkImport": "Bulk Import",
      "addCompany": "Add Company",
      "previous": "Previous",
      "next": "Next",
      "pageOf": "Page Of {{page}} {{total}}",
      "companyName": "Company Name",
      "actions": "Actions",
      "viewDetails": "View Details",
      "statement": "Statement",
      "edit": "Edit",
      "delete": "Delete",
      "none": "None",
      "type": "Type",
      "noCompaniesFound": "No Companies Found"
    },
    "editCompany": "Edit Company",
    "addNewCompany": "Add New Company",
    "updateCompanyDetails": "Update company details",
    "enterCompanyDetails": "Enter company details to add to the system",
    "symbolPlaceholder": "e.g., AAPL",
    "companyName": "Company Name",
    "companyNamePlaceholder": "e.g., Apple Inc.",
    "serialNumber": "Serial Number",
    "serialNumberPlaceholder": "e.g., 1",
    "sectorPlaceholder": "e.g., Technology",
    "symbol2": "Symbol 2",
    "alternativeSymbol": "Alternative symbol",
    "symbol3": "Symbol 3",
    "alternativeSymbol3": "Alternative symbol 3",
    "selectType": "Select type",
    "equity": "Equity",
    "bond": "Bond",
    "mutualFund": "Mutual Fund",
    "etf": "ETF",
    "other": "Other",
    "updating": "Updating...",
    "creating": "Creating...",
    "updateCompany": "Update Company",
    "createCompany": "Create Company",
    "bulkImport": {
      "invalidJsonFile": "Invalid Json File",
      "invalidJsonFormat": "Invalid Json Format",
      "failedToDownloadTemplate": "Failed To Download Template",
      "selectCsvFile": "Select Csv File",
      "enterJsonContent": "Enter Json Content",
      "bulkImportFailed": "Bulk Import Failed",
      "bulkImportCompleted": "Bulk Import Completed",
      "bulkImportFailedCheckFormat": "Bulk Import Failed Check Format",
      "title": "Bulk Import",
      "description": "Bulk Import description",
      "importFormat": "Import Format",
      "csvFile": "Csv File",
      "downloadTemplate": "Download Template",
      "requiredColumns": "Required Columns",
      "jsonFile": "Json File",
      "orPasteJsonContent": "Or Paste Json Content",
      "forceImportDescription": "Force Import description",
      "preview": "Preview {{count}}"
    },
    "importCompanies": "Import Companies",
    "symbol": "Symbol",
    "sector": "Sector",
    "securityType": "Security Type"
  },
  "bulkImport": {
    "invalidJsonFile": "Invalid JSON file",
    "invalidJsonFormat": "Invalid JSON format",
    "failedToDownloadTemplate": "Failed to download template",
    "selectCsvFile": "Please select a CSV file",
    "enterJsonContent": "Please enter JSON content or upload a JSON file",
    "bulkImportFailed": "Bulk import failed",
    "bulkImportCompleted": "Bulk import completed",
    "bulkImportFailedCheckFormat": "Bulk import failed. Please check your file format and try again.",
    "title": "Bulk Import Companies",
    "description": "Import multiple companies at once using CSV or JSON format",
    "importFormat": "Import Format",
    "csvFile": "CSV File",
    "downloadTemplate": "Download Template",
    "requiredColumns": "Required columns: symbol, instrumentName. Optional: serialNumber, symbol2, sector, symbol3, instrumentType",
    "jsonFile": "JSON File",
    "orPasteJsonContent": "Or paste JSON content",
    "forceImportDescription": "Force import (update existing companies even if duplicates are detected)",
    "preview": "Preview ({{count}} records)"
  },
  "importCompanies": "Import Companies",
  "importing": "Importing...",
  "legal": {
    "termsOfService": {
      "back": "Back",
      "title": "Terms of Service",
      "section1Title": "1. Acceptance of Terms",
      "section1Description": "By accessing and using {{brand}}, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.",
      "section2Title": "2. Description of Service",
      "section2Description": "{{brand}} provides a portfolio management and accounting platform for organizations. The service is provided on an \"as is\" basis without warranties of any kind.",
      "section3Title": "3. User Responsibilities",
      "section3Description": "Users are responsible for maintaining the confidentiality of their account credentials and for all activities that occur under their account. You agree to notify us immediately of any unauthorized use of your account.",
      "section4Title": "4. Data Privacy",
      "section4Description": "Your use of our service is also governed by our Privacy Policy. Please review our Privacy Policy, which also governs our service and outlines how we collect, use, and protect your personal information.",
      "section5Title": "5. Intellectual Property",
      "section5Description": "All content, features, and functionality of {{brand}} are owned by us and are protected by international copyright, trademark, and other intellectual property laws.",
      "section6Title": "6. Limitation of Liability",
      "section6Description": "In no event shall {{brand}} be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.",
      "section7Title": "7. Modifications",
      "section7Description": "We reserve the right to modify these terms at any time. Your continued use of the service after such modifications constitutes your acceptance of the revised terms.",
      "section8Title": "8. Contact Information",
      "section8Description": "If you have any questions about these Terms of Service, please contact us through your organization's administrator.",
      "lastUpdated": "Last updated: "
    },
    "privacyPolicy": {
      "back": "Privacy Policy Back",
      "title": "Privacy Policy",
      "section1Title": "Section 1",
      "section1Description": "Section 1 description {{brand}}",
      "section2Title": "Section 2",
      "section2Description": "Section 2 description",
      "section3Title": "Section 3",
      "section3Description": "Section 3 description",
      "section4Title": "Section 4",
      "section4Description": "Section 4 description",
      "section5Title": "Section 5",
      "section5Description": "Section 5 description",
      "section6Title": "Section 6",
      "section6Description": "Section 6 description",
      "section7Title": "Section 7",
      "section7Description": "Section 7 description",
      "section8Title": "Section 8",
      "section8Description": "Section 8 description",
      "section9Title": "Section 9",
      "section9Description": "Section 9 description",
      "lastUpdated": "Last Updated"
    }
  },
  "errors": {
    "investment": {
      "purchaseDateInvalid": "Purchase date is invalid. Please provide a valid date.",
      "saleDateInvalid": "Sale date is invalid. Please provide a valid date.",
      "saleDateBeforePurchaseDate": "Sale date must be after purchase date.",
      "idempotentDisposalMismatch": "Idempotent disposal mismatch detected."
    },
    "surface": {
      "modelMissing": "Unable to load surface data",
      "contractInvalid": "Invalid surface contract",
      "actionFailed": "Action failed",
      "formInvalid": "Invalid form",
      "configurationInvalid": "Invalid configuration",
      "empty": {
        "noRows": "No data available",
        "filteredOut": "No results match your filters"
      }
    },
    "report": {
      "runtimeFailed": "An error occurred while generating the report. Please try again or contact support with the request ID.",
      "lineageRequired": "Lineage information is required for this report.",
      "lineageCollectionFailed": "Failed to collect lineage information for this report.",
      "metadataUnavailable": "Report metadata is unavailable.",
      "tenantContextRequired": "Branch context is required for report queries",
      "invalidPivotBy": "Invalid pivotBy value",
      "branchIdRequired": "Branch ID is required",
      "organizationIdRequired": "Organization ID is required",
      "userIdRequired": "User ID (actor) is required",
      "nameRequired": "Name is required",
      "definitionNotFound": "Report definition not found",
      "runNotFound": "Report run not found",
      "outputNotFound": "Report output not found",
      "unsupportedType": "Unsupported report type"
    },
    "common": {
      "unauthorized": "Unauthorized",
      "forbidden": "Access Denied",
      "notFound": "Resource Not Found",
      "conflict": "Conflict",
      "badRequest": "Bad Request",
      "internalError": "Internal Server Error"
    },
    "branch": {
      "hasActiveChildren": "This branch has active child branches. Suspend or deactivate all child branches first.",
      "lastUsableProtected": "This is the last active branch in the organization and cannot be deactivated.",
      "lifecycleReasonRequired": "A reason is required when suspending or deactivating a branch.",
      "mustBeActiveToDefault": "The branch must be active to be set as the default branch."
    },
    "governance": {
      "unhandledExperience": "Unhandled experience or governance definition not found.",
      "unhandledAction": "Unhandled action for this experience.",
      "organizationIdRequired": "Organization ID is required for this operation.",
      "organizationNameRequired": "Organization name is required.",
      "bundleNameRequired": "Permission bundle name is required.",
      "bundleNameDuplicate": "A permission bundle with this name already exists in the organization.",
      "bundleIdRequired": "Permission bundle ID is required.",
      "bundleNotFound": "Permission bundle not found.",
      "bundleNoChanges": "No changes were provided for the permission bundle.",
      "functionIdsRequired": "At least one function ID is required for this operation."
    },
    "rateLimit": {
      "blacklisted": "Access denied - identifier is blacklisted",
      "exceeded": "Too many requests. Please try again later."
    },
    "csrf": {
      "tokenMissing": "CSRF token is missing",
      "tokenMismatch": "CSRF token mismatch",
      "tokenInvalid": "CSRF token is invalid or expired"
    },
    "context": {
      "requestContextRequired": "Request context is required",
      "organizationContextRequired": "Organization context is required",
      "userContextRequired": "User context is required",
      "tenantContextRequired": "Branch context is required"
    },
    "user": {
      "notFound": "User not found",
      "alreadyExists": "User already exists",
      "idTooLong": "User ID must not exceed 15 characters",
      "idInvalidFormat": "User ID must be alphanumeric with hyphens or underscores only",
      "usernameAlreadyExists": "Username already exists",
      "emailAlreadyExists": "Email already exists",
      "branchNotFound": "Branch not found",
      "userTypeNotFound": "User type not found",
      "cannotSuspendSelf": "You cannot suspend your own account",
      "suspensionReasonRequired": "Suspension reason is required",
      "reactivationReasonRequired": "Reactivation reason is required",
      "notSuspended": "User is not suspended",
      "accountNotLocked": "User account is not locked or suspended",
      "deletionReasonRequired": "Deletion reason is mandatory",
      "cannotDeleteSelf": "You cannot delete your own account",
      "alreadyDeleted": "User is already deleted",
      "notPendingDeletion": "User is not pending deletion approval",
      "reapplyReasonRequired": "Reapply reason is required",
      "notRejected": "Only REJECTED users can be reapplied",
      "accountLocked": "Account is locked until {{lockedUntil}}",
      "passwordTooShort": "Password must be at least 8 characters",
      "passwordTooLong": "Password must not exceed 128 characters",
      "passwordComplexity": "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)",
      "notActive": "User account is not active",
      "notPendingApproval": "User is not pending approval (current status: {{status}})",
      "rejectionReasonTooLong": "Rejection reason must not exceed 2500 characters",
      "cannotCreatePlatformRoot": "Cannot create users with PLATFORM_ROOT user type. This is reserved for bootstrap only",
      "notActiveForSuspension": "Only ACTIVE users can be suspended. Current status: {{status}}",
      "cannotUpdateStatus": "Cannot update user with status: {{status}}",
      "cannotApproveOwnDeletion": "Cannot approve your own deletion request (dual control required)"
    },
    "portfolio": {
      "notFound": "Portfolio not found",
      "accessDenied": "Portfolio does not belong to your organization",
      "clientAccessDenied": "Portfolio does not belong to your client account",
      "holdingsNotFound": "No position facts found for organization {{organizationId}} and branch {{branchId}}. Holdings data is not available. Please ensure transactions have been processed and position facts have been generated.",
      "organizationRequired": "Organization context is required to retrieve portfolio holdings",
      "tenantRequired": "Branch context is required to retrieve portfolio holdings",
      "invalidClientAccount": "Invalid clientAccountId for portfolio recalculation",
      "clientAccountRequired": "clientAccountId is required when scope is CLIENT_ACCOUNT",
      "analyticsDisabled": "Analytics features are currently disabled. This feature uses simulated data and is not yet production-ready.",
      "positive": "Positive",
      "periodUnsupported": "Period '{{period}}' is not supported. Allowed periods are: {{allowedPeriods}}.",
      "holdingLotQuantityPositive": "Holding lot quantity must be positive",
      "holdingLotRemainingNegative": "Holding lot remaining quantity cannot be negative",
      "remainingExceedsPurchased": "Remaining quantity cannot exceed purchased quantity",
      "costPerUnitNegative": "Cost per unit cannot be negative",
      "totalLotCostNegative": "Total lot cost cannot be negative",
      "disposalQuantityPositive": "Transaction disposal quantity must be positive",
      "saleRateNegative": "Sale rate cannot be negative",
      "saleAmountNegative": "Sale amount cannot be negative",
      "soldCostBasisNegative": "Sold cost basis cannot be negative",
      "transactionQuantityPositive": "Transaction quantity must be positive",
      "pricePerUnitNegative": "Price per unit cannot be negative",
      "totalAmountNegative": "Total amount cannot be negative",
      "commissionNegative": "Commission cannot be negative",
      "dpChargesNegative": "DP charges cannot be negative",
      "sebonFeeNegative": "SEBON fee cannot be negative",
      "otherChargesNegative": "Other charges cannot be negative",
      "totalCostNegative": "Total cost cannot be negative",
      "capitalGainTaxNegative": "Capital gain tax cannot be negative"
    },
    "transaction": {
      "notFound": "Transaction not found",
      "organizationRequired": "Organization ID is required for transaction queries",
      "tenantRequired": "Branch ID is required for transaction queries",
      "userNotFound": "User not found",
      "approvalWorkflowNotFound": "Approval workflow not found",
      "notPendingApproval": "Transaction is not pending approval",
      "rejectionReasonRequired": "Rejection reason is required",
      "batchNotFound": "Bulk transaction batch {{batchId}} not found",
      "idsRequired": "Transaction IDs are required",
      "bulkBatchNotFound": "Bulk transaction batch not found",
      "reversalReasonRequired": "Reversal reason is required",
      "reversalReasonTooShort": "Reversal reason must be at least 10 characters",
      "accessDenied": "You do not have permission to access this transaction",
      "statusAlreadySet": "Transaction is already in {{toStatus}} status. No transition needed.",
      "invalidStatusTransition": "Invalid status transition: {{from}} -> {{to}} is not allowed for {{operation}}. Valid transitions from {{from}}: {{validTransitions}}",
      "openingBalanceDateAfterTransaction": "Opening balance date ({{openingDate}}) is after first transaction date ({{transactionDate}}) for {{instrumentSymbol}} in account {{clientAccountId}}. This is a data integrity issue requiring repair. Please correct the opening balance date or the transaction date."
    },
    "export": {
      "notFound": "Export not found or access denied",
      "notReady": "Export is not ready for download",
      "expired": "Export has expired",
      "unsupportedFormat": "Unsupported export format",
      "generationFailed": "Export generation failed",
      "gainLossBlocked": "Gain-loss export is blocked because the underlying report has blocking data quality errors",
      "tenantRequired": "Branch ID is required for gain-loss-report export",
      "userNotFound": "User not found",
      "userNoOrganization": "User is not linked to an organization. Complete setup before creating exports."
    },
    "import": {
      "noPortfolioStatementSheets": "No portfolio statement sheets found in Excel file",
      "invalidExcelFormat": "Invalid Excel file format",
      "csvFileEmpty": "CSV file is empty",
      "clientAccountIdRequired": "Client account ID is required for opening balance imports"
    },
    "validation": {
      "transactionTypeNotFound": "Transaction type not found",
      "investmentApproachNotFound": "Investment approach not found",
      "fiscalYearNotFound": "Fiscal year not found",
      "sectorNotFound": "Sector not found"
    },
    "company": {
      "notFound": "Company not found"
    },
    "clientAccount": {
      "notFound": "Client account not found"
    },
    "permission": {
      "denied": "Permission denied"
    },
    "search": {
      "savedNotFound": "Saved search not found",
      "organizationNotFound": "Organization not found for user"
    },
    "reportScope": {
      "startDateAfterEndDate": "Start date must be before or equal to end date",
      "asOfDateBeforeStartDate": "As of date must be after or equal to start date",
      "asOfDateAfterEndDate": "As of date must be before or equal to end date"
    },
    "lot": {
      "quantityPositive": "Lot quantity must be positive",
      "saleQuantityPositive": "Sale quantity must be positive"
    },
    "upload": {
      "fileTooLarge": "File Too Large",
      "invalidMimeType": "Invalid Mime Type",
      "invalidExtension": "Invalid Extension"
    }
  },
  "marketData": {
    "pricesView": {
      "title": "Prices View"
    },
    "summary": {
      "totalSymbols": "Total Symbols",
      "staleCount": "Stale Count",
      "latestAvailableDate": "Latest Available Date",
      "latestNepseTradeDay": "Latest NEPSE Trade Day",
      "needsTodayImport": "Needs Today Import",
      "todayIsTradeDay": "Today is Trade Day"
    },
    "marketDataView": {
      "freshnessModeBanner": "Freshness view is active. Showing symbols without latest trade-day coverage ({{date}}).",
      "importReview": "Import Review",
      "importSummary": "Import Summary",
      "problematicRows": "Problematic Rows",
      "row": "Row",
      "symbol": "Symbol",
      "issues": "Issues",
      "errorsTitle": "Errors",
      "andMore": "And More {{count}}",
      "reimporting": "Reimporting",
      "skipProblematic": "Skip Problematic",
      "dismiss": "Dismiss",
      "loadErrorTitle": "Load Error",
      "marketDataNotAvailable": "Market Data Not Available {{date}}",
      "importMarketData": "Import Market Data",
      "nonTradingDayImportHint": "Non Trading Day Import hint",
      "backToAllPrices": "Back To All Prices",
      "latestPrice": "Latest Price",
      "latestClose": "Latest Close",
      "date": "Date",
      "previousDayChange": "Previous Day Change",
      "noHistoricalData": "No Historical Data",
      "priceHistory": "Price History",
      "dailyPriceData": "Daily Price Data {{symbol}}",
      "priceHistoryTitle": "Price History",
      "latestMarketPrices": "Latest Market Prices",
      "latestPricesDescription": "Latest Prices description {{date}}",
      "uploading": "Uploading",
      "import": "Import",
      "importHelpText": "Import Help Text",
      "closePrice": "Close Price",
      "open": "Market Data View Open",
      "high": "High",
      "low": "Low",
      "volume": "Volume",
      "dayChange": "Day Change",
      "currency": "Currency",
      "basis": "Basis",
      "asOfDate": "As Of Date",
      "qualityStatus": "Quality Status",
      "source": "Source",
      "close": "Market Data View Close",
      "invalidViewFallback": "Invalid View Fallback",
      "upload": "Upload",
      "uploadDesc": "Upload"
    },
    "marketDataImport": {
      "title": "Market Data Import",
      "description": "Market Data Import description",
      "checkingFile": "Checking File",
      "uploadingMarketData": "Uploading Market Data",
      "dropCsvOrBrowse": "Drop CSV Or Browse",
      "supportsNepseFormat": "Supports NEPSE Format",
      "importCompleted": "Import Completed",
      "newRecordsImported": "New Records Imported",
      "existingRecordsUpdated": "Existing Records Updated",
      "rowsSkipped": "Rows Skipped",
      "errors": "Errors",
      "expectedCsvFormat": "Expected CSV Format",
      "formatLine1": "Format Line 1",
      "formatLine2": "Format Line 2",
      "formatLine3": "Format Line 3",
      "formatLine4": "Format Line 4",
      "downloadFromNepse": "Download From NEPSE"
    },
    "review": {
      "title": "Review",
      "rowsWithIssues": "Rows With Issues {{count}}",
      "proceedOrCancel": "Proceed Or Cancel {{validRows}}",
      "rowsReadyToImport": "Rows Ready To Import {{count}}",
      "rowsWithIssuesCount": "Rows With Issues Count {{count}}",
      "rowNumber": "Row Number",
      "symbol": "Symbol",
      "issues": "Issues",
      "rawDataPreview": "Raw Data Preview",
      "close": "Review Close",
      "open": "Review Open",
      "high": "High",
      "low": "Low",
      "volume": "Volume",
      "problematicRowsSkipped": "Problematic Rows Skipped {{count}}",
      "importValidRows": "Import Valid Rows {{count}}"
    },
    "actions": {
      "importPrice": "Import Price",
      "refreshMarketData": "Refresh Market Data",
      "refreshPrice": "Refresh Price",
      "uploadMarketData": "Upload Market Data",
      "viewHistory": "View History",
      "viewHistoryDesc": "View History",
      "importPriceDesc": "Import Price",
      "refreshPriceDesc": "Refresh Price",
      "uploadMarketDataDesc": "Upload Market Data",
      "refreshMarketDataDesc": "Refresh Market Data"
    },
    "upload": {
      "confirmation": "Upload this market data file?",
      "success": "Market data uploaded successfully"
    }
  },
  "navigation": {
    "planned": "Coming soon",
    "maintenance": "Under maintenance",
    "disabled": "Disabled",
    "moduleDisabled": "Module disabled",
    "denied": "Access denied",
    "aalRequired": "Additional authentication required",
    "permissionDenied": "Permission required",
    "actorDenied": "Not available for your role",
    "scopeDenied": "Not available in this context",
    "clientScopeRequired": "Client context required",
    "delegationDenied": "Delegation not permitted",
    "entitlementMissing": "Higher tier required",
    "reports": "Reports",
    "lockedReasons": {
      "requiresEnterpriseTier": "Requires Enterprise tier",
      "requiresProfessionalTier": "Requires Professional tier",
      "permissionRequired": "Permission required",
      "unavailableData": "Data unavailable",
      "descriptorRequired": "Descriptor Required",
      "notAvailable": "Not Available"
    }
  },
  "dataQualityOperational": {
    "criticalIssues": "Critical issues",
    "fixFirst": "Fix first",
    "ok": "OK",
    "title": "Data Quality Operational",
    "description": "Data Quality Operational description",
    "refresh": "Refresh",
    "dataReliability": "Data Reliability",
    "lastChecked": "Last Checked",
    "marketPriceIssues": "Market Price Issues",
    "affectsValuation": "Affects Valuation",
    "reconciliationIssues": "Reconciliation Issues",
    "affectsReports": "Affects Reports",
    "importIssues": "Import Issues",
    "affectsImports": "Affects Imports",
    "primaryIssueQueue": "Primary Issue Queue",
    "highestSeverityFirst": "Highest Severity First",
    "noIssuesTitle": "No Issues",
    "noIssuesDescription": "No Issues description",
    "remediationActions": "Remediation Actions",
    "remediationActionsSubtitle": "Remediation Actions Subtitle",
    "updateMarketPrices": "Update Market Prices",
    "fixOpeningBalances": "Fix Opening Balances",
    "reconcileTransactions": "Reconcile Transactions",
    "fixContinuityGaps": "Fix Continuity Gaps",
    "needCertifiedEvidence": "Need Certified Evidence",
    "certifiedReportDescription": "Certified Report description",
    "openDataQualityReport": "Open Data Quality Report",
    "invalidViewFallback": "Invalid View Fallback"
  },
  "nepal": {
    "vatDashboard": {
      "failedToLoadConfig": "Failed to load VAT configuration",
      "failedToLoadReturns": "Failed to load VAT returns",
      "failedToLoadFiscalYears": "Failed to load fiscal years",
      "title": "VAT Dashboard",
      "updateConfig": "Update Configuration",
      "configureVat": "Configure VAT",
      "loadingConfig": "Loading configuration...",
      "registrationNo": "Registration No.",
      "notProvided": "Not provided",
      "vatRate": "VAT Rate",
      "registered": "Registered",
      "since": "Since",
      "vatRegistrationNumber": "VAT Registration Number",
      "vatRatePercent": "VAT Rate (%)",
      "effectiveFrom": "Effective From",
      "registrationStatus": "Registration Status",
      "submit": "Submit",
      "noReturnsYet": "No returns yet",
      "activeFiscalYears": "Active Fiscal Years"
    },
    "irdExport": {
      "downloadFailed": "Download Failed",
      "title": "IRD Export",
      "description": "Export IRD regulatory reports",
      "refreshFiscalYears": "Refresh Fiscal Years",
      "loadingFiscalYears": "Loading Fiscal Years",
      "vatRegisters": "VAT Registers",
      "from": "From",
      "to": "To",
      "downloading": "Downloading",
      "salesRegister": "Sales Register",
      "purchaseRegister": "Purchase Register",
      "tdsRegister": "TDS Register",
      "fiscalYear": "Fiscal Year",
      "selectFiscalYear": "Select Fiscal Year",
      "tdsRegisterCsv": "TDS Register CSV"
    }
  },
  "vat": {
    "registered": "Registered",
    "notRegistered": "Not Registered",
    "vatReturns": "VAT Returns",
    "generateReturn": "Generate Return",
    "period": "Period",
    "outputVat": "Output VAT",
    "inputVat": "Input VAT",
    "netVat": "Net VAT",
    "status": "Status"
  },
  "root": {
    "navigation": {
      "overview": "Overview",
      "branches": "Branches",
      "users": "Users",
      "audit": "Audit",
      "system": "System",
      "approvals": "Approvals",
      "jobs": "Jobs",
      "alerts": "Alerts",
      "powerTools": "Power Tools",
      "settings": "Settings"
    },
    "shell": {
      "title": "Admin Console",
      "moreNavigationAria": "More navigation",
      "openAdminToolsAria": "Open admin tools",
      "adminTools": "Admin Tools",
      "rootTools": "Root Tools",
      "connected": "Connected",
      "logout": "Logout",
      "back": "Back"
    },
    "health": {
      "healthy": "Healthy",
      "degraded": "Degraded"
    }
  },
  "rebalancing": {
    "view": {
      "disabled": {
        "title": "Disabled",
        "description": "Rebalancing is currently disabled for this portfolio.",
        "configurationHint": "Contact your administrator to enable rebalancing."
      },
      "header": {
        "title": "Rebalancing",
        "description": "Portfolio rebalancing analysis and proposals.",
        "portfolioScenario": "Portfolio Scenario",
        "refreshAnalysis": "Refresh Analysis"
      },
      "featureDisabled": {
        "title": "Feature Disabled",
        "description": "The rebalancing feature is not enabled for your organization."
      },
      "summary": {
        "portfolioId": "Portfolio ID",
        "historyEntries": "History Entries",
        "lastRebalanced": "Last Rebalanced"
      },
      "analysis": {
        "title": "Analysis",
        "description": "Drift analysis and recommended adjustments.",
        "loading": "Loading",
        "totalDrift": "Total Drift",
        "maxDrift": "Max Drift",
        "rebalancingRequired": "Rebalancing Required",
        "noDriftData": "No Drift Data",
        "generateProposal": "Generate Proposal"
      },
      "proposalReview": {
        "title": "Proposal Review",
        "description": "Review and approve the proposed rebalancing trades.",
        "empty": "Empty",
        "proposalId": "Proposal ID",
        "estimatedCost": "Estimated Cost",
        "complianceChecks": "Compliance Checks",
        "recommendedTrades": "Recommended Trades",
        "noTrades": "No Trades",
        "submitForApproval": "Submit For Approval",
        "approveProposal": "Approve Proposal",
        "executeRebalancing": "Execute Rebalancing"
      },
      "execution": {
        "title": "Execution",
        "description": "Execute approved rebalancing trades.",
        "empty": "Empty",
        "successes": "Successes",
        "failures": "Failures",
        "totalCost": "Total Cost"
      },
      "history": {
        "title": "History",
        "description": "Past rebalancing proposals and executions.",
        "loading": "Loading",
        "empty": "Empty",
        "loadProposal": "Load Proposal"
      }
    },
    "actions": {
      "generateProposal": "Generate Proposal",
      "generateProposalDesc": "Generate Proposal",
      "execute": "Execute",
      "executeDesc": "Execute"
    }
  },
  "investmentSettings": {
    "benchmark": {
      "title": "Benchmark Settings",
      "description": "Configure benchmark performance targets and concentration limits for portfolio comparison",
      "fields": {
        "symbol": "Symbol",
        "period": "Period",
        "manualTarget": "Manual Target",
        "sectorLimit": "Sector Limit",
        "top10Limit": "Top10 Limit"
      },
      "placeholders": {
        "symbol": "Symbol",
        "period": "Period",
        "manualTarget": "Manual Target",
        "sectorLimit": "Sector Limit",
        "top10Limit": "Top10 Limit"
      },
      "periods": {
        "oneMonth": "One Month",
        "threeMonths": "Three Months",
        "sixMonths": "Six Months",
        "oneYear": "One Year",
        "threeYears": "Three Years"
      },
      "descriptions": {
        "manualTarget": "Manual Target",
        "sectorLimit": "Sector Limit",
        "top10Limit": "Top10 Limit"
      },
      "notes": {
        "dataSourceLabel": "Data Source",
        "dataSource": "Data Source",
        "manualTargetLabel": "Manual Target",
        "manualTarget": "Manual Target",
        "concentrationLimitsLabel": "Concentration Limits",
        "concentrationLimits": "Concentration Limits"
      }
    }
  },
  "action": {
    "label": "Action",
    "labelDesc": "Action",
    "preview": "Preview",
    "commit": "Commit",
    "recover": "Recover",
    "process": "Process",
    "edit": "Edit",
    "delete": "Delete",
    "submit": "Submit",
    "approve": "Approve",
    "post": "Post",
    "reverse": "Reverse",
    "start": "Start",
    "upload": "Upload",
    "cancel": "Cancel",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "withdraw": "Withdraw",
    "repair": "Repair",
    "repost": "Repost",
    "create": "Create",
    "import": "Import",
    "viewBreaks": "View Breaks",
    "retry": "Retry",
    "transferPosition": "Transfer Position",
    "eligibility": {
      "invalidState": "This action is not available for the current record state.",
      "makerCheckerViolation": "Maker-checker policy: you cannot approve your own request.",
      "selfModification": "You cannot modify your own access.",
      "lastAdmin": "This is the last administrator and cannot be disabled.",
      "systemRole": "System roles cannot be modified or deleted.",
      "roleInUse": "This role is assigned to users and cannot be deleted."
    },
    "reactivate": "Reactivate",
    "restate": "Restate",
    "retire": "Retire",
    "suspend": "Suspend",
    "view": "View",
    "reject": "Reject Investment Corporate Action",
    "disable": "Disable"
  },
  "journal": {
    "createTitle": "Create journal",
    "entryDate": "Entry date",
    "fiscalYear": "Fiscal year",
    "reference": "Reference",
    "narration": "Narration",
    "lines": "Journal lines",
    "ledgerAccount": "Ledger account",
    "debit": "Debit",
    "credit": "Credit",
    "lineNarration": "Line narration",
    "addLine": "Add line",
    "removeLine": "Remove line",
    "create": "Create draft",
    "createFailed": "Unable to create the journal draft.",
    "balancedLineGuidance": "Enter balanced debit and credit lines. The server validates the final journal before it is saved.",
    "reverseTitle": "Reverse Journal Entry",
    "reversePrompt": "Are you sure you want to reverse this journal entry? A reversing entry will be created in the opposite direction.",
    "reversalDate": "Reversal Date",
    "reversalReason": "Reversal Reason",
    "validation": {
      "entryDateOutsideFiscalYear": "Entry date must fall within the selected open fiscal year.",
      "accountRequired": "Select a ledger account for this line.",
      "amountInvalid": "Enter a valid non-negative amount.",
      "sideRequired": "Enter a positive debit or credit amount, but not both."
    }
  },
  "item": {
    "label": "Item",
    "labelDesc": "Item"
  },
  "report": {
    "table": {
      "row": "Row",
      "rowDesc": "Row",
      "value": "Value",
      "valueDesc": "Value"
    },
    "portfolio": {
      "title": "Portfolio Report"
    },
    "tax": {
      "title": "Tax Report"
    },
    "download": "Download",
    "asOf": "As of",
    "parameters": "Parameters",
    "formats": "Available formats"
  },
  "composition": {
    "chartRendered": "Chart Rendered",
    "chartNoData": "Chart No Data",
    "tableNotAvailable": "Not Available"
  },
  "governance": {
    "noAuditEntries": "No Audit Entries",
    "auditTimelineTitle": "Audit Timeline",
    "explainAccessTitle": "Explain Access",
    "runExplainAccess": "Run Explain Access",
    "formNotAvailable": "Not Available",
    "formFieldPlaceholder": "Field",
    "tableNotAvailable": "Not Available",
    "systemPostureTitle": "System Posture",
    "actionResult": {
      "exportId": "Export ID",
      "recordCount": "Records",
      "status": "Status",
      "download": "Download Export",
      "checkStatus": "Check Status",
      "entityCreated": "Created {{entityType}} ({{entityId}})",
      "entityUpdated": "Updated {{entityType}} ({{entityId}})",
      "changedFields": "Changed fields",
      "refreshedAt": "Refreshed at",
      "affectedCount": "Affected records",
      "fieldLabels": {
        "name": "Name",
        "address": "Address",
        "description": "Field Labels description",
        "status": "Status",
        "email": "Email",
        "phone": "Phone",
        "code": "Code",
        "tier": "Tier"
      },
      "entityDeleted": "Entity Deleted"
    },
    "explainAccessResultTitle": "Explain Access Result",
    "explainAccess": {
      "finalDecision": "Final Decision"
    },
    "formSubmitActionMissing": "Submit Action Missing"
  },
  "workflows": {
    "noStep": "No Step",
    "stepIndicator": "Step Indicator",
    "formNotAvailable": "Not Available",
    "formFieldPlaceholder": "Field",
    "previewNotAvailable": "Preview Not Available",
    "previewTitle": "Preview",
    "previewTruncated": "Preview Truncated",
    "startOver": "Start Over",
    "reviewTitle": "Review",
    "uploadInstructions": "Upload Instructions",
    "selectFile": "Select File",
    "confirmUpload": "Confirm Upload",
    "validationPassed": "Validation Passed",
    "validationIssues": "Validation Issues"
  },
  "approvals": {
    "actions": {
      "approve": "Approve",
      "approveDesc": "Approve",
      "reject": "Reject",
      "rejectDesc": "Reject"
    }
  },
  "submit": "Submit",
  "submitDesc": "Submit",
  "navigate": "Navigate",
  "navigateDesc": "Navigate",
  "delete": "Delete",
  "deleteDesc": "Delete",
  "Next": "Next",
  "NextDesc": "Next",
  "dataQuality": {
    "actions": {
      "remediate": "Remediate",
      "remediateDesc": "Remediate"
    }
  },
  "bulkTransactions": {
    "actions": {
      "validate": "Validate",
      "validateDesc": "Validate",
      "commit": "Commit",
      "commitDesc": "Commit"
    }
  },
  "surface": {
    "actions": {
      "errors": {
        "unsupportedActionKind": "Unsupported Action Kind",
        "missingEndpoint": "Missing Endpoint",
        "missingMethod": "Missing Method",
        "invalidReasonPayload": "Invalid Reason Payload",
        "uploadPayloadRequired": "Upload Payload Required"
      }
    }
  },
  "a11y": {
    "form": {
      "reports": {
        "parameters": "Report parameters",
        "definition": "Report definition",
        "run": "Generate report run form",
        "runIrdFiscalYear": "IrdFiscalYear Reports Run form",
        "liveParameters": "Live report parameter form",
        "holdingsParameters": "Holdings report parameter form",
        "clientHoldingsParameters": "Client holdings report parameter form",
        "trialBalanceParameters": "Trial balance report parameter form",
        "reconciliationParameters": "Reconciliation report parameter form",
        "transactionActivityParameters": "Transaction activity report parameter form",
        "financialStatementsParameters": "Financial statements report parameter form",
        "irdRun": "IRD capital-gains filing run form",
        "portfolioPerformance": "Portfolio performance report parameters",
        "portfolioCustodyEvidence": "CDSC custody evidence report parameters"
      },
      "admin": {
        "branch": {
          "create": "Create Admin Branch form",
          "edit": "Edit Admin Branch form",
          "view": "View Admin Branch form"
        },
        "client": {
          "create": "Create Admin Client form",
          "edit": "Edit Admin Client form",
          "view": "View Admin Client form"
        },
        "clientAccount": {
          "create": "Create Admin Client Account form",
          "edit": "Edit Admin Client Account form",
          "view": "View Admin Client Account form"
        },
        "moduleAssignment": {
          "create": "Create Admin Module Assignment form",
          "edit": "Edit Admin Module Assignment form",
          "view": "View Admin Module Assignment form"
        },
        "organizationProfile": {
          "edit": "Edit Admin Organization Profile form"
        },
        "platformModuleAssignment": {
          "create": "Create Admin Platform Module Assignment form"
        },
        "platformOrganization": {
          "edit": "Edit Admin Platform Organization form",
          "view": "View Admin Platform Organization form"
        },
        "platformUser": {
          "create": "Create Admin Platform User form",
          "edit": "Edit Admin Platform User form",
          "view": "View Admin Platform User form"
        },
        "portfolio": {
          "create": "Create Admin Portfolio form",
          "edit": "Edit Admin Portfolio form",
          "view": "View Admin Portfolio form"
        },
        "role": {
          "create": "Create Admin Role form",
          "edit": "Edit Admin Role form",
          "view": "View Admin Role form"
        },
        "user": {
          "create": "Create Admin User form",
          "edit": "Edit Admin User form",
          "view": "View Admin User form"
        }
      },
      "data": {
        "corporateAction": {
          "create": "Create Data Corporate Action form",
          "edit": "Edit Data Corporate Action form",
          "view": "View Data Corporate Action form"
        },
        "instrument": {
          "create": "Create Data Instrument form",
          "edit": "Edit Data Instrument form",
          "view": "View Data Instrument form"
        }
      },
      "importJob": {
        "create": "Create Import Job form"
      },
      "report": {
        "clientStatement": {
          "parameters": "Parameters Report Client Statement form"
        }
      },
      "transaction": {
        "create": "Create Transaction form"
      },
      "platformSupportDelegation": {
        "create": "Create maintenance delegation form",
        "view": "Maintenance delegation detail form",
        "revoke": "Maintenance delegation revocation form"
      }
    },
    "action": {
      "accounting": {
        "journals": {
          "post": "Post Accounting Journals",
          "reverse": "Reverse Accounting Journals"
        }
      },
      "admin": {
        "openingCutover": {
          "import": "Import Admin Opening Cutover"
        }
      },
      "data": {
        "cash": {
          "view": "View Data Cash"
        },
        "corporateActions": {
          "approve": "Approve Data Corporate Actions",
          "cancel": "Cancel Data Corporate Actions",
          "create": "Create Data Corporate Actions",
          "edit": "Edit Data Corporate Actions",
          "process": "Process Data Corporate Actions",
          "submit": "Submit Data Corporate Actions"
        },
        "instruments": {
          "create": "Create Data Instruments",
          "edit": "Edit Data Instruments",
          "import": "Import Data Instruments"
        },
        "marketPrices": {
          "import": "Import Data Market Prices"
        },
        "positions": {
          "transfer": "Transfer Data Positions",
          "view": "View Data Positions"
        },
        "reconciliation": {
          "cancel": "Cancel Data Reconciliation",
          "create": "Create Data Reconciliation",
          "retry": "Retry Data Reconciliation",
          "viewBreaks": "View breaks Data Reconciliation"
        }
      },
      "holdings": {
        "view": "View Holdings"
      },
      "importJob": {
        "create": "Create Import Job"
      },
      "investment": {
        "positionTransfers": {
          "approve": "Approve Investment Position Transfers",
          "cancel": "Cancel Investment Position Transfers",
          "execute": "Execute Investment Position Transfers",
          "request": "Request Investment Position Transfers",
          "reverse": "Reverse Investment Position Transfers"
        },
        "transactions": {
          "approve": "Approve Investment Transactions",
          "import": "Import Investment Transactions",
          "post": "Post Investment Transactions",
          "reject": "Reject Investment Transactions",
          "repair": "Repair Investment Transactions",
          "repost": "Repost Investment Transactions",
          "reverse": "Reverse Investment Transactions",
          "submit": "Submit Investment Transactions",
          "withdraw": "Withdraw Investment Transactions"
        }
      },
      "moduleAssignment": {
        "configure": "Configure Module Assignment"
      },
      "openingCutover": {
        "view": "View Opening Cutover"
      },
      "organizationBranch": {
        "delete": "Delete Organization Branch",
        "edit": "Edit Organization Branch"
      },
      "organizationClient": {
        "delete": "Delete Organization Client",
        "edit": "Edit Organization Client"
      },
      "organizationClientAccount": {
        "disable": "Disable Organization Client Account",
        "edit": "Edit Organization Client Account"
      },
      "organizationModuleAssignment": {
        "delete": "Delete Organization Module Assignment"
      },
      "organizationPortfolio": {
        "disable": "Disable Organization Portfolio",
        "edit": "Edit Organization Portfolio"
      },
      "organizationProfile": {
        "edit": "Edit Organization Profile",
        "save": "Save Organization Profile"
      },
      "platformModule": {
        "revoke": "Revoke Platform Module"
      },
      "platformUser": {
        "disable": "Disable Platform User",
        "edit": "Edit Platform User"
      },
      "role": {
        "create": "Create Role",
        "update": "Update Role"
      },
      "settlement": {
        "instructions": {
          "cancel": "Cancel Settlement Instructions",
          "confirm": "Confirm Settlement Instructions",
          "correct": "Correct Settlement Instructions",
          "create": "Create Settlement Instructions"
        }
      },
      "submit": "Submit",
      "transaction": {
        "create": "Create Transaction"
      },
      "user": {
        "create": "Create User",
        "update": "Update User"
      },
      "form": {
        "admin": {
          "branch": {
            "create": {
              "submit": "Submit Admin Branch Create form"
            },
            "edit": {
              "submit": "Submit Admin Branch Edit form"
            }
          },
          "client": {
            "create": {
              "submit": "Submit Admin Client Create form"
            },
            "edit": {
              "submit": "Submit Admin Client Edit form"
            }
          },
          "clientAccount": {
            "create": {
              "submit": "Submit Admin Client Account Create form"
            },
            "edit": {
              "submit": "Submit Admin Client Account Edit form"
            }
          },
          "moduleAssignment": {
            "create": {
              "submit": "Submit Admin Module Assignment Create form"
            },
            "edit": {
              "submit": "Submit Admin Module Assignment Edit form"
            }
          },
          "platformModuleAssignment": {
            "create": {
              "submit": "Submit Admin Platform Module Assignment Create form"
            }
          },
          "platformOrganization": {
            "edit": {
              "submit": "Submit Admin Platform Organization Edit form"
            }
          },
          "platformUser": {
            "create": {
              "submit": "Submit Admin Platform User Create form"
            },
            "edit": {
              "submit": "Submit Admin Platform User Edit form"
            }
          },
          "portfolio": {
            "create": {
              "submit": "Submit Admin Portfolio Create form"
            },
            "edit": {
              "submit": "Submit Admin Portfolio Edit form"
            }
          }
        }
      },
      "reports": {
        "cancel": "Cancel report dialog",
        "runLive": "Run governed live report"
      },
      "create": "Create action",
      "edit": "Edit action",
      "delete": "Delete action",
      "cancel": "Cancel action",
      "platformSupportDelegation": {
        "create": "Create a scoped maintenance delegation",
        "revoke": "Open maintenance delegation revocation",
        "confirmRevoke": "Confirm maintenance delegation revocation"
      }
    },
    "dashboard": {
      "platform": "Platform operations dashboard",
      "organization": "Organization portfolio dashboard",
      "client": "Client portfolio dashboard"
    },
    "accountNumber": "Account number",
    "accountType": "Account type",
    "actionType": "Action type",
    "approvedAt": "Approved at",
    "approvedBy": "Approved by",
    "asOfDate": "As of date",
    "assignedModules": "Assigned modules",
    "availableQuantity": "Available quantity",
    "avgCost": "Average cost",
    "baseCurrency": "Base currency",
    "boId": "BO ID",
    "branchCount": "Branch count",
    "breachType": "Breach type",
    "breachValue": "Breach value",
    "businessReference": "Business reference",
    "capitalGain": "Capital gain",
    "change": "Change",
    "client": "Client",
    "clientAccountId": "Client account ID",
    "clientCode": "Client code",
    "clientName": "Client name",
    "clientType": "Client type",
    "code": "Code",
    "completedAt": "Completed at",
    "concentrationPct": "Concentration percentage",
    "configurationVersionId": "Configuration version ID",
    "createdAt": "Created at",
    "currency": "Currency",
    "currentBalance": "Current balance",
    "custodyAccount": "Custody account",
    "destinationPortfolioAccountId": "Destination portfolio account ID",
    "detectedAt": "Detected at",
    "displayName": "Display name",
    "dpCode": "DP code",
    "email": "Email",
    "endDate": "End date",
    "entityId": "Entity ID",
    "entityType": "Entity type",
    "entryDate": "Entry date",
    "entryNumber": "Entry number",
    "errorCount": "Error count",
    "exDate": "Ex-date",
    "exchange": "Exchange",
    "expectedCash": "Expected cash",
    "expectedDate": "Expected date",
    "expectedQuantity": "Expected quantity",
    "externalReference": "External reference",
    "failureReason": "Failure reason",
    "firstName": "First name",
    "fiscalYearName": "Fiscal year name",
    "fullName": "Full name",
    "holdingPeriodDays": "Holding period (days)",
    "id": "ID",
    "importType": "Import type",
    "instrumentName": "Instrument name",
    "instrumentSymbol": "Instrument symbol",
    "instrumentType": "Instrument type",
    "isActive": "Active",
    "isDefault": "Default",
    "isLocked": "Locked",
    "isSystem": "System",
    "isin": "ISIN",
    "journalEntryId": "Journal entry ID",
    "jurisdiction": "Jurisdiction",
    "lastName": "Last name",
    "lastUpdated": "Last updated",
    "limitValue": "Limit value",
    "lots": "Lots",
    "manifestHash": "Manifest hash",
    "marketPrice": "Market price",
    "marketValue": "Market value",
    "marketValueCurrency": "Market value currency",
    "matchedRecords": "Matched records",
    "membershipStatus": "Membership status",
    "mfaEnabled": "MFA enabled",
    "module": "Module",
    "name": "Name",
    "narration": "Narration",
    "ownerClientAccountId": "Owner client account ID",
    "ownerType": "Owner type",
    "parentBranchId": "Parent branch ID",
    "parentBranchName": "Parent branch name",
    "payDate": "Pay date",
    "periodNumber": "Period number",
    "platformAccess": {
      "action": "Action",
      "module": "Module",
      "permission": "Permission",
      "persona": "Persona",
      "resource": "Resource",
      "roleCode": "Role Code",
      "scope": "Scope"
    },
    "platformModule": {
      "effectiveFrom": "Effective from",
      "expectedUpdatedAt": "Expected update at",
      "maxBranches": "Maximum branches",
      "maxUsers": "Maximum users",
      "module": "Module",
      "organization": "Organization",
      "organizationCode": "Organization code",
      "status": "Status"
    },
    "portfolioAccountId": "Portfolio account ID",
    "portfolioAccountNumber": "Portfolio account number",
    "previewedBy": "Previewed by",
    "pricePerUnit": "Price per unit",
    "quantity": "Quantity",
    "reason": "Reason",
    "recordCount": "Record count",
    "recordDate": "Record date",
    "recoveryQueue": "Recovery queue",
    "reference": "Reference",
    "reports": {
      "generateRun": "Generate report run",
      "saveDefinition": "Save report definition"
    },
    "reversalReason": "Reversal reason",
    "reversedAt": "Reversed at",
    "reversedBy": "Reversed by",
    "riskMeasure": "Risk measure",
    "roles": "Roles",
    "ruleId": "Rule ID",
    "ruleVersion": "Rule version",
    "runId": "Run ID",
    "saleDate": "Sale date",
    "sector": "Sector",
    "securityName": "Security name",
    "settledCash": "Settled cash",
    "settledQuantity": "Settled quantity",
    "severity": "Severity",
    "sourceAuthority": "Source authority",
    "sourceBatchId": "Source batch ID",
    "sourceFileName": "Source file name",
    "sourcePortfolioAccountId": "Source portfolio account ID",
    "sourceState": "Source state",
    "startDate": "Start date",
    "startedAt": "Started at",
    "status": "Status",
    "strategy": "Strategy",
    "supersededByBatchId": "Superseded by batch ID",
    "supersedesBatchId": "Supersedes batch ID",
    "symbol": "Symbol",
    "table": {
      "admin": {
        "audit": "Admin Audit table",
        "openingCutover": "Admin Opening Cutover table",
        "organizationBranches": "Admin Organization Branches table",
        "organizationClientAccounts": "Admin Organization Client Accounts table",
        "organizationClients": "Admin Organization Clients table",
        "organizationModuleAssignments": "Admin Organization Module Assignments table",
        "organizationPortfolios": "Admin Organization Portfolios table",
        "organizations": "Admin Organizations table",
        "platformAccessInspector": "Admin Platform Access Inspector table",
        "platformModules": "Admin Platform Modules table",
        "roles": "Admin Roles table",
        "users": "Admin Users table"
      },
      "dashboard": {
        "holdings": "Dashboard Holdings table"
      },
      "data": {
        "cashPositions": "Data Cash Positions table",
        "clients": "Data Clients table",
        "complianceBreaches": "Data Compliance Breaches table",
        "corporateActions": "Data Corporate Actions table",
        "factBatches": "Data Fact Batches table",
        "fiscalPeriods": "Data Fiscal Periods table",
        "holdings": "Data Holdings table",
        "importJobs": "Data Import Jobs table",
        "instruments": "Data Instruments table",
        "journals": "Data Journals table",
        "portfolios": "Data Portfolios table",
        "positions": "Data Positions table",
        "reconciliationRuns": "Data Reconciliation Runs table",
        "riskExposures": "Data Risk Exposures table",
        "taxRecords": "Data Tax Records table",
        "fiscalYears": "Fiscal Years table"
      },
      "investment": {
        "positionTransfers": "Investment Position Transfers table",
        "transactions": "Investment Transactions table"
      },
      "settlement": {
        "instructions": "Settlement Instructions table"
      },
      "platformSupportDelegations": "Maintenance delegation table",
      "marketPrices": "Market prices and valuation observations",
      "portfolioPerformance": "Portfolio performance, Nepal tax, and NFRS evidence summary"
    },
    "taxAmount": "Tax amount",
    "taxDomain": "Tax domain",
    "taxRate": "Tax rate",
    "totalAmount": "Total amount",
    "totalCost": "Total cost",
    "totalCredit": "Total credit",
    "totalDebit": "Total debit",
    "totalLines": "Total lines",
    "totalQuantity": "Total quantity",
    "totalRecords": "Total records",
    "transactionDate": "Transaction date",
    "transactionId": "Transaction ID",
    "transactionType": "Transaction type",
    "unmatchedRecords": "Unmatched records",
    "unrealizedGainLoss": "Unrealized gain/loss",
    "unrealizedPnl": "Unrealized P&L",
    "updatedAt": "Updated at",
    "userEmail": "User email",
    "userTypeId": "User type ID",
    "valuation": "Valuation",
    "valuationAsOf": "Valuation as of",
    "valuationFreshness": "Valuation freshness",
    "valuationSource": "Valuation source",
    "version": "Version",
    "warningCount": "Warning count",
    "weightedAverageCost": "Weighted average cost",
    "col": {
      "rowData": "Row Data",
      "approvedAt": "Approved at",
      "approvedBy": "Approved by",
      "journalEntryId": "Journal entry ID",
      "manifestHash": "Manifest hash",
      "previewedBy": "Previewed by",
      "reversalReason": "Reversal reason",
      "recoveryQueue": "Recovery queue",
      "reversedAt": "Reversed at",
      "reversedBy": "Reversed by",
      "supersededByBatchId": "Superseded by batch ID",
      "supersedesBatchId": "Supersedes batch ID",
      "totalLines": "Total lines",
      "errors": "Errors",
      "warnings": "Warnings",
      "importType": "Import type",
      "sourceFileName": "Source file name",
      "symbol": "Symbol",
      "name": "Name",
      "firstName": "First name",
      "lastName": "Last name",
      "isin": "ISIN",
      "assetType": "Asset Type",
      "runId": "Run ID",
      "businessReference": "Business reference",
      "sourcePortfolioAccountId": "Source portfolio account ID",
      "destinationPortfolioAccountId": "Destination portfolio account ID",
      "transactionId": "Transaction ID",
      "expectedQuantity": "Expected quantity",
      "settledQuantity": "Settled quantity",
      "expectedCash": "Expected cash",
      "settledCash": "Settled cash",
      "expectedDate": "Expected date",
      "failureReason": "Failure reason",
      "reason": "Reason",
      "status": "Status",
      "startedAt": "Started at",
      "completedAt": "Completed at",
      "id": "ID",
      "type": "Type",
      "date": "Date",
      "email": "Email",
      "mfa": "MFA",
      "roles": "Roles",
      "orgTenant": "Org / Branch",
      "userType": "User Type",
      "system": "System",
      "quantity": "Quantity",
      "avgCost": "Average cost",
      "marketPrice": "Market price",
      "marketValue": "Market value",
      "valuation": "Valuation",
      "valuationAsOf": "Valuation as of",
      "unrealizedPnl": "Unrealized P&L",
      "unrealizedGainLoss": "Unrealized gain/loss",
      "lots": "Lots",
      "change": "Change",
      "reportId": "Report ID",
      "reportDefinitionId": "Report Definition ID",
      "reportingPeriodStart": "Period Start",
      "reportingPeriodEnd": "Period End",
      "createdAt": "Created at",
      "updatedAt": "Updated at",
      "currentBalance": "Current balance",
      "sourceBatchId": "Source batch ID",
      "price": "Price",
      "grossAmount": "Gross Amount",
      "instrument": "Instrument",
      "actionType": "Action type",
      "currency": "Currency",
      "clientCode": "Client code",
      "clientName": "Client name",
      "marketValueCurrency": "Market value currency",
      "sourceState": "Source state",
      "valuationFreshness": "Valuation freshness",
      "valuationSource": "Valuation source",
      "difference": "Difference",
      "displayName": "Display name",
      "errorCount": "Error count",
      "exDate": "Ex-date",
      "exchange": "Exchange",
      "generatedAt": "Generated At",
      "instrumentSymbol": "Instrument symbol",
      "isSystem": "System",
      "matchedRecords": "Matched records",
      "mfaEnabled": "MFA enabled",
      "payDate": "Pay date",
      "pricePerUnit": "Price per unit",
      "recordCount": "Record count",
      "recordDate": "Record date",
      "resolved": "Resolved",
      "resolvedAt": "Resolved At",
      "resolvedBy": "Resolved By",
      "rowNumber": "Row",
      "sourceValue": "Source Value",
      "targetValue": "Target Value",
      "branchId": "Branch ID",
      "totalRecords": "Total records",
      "totalAmount": "Total amount",
      "transactionDate": "Transaction date",
      "transactionType": "Transaction type",
      "unmatchedRecords": "Unmatched records",
      "userTypeId": "User type ID",
      "validationErrors": "Validation Errors",
      "warningCount": "Warning count",
      "code": "Code",
      "isDefault": "Default",
      "module": "Module",
      "configurationVersionId": "Configuration version ID",
      "version": "Version",
      "fullName": "Full name",
      "accountType": "Account type",
      "isActive": "Active",
      "client": "Client",
      "custodyAccount": "Custody account",
      "accountNumber": "Account number",
      "baseCurrency": "Base Currency column",
      "strategy": "Strategy column",
      "ownerType": "Owner type",
      "ownerClientAccountId": "Owner client account ID",
      "boId": "BO ID",
      "dpCode": "DP code",
      "clientType": "Client type",
      "action": "Action",
      "asOfDate": "As of date",
      "availableQuantity": "Available quantity",
      "breachType": "Breach type",
      "breachValue": "Breach value",
      "severity": "Severity",
      "calculationVersion": "Calculation Version",
      "capitalGain": "Capital gain",
      "clientAccountId": "Client account ID",
      "concentrationPct": "Concentration percentage",
      "costBasis": "Cost Basis",
      "description": "Description",
      "detectedAt": "Detected at",
      "endDate": "End date",
      "entityId": "Entity ID",
      "entityType": "Entity type",
      "fiscalYear": "Fiscal Year",
      "fiscalYearName": "Fiscal year name",
      "holdingPeriodDays": "Holding period (days)",
      "instrumentId": "Instrument ID",
      "instrumentName": "Instrument name",
      "instrumentType": "Instrument type",
      "isLocked": "Locked",
      "journalDate": "Journal Date",
      "kind": "Kind",
      "lastUpdated": "Last updated",
      "limitValue": "Limit value",
      "membershipStatus": "Membership status",
      "periodNumber": "Period number",
      "portfolioAccountId": "Portfolio account ID",
      "realizedGain": "Realized Gain",
      "reference": "Reference",
      "riskMeasure": "Risk measure",
      "ruleId": "Rule ID",
      "ruleVersion": "Rule version",
      "saleDate": "Sale date",
      "sector": "Sector",
      "securityName": "Security name",
      "sourceAuthority": "Source authority",
      "sourceBook": "Source Book",
      "startDate": "Start date",
      "taxAmount": "Tax amount",
      "taxDomain": "Tax domain",
      "taxRate": "Tax rate",
      "totalCost": "Total cost",
      "totalCredit": "Total credit",
      "totalDebit": "Total debit",
      "totalQuantity": "Total quantity",
      "unrealizedGain": "Unrealized Gain",
      "userEmail": "User email",
      "weightedAverageCost": "Weighted average cost",
      "jurisdiction": "Jurisdiction",
      "assignedModules": "Assigned modules",
      "branchCount": "Branch count",
      "parentBranchId": "Parent branch ID",
      "parentBranchName": "Parent branch name",
      "portfolioAccountNumber": "Portfolio account number",
      "effectiveFrom": "Effective From",
      "entryDate": "Entry date",
      "entryNumber": "Entry number",
      "expectedUpdatedAt": "Expected Update At",
      "externalReference": "External reference",
      "maxBranches": "Max Branches",
      "maxUsers": "Max Users",
      "narration": "Narration",
      "organizationCode": "Organization Code",
      "organizationName": "Organization Name",
      "permission": "Permission",
      "persona": "Persona",
      "resource": "Resource",
      "resourceScope": "Resource Scope",
      "roleCode": "Role Code",
      "platformModule": {
        "organization": "Organization",
        "organizationCode": "Organization code",
        "module": "Module",
        "status": "Status",
        "maxBranches": "Maximum branches",
        "maxUsers": "Maximum users",
        "effectiveFrom": "Effective from",
        "expectedUpdatedAt": "Expected update at"
      },
      "platformAccess": {
        "persona": "Persona",
        "roleCode": "Role Code",
        "permission": "Permission",
        "module": "Module",
        "resource": "Resource",
        "action": "Action",
        "scope": "Scope"
      },
      "yearCode": "Year code column",
      "isClosed": "Closed column",
      "address": "Address column",
      "phone": "Phone column",
      "panNumber": "PAN Number column",
      "mandateStartDate": "Mandate Start Date column",
      "mandateEndDate": "Mandate End Date column",
      "legalName": "Legal Name column",
      "branchName": "Branch column",
      "lastLoginAt": "Last Login column",
      "commission": "Commission column",
      "sebonFee": "SEBON Fee column",
      "dpCharges": "DP Charges column",
      "declarationDate": "Declaration Date column",
      "ratioNumerator": "Ratio Numerator column",
      "ratioDenominator": "Ratio Denominator column",
      "cashRate": "Cash Rate column",
      "fiscalYearId": "Fiscal Year column",
      "postedAt": "Posted At column",
      "reversalOf": "Reversal Of column",
      "maintenanceDelegations": {
        "supportUserIdentityId": "Support user column",
        "targetOrganizationId": "Target organization column",
        "purpose": "Purpose column",
        "ticketReference": "Ticket column",
        "status": "Status column",
        "effectiveFrom": "Effective time column",
        "expiresAt": "Expiry time column",
        "sessionStartedAt": "Session start column",
        "sessionEndedAt": "Session end column",
        "policyVersion": "Policy version column"
      }
    }
  },
  "nav": {
    "dashboard": "Home",
    "transactions": "Transactions",
    "holdings": "Holdings",
    "reports": "Reports",
    "reconciliation": "Reconciliation",
    "regulatory": "Regulatory",
    "corporateActions": "Corporate Actions",
    "data": "Data",
    "admin": "Admin",
    "settings": "Settings"
  },
  "domain": {
    "investments": "Investments",
    "dataOperations": "Data & Operations",
    "reportsCompliance": "Reports & Compliance",
    "administration": "Administration",
    "platform": "Platform"
  },
  "holding": {
    "list": {
      "title": "Holdings"
    },
    "quantity": "Quantity",
    "costBasis": "Cost Basis",
    "marketValue": "Market Value",
    "unrealizedGain": "Unrealized Gain"
  },
  "corporateActions": {
    "planned": "Corporate actions are planned and not yet available."
  },
  "reconciliation": {
    "title": "Reconciliation",
    "matched": "Matched",
    "breaks": "Breaks",
    "adjust": "Adjust",
    "startRun": "Start Reconciliation Run",
    "planned": "Reconciliation is planned and not yet available.",
    "adjustment": {
      "title": "Create Adjustment",
      "breakId": "Break ID: {{breakId}}",
      "adjustmentType": "Adjustment Type",
      "reason": "Reason",
      "reasonPlaceholder": "Explain why this adjustment is needed",
      "reasonMinLength": "Reason must be at least 10 characters",
      "adjustmentAmount": "Adjustment Amount",
      "adjustmentQuantity": "Adjustment Quantity",
      "referenceId": "Reference ID",
      "referenceIdPlaceholder": "Optional reference (e.g., ticket number)",
      "notes": "Notes",
      "notesPlaceholder": "Additional notes",
      "cancel": "Cancel",
      "submit": "Create Adjustment",
      "types": {
        "manualMatch": "Manual Match",
        "priceAdjustment": "Price Adjustment",
        "quantityAdjustment": "Quantity Adjustment",
        "feeAdjustment": "Fee Adjustment",
        "writeOff": "Write Off"
      }
    }
  },
  "regulatory": {
    "sebon": {
      "title": "SEBON Report"
    },
    "ird": {
      "title": "IRD Report"
    },
    "nrb": {
      "title": "NRB Report"
    },
    "fiu": {
      "title": "FIU Report"
    },
    "submit": {
      "manual": "Manual Submission"
    }
  },
  "import": {
    "upload": {
      "title": "Upload Import"
    },
    "preview": {
      "title": "Preview",
      "confirm": "Confirm Import",
      "success": "Import previewed successfully"
    },
    "errors": {
      "rowErrors": "Row Errors"
    },
    "retry": "Retry",
    "commit": {
      "success": "Import committed successfully"
    },
    "recover": {
      "success": "Import recovered successfully"
    },
    "detail": {
      "title": "Import Job Details"
    },
    "rows": {
      "title": "Import Rows"
    }
  },
  "calendar": {
    "gregorian": "Gregorian",
    "bikramSambat": "Bikram Sambat",
    "switch": "Switch Calendar"
  },
  "error": {
    "auth": {
      "unauthorized": "You are not authorized",
      "forbidden": "Access forbidden",
      "tokenExpired": "Your session has expired",
      "mfaRequired": "Multi-factor authentication required"
    },
    "validation": {
      "failed": "Validation failed"
    },
    "notFound": "Resource not found",
    "conflict": "A conflict occurred",
    "rateLimit": "Rate limit exceeded",
    "server": "Internal server error",
    "serviceUnavailable": "Service unavailable"
  },
  "operations": {
    "search": {
      "query": {
        "label": "Search Authorized Experience",
        "description": "Search navigation, records, and actions within the authorized organization scope."
      },
      "selection": {
        "label": "Record Search Selection",
        "description": "Record bounded search selection telemetry for relevance analytics."
      }
    },
    "organizationGovernance": {
      "read": {
        "label": "Read organization governance",
        "description": "View governance records and evidence for the active organization."
      },
      "manage": {
        "label": "Manage organization governance",
        "description": "Record a governed decision in the active organization with audit and concurrency controls."
      }
    },
    "accounting": {
      "ledger": {
        "rebuildBalances": {
          "label": "Rebuild Ledger Balances",
          "description": "Recompute all ledger account balances from journal lines.",
          "makerChecker": {
            "reason": "Manual ledger balance rebuild requested."
          }
        },
        "trialBalance": {
          "label": "Perform Accounting Ledger",
          "description": "Perform the authorized Accounting Ledger Trial Balance operation within your permitted scope."
        },
        "generalLedger": {
          "label": "Perform Accounting Ledger",
          "description": "Perform the authorized Accounting Ledger General Ledger operation within your permitted scope."
        }
      },
      "fiscalYear": {
        "get": {
          "label": "Get Fiscal Year",
          "description": "Retrieve a single fiscal year with its periods."
        },
        "create": {
          "label": "Create Accounting Fiscal Year",
          "description": "Perform the authorized Accounting Fiscal Year Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "list": {
          "label": "View Accounting Fiscal Year",
          "description": "Perform the authorized Accounting Fiscal Year List operation within your permitted scope."
        },
        "close": {
          "label": "Close Accounting Fiscal Year",
          "description": "Perform the authorized Accounting Fiscal Year Close operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "reopen": {
          "label": "Reopen Accounting Fiscal Year",
          "description": "Perform the authorized Accounting Fiscal Year Reopen operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "fiscalPeriods": {
        "generate": {
          "label": "Generate Fiscal Periods",
          "description": "Auto-generate 12 BS-calendar periods for the fiscal year.",
          "makerChecker": {
            "reason": "Bulk period generation requires maker-checker approval."
          }
        }
      },
      "management-fee": {
        "list": {
          "label": "List management fees",
          "description": "List management-fee accruals and lifecycle records for the authorized scope."
        },
        "get": {
          "label": "View management fee",
          "description": "View one management-fee accrual or lifecycle record."
        },
        "calculate": {
          "label": "Calculate management fee",
          "description": "Calculate management fees for the selected authorized scope and period."
        },
        "approve": {
          "label": "Approve management fee",
          "description": "Approve a calculated management fee for downstream accounting."
        },
        "waive": {
          "label": "Waive management fee",
          "description": "Waive an eligible management fee with an auditable reason."
        },
        "invoice": {
          "label": "Invoice management fee",
          "description": "Create an invoice for an approved management fee."
        },
        "pay": {
          "label": "Record management fee payment",
          "description": "Record payment against an invoiced management fee."
        },
        "credit": {
          "label": "Credit management fee",
          "description": "Create a credit adjustment for an eligible management fee."
        },
        "reverse": {
          "label": "Reverse management fee",
          "description": "Reverse an eligible management-fee lifecycle entry with audit evidence."
        }
      },
      "performance-fee": {
        "list": {
          "label": "List performance fees",
          "description": "List performance-fee calculations and lifecycle records for the authorized scope."
        },
        "calculate": {
          "label": "Calculate performance fee",
          "description": "Calculate performance fees for the selected authorized scope and performance period."
        },
        "approve": {
          "label": "Approve performance fee",
          "description": "Approve a calculated performance fee for downstream accounting."
        },
        "crystallize": {
          "label": "Crystallize performance fee",
          "description": "Crystallize an approved performance fee at the applicable lifecycle point."
        },
        "invoice": {
          "label": "Invoice performance fee",
          "description": "Create an invoice for a crystallized performance fee."
        },
        "invoice-post": {
          "label": "Post performance fee invoice",
          "description": "Post a performance-fee invoice to the accounting ledger."
        },
        "pay": {
          "label": "Record performance fee payment",
          "description": "Record payment against an invoiced performance fee."
        },
        "payment-post": {
          "label": "Post performance fee payment",
          "description": "Post a performance-fee payment to the accounting ledger."
        },
        "restate": {
          "label": "Restate performance fee",
          "description": "Restate an eligible performance-fee calculation using the authoritative data set."
        },
        "restatement-reversal-post": {
          "label": "Post performance fee restatement reversal",
          "description": "Post the accounting reversal created by a performance-fee restatement."
        }
      },
      "reconciliation": {
        "list": {
          "label": "View Accounting Reconciliation",
          "description": "Perform the authorized Accounting Reconciliation List operation within your permitted scope."
        },
        "get": {
          "label": "View Accounting Reconciliation",
          "description": "Perform the authorized Accounting Reconciliation Get operation within your permitted scope."
        },
        "create": {
          "label": "Create Accounting Reconciliation",
          "description": "Perform the authorized Accounting Reconciliation Create operation within your permitted scope."
        },
        "update": {
          "label": "Update Accounting Reconciliation",
          "description": "Perform the authorized Accounting Reconciliation Update operation within your permitted scope."
        }
      },
      "journal": {
        "list": {
          "label": "View Accounting Journal",
          "description": "Perform the authorized Accounting Journal List operation within your permitted scope."
        },
        "create": {
          "label": "Perform Accounting Opening Cutover",
          "description": "Perform the authorized Accounting Opening Cutover Preview operation within your permitted scope."
        },
        "post": {
          "label": "Post Accounting Journal",
          "description": "Perform the authorized Accounting Journal Post operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "get": {
          "label": "View Accounting Journal",
          "description": "Perform the authorized Accounting Journal Get operation within your permitted scope."
        },
        "reverse": {
          "label": "Reverse Accounting Journal",
          "description": "Perform the authorized Accounting Journal Reverse operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "coa": {
        "createGroup": {
          "label": "Perform Accounting Coa",
          "description": "Perform the authorized Accounting Coa Create Group operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "getGroups": {
          "label": "Perform Accounting Coa",
          "description": "Perform the authorized Accounting Coa Get Groups operation within your permitted scope."
        },
        "createAccount": {
          "label": "Perform Accounting Coa",
          "description": "Perform the authorized Accounting Coa Create Account operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "getAccounts": {
          "label": "Perform Accounting Coa",
          "description": "Perform the authorized Accounting Coa Get Accounts operation within your permitted scope."
        },
        "getAccount": {
          "label": "Perform Accounting Coa",
          "description": "Perform the authorized Accounting Coa Get Account operation within your permitted scope."
        },
        "updateAccount": {
          "label": "Perform Accounting Coa",
          "description": "Perform the authorized Accounting Coa Update Account operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "getAccountBalance": {
          "label": "Perform Accounting Coa",
          "description": "Perform the authorized Accounting Coa Get Account Balance operation within your permitted scope."
        }
      },
      "fiscalPeriod": {
        "create": {
          "label": "Create Accounting Fiscal Period",
          "description": "Perform the authorized Accounting Fiscal Period Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "list": {
          "label": "View Accounting Fiscal Period",
          "description": "Perform the authorized Accounting Fiscal Period List operation within your permitted scope."
        },
        "lock": {
          "label": "Lock Accounting Fiscal Period",
          "description": "Perform the authorized Accounting Fiscal Period Lock operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "unlock": {
          "label": "Unlock Accounting Fiscal Period",
          "description": "Perform the authorized Accounting Fiscal Period Unlock operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "postingRule": {
        "create": {
          "label": "Create Accounting Posting Rule",
          "description": "Perform the authorized Accounting Posting Rule Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "list": {
          "label": "View Accounting Posting Rule",
          "description": "Perform the authorized Accounting Posting Rule List operation within your permitted scope."
        },
        "update": {
          "label": "Update Accounting Posting Rule",
          "description": "Perform the authorized Accounting Posting Rule Update operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "test": {
          "label": "Test Accounting Posting Rule",
          "description": "Perform the authorized Accounting Posting Rule Test operation within your permitted scope."
        }
      },
      "autoPost": {
        "label": "Perform Accounting",
        "description": "Perform the authorized Accounting Auto Post operation within your permitted scope.",
        "makerChecker": {
          "reason": "This governed operation requires independent approval."
        }
      }
    },
    "reporting": {
      "export": {
        "label": "Export Report",
        "description": "Export a governed report as CSV with formula-injection protection and audit trail."
      }
    },
    "marketData": {
      "correct": {
        "label": "Correct Market Data Observation",
        "description": "Correct a market data observation with audit evidence and restatement versioning."
      },
      "history": {
        "label": "Read Market Data Correction History",
        "description": "View the correction history and audit revisions for a market data observation."
      },
      "prices": {
        "list": {
          "label": "View market prices and valuation data",
          "description": "View authorized daily OHLCV market observations, valuation prices and source evidence."
        },
        "get": {
          "label": "View market data detail",
          "description": "View one authoritative market or valuation observation with daily snapshot context and lineage."
        }
      }
    },
    "investment": {
      "compliance": {
        "breaches": {
          "get": {
            "label": "View Compliance Breach",
            "description": "View a scoped compliance breach and its remediation evidence."
          },
          "list": {
            "label": "View Compliance Breaches",
            "description": "Perform the authorized Compliance Breaches List operation within your permitted scope."
          }
        }
      },
      "risk": {
        "exposures": {
          "list": {
            "label": "List Risk Exposures",
            "description": "List risk exposures and concentration metrics for the active organization."
          }
        }
      },
      "corporateAction": {
        "list": {
          "label": "View Investment Corporate Action",
          "description": "Perform the authorized Investment Corporate Action List operation within your permitted scope."
        },
        "create": {
          "label": "Create Investment Corporate Action",
          "description": "Perform the authorized Investment Corporate Action Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "update": {
          "label": "Update Investment Corporate Action",
          "description": "Perform the authorized Investment Corporate Action Cancel operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "get": {
          "label": "View Investment Corporate Action",
          "description": "Perform the authorized Investment Corporate Action Get operation within your permitted scope."
        },
        "process": {
          "label": "Process Investment Corporate Action",
          "description": "Perform the authorized Investment Corporate Action Process operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "entitlements": {
          "list": {
            "label": "View Investment Corporate Action Entitlements",
            "description": "Perform the authorized Investment Corporate Action Entitlements List operation within your permitted scope."
          }
        },
        "elect": {
          "label": "Elect Investment Corporate Action",
          "description": "Perform the authorized Investment Corporate Action Elect operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "allocate": {
          "label": "Allocate Investment Corporate Action",
          "description": "Perform the authorized Investment Corporate Action Allocate operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "exDate": {
          "classify": {
            "label": "Classify Investment Corporate Action Ex Date",
            "description": "Perform the authorized Investment Corporate Action Ex Date Classify operation within your permitted scope."
          },
          "verify": {
            "label": "Verify Investment Corporate Action Ex Date",
            "description": "Perform the authorized Investment Corporate Action Ex Date Verify operation within your permitted scope."
          }
        }
      },
      "fact": {
        "list": {
          "label": "View Investment Fact",
          "description": "Perform the authorized Investment Fact List operation within your permitted scope."
        },
        "get": {
          "label": "View Investment Fact",
          "description": "Perform the authorized Investment Fact Get operation within your permitted scope."
        },
        "create": {
          "label": "Create Investment Fact",
          "description": "Perform the authorized Investment Fact Create operation within your permitted scope."
        },
        "position": {
          "label": "Perform Investment Fact",
          "description": "Perform the authorized Investment Fact Position operation within your permitted scope."
        },
        "valuation": {
          "label": "Perform Investment Fact",
          "description": "Perform the authorized Investment Fact Valuation operation within your permitted scope."
        },
        "movement": {
          "label": "Perform Investment Fact",
          "description": "Perform the authorized Investment Fact Movement operation within your permitted scope."
        },
        "realized": {
          "label": "Perform Investment Fact",
          "description": "Perform the authorized Investment Fact Realized operation within your permitted scope."
        },
        "cgt": {
          "label": "Perform Investment Fact",
          "description": "Perform the authorized Investment Fact Cgt operation within your permitted scope."
        },
        "nfrs": {
          "label": "Perform Investment Fact",
          "description": "Perform the authorized Investment Fact Nfrs operation within your permitted scope."
        },
        "batches": {
          "list": {
            "label": "View Investment Fact Batches",
            "description": "Perform the authorized Investment Fact Batches List operation within your permitted scope."
          }
        },
        "batch": {
          "get": {
            "label": "View Investment Fact Batch",
            "description": "Perform the authorized Investment Fact Batch Get operation within your permitted scope."
          },
          "lineage": {
            "label": "Perform Investment Fact Batch",
            "description": "Perform the authorized Investment Fact Batch Lineage operation within your permitted scope."
          }
        }
      },
      "transaction": {
        "create": {
          "label": "Create Investment Transaction",
          "description": "Perform the authorized Investment Transaction Create operation within your permitted scope."
        },
        "list": {
          "label": "View Investment Transaction",
          "description": "Perform the authorized Investment Transaction List operation within your permitted scope."
        },
        "export": {
          "label": "Export Investment Transaction",
          "description": "Perform the authorized Investment Transaction Export operation within your permitted scope."
        },
        "get": {
          "label": "View Investment Transaction",
          "description": "Perform the authorized Investment Transaction Get operation within your permitted scope."
        },
        "submit": {
          "label": "Submit Investment Transaction",
          "description": "Perform the authorized Investment Transaction Submit operation within your permitted scope."
        },
        "approve": {
          "label": "Approve Investment Transaction",
          "description": "Perform the authorized Investment Transaction Approve operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "reject": {
          "label": "Reject Investment Transaction",
          "description": "Perform the authorized Investment Transaction Reject operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "withdraw": {
          "label": "Withdraw Investment Transaction",
          "description": "Perform the authorized Investment Transaction Withdraw operation within your permitted scope."
        },
        "post": {
          "label": "Post Investment Transaction",
          "description": "Perform the authorized Investment Transaction Post operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "repair": {
          "label": "Repair Investment Transaction",
          "description": "Perform the authorized Investment Transaction Repair operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "repost": {
          "label": "Repost Investment Transaction",
          "description": "Perform the authorized Investment Transaction Repost operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "reverse": {
          "label": "Reverse Investment Transaction",
          "description": "Perform the authorized Investment Transaction Reverse operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "lots": {
          "label": "Perform Investment Transaction",
          "description": "Perform the authorized Investment Transaction Lots operation within your permitted scope."
        },
        "disposals": {
          "label": "Perform Investment Transaction",
          "description": "Perform the authorized Investment Transaction Disposals operation within your permitted scope."
        },
        "facts": {
          "label": "Perform Investment Transaction",
          "description": "Perform the authorized Investment Transaction Facts operation within your permitted scope."
        }
      },
      "instrument": {
        "list": {
          "label": "View Investment Instrument",
          "description": "Perform the authorized Investment Instrument List operation within your permitted scope."
        },
        "get": {
          "label": "View Investment Instrument",
          "description": "Perform the authorized Investment Instrument Get operation within your permitted scope."
        },
        "create": {
          "label": "Create Investment Instrument",
          "description": "Perform the authorized Investment Instrument Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "update": {
          "label": "Update Investment Instrument",
          "description": "Perform the authorized Investment Instrument Update operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "override": {
          "create": {
            "label": "Create Investment Instrument Override",
            "description": "Perform the authorized Investment Instrument Override Create operation within your permitted scope.",
            "makerChecker": {
              "reason": "This governed operation requires independent approval."
            }
          },
          "list": {
            "label": "View Investment Instrument Override",
            "description": "Perform the authorized Investment Instrument Override List operation within your permitted scope."
          },
          "update": {
            "label": "Update Investment Instrument Override",
            "description": "Perform the authorized Investment Instrument Override Update operation within your permitted scope.",
            "makerChecker": {
              "reason": "This governed operation requires independent approval."
            }
          },
          "delete": {
            "label": "Delete Investment Instrument Override",
            "description": "Perform the authorized Investment Instrument Override Delete operation within your permitted scope.",
            "makerChecker": {
              "reason": "This governed operation requires independent approval."
            }
          }
        },
        "delete": {
          "label": "Delete Investment Instrument",
          "description": "Perform the authorized Investment Instrument Delete operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "bulkUpsert": {
          "label": "Perform Investment Instrument",
          "description": "Perform the authorized Investment Instrument Bulk Upsert operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "marketData": {
        "create": {
          "label": "Create Investment Market Data",
          "description": "Perform the authorized Investment Market Data Create operation within your permitted scope."
        },
        "list": {
          "label": "View Investment Market Data",
          "description": "Perform the authorized Investment Market Data List operation within your permitted scope."
        },
        "get": {
          "label": "View Investment Market Data",
          "description": "Perform the authorized Investment Market Data Get operation within your permitted scope."
        },
        "update": {
          "label": "Update Investment Market Data",
          "description": "Perform the authorized Investment Market Data Update operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "delete": {
          "label": "Delete Investment Market Data",
          "description": "Perform the authorized Investment Market Data Delete operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "bulkUpsert": {
          "label": "Perform Investment Market Data",
          "description": "Perform the authorized Investment Market Data Bulk Upsert operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "portfolioAccount": {
        "list": {
          "label": "View Investment Portfolio Account",
          "description": "Perform the authorized Investment Portfolio Account List operation within your permitted scope."
        },
        "get": {
          "label": "View Investment Portfolio Account",
          "description": "Perform the authorized Investment Portfolio Account Get operation within your permitted scope."
        },
        "getBalance": {
          "label": "Perform Investment Portfolio Account",
          "description": "Perform the authorized Investment Portfolio Account Get Balance operation within your permitted scope."
        },
        "create": {
          "label": "Create Investment Portfolio Account",
          "description": "Perform the authorized Investment Portfolio Account Create operation within your permitted scope."
        },
        "update": {
          "label": "Update Investment Portfolio Account",
          "description": "Perform the authorized Investment Portfolio Account Update operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "signatories": {
          "list": {
            "label": "View Investment Portfolio Account Signatories",
            "description": "Perform the authorized Investment Portfolio Account Signatories List operation within your permitted scope."
          }
        },
        "signatory": {
          "create": {
            "label": "Create Investment Portfolio Account Signatory",
            "description": "Perform the authorized Investment Portfolio Account Signatory Create operation within your permitted scope.",
            "makerChecker": {
              "reason": "This governed operation requires independent approval."
            }
          },
          "delete": {
            "label": "Delete Investment Portfolio Account Signatory",
            "description": "Perform the authorized Investment Portfolio Account Signatory Delete operation within your permitted scope.",
            "makerChecker": {
              "reason": "This governed operation requires independent approval."
            }
          }
        }
      },
      "position-transfer": {
        "list": {
          "label": "List position transfers",
          "description": "List position-transfer requests visible in the authorized organization scope."
        },
        "get": {
          "label": "View position transfer",
          "description": "View one authorized position-transfer request and its allocations."
        },
        "eligibility": {
          "label": "Check position transfer eligibility",
          "description": "Evaluate the current lifecycle actions available for a position transfer."
        },
        "request-eligibility": {
          "label": "Check transfer request eligibility",
          "description": "Evaluate eligible destinations and source lots before requesting a position transfer."
        },
        "request": {
          "label": "Request position transfer",
          "description": "Create a maker-checker position-transfer request from authorized source lots."
        },
        "approve": {
          "label": "Approve position transfer",
          "description": "Approve an eligible position-transfer request under maker-checker controls."
        },
        "execute": {
          "label": "Execute position transfer",
          "description": "Execute an approved position transfer and preserve authoritative lot lineage."
        },
        "cancel": {
          "label": "Cancel position transfer",
          "description": "Cancel an eligible position-transfer request before execution."
        },
        "reverse": {
          "label": "Reverse position transfer",
          "description": "Reverse an eligible executed position transfer with auditable lineage."
        }
      }
    },
    "navigation": {
      "read": {
        "label": "Read Navigation",
        "description": "Retrieve navigation items for the current user context."
      },
      "hub": {
        "label": "Perform Navigation",
        "description": "Perform the authorized Navigation Hub operation within your permitted scope.",
        "read": {
          "label": "View Navigation Hub",
          "description": "Perform the authorized Navigation Hub Read operation within your permitted scope."
        }
      },
      "shell": {
        "read": {
          "label": "View Navigation Shell",
          "description": "Perform the authorized Navigation Shell Read operation within your permitted scope."
        }
      },
      "routes": {
        "read": {
          "label": "View Navigation Routes",
          "description": "Perform the authorized Navigation Routes Read operation within your permitted scope."
        }
      },
      "route": {
        "read": {
          "label": "View Navigation Route",
          "description": "Perform the authorized Navigation Route Read operation within your permitted scope."
        }
      }
    },
    "auth": {
      "delegation": {
        "enter": {
          "label": "Enter Support Delegation",
          "description": "Enter an approved read-only support delegation."
        },
        "exit": {
          "label": "Perform Auth Delegation",
          "description": "Perform the authorized Auth Delegation Exit operation within your permitted scope."
        }
      },
      "exit": {
        "label": "Exit Support Delegation",
        "description": "Return to your platform session and end delegated support access."
      },
      "switchContext": {
        "label": "Switch Active Context",
        "description": "Switch to another organization or branch context."
      },
      "password": {
        "change": {
          "label": "Change Password",
          "description": "Change the current user's password."
        },
        "forgot": {
          "label": "Perform Auth Password",
          "description": "Perform the authorized Auth Password Forgot operation within your permitted scope."
        },
        "reset": {
          "label": "Perform Auth Password",
          "description": "Perform the authorized Auth Password Reset operation within your permitted scope."
        }
      },
      "sessions": {
        "manage": {
          "label": "Manage Sessions",
          "description": "List and revoke active user sessions."
        },
        "revoke": {
          "label": "Revoke Session",
          "description": "End a specific active user session."
        }
      },
      "login": {
        "label": "Perform Auth",
        "description": "Perform the authorized Auth Login operation within your permitted scope."
      },
      "logout": {
        "label": "Perform Auth",
        "description": "Perform the authorized Auth Logout operation within your permitted scope."
      },
      "refresh": {
        "label": "Perform Auth",
        "description": "Perform the authorized Auth Refresh operation within your permitted scope."
      },
      "challenge": {
        "totp": {
          "label": "Perform Auth Challenge",
          "description": "Perform the authorized Auth Challenge Totp operation within your permitted scope."
        },
        "recovery": {
          "label": "Perform Auth Challenge",
          "description": "Perform the authorized Auth Challenge Recovery operation within your permitted scope."
        }
      },
      "selectContext": {
        "label": "Perform Auth Select",
        "description": "Perform the authorized Auth Select Context operation within your permitted scope."
      },
      "invitation": {
        "accept": {
          "label": "Perform Auth Invitation",
          "description": "Perform the authorized Auth Invitation Accept operation within your permitted scope."
        }
      },
      "mfa": {
        "enroll": {
          "label": "Perform Auth Mfa",
          "description": "Perform the authorized Auth Mfa Enroll operation within your permitted scope."
        },
        "verify": {
          "label": "Verify Auth Mfa",
          "description": "Perform the authorized Auth Mfa Verify operation within your permitted scope."
        },
        "disable": {
          "label": "Disable Auth Mfa",
          "description": "Perform the authorized Auth Mfa Disable operation within your permitted scope."
        },
        "backupCodes": {
          "regenerate": {
            "label": "Perform Auth Mfa Backup Codes",
            "description": "Perform the authorized Auth Mfa Backup Codes Regenerate operation within your permitted scope."
          }
        }
      },
      "readProfile": {
        "label": "Perform Auth",
        "description": "Perform the authorized Auth Read Profile operation within your permitted scope."
      }
    },
    "regulatory": {
      "reportRun": {
        "export": {
          "label": "Export report run",
          "description": "Export an authorized completed report run."
        },
        "generate": {
          "label": "Generate Regulatory Report Run",
          "description": "Perform the authorized Regulatory Report Run Generate operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "list": {
          "label": "View Regulatory Report Run",
          "description": "Perform the authorized Regulatory Report Run List operation within your permitted scope."
        },
        "get": {
          "label": "View Regulatory Report Run",
          "description": "Perform the authorized Regulatory Report Run Get operation within your permitted scope."
        },
        "artifact": {
          "get": {
            "label": "View Regulatory Report Run Artifact",
            "description": "Perform the authorized Regulatory Report Run Artifact Get operation within your permitted scope."
          }
        },
        "cancel": {
          "label": "Cancel Regulatory Report Run",
          "description": "Perform the authorized Regulatory Report Run Cancel operation within your permitted scope."
        },
        "retry": {
          "label": "Retry Regulatory Report Run",
          "description": "Perform the authorized Regulatory Report Run Retry operation within your permitted scope."
        },
        "validate": {
          "label": "Validate Regulatory Report Run",
          "description": "Perform the authorized Regulatory Report Run Validate operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "submit": {
          "label": "Submit Regulatory Report Run",
          "description": "Perform the authorized Regulatory Report Run Submit operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "taxRemittance": {
        "list": {
          "label": "List tax remittances",
          "description": "List governed tax remittance records for the active organization."
        },
        "record": {
          "label": "Record tax remittance",
          "description": "Record a payment or adjustment against an acknowledged tax filing.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "makerChecker": {
          "reason": "Tax remittance recording requires independent approval."
        }
      },
      "reportDefinition": {
        "list": {
          "label": "View Regulatory Report Definition",
          "description": "Perform the authorized Regulatory Report Definition List operation within your permitted scope."
        },
        "get": {
          "label": "View Regulatory Report Definition",
          "description": "Perform the authorized Regulatory Report Definition Get operation within your permitted scope."
        },
        "create": {
          "label": "Create Regulatory Report Definition",
          "description": "Perform the authorized Regulatory Report Definition Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "update": {
          "label": "Update Regulatory Report Definition",
          "description": "Perform the authorized Regulatory Report Definition Update operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "disable": {
          "label": "Disable Regulatory Report Definition",
          "description": "Perform the authorized Regulatory Report Definition Disable operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "submission": {
        "list": {
          "label": "View Regulatory Submission",
          "description": "Perform the authorized Regulatory Submission List operation within your permitted scope."
        },
        "acknowledge": {
          "label": "Acknowledge Regulatory Submission",
          "description": "Perform the authorized Regulatory Submission Acknowledge operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      }
    },
    "platform": {
      "organizations": {
        "offboardingExport": {
          "label": "Export Organization Offboarding Bundle",
          "description": "Create an encrypted, custody-audited export for organization offboarding."
        },
        "list": {
          "label": "View Platform Organizations"
        },
        "read": {
          "label": "View Platform Organizations"
        },
        "create": {
          "label": "Create Platform Organizations"
        },
        "update": {
          "label": "Update Platform Organizations"
        },
        "disable": {
          "label": "Disable Platform Organizations"
        },
        "onboardingReadiness": {
          "label": "View Platform Organizations Onboarding Readiness"
        },
        "supportCommand": {
          "issue": {
            "label": "Issue Platform Organizations Support Command"
          }
        }
      },
      "dashboard": {
        "read": {
          "label": "View platform dashboard",
          "description": "View the platform operational workspace without organization business data."
        }
      },
      "integration": {
        "entitlements": {
          "issue": {
            "label": "Issue entitlement assertion",
            "description": "Issue the signed organization entitlement assertion used by an organization runtime."
          }
        },
        "reference-data": {
          "issue": {
            "label": "Issue reference data assertion",
            "description": "Issue the signed reference-data release assertion used by an organization runtime."
          }
        },
        "support-delegation": {
          "issue": {
            "label": "Issue support delegation assertion",
            "description": "Issue the signed support-delegation assertion for an authorized support session."
          }
        },
        "runtime-heartbeat": {
          "ingest": {
            "label": "Ingest runtime heartbeat",
            "description": "Record a heartbeat from an authorized organization runtime installation."
          }
        },
        "usage-statement": {
          "ingest": {
            "label": "Ingest usage statement",
            "description": "Record an organization runtime usage statement for platform metering."
          }
        },
        "bootstrap-attestation": {
          "ingest": {
            "label": "Ingest bootstrap attestation",
            "description": "Record the organization runtime bootstrap-completion attestation."
          }
        },
        "support-commands": {
          "read": {
            "label": "Read support commands",
            "description": "Read pending platform support commands for an organization runtime."
          }
        },
        "support-command": {
          "acknowledge": {
            "label": "Acknowledge support command",
            "description": "Acknowledge execution or receipt of an organization support command."
          }
        }
      },
      "reference-data": {
        "release": {
          "create": {
            "label": "Create reference data release",
            "description": "Create a draft platform reference-data release."
          },
          "publish": {
            "label": "Publish reference data release",
            "description": "Publish an approved reference-data release for organization runtimes."
          }
        }
      },
      "health": {
        "check": {
          "label": "Perform Platform Health",
          "description": "Perform the authorized Platform Health Check operation within your permitted scope."
        },
        "readiness": {
          "label": "Perform Platform Health",
          "description": "Perform the authorized Platform Health Readiness operation within your permitted scope."
        },
        "liveness": {
          "label": "Perform Platform Health",
          "description": "Perform the authorized Platform Health Liveness operation within your permitted scope."
        }
      },
      "module": {
        "enable": {
          "label": "Enable Platform Module",
          "description": "Perform the authorized Platform Module Enable operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "disable": {
          "label": "Disable Platform Module",
          "description": "Perform the authorized Platform Module Disable operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "entitlements": {
        "list": {
          "label": "View Platform Entitlements",
          "description": "Perform the authorized Platform Entitlements List operation within your permitted scope."
        }
      },
      "license": {
        "create": {
          "label": "Create Platform License",
          "description": "Perform the authorized Platform License Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "list": {
          "label": "View Platform License",
          "description": "Perform the authorized Platform License List operation within your permitted scope."
        }
      },
      "dataHub": {
        "read": {
          "label": "View Platform Data Hub",
          "description": "Perform the authorized Platform Data Hub Read operation within your permitted scope."
        }
      },
      "reports": {
        "read": {
          "label": "View Platform Reports",
          "description": "Perform the authorized Platform Reports Read operation within your permitted scope."
        },
        "snapshot": {
          "create": {
            "label": "Create Platform Reports Snapshot"
          }
        },
        "restatement": {
          "create": {
            "label": "Create Platform Reports Restatement"
          }
        }
      },
      "modules": {
        "list": {
          "label": "View Platform Modules"
        },
        "read": {
          "label": "View Platform Modules"
        },
        "assign": {
          "label": "Assign Platform Modules"
        },
        "revoke": {
          "label": "Revoke Platform Modules"
        },
        "catalog": {
          "list": {
            "label": "View Platform Modules Catalog"
          },
          "manage": {
            "label": "Manage Platform Modules Catalog"
          }
        },
        "assignToOrganization": {
          "label": "Perform Platform Modules"
        },
        "revokeFromOrganization": {
          "label": "Perform Platform Modules"
        }
      },
      "supportDelegations": {
        "list": {
          "label": "View Platform Support Delegations"
        }
      },
      "users": {
        "list": {
          "label": "View Platform Users"
        },
        "read": {
          "label": "View Platform Users"
        },
        "create": {
          "label": "Create Platform Users"
        },
        "update": {
          "label": "Update Platform Users"
        },
        "disable": {
          "label": "Disable Platform Users"
        }
      },
      "audit": {
        "list": {
          "label": "View Platform Audit"
        },
        "read": {
          "label": "View Platform Audit"
        },
        "export": {
          "label": "Export Platform Audit"
        }
      },
      "configuration-rollout": {
        "read": {
          "label": "View Platform Configuration Rollout"
        },
        "manage": {
          "label": "Manage Platform Configuration Rollout"
        }
      },
      "data-residency": {
        "read": {
          "label": "View Platform Data Residency"
        },
        "policy": {
          "update": {
            "label": "Update Platform Data Residency Policy"
          }
        },
        "transfer": {
          "evaluate": {
            "label": "Evaluate Platform Data Residency Transfer"
          }
        },
        "exception": {
          "approve": {
            "label": "Approve Platform Data Residency Exception"
          }
        }
      },
      "jurisdiction-packages": {
        "read": {
          "label": "View Platform Jurisdiction Packages"
        },
        "manage": {
          "label": "Manage Platform Jurisdiction Packages"
        }
      },
      "reference-master": {
        "read": {
          "label": "View Platform Reference Master"
        },
        "manage": {
          "label": "Manage Platform Reference Master"
        }
      },
      "market-data-quality": {
        "read": {
          "label": "View Platform Market Data Quality"
        },
        "manage": {
          "label": "Manage Platform Market Data Quality"
        },
        "approve": {
          "label": "Approve Platform Market Data Quality"
        }
      },
      "provider-ingestion": {
        "read": {
          "label": "View Platform Provider Ingestion"
        },
        "manage": {
          "label": "Manage Platform Provider Ingestion"
        }
      },
      "issuer-events": {
        "read": {
          "label": "View Platform Issuer Events"
        },
        "manage": {
          "label": "Manage Platform Issuer Events"
        },
        "approve": {
          "label": "Approve Platform Issuer Events"
        }
      },
      "permission-catalog-migrations": {
        "read": {
          "label": "View Platform Permission Catalog Migrations"
        },
        "manage": {
          "label": "Manage Platform Permission Catalog Migrations"
        }
      },
      "federation": {
        "read": {
          "label": "View Platform Federation"
        },
        "manage": {
          "label": "Manage Platform Federation"
        }
      },
      "service-accounts": {
        "read": {
          "label": "View Platform Service Accounts"
        },
        "manage": {
          "label": "Manage Platform Service Accounts"
        }
      },
      "access-reviews": {
        "read": {
          "label": "View Platform Access Reviews"
        },
        "manage": {
          "label": "Manage Platform Access Reviews"
        }
      },
      "cryptographic-keys": {
        "read": {
          "label": "View Platform Cryptographic Keys"
        },
        "manage": {
          "label": "Manage Platform Cryptographic Keys"
        }
      },
      "scheduled-controls": {
        "read": {
          "label": "View Platform Scheduled Controls"
        },
        "manage": {
          "label": "Manage Platform Scheduled Controls"
        },
        "approve": {
          "label": "Approve Platform Scheduled Controls"
        }
      },
      "security-incidents": {
        "read": {
          "label": "View Platform Security Incidents"
        },
        "manage": {
          "label": "Manage Platform Security Incidents"
        }
      },
      "organization-ownership": {
        "read": {
          "label": "View Platform Organization Ownership"
        },
        "request": {
          "label": "Request Platform Organization Ownership"
        },
        "approve": {
          "label": "Approve Platform Organization Ownership"
        }
      },
      "migration-governance": {
        "read": {
          "label": "View Platform Migration Governance"
        },
        "request": {
          "label": "Request Platform Migration Governance"
        },
        "approve": {
          "label": "Approve Platform Migration Governance"
        }
      },
      "organization-portability": {
        "read": {
          "label": "View Platform Organization Portability"
        },
        "request": {
          "label": "Request Platform Organization Portability"
        },
        "approve": {
          "label": "Approve Platform Organization Portability"
        },
        "purge": {
          "label": "Purge Platform Organization Portability"
        }
      },
      "notification-governance": {
        "read": {
          "label": "View Platform Notification Governance"
        },
        "manage": {
          "label": "Manage Platform Notification Governance"
        },
        "approve": {
          "label": "Approve Platform Notification Governance"
        }
      },
      "support-delegations": {
        "read": {
          "label": "View Platform Support Delegations"
        },
        "create": {
          "label": "Create Platform Support Delegations"
        },
        "approve": {
          "label": "Approve Platform Support Delegations"
        },
        "revoke": {
          "label": "Revoke Platform Support Delegations"
        }
      },
      "clientAccount": {
        "list": {
          "label": "View Platform Client Account",
          "description": "Perform the authorized Platform Client Account List operation within your permitted scope."
        },
        "get": {
          "label": "View Platform Client Account",
          "description": "Perform the authorized Platform Client Account Get operation within your permitted scope."
        },
        "create": {
          "label": "Create Platform Client Account",
          "description": "Perform the authorized Platform Client Account Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "update": {
          "label": "Update Platform Client Account",
          "description": "Perform the authorized Platform Client Account Update operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "documents": {
          "list": {
            "label": "View Platform Client Account Documents",
            "description": "Perform the authorized Platform Client Account Documents List operation within your permitted scope."
          }
        },
        "document": {
          "create": {
            "label": "Create Platform Client Account Document",
            "description": "Perform the authorized Platform Client Account Document Create operation within your permitted scope.",
            "makerChecker": {
              "reason": "This governed operation requires independent approval."
            }
          }
        }
      }
    },
    "feeRules": {
      "list": {
        "label": "List fee schedules",
        "description": "View effective global, organization, and branch fee schedules."
      },
      "read": {
        "label": "Read fee schedule",
        "description": "Review one effective-dated fee schedule and its calculation components."
      },
      "create-version": {
        "label": "Create fee-schedule version",
        "description": "Create an immutable draft version of brokerage, DP, and SEBON charges."
      },
      "submit": {
        "label": "Submit fee schedule",
        "description": "Submit a draft fee schedule for independent approval."
      },
      "approve": {
        "label": "Approve fee schedule",
        "description": "Activate a submitted fee schedule using maker-checker approval."
      },
      "suspend": {
        "label": "Suspend fee schedule",
        "description": "Stop an active fee schedule from being selected for new postings."
      },
      "retire": {
        "label": "Retire fee schedule",
        "description": "Retire a non-active fee schedule while retaining calculation lineage."
      },
      "impact-analyze": {
        "label": "Analyze fee-schedule impact",
        "description": "Count immutable posted transactions and candidate activity in the effective period."
      }
    },
    "organization": {
      "regulatory-profile": {
        "read": {
          "label": "Read organization regulatory profile",
          "description": "View the organization's verified regulatory identity and effective license metadata."
        },
        "update": {
          "label": "Update organization regulatory profile",
          "description": "Update verified regulator licenses and filing identity under AAL2, optimistic locking, audit, and idempotency controls."
        }
      },
      "branches": {
        "list": {
          "label": "View Organization Branches"
        },
        "read": {
          "label": "View Organization Branches"
        },
        "create": {
          "label": "Create Organization Branches"
        },
        "update": {
          "label": "Update Organization Branches"
        },
        "disable": {
          "label": "Disable Organization Branches"
        },
        "make-default": {
          "label": "Perform Organization Branches"
        }
      },
      "clients": {
        "list": {
          "label": "View Organization Clients"
        },
        "read": {
          "label": "View Organization Clients"
        },
        "create": {
          "label": "Create Organization Clients"
        },
        "update": {
          "label": "Update Organization Clients"
        },
        "disable": {
          "label": "Disable Organization Clients"
        }
      },
      "clientAccounts": {
        "list": {
          "label": "View Organization Client Accounts"
        },
        "read": {
          "label": "View Organization Client Accounts"
        },
        "create": {
          "label": "Create Organization Client Accounts"
        },
        "update": {
          "label": "Update Organization Client Accounts"
        },
        "disable": {
          "label": "Disable Organization Client Accounts"
        },
        "documents": {
          "list": {
            "label": "View Organization Client Accounts Documents"
          },
          "create": {
            "label": "Create Organization Client Accounts Documents"
          },
          "remove": {
            "label": "Remove Organization Client Accounts Documents"
          }
        },
        "signatories": {
          "list": {
            "label": "View Organization Client Accounts Signatories"
          },
          "create": {
            "label": "Create Organization Client Accounts Signatories"
          },
          "remove": {
            "label": "Remove Organization Client Accounts Signatories"
          }
        }
      },
      "portfolios": {
        "list": {
          "label": "View Organization Portfolios"
        },
        "read": {
          "label": "View Organization Benchmark Assignments"
        },
        "create": {
          "label": "Create Organization Benchmark Assignments"
        },
        "update": {
          "label": "Approve Organization Benchmark Assignments"
        },
        "disable": {
          "label": "Disable Organization Portfolios"
        }
      },
      "modules": {
        "listAssigned": {
          "label": "Perform Organization Modules"
        },
        "enable": {
          "label": "Enable Organization Modules"
        },
        "disable": {
          "label": "Disable Organization Modules"
        },
        "configure": {
          "label": "Configure Organization Modules"
        }
      },
      "profile": {
        "read": {
          "label": "View Organization Profile"
        },
        "detail": {
          "read": {
            "label": "View Organization Profile Detail",
            "description": "Perform the authorized Organization Profile Detail Read operation within your permitted scope."
          }
        },
        "update": {
          "label": "Update Organization Profile"
        }
      },
      "users": {
        "list": {
          "label": "View Organization Users"
        },
        "read": {
          "label": "View Organization Users"
        },
        "create": {
          "label": "Create Organization Users"
        },
        "update": {
          "label": "Update Organization Users"
        },
        "disable": {
          "label": "Disable Organization Users"
        },
        "unlock": {
          "label": "Unlock Organization Users"
        },
        "force-password-reset": {
          "label": "Perform Organization Users"
        },
        "mfa": {
          "require-enrollment": {
            "label": "Perform Organization Users Mfa"
          },
          "reset-enrollment": {
            "label": "Perform Organization Users Mfa"
          },
          "disable": {
            "label": "Disable Organization Users Mfa"
          },
          "regenerate-recovery": {
            "label": "Perform Organization Users Mfa"
          }
        }
      },
      "roles": {
        "list": {
          "label": "View Organization Roles"
        },
        "read": {
          "label": "View Organization Roles"
        },
        "create": {
          "label": "Create Organization Roles"
        },
        "update": {
          "label": "Update Organization Roles"
        },
        "disable": {
          "label": "Disable Organization Roles"
        }
      },
      "permissions": {
        "list": {
          "label": "View Organization Permissions"
        }
      },
      "permission-assignments": {
        "list": {
          "label": "View Organization Permission Assignments"
        },
        "edit": {
          "label": "Perform Organization Permission Assignments"
        }
      },
      "audit": {
        "list": {
          "label": "View Organization Audit"
        },
        "read": {
          "label": "View Organization Audit"
        },
        "export": {
          "label": "Export Organization Audit"
        }
      },
      "access-inspector": {
        "read": {
          "label": "View Organization Access Inspector"
        }
      },
      "legal-hold": {
        "place": {
          "label": "Place Organization Legal Hold"
        },
        "remove": {
          "label": "Remove Organization Legal Hold"
        },
        "list": {
          "label": "View Organization Legal Hold"
        }
      },
      "admin-delegation": {
        "create": {
          "label": "Create Organization Admin Delegation"
        },
        "revoke": {
          "label": "Revoke Organization Admin Delegation"
        },
        "list": {
          "label": "View Organization Admin Delegation"
        }
      }
    },
    "portfolioPerformance": {
      "list": {
        "label": "View portfolio performance",
        "description": "View scoped portfolio valuation, gain/loss, Nepal tax provenance, and NFRS evidence."
      },
      "export": {
        "label": "Export Investment Performance",
        "description": "Perform the authorized Investment Performance Export operation within your permitted scope."
      },
      "clientReadOwn": {
        "label": "Perform Client Portfolio Performance",
        "description": "Perform the authorized Client Portfolio Performance Read Own operation within your permitted scope."
      }
    },
    "portfolioCustody": {
      "list": {
        "label": "View portfolio custody evidence",
        "description": "View scoped BOID, DP code, internal positions, and CDSC document evidence without claiming external balance reconciliation."
      },
      "clientReadOwn": {
        "label": "View my custody evidence",
        "description": "View your own BOID, DP code, internal positions, and CDSC document evidence."
      }
    },
    "dashboard": {
      "view": {
        "label": "View Dashboard",
        "description": "Perform the authorized Dashboard View operation within your permitted scope."
      }
    },
    "holdings": {
      "view": {
        "label": "View Holdings",
        "description": "Perform the authorized Holdings View operation within your permitted scope."
      }
    },
    "reports": {
      "view": {
        "label": "View Reports",
        "description": "Perform the authorized Reports View operation within your permitted scope."
      },
      "detail": {
        "read": {
          "label": "View Reports Detail",
          "description": "Perform the authorized Reports Detail Read operation within your permitted scope."
        }
      }
    },
    "reconciliation": {
      "view": {
        "label": "View Reconciliation",
        "description": "Perform the authorized Reconciliation View operation within your permitted scope."
      },
      "statement": {
        "create": {
          "label": "Create Reconciliation Statement",
          "description": "Perform the authorized Reconciliation Statement Create operation within your permitted scope."
        },
        "list": {
          "label": "View Reconciliation Statement",
          "description": "Perform the authorized Reconciliation Statement List operation within your permitted scope."
        },
        "get": {
          "label": "View Reconciliation Statement",
          "description": "Perform the authorized Reconciliation Statement Get operation within your permitted scope."
        }
      },
      "run": {
        "create": {
          "label": "Create Reconciliation Run",
          "description": "Perform the authorized Reconciliation Run Create operation within your permitted scope."
        },
        "list": {
          "label": "View Reconciliation Run",
          "description": "Perform the authorized Reconciliation Run List operation within your permitted scope."
        },
        "get": {
          "label": "View Reconciliation Run",
          "description": "Perform the authorized Reconciliation Run Get operation within your permitted scope."
        },
        "breaks": {
          "list": {
            "label": "View Reconciliation Run Breaks",
            "description": "Perform the authorized Reconciliation Run Breaks List operation within your permitted scope."
          }
        },
        "matches": {
          "list": {
            "label": "View Reconciliation Run Matches",
            "description": "Perform the authorized Reconciliation Run Matches List operation within your permitted scope."
          }
        },
        "cancel": {
          "description": "Perform the authorized Reconciliation Run Cancel operation within your permitted scope."
        },
        "retry": {
          "description": "Perform the authorized Reconciliation Run Retry operation within your permitted scope."
        }
      },
      "break": {
        "get": {
          "label": "View Reconciliation Break",
          "description": "Perform the authorized Reconciliation Break Get operation within your permitted scope."
        },
        "update": {
          "label": "Update Reconciliation Break",
          "description": "Perform the authorized Reconciliation Break Update operation within your permitted scope."
        }
      },
      "adjustment": {
        "create": {
          "label": "Create Reconciliation Adjustment",
          "description": "Perform the authorized Reconciliation Adjustment Create operation within your permitted scope."
        },
        "list": {
          "label": "View Reconciliation Adjustment",
          "description": "Perform the authorized Reconciliation Adjustment List operation within your permitted scope."
        },
        "approve": {
          "label": "Approve Reconciliation Adjustment",
          "description": "Perform the authorized Reconciliation Adjustment Approve operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "reject": {
          "label": "Reject Reconciliation Adjustment",
          "description": "Perform the authorized Reconciliation Adjustment Reject operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "post": {
          "label": "Post Reconciliation Adjustment",
          "description": "Perform the authorized Reconciliation Adjustment Post operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "aging": {
        "execute": {
          "label": "Execute Reconciliation Aging",
          "description": "Perform the authorized Reconciliation Aging Execute operation within your permitted scope."
        }
      },
      "escalation": {
        "execute": {
          "label": "Execute Reconciliation Escalation",
          "description": "Perform the authorized Reconciliation Escalation Execute operation within your permitted scope."
        }
      },
      "suspenseCash": {
        "caseCreate": {
          "label": "Create Reconciliation Suspense Cash",
          "description": "Perform the authorized Reconciliation Suspense Cash Create operation within your permitted scope."
        },
        "caseList": {
          "label": "View Reconciliation Suspense Cash",
          "description": "Perform the authorized Reconciliation Suspense Cash List operation within your permitted scope."
        },
        "resolutionRequest": {
          "label": "Perform Reconciliation Suspense Cash",
          "description": "Perform the authorized Reconciliation Suspense Cash Resolution Request operation within your permitted scope."
        },
        "resolutionApprove": {
          "label": "Perform Reconciliation Suspense Cash",
          "description": "Perform the authorized Reconciliation Suspense Cash Resolution Approve operation within your permitted scope."
        },
        "reopenRequest": {
          "label": "Perform Reconciliation Suspense Cash",
          "description": "Perform the authorized Reconciliation Suspense Cash Reopen Request operation within your permitted scope."
        },
        "reopenApprove": {
          "label": "Perform Reconciliation Suspense Cash",
          "description": "Perform the authorized Reconciliation Suspense Cash Reopen Approve operation within your permitted scope."
        }
      }
    },
    "corporateActions": {
      "view": {
        "label": "View Corporate Actions",
        "description": "Perform the authorized Corporate Actions View operation within your permitted scope."
      }
    },
    "settings": {
      "view": {
        "label": "View Settings",
        "description": "Perform the authorized Settings View operation within your permitted scope."
      },
      "profile": {
        "label": "Perform Settings",
        "description": "Perform the authorized Settings Profile operation within your permitted scope.",
        "update": {
          "label": "Update Settings Profile",
          "description": "Perform the authorized Settings Profile Update operation within your permitted scope."
        }
      },
      "preferences": {
        "label": "Perform Settings",
        "description": "Perform the authorized Settings Preferences operation within your permitted scope.",
        "update": {
          "label": "Update Settings Preferences",
          "description": "Perform the authorized Settings Preferences Update operation within your permitted scope."
        }
      },
      "mfa": {
        "label": "Perform Settings",
        "description": "Perform the authorized Settings Mfa operation within your permitted scope."
      },
      "security": {
        "label": "Perform Settings",
        "description": "Perform the authorized Settings Security operation within your permitted scope."
      }
    },
    "admin": {
      "hub": {
        "label": "Perform Admin",
        "description": "Perform the authorized Admin Hub operation within your permitted scope.",
        "platform": {
          "label": "Perform Admin Hub",
          "description": "Perform the authorized Admin Hub Platform operation within your permitted scope."
        },
        "organization": {
          "label": "Perform Admin Hub",
          "description": "Perform the authorized Admin Hub Organization operation within your permitted scope."
        }
      },
      "users": {
        "view": {
          "label": "View Admin Users",
          "description": "Perform the authorized Admin Users View operation within your permitted scope."
        },
        "detail": {
          "label": "Perform Admin Users",
          "description": "Perform the authorized Admin Users Detail operation within your permitted scope."
        }
      },
      "roles": {
        "view": {
          "label": "View Admin Roles",
          "description": "Perform the authorized Admin Roles View operation within your permitted scope."
        },
        "detail": {
          "label": "Perform Admin Roles",
          "description": "Perform the authorized Admin Roles Detail operation within your permitted scope."
        }
      },
      "organization": {
        "view": {
          "label": "View Admin Organization",
          "description": "Perform the authorized Admin Organization View operation within your permitted scope."
        }
      },
      "audit": {
        "view": {
          "label": "View Admin Audit",
          "description": "Perform the authorized Admin Audit View operation within your permitted scope."
        }
      },
      "auditLog": {
        "list": {
          "label": "View Admin Audit Log",
          "description": "Perform the authorized Admin Audit Log List operation within your permitted scope."
        }
      },
      "modules": {
        "list": {
          "label": "View Admin Modules",
          "description": "Perform the authorized Admin Modules List operation within your permitted scope."
        }
      },
      "user": {
        "create": {
          "label": "Create Admin User",
          "description": "Perform the authorized Admin User Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "update": {
          "label": "Update Admin User",
          "description": "Perform the authorized Admin User Update operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "delete": {
          "label": "Delete Admin User",
          "description": "Perform the authorized Admin User Delete operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "role": {
        "create": {
          "label": "Create Admin Role",
          "description": "Perform the authorized Admin Role Create operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "update": {
          "label": "Update Admin Role",
          "description": "Perform the authorized Admin Role Update operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "delete": {
          "label": "Delete Admin Role",
          "description": "Perform the authorized Admin Role Delete operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      }
    },
    "data": {
      "hub": {
        "label": "Perform Data",
        "description": "Perform the authorized Data Hub operation within your permitted scope."
      }
    },
    "import": {
      "list": {
        "label": "View Import",
        "description": "Perform the authorized Import List operation within your permitted scope."
      },
      "get": {
        "label": "View Import",
        "description": "Perform the authorized Import Get operation within your permitted scope."
      },
      "upload": {
        "label": "Upload Import",
        "description": "Perform the authorized Import Upload operation within your permitted scope."
      },
      "commit": {
        "label": "Perform Import",
        "description": "Perform the authorized Import Commit operation within your permitted scope.",
        "makerChecker": {
          "reason": "This governed operation requires independent approval."
        }
      },
      "validate": {
        "label": "Validate Import",
        "description": "Perform the authorized Import Validate operation within your permitted scope."
      },
      "reconcile": {
        "label": "Perform Import",
        "description": "Perform the authorized Import Reconcile operation within your permitted scope."
      },
      "rows": {
        "list": {
          "label": "View Import Rows",
          "description": "Perform the authorized Import Rows List operation within your permitted scope."
        }
      },
      "recover": {
        "label": "Recover Import",
        "description": "Perform the authorized Import Recover operation within your permitted scope.",
        "makerChecker": {
          "reason": "This governed operation requires independent approval."
        }
      },
      "cancel": {
        "label": "Cancel Import",
        "description": "Perform the authorized Import Cancel operation within your permitted scope.",
        "makerChecker": {
          "reason": "This governed operation requires independent approval."
        }
      }
    },
    "access": {
      "members": {
        "read": {
          "label": "View Access Members",
          "description": "Perform the authorized Access Members Read operation within your permitted scope."
        }
      },
      "roles": {
        "read": {
          "label": "View Access Roles",
          "description": "Perform the authorized Access Roles Read operation within your permitted scope."
        },
        "manage": {
          "label": "Manage Access Roles",
          "description": "Perform the authorized Access Roles Manage operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "permissions": {
        "read": {
          "label": "View Access Permissions",
          "description": "Perform the authorized Access Permissions Read operation within your permitted scope."
        },
        "manage": {
          "label": "Manage Access Permissions",
          "description": "Perform the authorized Access Permissions Manage operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "membership": {
        "manage": {
          "label": "Manage Access Membership",
          "description": "Perform the authorized Access Membership Manage operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      }
    },
    "metrics": {
      "read": {
        "label": "View Platform Metrics",
        "description": "Perform the authorized Platform Metrics Read operation within your permitted scope."
      },
      "read-json": {
        "label": "Perform Platform Metrics",
        "description": "Perform the authorized Platform Metrics Read Json operation within your permitted scope."
      }
    },
    "client": {
      "dashboard": {
        "read": {
          "label": "View Client Dashboard"
        }
      },
      "profile": {
        "read": {
          "label": "View Client Profile"
        },
        "updateLimited": {
          "label": "Perform Client Profile"
        }
      },
      "holdings": {
        "readOwn": {
          "label": "Perform Client Holdings"
        }
      },
      "transactions": {
        "readOwn": {
          "label": "Perform Client Transactions"
        }
      },
      "reports": {
        "readOwn": {
          "label": "Perform Client Reports"
        },
        "exportOwn": {
          "label": "Perform Client Reports"
        }
      },
      "documents": {
        "readOwn": {
          "label": "Perform Client Documents"
        }
      }
    },
    "compliance": {
      "aml-cases": {
        "list": {
          "label": "View Compliance Aml Cases",
          "description": "Perform the authorized Compliance Aml Cases List operation within your permitted scope."
        },
        "get": {
          "label": "View Compliance Aml Cases",
          "description": "Perform the authorized Compliance Aml Cases Get operation within your permitted scope."
        },
        "open": {
          "label": "Open Compliance Aml Cases",
          "description": "Perform the authorized Compliance Aml Cases Open operation within your permitted scope."
        },
        "review": {
          "label": "Perform Compliance Aml Cases",
          "description": "Perform the authorized Compliance Aml Cases Review operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "report": {
          "label": "Perform Compliance Aml Cases",
          "description": "Perform the authorized Compliance Aml Cases Report operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        },
        "close": {
          "label": "Close Compliance Aml Cases",
          "description": "Perform the authorized Compliance Aml Cases Close operation within your permitted scope.",
          "makerChecker": {
            "reason": "This governed operation requires independent approval."
          }
        }
      },
      "nepal": {
        "generate": {
          "label": "Generate Compliance Nepal",
          "description": "Perform the authorized Compliance Nepal Generate operation within your permitted scope."
        },
        "export": {
          "label": "Export Compliance Nepal",
          "description": "Perform the authorized Compliance Nepal Export operation within your permitted scope."
        }
      },
      "breaches": {
        "open": {
          "label": "Open compliance breach",
          "description": "Open a compliance breach from an authorized finding or exception."
        },
        "remediate": {
          "label": "Remediate compliance breach",
          "description": "Record remediation for an open compliance breach."
        },
        "waive": {
          "label": "Waive compliance breach",
          "description": "Waive an eligible compliance breach under maker-checker governance."
        }
      }
    },
    "planned": {
      "market": {
        "prices": {
          "override": {
            "label": "Perform Market Prices",
            "description": "Perform the authorized Market Prices Override operation within your permitted scope."
          }
        },
        "fxRates": {
          "list": {
            "label": "View Market Fx Rates",
            "description": "Perform the authorized Market Fx Rates List operation within your permitted scope."
          }
        },
        "benchmarks": {
          "list": {
            "label": "View Market Benchmarks",
            "description": "Perform the authorized Market Benchmarks List operation within your permitted scope."
          }
        },
        "providers": {
          "list": {
            "label": "View Market Providers",
            "description": "Perform the authorized Market Providers List operation within your permitted scope."
          }
        },
        "exceptions": {
          "list": {
            "label": "View Market Exceptions",
            "description": "Perform the authorized Market Exceptions List operation within your permitted scope."
          }
        }
      },
      "investment": {
        "mandates": {
          "list": {
            "label": "View Investment Mandates",
            "description": "Perform the authorized Investment Mandates List operation within your permitted scope."
          }
        }
      },
      "custody": {
        "balances": {
          "list": {
            "label": "View Custody Balances",
            "description": "Perform the authorized Custody Balances List operation within your permitted scope."
          }
        }
      },
      "accounting": {
        "journals": {
          "list": {
            "label": "View Accounting Journals",
            "description": "Perform the authorized Accounting Journals List operation within your permitted scope."
          },
          "get": {
            "label": "View Accounting Journals",
            "description": "Perform the authorized Accounting Journals Get operation within your permitted scope."
          }
        },
        "chartOfAccounts": {
          "list": {
            "label": "View Accounting Chart Of Accounts",
            "description": "Perform the authorized Accounting Chart Of Accounts List operation within your permitted scope."
          }
        },
        "fiscalPeriods": {
          "list": {
            "label": "View Accounting Fiscal Periods",
            "description": "Perform the authorized Accounting Fiscal Periods List operation within your permitted scope."
          }
        }
      },
      "tax": {
        "records": {
          "list": {
            "label": "View Tax Records",
            "description": "Perform the authorized Tax Records List operation within your permitted scope."
          }
        },
        "calculations": {
          "list": {
            "label": "View Tax Calculations",
            "description": "Perform the authorized Tax Calculations List operation within your permitted scope."
          }
        }
      },
      "evidence": {
        "list": {
          "label": "View Evidence",
          "description": "Perform the authorized Evidence List operation within your permitted scope."
        },
        "get": {
          "label": "View Evidence",
          "description": "Perform the authorized Evidence Get operation within your permitted scope."
        },
        "upload": {
          "label": "Upload Evidence",
          "description": "Perform the authorized Evidence Upload operation within your permitted scope."
        }
      },
      "organization": {
        "approval-policies": {
          "list": {
            "label": "View Organization Approval Policies",
            "description": "Perform the authorized Organization Approval Policies List operation within your permitted scope."
          },
          "update": {
            "label": "Update Organization Approval Policies",
            "description": "Perform the authorized Organization Approval Policies Update operation within your permitted scope."
          }
        },
        "permission-bundles": {
          "list": {
            "label": "View Organization Permission Bundles",
            "description": "Perform the authorized Organization Permission Bundles List operation within your permitted scope."
          },
          "create": {
            "label": "Create Organization Permission Bundles",
            "description": "Perform the authorized Organization Permission Bundles Create operation within your permitted scope."
          },
          "update": {
            "label": "Update Organization Permission Bundles",
            "description": "Perform the authorized Organization Permission Bundles Update operation within your permitted scope."
          }
        },
        "retention-policies": {
          "read": {
            "label": "View Organization Retention Policies",
            "description": "Perform the authorized Organization Retention Policies Read operation within your permitted scope."
          },
          "update": {
            "label": "Update Organization Retention Policies",
            "description": "Perform the authorized Organization Retention Policies Update operation within your permitted scope."
          }
        },
        "export-policies": {
          "read": {
            "label": "View Organization Export Policies",
            "description": "Perform the authorized Organization Export Policies Read operation within your permitted scope."
          },
          "update": {
            "label": "Update Organization Export Policies",
            "description": "Perform the authorized Organization Export Policies Update operation within your permitted scope."
          }
        },
        "security-settings": {
          "read": {
            "label": "View Organization Security Settings",
            "description": "Perform the authorized Organization Security Settings Read operation within your permitted scope."
          },
          "update": {
            "label": "Update Organization Security Settings",
            "description": "Perform the authorized Organization Security Settings Update operation within your permitted scope."
          }
        },
        "jurisdiction-settings": {
          "read": {
            "label": "View Organization Jurisdiction Settings",
            "description": "Perform the authorized Organization Jurisdiction Settings Read operation within your permitted scope."
          },
          "update": {
            "label": "Update Organization Jurisdiction Settings",
            "description": "Perform the authorized Organization Jurisdiction Settings Update operation within your permitted scope."
          }
        },
        "support-access": {
          "read": {
            "label": "View Organization Support Access",
            "description": "Perform the authorized Organization Support Access Read operation within your permitted scope."
          },
          "manage": {
            "label": "Manage Organization Support Access",
            "description": "Perform the authorized Organization Support Access Manage operation within your permitted scope."
          }
        }
      },
      "platform": {
        "security-posture": {
          "read": {
            "label": "View Platform Security Posture",
            "description": "Perform the authorized Platform Security Posture Read operation within your permitted scope."
          }
        },
        "data-provider-health": {
          "read": {
            "label": "View Platform Data Provider Health",
            "description": "Perform the authorized Platform Data Provider Health Read operation within your permitted scope."
          }
        },
        "maintenance-delegations": {
          "list": {
            "label": "View Platform Maintenance Delegations",
            "description": "Perform the authorized Platform Maintenance Delegations List operation within your permitted scope."
          },
          "create": {
            "label": "Create Platform Maintenance Delegations",
            "description": "Perform the authorized Platform Maintenance Delegations Create operation within your permitted scope."
          },
          "read": {
            "label": "View Platform Maintenance Delegations",
            "description": "Perform the authorized Platform Maintenance Delegations Read operation within your permitted scope."
          },
          "approve": {
            "label": "Approve Platform Maintenance Delegations",
            "description": "Perform the authorized Platform Maintenance Delegations Approve operation within your permitted scope."
          },
          "revoke": {
            "label": "Revoke Platform Maintenance Delegations",
            "description": "Perform the authorized Platform Maintenance Delegations Revoke operation within your permitted scope."
          }
        }
      }
    },
    "taxRules": {
      "list": {
        "label": "View Organization Tax Rules",
        "description": "Perform the authorized Organization Tax Rules List operation within your permitted scope."
      },
      "read": {
        "label": "View Organization Tax Rules",
        "description": "Perform the authorized Organization Tax Rules Read operation within your permitted scope."
      },
      "create-version": {
        "label": "Perform Organization Tax Rules",
        "description": "Perform the authorized Organization Tax Rules Create Version operation within your permitted scope."
      },
      "submit": {
        "label": "Submit Organization Tax Rules",
        "description": "Perform the authorized Organization Tax Rules Submit operation within your permitted scope."
      },
      "approve": {
        "label": "Approve Organization Tax Rules",
        "description": "Perform the authorized Organization Tax Rules Approve operation within your permitted scope."
      },
      "suspend": {
        "label": "Suspend Organization Tax Rules",
        "description": "Perform the authorized Organization Tax Rules Suspend operation within your permitted scope."
      },
      "retire": {
        "label": "Retire Organization Tax Rules",
        "description": "Perform the authorized Organization Tax Rules Retire operation within your permitted scope."
      },
      "impact-analyze": {
        "label": "Perform Organization Tax Rules",
        "description": "Perform the authorized Organization Tax Rules Impact Analyze operation within your permitted scope."
      }
    },
    "settlement": {
      "instructions": {
        "list": {
          "label": "List settlement instructions",
          "description": "List settlement instructions within the authorized organization scope."
        },
        "get": {
          "label": "View settlement instruction",
          "description": "View one settlement instruction and its current lifecycle state."
        },
        "create": {
          "label": "Create settlement instruction",
          "description": "Create a settlement instruction for an authorized transaction or obligation."
        },
        "confirm": {
          "label": "Confirm settlement instruction",
          "description": "Confirm an eligible settlement instruction under the required assurance controls."
        },
        "correct": {
          "label": "Correct settlement instruction",
          "description": "Correct an eligible settlement instruction while preserving audit history."
        },
        "cancel": {
          "label": "Cancel settlement instruction",
          "description": "Cancel an eligible settlement instruction before completion."
        },
        "availability": {
          "label": "Check settlement availability",
          "description": "Evaluate whether settlement actions are currently available for the authorized scope."
        }
      },
      "failures": {
        "list": {
          "label": "List settlement failures",
          "description": "List failed settlement instructions requiring operational attention."
        }
      }
    }
  },
  "hub": {
    "data": {
      "title": "Data",
      "description": "Manage and review investment, reference, and operational data.",
      "reference": {
        "title": "Reference Data"
      },
      "operational": {
        "title": "Operational Data"
      },
      "exceptions": {
        "title": "Exceptions"
      },
      "facts": {
        "title": "Facts"
      },
      "market": {
        "title": "Market Data"
      },
      "portfolio": {
        "title": "Portfolio"
      },
      "settlement": {
        "title": "Settlement"
      },
      "accounting": {
        "title": "Accounting"
      },
      "compliance": {
        "title": "Compliance"
      },
      "tax": {
        "title": "Tax"
      },
      "documents": {
        "title": "Documents"
      }
    },
    "admin": {
      "title": "Admin",
      "description": "Organization, access, and audit management.",
      "core": {
        "title": "Core Administration"
      },
      "platform": {
        "title": "Platform administration",
        "description": "Manage platform organizations, modules, support access, health, and platform-wide governance."
      },
      "organization": {
        "title": "Organization administration",
        "description": "Manage this organization’s profile, users, roles, clients, portfolios, modules, and audit activity."
      },
      "setupHistory": {
        "title": "Setup History"
      },
      "organizationSetup": {
        "title": "Organization",
        "description": "Maintain organization details, branches, and enabled portfolio capabilities."
      },
      "peopleAccess": {
        "title": "People and access",
        "description": "Manage users, roles, assignments, and operational access."
      },
      "clientPortfolio": {
        "title": "Client and portfolio setup",
        "description": "Onboard clients, configure accounts and portfolios, and maintain settlement instructions."
      },
      "referenceData": {
        "title": "Investment reference data",
        "description": "Maintain instruments and the reference configuration used by portfolio operations."
      },
      "assurance": {
        "title": "Assurance",
        "description": "Review audit evidence and explain effective access decisions."
      }
    }
  },
  "dataHub": {
    "description": "Data hub"
  },
  "page": {
    "users": {
      "title": "Users",
      "description": "Manage users and role assignments.",
      "createTitle": "Create User",
      "editTitle": "Edit User"
    },
    "roles": {
      "title": "Roles",
      "description": "Define assignable roles and permission boundaries.",
      "createTitle": "Create Role",
      "editTitle": "Edit Role"
    },
    "organization": {
      "title": "Organization",
      "description": "Manage organization settings.",
      "detail": {
        "title": "Organization Details"
      },
      "createTitle": "Create organization",
      "editTitle": "Edit organization"
    },
    "organizationGovernance": {
      "title": "Governance and policy controls",
      "description": "Operate versioned accounting, compliance, client, privacy, integration, monetary approval, and risk controls for the active organization."
    },
    "organizationUsers": {
      "title": "Organization Users",
      "description": "Manage users within this organization.",
      "editTitle": "Edit User"
    },
    "organizationRoles": {
      "title": "Organization Roles",
      "description": "Manage roles and permission assignments for this organization.",
      "editTitle": "Edit Role"
    },
    "organizationAudit": {
      "title": "Organization Audit",
      "description": "Review organization-scoped audit events and changes."
    },
    "openingCutover": {
      "title": "Opening Cutover",
      "description": "Initialize portfolio balances and opening positions for start of year."
    },
    "openingCutoverHistory": {
      "title": "Opening Cutover History",
      "description": "Review approved and completed opening cutover batches."
    },
    "taxRules": {
      "title": "Tax Rules",
      "description": "Manage tax rules and effective date versions."
    },
    "feeRules": {
      "title": "Fee Rules",
      "description": "Manage brokerage, SEBON, DP, and other charge rules."
    },
    "audit": {
      "title": "Audit Explorer",
      "description": "Review audit events and changes.",
      "detailTitle": "Audit detail"
    },
    "instruments": {
      "title": "Instruments",
      "description": "Manage instruments and securities.",
      "detail": {
        "title": "Instrument Details"
      }
    },
    "imports": {
      "title": "Imports",
      "description": "Upload and review data imports.",
      "detail": {
        "title": "Import Job Details"
      },
      "rows": {
        "title": "Import Job Rows"
      }
    },
    "reconciliation": {
      "title": "Reconciliation",
      "description": "Reconcile data exceptions.",
      "detail": {
        "title": "Reconciliation Run Details"
      }
    },
    "corporateActions": {
      "title": "Corporate Actions",
      "description": "Dividends, bonuses, and other events.",
      "detail": {
        "title": "Corporate Action Details"
      }
    },
    "holdings": {
      "title": "Current Holdings",
      "description": "Aggregated quantities, cost basis, and market value per instrument — derived from posted transactions and opening balances."
    },
    "factBatches": {
      "title": "Fact Batches",
      "description": "Manage fact batches.",
      "detail": {
        "title": "Fact Batch Details"
      }
    },
    "transactions": {
      "title": "Transactions"
    },
    "reports": {
      "title": "Reports"
    },
    "platformAccessInspector": {
      "title": "Platform Access Inspector",
      "description": "Inspect effective platform-wide access for any user."
    },
    "organizationAccessInspector": {
      "title": "Organization Access Inspector",
      "identity": "Identity context",
      "delegation": "Delegation",
      "permissions": "Permissions",
      "modules": "Enabled modules",
      "accounts": "Account scope",
      "policy": "Persona policy",
      "subject": "Subject user",
      "description": "Inspect effective access for organization users."
    },
    "moduleAssignments": {
      "title": "Module Assignments",
      "description": "Enable, disable, and configure modules for your organization.",
      "createTitle": "Enable Module",
      "editTitle": "Configure Module Assignment"
    },
    "clients": {
      "title": "Clients",
      "description": "Manage client profiles and their status.",
      "createTitle": "Create Client",
      "editTitle": "Edit Client",
      "detailTitle": "Client Details"
    },
    "clientAccounts": {
      "title": "Client Accounts",
      "description": "Manage client accounts and their configuration.",
      "createTitle": "Create Client Account",
      "editTitle": "Edit Client Account",
      "detailTitle": "Client Account Details"
    },
    "portfolios": {
      "title": "Portfolios",
      "description": "Manage portfolio accounts for your organization.",
      "createTitle": "Create Portfolio",
      "editTitle": "Edit Portfolio",
      "detailTitle": "Portfolio Details"
    },
    "permissionAssignments": {
      "title": "Permission Assignments",
      "description": "Assign and revoke role permissions.",
      "editTitle": "Edit permission assignments"
    },
    "platformOrganizations": {
      "title": "Platform Organizations",
      "detail": {
        "title": "Platform Organizations details"
      },
      "description": "Platform Organizations description"
    },
    "platformModules": {
      "title": "Platform Modules",
      "description": "Platform Modules description"
    },
    "platformUsers": {
      "title": "Platform Users",
      "createTitle": "Create platform users",
      "editTitle": "Edit platform users",
      "description": "Platform Users description"
    },
    "platformHealth": {
      "title": "Platform Health",
      "description": "Platform Health description"
    },
    "platformSupportDelegations": {
      "title": "Maintenance delegations",
      "description": "Grant tightly scoped, time-limited maintenance access to approved platform support users.",
      "createTitle": "Create maintenance delegation",
      "detailTitle": "Maintenance delegation details"
    },
    "platformAudit": {
      "title": "Platform Audit",
      "description": "Platform Audit description"
    },
    "organizationPermissionAssignments": {
      "title": "Organization Permission Assignments"
    },
    "securityPosture": {
      "title": "Security Posture",
      "description": "Monitor the platform security posture and access control configuration."
    },
    "dataProviderHealth": {
      "title": "Data Provider Health",
      "description": "Monitor the health and connectivity of market data providers."
    },
    "maintenanceDelegations": {
      "title": "Maintenance Delegations",
      "description": "Manage time-limited maintenance access delegation grants."
    },
    "permissionBundles": {
      "title": "Permission Bundles",
      "description": "Define and manage reusable sets of permissions for role assignment."
    },
    "approvalPolicies": {
      "title": "Approval Policies",
      "description": "Configure multi-level approval workflows for financial operations."
    },
    "supportAccess": {
      "title": "Support Access",
      "description": "Manage support team access grants to organization data."
    },
    "retentionPolicies": {
      "title": "Retention Policies",
      "description": "Configure data retention and archival schedules for the organization."
    },
    "exportPolicies": {
      "title": "Export Policies",
      "description": "Manage authorized data export rules and delivery channels."
    },
    "securitySettings": {
      "title": "Security Settings",
      "description": "Configure organization-level security policies and MFA requirements."
    },
    "regulatoryProfile": {
      "title": "Regulatory Profile",
      "description": "Manage the organization regulatory classification and jurisdiction settings."
    },
    "jurisdictionSettings": {
      "title": "Jurisdiction Settings",
      "description": "Configure applicable jurisdictions and regulatory frameworks for the organization."
    },
    "branches": {
      "title": "Branches",
      "description": "Manage branches within your organization.",
      "createTitle": "Create Branch",
      "editTitle": "Edit Branch",
      "detailTitle": "Branch Details"
    },
    "reportDetail": {
      "title": "Report Detail",
      "description": "View detailed report data with configurable parameters."
    },
    "fiscalYears": {
      "title": "Fiscal Years",
      "description": "Create and manage fiscal years and accounting periods.",
      "createTitle": "Create Fiscal Year",
      "detail": {
        "title": "Fiscal Year"
      },
      "periods": {
        "title": "Fiscal Periods"
      }
    },
    "marketPrices": {
      "detail": {
        "title": "Market data detail"
      }
    }
  },
  "card": {
    "organizationGovernance": "Governance and policy controls",
    "instruments": {
      "title": "Instruments",
      "description": "Manage instruments and securities."
    },
    "transactions": {
      "title": "Transactions",
      "description": "Transaction management."
    },
    "transactionApprovals": {
      "title": "Approvals",
      "description": "Approve pending transactions."
    },
    "transactionReversals": {
      "title": "Reversals",
      "description": "Reverse posted transactions."
    },
    "imports": {
      "title": "Import Evidence",
      "description": "Upload and review imports."
    },
    "corporateActions": {
      "title": "Corporate Actions",
      "description": "Dividends, bonuses, and other events."
    },
    "holdings": {
      "title": "Current Holdings",
      "description": "Aggregated quantities, cost basis, and market value per instrument — derived from posted transactions and opening balances."
    },
    "reconciliation": {
      "title": "Reconciliation",
      "description": "Reconcile exceptions."
    },
    "factBatches": {
      "title": "Fact Batches",
      "description": "Manage fact batches."
    },
    "moduleAssignments": "Module Assignments",
    "clients": "Clients",
    "clientAccounts": "Client Accounts",
    "portfolios": "Portfolios",
    "permissionAssignments": "Permission Assignments",
    "platformUsers": "Platform Users",
    "platformModules": "Platform Modules",
    "platformAudit": "Platform Audit",
    "platformHealth": "Platform Health",
    "platformSupportDelegations": "Platform Support Delegations",
    "marketPrices": {
      "title": "Market Prices & Valuation",
      "description": "Review daily OHLCV market observations and the authoritative prices used for portfolio valuation."
    },
    "fxRates": {
      "title": "FX Rates",
      "description": "View and manage foreign exchange rates."
    },
    "benchmarks": {
      "title": "Benchmarks",
      "description": "View and manage performance benchmarks."
    },
    "marketDataProviders": {
      "title": "Market Data Providers",
      "description": "Configure and monitor market data provider connections."
    },
    "marketDataExceptions": {
      "title": "Market Data Exceptions",
      "description": "Review and resolve market data quality exceptions."
    },
    "clientsData": {
      "title": "Clients",
      "description": "View and manage client data."
    },
    "portfoliosData": {
      "title": "Portfolios",
      "description": "View and manage portfolio data."
    },
    "mandates": {
      "title": "Mandates",
      "description": "View and manage investment mandates."
    },
    "positions": {
      "title": "Positions",
      "description": "Current portfolio positions aggregated by instrument and account, showing quantity, cost, and market value. Positions are the portfolio-management view of the same holdings data."
    },
    "cash": {
      "title": "Cash",
      "description": "Cash balances and movements across client accounts and portfolios, including deposits, withdrawals, fees, and interest."
    },
    "performance": {
      "title": "Performance",
      "description": "View portfolio performance metrics and attribution."
    },
    "compliance": {
      "title": "Compliance",
      "description": "View compliance status and breaches."
    },
    "journals": {
      "title": "Journals",
      "description": "View accounting journals and entries."
    },
    "chartOfAccounts": {
      "title": "Chart of Accounts",
      "description": "View and manage the chart of accounts."
    },
    "fiscalPeriods": {
      "title": "Fiscal Periods",
      "description": "Manage fiscal years and periods."
    },
    "complianceBreaches": {
      "title": "Compliance Breaches",
      "description": "Review and manage investment compliance breaches."
    },
    "riskExposures": {
      "title": "Risk Exposures",
      "description": "View portfolio risk exposure analytics."
    },
    "taxRecords": {
      "title": "Tax Records",
      "description": "View and manage tax records and calculations."
    },
    "settlementInstructions": {
      "title": "Settlement Instructions",
      "description": "View and manage securities settlement instructions."
    },
    "positionTransfers": {
      "title": "Position Transfers",
      "description": "Request and govern in-kind transfers between eligible portfolios for the same client.",
      "empty": "No position transfers found.",
      "saved": "Position transfer updated.",
      "requestFailed": "The position-transfer request could not be completed.",
      "requestEligibilityFailed": "Eligible destination portfolios and lots could not be loaded.",
      "allocations": "Lot allocations",
      "eligibility": "Status: {{status}}. Cash: {{cash}}; disposal: {{disposal}}; tax: {{tax}}; artificial gain: {{artificialGain}}.",
      "columns": {
        "reference": "Reference",
        "instrument": "Instrument",
        "status": "Status",
        "source": "Source portfolio",
        "destination": "Destination portfolio",
        "lots": "Lots",
        "actions": "Actions"
      },
      "fields": {
        "sourcePortfolioAccountId": "Source portfolio ID",
        "destinationPortfolioAccountId": "Destination portfolio ID",
        "businessReference": "Business reference",
        "instrumentSymbol": "Instrument symbol",
        "reason": "Reason",
        "sourceLotId": "Source lot ID",
        "quantity": "Quantity",
        "workflowKind": "Workflow type",
        "id": "Transfer ID",
        "expectedVersion": "Expected version",
        "allocationPlan": "Lot allocation plan"
      },
      "actions": {
        "request": "Request transfer",
        "approve": "Approve",
        "execute": "Execute",
        "cancel": "Cancel",
        "reverse": "Reverse",
        "details": "Details",
        "addAllocation": "Add lot",
        "removeAllocation": "Remove lot"
      },
      "statuses": {
        "REQUESTED": "Requested",
        "APPROVED": "Approved",
        "EXECUTED": "Executed",
        "CANCELLED": "Cancelled",
        "REVERSED": "Reversed"
      }
    },
    "managementFees": {
      "title": "Management Fees",
      "description": "Review eligible managed portfolios and governed fee calculations.",
      "portfolio": "Portfolio",
      "period": "Service period",
      "calculate": "Calculate",
      "reason": "Reason",
      "approve": "Approve",
      "waive": "Waive",
      "invoice": "Issue invoice",
      "pay": "Record payment",
      "credit": "Credit",
      "reverse": "Reverse",
      "updated": "Management fee updated.",
      "requestFailed": "The management fee request could not be completed.",
      "calculationPanel": "Calculation",
      "selectPortfolioFirst": "Select a portfolio first",
      "reasonHelper": "Reason for the fee action",
      "accrualsTitle": "Accruals",
      "noAccruals": "No accruals",
      "noAccrualsDescription": "There are no accruals to display.",
      "invoices": "Invoices"
    },
    "performanceFees": {
      "title": "Performance Fees",
      "description": "Calculate fees only from finalized portfolio valuations and governed external cash flows.",
      "portfolio": "Portfolio",
      "period": "Crystallization period",
      "calculate": "Calculate",
      "approve": "Approve",
      "crystallize": "Crystallize",
      "updated": "Performance fee updated.",
      "requestFailed": "The performance fee request could not be completed.",
      "calculationPanel": "Calculation",
      "periodStart": "Period start",
      "periodEnd": "Period end",
      "calculationsTitle": "Calculations",
      "noCalculations": "No calculations",
      "noCalculationsDescription": "There are no calculations to display."
    },
    "settlement": {
      "title": "Settlement Instructions",
      "failuresTitle": "Settlement Failures",
      "description": "Track external settlement progress without posting the underlying transaction.",
      "empty": "No settlement instructions found.",
      "saved": "Settlement instruction updated.",
      "requestFailed": "The settlement request could not be completed.",
      "availability": "Unsettled quantity: {{unsettledQuantity}}; unsettled cash: {{unsettledCash}}.",
      "columns": {
        "status": "Status",
        "transactionId": "Transaction",
        "expectedQuantity": "Expected quantity",
        "settledQuantity": "Settled quantity",
        "expectedCash": "Expected cash",
        "settledCash": "Settled cash",
        "currency": "Currency",
        "expectedDate": "Expected date",
        "externalReference": "External reference",
        "failureReason": "Failure reason",
        "actions": "Actions"
      },
      "fields": {
        "transactionId": "Transaction ID",
        "expectedQuantity": "Expected quantity",
        "expectedCash": "Expected cash",
        "expectedDate": "Expected date",
        "externalMessageId": "External message ID",
        "sequence": "Sequence",
        "quantity": "Quantity",
        "cash": "Cash",
        "status": "Status",
        "reason": "Reason",
        "workflowKind": "Workflow"
      },
      "actions": {
        "create": "Create instruction",
        "confirm": "Confirm",
        "correct": "Correct",
        "cancel": "Cancel",
        "availability": "Availability"
      },
      "statuses": {
        "PENDING": "Pending",
        "PARTIALLY_SETTLED": "Partially settled",
        "SETTLED": "Settled",
        "FAILED": "Failed",
        "CANCELLED": "Cancelled",
        "CORRECTED": "Corrected"
      }
    },
    "custodyBalances": {
      "title": "Custody Balances",
      "description": "View custody account balances and positions."
    },
    "evidence": {
      "title": "Evidence",
      "description": "View and manage supporting evidence for financial events."
    },
    "branches": "Branches",
    "fiscalCalendar": {
      "title": "Fiscal Calendar",
      "description": "Manage fiscal years, periods, and accounting calendar."
    },
    "fiscalYears": {
      "title": "Fiscal Years",
      "description": "Create and manage fiscal years and their periods."
    }
  },
  "corporateAction": {
    "process": {
      "success": "Corporate action processed successfully"
    }
  },
  "col": {
    "rowData": "Row Data",
    "approvedAt": "Approved At",
    "approvedBy": "Approved By",
    "journalEntryId": "Journal Entry ID",
    "manifestHash": "Manifest Hash",
    "previewedBy": "Previewed By",
    "reversalReason": "Reversal Reason",
    "recoveryQueue": "Recovery Queue",
    "reversedAt": "Reversed At",
    "reversedBy": "Reversed By",
    "supersededByBatchId": "Superseded By Batch ID",
    "supersedesBatchId": "Supersedes Batch ID",
    "totalLines": "Total Lines",
    "errors": "Errors",
    "warnings": "Warnings",
    "importType": "Import Type",
    "sourceFileName": "Source File",
    "symbol": "Symbol",
    "name": "Name",
    "firstName": "First Name",
    "lastName": "Last Name",
    "isin": "ISIN",
    "assetType": "Asset Type",
    "runId": "Run ID",
    "businessReference": "Business Reference",
    "sourcePortfolioAccountId": "Source Portfolio",
    "destinationPortfolioAccountId": "Destination Portfolio",
    "transactionId": "Transaction ID",
    "expectedQuantity": "Expected Quantity",
    "settledQuantity": "Settled Quantity",
    "expectedCash": "Expected Cash",
    "settledCash": "Settled Cash",
    "expectedDate": "Expected Date",
    "failureReason": "Failure Reason",
    "reason": "Reason",
    "status": "Status",
    "startedAt": "Started At",
    "completedAt": "Completed At",
    "id": "ID",
    "type": "Type",
    "date": "Date",
    "email": "Email",
    "mfa": "MFA",
    "roles": "Roles",
    "orgTenant": "Org / Branch",
    "userType": "User Type",
    "system": "System",
    "quantity": "Quantity",
    "avgCost": "Avg Cost",
    "marketPrice": "Market Price",
    "marketValue": "Market Value",
    "valuation": "Valuation",
    "valuationAsOf": "Valuation As Of",
    "unrealizedPnl": "Unrealized P&L",
    "unrealizedGainLoss": "Unrealized Gain/Loss",
    "lots": "Lots",
    "change": "Change",
    "reportId": "Report ID",
    "reportDefinitionId": "Report Definition ID",
    "reportingPeriodStart": "Period Start",
    "reportingPeriodEnd": "Period End",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "currentBalance": "Current Balance",
    "sourceBatchId": "Source Batch ID",
    "price": "Price",
    "grossAmount": "Gross amount",
    "instrument": "Instrument",
    "actionType": "Action Type",
    "currency": "Currency",
    "clientCode": "Client Code",
    "clientName": "Client Name",
    "marketValueCurrency": "Market Value Currency",
    "sourceState": "Source State",
    "valuationFreshness": "Valuation Freshness",
    "valuationSource": "Valuation Source",
    "difference": "Difference",
    "displayName": "Name",
    "errorCount": "Errors",
    "exDate": "Ex-Date",
    "exchange": "Exchange",
    "generatedAt": "Generated At",
    "instrumentSymbol": "Instrument Symbol",
    "isSystem": "System",
    "matchedRecords": "Matched",
    "mfaEnabled": "MFA Enabled",
    "payDate": "Pay Date",
    "pricePerUnit": "Price/Unit",
    "recordCount": "Records",
    "recordDate": "Record Date",
    "resolved": "Resolved",
    "resolvedAt": "Resolved At",
    "resolvedBy": "Resolved By",
    "rowNumber": "Row",
    "sourceValue": "Source Value",
    "targetValue": "Target Value",
    "branchId": "Branch ID",
    "totalRecords": "Total",
    "totalAmount": "Total Amount",
    "transactionDate": "Transaction Date",
    "transactionType": "Transaction Type",
    "unmatchedRecords": "Unmatched",
    "userTypeId": "User Type",
    "validationErrors": "Validation Errors",
    "warningCount": "Warnings",
    "code": "Code",
    "isDefault": "Default",
    "module": "Module",
    "configurationVersionId": "Configuration Version",
    "version": "Version",
    "fullName": "Full Name",
    "accountType": "Account Type",
    "isActive": "Active",
    "client": "Client",
    "custodyAccount": "Custody Account",
    "accountNumber": "Account Number",
    "baseCurrency": "Base Currency",
    "strategy": "Strategy",
    "ownerType": "Owner Type",
    "ownerClientAccountId": "Owner Client Account",
    "boId": "BO ID",
    "dpCode": "DP Code",
    "clientType": "Client Type",
    "action": "Action",
    "asOfDate": "As Of Date",
    "availableQuantity": "Available Quantity",
    "breachType": "Breach Type",
    "breachValue": "Breach Value",
    "severity": "Severity",
    "calculationVersion": "Calculation Version",
    "capitalGain": "Capital Gain",
    "clientAccountId": "Client Account",
    "concentrationPct": "Concentration %",
    "costBasis": "Cost Basis",
    "description": "Description",
    "detectedAt": "Detected At",
    "endDate": "End Date",
    "entityId": "Entity ID",
    "entityType": "Entity Type",
    "fiscalYear": "Fiscal Year",
    "fiscalYearName": "Fiscal Year",
    "holdingPeriodDays": "Holding Period Days",
    "instrumentId": "Instrument ID",
    "instrumentName": "Instrument Name",
    "instrumentType": "Instrument Type",
    "isLocked": "Locked",
    "journalDate": "Journal Date",
    "kind": "Kind",
    "lastUpdated": "Last Updated",
    "limitValue": "Limit Value",
    "membershipStatus": "Membership Status",
    "periodNumber": "Period Number",
    "portfolioAccountId": "Portfolio Account",
    "realizedGain": "Realized Gain",
    "reference": "Reference",
    "riskMeasure": "Risk Measure",
    "ruleId": "Rule ID",
    "ruleVersion": "Rule Version",
    "saleDate": "Sale Date",
    "sector": "Sector",
    "securityName": "Security Name",
    "sourceAuthority": "Source Authority",
    "sourceBook": "Source Book",
    "startDate": "Start Date",
    "taxAmount": "Tax Amount",
    "taxDomain": "Tax Domain",
    "taxRate": "Tax Rate",
    "totalCost": "Total Cost",
    "totalCredit": "Total Credit",
    "totalDebit": "Total Debit",
    "totalQuantity": "Total Quantity",
    "unrealizedGain": "Unrealized Gain",
    "userEmail": "User Email",
    "weightedAverageCost": "Weighted Average Cost",
    "jurisdiction": "Jurisdiction",
    "assignedModules": "Modules",
    "branchCount": "Branches",
    "parentBranchId": "Parent Branch",
    "parentBranchName": "Parent Branch",
    "portfolioAccountNumber": "Portfolio account",
    "effectiveFrom": "Effective From",
    "entryDate": "Entry Date",
    "entryNumber": "Entry Number",
    "expectedUpdatedAt": "Expected Update At",
    "externalReference": "External Reference",
    "maxBranches": "Max Branches",
    "maxUsers": "Max Users",
    "narration": "Narration",
    "organizationCode": "Organization Code",
    "organizationName": "Organization Name",
    "permission": "Permission",
    "persona": "Persona",
    "resource": "Resource",
    "resourceScope": "Resource Scope",
    "roleCode": "Role Code",
    "yearCode": "Year code",
    "isClosed": "Closed",
    "branchName": "Branch",
    "lastLoginAt": "Last Login",
    "legalName": "Legal Name",
    "componentSummary": "Fee Components",
    "phone": "Phone",
    "panNumber": "PAN Number",
    "address": "Address",
    "mandateStartDate": "Mandate Start",
    "mandateEndDate": "Mandate End",
    "commission": "Commission",
    "sebonFee": "SEBON Fee",
    "dpCharges": "DP Charges",
    "declarationDate": "Declaration Date",
    "ratioNumerator": "Ratio Numerator",
    "ratioDenominator": "Ratio Denominator",
    "cashRate": "Cash Rate",
    "fiscalYearId": "Fiscal Year",
    "postedAt": "Posted At",
    "reversalOf": "Reversal Of",
    "clientAccountName": "Client",
    "totalCharges": "Total charges",
    "postingStatus": "Posting status"
  },
  "role": {
    "add": "Add Role",
    "create": "Create Role",
    "edit": "Edit Role",
    "delete": "Delete Role",
    "confirmDeleteTitle": "Delete role?",
    "confirmDelete": "Are you sure you want to delete this role?",
    "deleteSuccess": "Role disabled successfully"
  },
  "field": {
    "txnType": "Transaction Type",
    "transactionDate": "Transaction Date",
    "settlementDate": "Settlement Date",
    "instrumentSymbol": "Instrument",
    "quantity": "Quantity",
    "pricePerUnit": "Price Per Unit",
    "currency": "Currency",
    "accountId": "Client Account",
    "portfolioId": "Portfolio",
    "commission": "Commission",
    "sebonFee": "SEBON Fee",
    "dpCharge": "DP Charge",
    "externalReference": "External Reference",
    "notes": "Notes",
    "role": {
      "name": "Role name",
      "code": "Role code",
      "description": "Description",
      "permissions": "Permissions",
      "expectedVersion": "Expected version",
      "status": "Status"
    },
    "user": {
      "email": "Email",
      "firstName": "First name",
      "lastName": "Last name",
      "password": "Password",
      "expectedVersion": "Expected version",
      "roles": "Roles",
      "status": "Status",
      "branchId": "Branch",
      "clientAccountId": "Client Account"
    },
    "instrument": {
      "symbol": "Symbol",
      "instrumentName": "Instrument name",
      "securityName": "Security name",
      "isin": "ISIN",
      "currency": "Currency",
      "exchange": "Exchange",
      "sector": "Sector",
      "instrumentType": "Instrument type",
      "status": "Status"
    },
    "clientAccount": {
      "code": "Client code",
      "fullName": "Full name",
      "email": "Email",
      "phone": "Phone",
      "panNumber": "PAN number",
      "accountType": "Account type",
      "isActive": "Active",
      "notes": "Notes"
    },
    "clientCustodyAccount": {
      "clientAccountId": "Client",
      "expectedVersion": "Record version",
      "accountNumber": "Custody account number",
      "accountType": "Custody account type",
      "baseCurrency": "Base currency",
      "isDefault": "Default account",
      "isActive": "Active"
    },
    "branch": {
      "code": "Code",
      "name": "Name",
      "address": "Address",
      "status": "Status",
      "expectedUpdatedAt": "Record version",
      "locale": "Locale",
      "timeZone": "Time Zone",
      "isDefault": "Default branch",
      "parentBranchId": "Parent Branch",
      "parentBranchName": "Parent Branch",
      "disableReason": "Reason for disabling this branch"
    },
    "organization": {
      "code": "Code",
      "name": "Name",
      "legalName": "Legal name",
      "jurisdiction": "Jurisdiction",
      "locale": "Locale",
      "timeZone": "Time Zone",
      "modules": "Modules",
      "baseCurrency": "Base Currency",
      "adminEmail": "Owner Email",
      "adminPassword": "Initial Owner Password",
      "status": "Status",
      "assignedModules": "Assigned Modules",
      "branchCount": "Branch Count",
      "defaultBranchCode": "Default Branch Code",
      "defaultBranchName": "Default Branch Name",
      "expectedVersion": "Expected version",
      "panNumber": "Permanent Account Number (PAN)",
      "sebonRegistrationNumber": "SEBON registration number",
      "regulatoryProfileReady": "Regulatory filing profile ready"
    },
    "client": {
      "expectedUpdatedAt": "Record version",
      "code": "Code",
      "fullName": "Full Name",
      "email": "Email",
      "phone": "Phone",
      "panNumber": "PAN Number",
      "accountType": "Account Type",
      "isActive": "Active",
      "notes": "Notes",
      "branchId": "Branch"
    },
    "portfolioAccount": {
      "accountNumber": "Account number",
      "boId": "BOID",
      "dpCode": "DP code",
      "ownerType": "Owner type",
      "ownerClientAccountId": "Owner client account",
      "isDefault": "Default portfolio",
      "isActive": "Active"
    },
    "portfolio": {
      "custodyAccountId": "Custody Account",
      "name": "Portfolio Name",
      "baseCurrency": "Base Currency",
      "strategy": "Strategy",
      "mandateStartDate": "Mandate Start Date",
      "mandateEndDate": "Mandate End Date",
      "status": "Status"
    },
    "module": {
      "module": "Module",
      "configurationVersionId": "Configuration Version",
      "expectedVersion": "Expected Version"
    },
    "transaction": {
      "status": "Status",
      "transactionNumber": "Transaction Number",
      "totalAmount": "Total Amount"
    },
    "reconciliationRun": {
      "reconciliationDate": "Reconciliation Date",
      "runType": "Run Type",
      "statements": "External Statements",
      "matchThreshold": "Match Threshold",
      "amountTolerance": "Amount Tolerance"
    },
    "importJob": {
      "importType": "Import Type",
      "sourceFileName": "Source File Name",
      "sourceSheetName": "Source Sheet Name",
      "csv": "CSV Data",
      "idempotencyKey": "Idempotency Key"
    },
    "corporateAction": {
      "actionType": "Action Type",
      "recordDate": "Record Date",
      "exDate": "Ex-Date",
      "declarationDate": "Declaration Date",
      "bookCloseDate": "Book Close Date",
      "payDate": "Pay Date",
      "fiscalYear": "Fiscal Year",
      "ratioNumerator": "Ratio Numerator",
      "ratioDenominator": "Ratio Denominator",
      "cashRate": "Cash Rate",
      "rightPrice": "Right Price",
      "replacementInstrumentSymbol": "Replacement Instrument Symbol",
      "sourceReference": "Source Reference",
      "status": "Status",
      "cancellationReason": "Cancellation Reason"
    },
    "data": {
      "instrument": {
        "expectedVersion": "Expected version"
      }
    },
    "platformModule": {
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "graceEndsAt": "Grace ends at",
      "maxBranches": "Maximum branches",
      "maxUsers": "Maximum users",
      "module": "Module",
      "organizationId": "Organization ID"
    },
    "platformUser": {
      "email": "Email",
      "expectedVersion": "Expected version",
      "firstName": "First name",
      "lastName": "Last name",
      "password": "Password",
      "roleCode": "Role code",
      "status": "Status"
    }
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "locked": "Locked",
    "suspended": "Suspended",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "success": "SUCCESS",
    "pending": "Pending",
    "failed": "FAILED",
    "open": "Open",
    "closed": "Closed",
    "elected": "Elected",
    "allocated": "Allocated",
    "expired": "Expired",
    "ok": "OK",
    "unknown": "Unknown",
    "unhealthy": "Unhealthy",
    "cancelled": "Cancelled",
    "critical": "Critical",
    "warning": "Warning",
    "info": "Info",
    "draft": "Draft",
    "submitted": "Submitted",
    "approved": "Approved",
    "posted": "Posted",
    "rejected": "Rejected",
    "withdrawn": "Withdrawn",
    "reversed": "Reversed",
    "completed": "Completed",
    "planned": "Planned",
    "degraded": "Degraded",
    "stale": "Stale",
    "partial": "Partial",
    "investigating": "Investigating",
    "resolved": "Resolved",
    "adjusted": "Adjusted",
    "ignored": "Ignored"
  },
  "txnType": {
    "purchase": "Purchase",
    "sale": "Sale",
    "bonusShare": "Bonus Share",
    "rightShare": "Right Share",
    "split": "Split",
    "merger": "Merger",
    "transferIn": "Transfer In",
    "transferOut": "Transfer Out",
    "cashDeposit": "Cash Deposit",
    "cashWithdrawal": "Cash Withdrawal",
    "fee": "Fee",
    "tax": "Tax",
    "interest": "Interest",
    "marginInterest": "Margin Interest",
    "correction": "Correction",
    "reversal": "Reversal"
  },
  "permission": {
    "readUsers": "Read Users",
    "manageUsers": "Manage Users",
    "readRoles": "Read Roles",
    "manageRoles": "Manage Roles"
  },
  "reconciliationRun": {
    "runType": {
      "funding": "Funding",
      "position": "Position",
      "cash": "Cash"
    }
  },
  "importJob": {
    "type": {
      "transaction": "Transaction",
      "instrument": "Instruments",
      "marketData": "Market prices",
      "custodyPosition": "Custody position",
      "openingCutover": "Opening cutover",
      "taxRule": "Tax rule",
      "fact": "Fact",
      "corporateAction": "Corporate actions",
      "feeRule": "Fee rules"
    },
    "corporateAction": {
      "actionType": "Action type",
      "recordDate": "Record date",
      "declarationDate": "Declaration date",
      "bookCloseDate": "Book-close date",
      "exDate": "Ex-date",
      "fiscalYear": "Fiscal year",
      "ratioNumerator": "Ratio numerator",
      "ratioDenominator": "Ratio denominator",
      "cashRate": "Cash rate",
      "rightPrice": "Right price",
      "replacementInstrumentSymbol": "Replacement instrument"
    }
  },
  "user": {
    "add": "Add User",
    "confirmDeleteTitle": "Disable user?",
    "confirmDelete": "Are you sure you want to disable this user?",
    "delete": "Disable",
    "deleteSuccess": "User disabled successfully",
    "action": {
      "unlock": "Unlock",
      "forcePasswordReset": "Force password reset",
      "mfaRequireEnrollment": "Require MFA",
      "mfaResetEnrollment": "Reset MFA",
      "mfaDisable": "Disable MFA",
      "reasonLabel": "Reason"
    },
    "confirmUnlockTitle": "Unlock user?",
    "confirmUnlock": "Clear the failed-login lockout for this user so they can sign in again?",
    "unlockSuccess": "User unlocked successfully",
    "confirmForcePasswordResetTitle": "Force password reset?",
    "confirmForcePasswordReset": "Reset this user's password and sign them out? They will receive a one-time reset token.",
    "forcePasswordResetSuccess": "Password reset forced successfully",
    "confirmMfaRequireEnrollmentTitle": "Require MFA enrollment?",
    "confirmMfaRequireEnrollment": "Require this user to enroll in MFA at their next sign-in? Their active sessions will be revoked.",
    "mfaRequireEnrollmentSuccess": "MFA enrollment required successfully",
    "confirmMfaResetEnrollmentTitle": "Reset MFA enrollment?",
    "confirmMfaResetEnrollment": "Remove this user's MFA credential and requirement? They will need to re-enroll. Active sessions will be revoked.",
    "mfaResetEnrollmentSuccess": "MFA enrollment reset successfully",
    "confirmMfaDisableTitle": "Disable MFA?",
    "confirmMfaDisable": "Disable MFA for this user? Their MFA credential and recovery codes will be removed and active sessions revoked.",
    "mfaDisableSuccess": "MFA disabled successfully"
  },
  "maintenanceDelegations": {
    "actions": {
      "enter": "Enter delegation",
      "revoke": "Revoke",
      "confirmRevoke": "Confirm revoke delegation",
      "create": "Create delegation"
    },
    "title": "Support Delegations",
    "description": "View and manage time-limited maintenance access delegation grants.",
    "createTitle": "Create Delegation",
    "createDescription": "Grant time-limited maintenance access to a support principal for this organization.",
    "revokeTitle": "Revoke Delegation",
    "revokeDescription": "Revoke this maintenance delegation grant immediately. Active sessions using this delegation will lose access.",
    "viewTitle": "View Delegation",
    "viewDescription": "View the details of this maintenance delegation grant.",
    "capability": {
      "ORG_ACCESS_INSPECT": "Org Access Inspect",
      "ORG_AUDIT_VIEW": "Org Audit View",
      "ORG_CONFIG_MANAGE": "Org Config Manage",
      "ORG_CONFIG_VIEW": "Org Config View",
      "ORG_DATA_CORRECT": "Org Data Correct",
      "ORG_DATA_VIEW": "Org Data View",
      "ORG_FINANCIAL_EXPORT": "Org Financial Export",
      "ORG_IDENTITY_MANAGE": "Org Identity Manage",
      "ORG_IDENTITY_VIEW": "Org Identity View",
      "ORG_IMPORT_RETRY": "Org Import Retry",
      "ORG_LEGAL_HOLD_MANAGE": "Org Legal Hold Manage",
      "ORG_RECONCILIATION_MANAGE": "Org Reconciliation Manage",
      "ORG_RECONCILIATION_VIEW": "Org Reconciliation View",
      "ORG_REPORT_RUN": "Org Report Run",
      "ORG_REPORT_VIEW": "Org Report View"
    },
    "fields": {
      "allowedOperationIds": "Allowed operations",
      "capabilities": "Capabilities",
      "effectiveFrom": "Effective from",
      "expiresAt": "Expires at",
      "justification": "Justification",
      "policyVersion": "Policy version",
      "purpose": "Purpose",
      "reason": "Reason",
      "requiredAal": "Required AAL",
      "resourceIds": "Resource IDs",
      "sessionEndedAt": "Session ended at",
      "sessionStartedAt": "Session started at",
      "status": "Status",
      "supportUserIdentityId": "Support user identity",
      "targetBranchId": "Target branch",
      "targetClientAccountId": "Target client account",
      "targetOrganizationId": "Target organization",
      "targetPortfolioAccountId": "Target portfolio account",
      "ticketReference": "Ticket reference"
    },
    "help": {
      "allowedOperationIds": "Operation IDs this delegation permits.",
      "capabilities": "Capabilities granted to the support principal.",
      "effectiveFrom": "When the delegation becomes active.",
      "expiresAt": "When the delegation expires.",
      "justification": "Justification for the delegation.",
      "purpose": "Purpose of the maintenance delegation.",
      "reason": "Reason for the delegation.",
      "resourceIds": "Resource IDs scoped to this delegation.",
      "supportUserIdentityId": "Support user identity for this delegation.",
      "targetBranchId": "Target branch for this delegation.",
      "targetClientAccountId": "Target client account for this delegation.",
      "targetOrganizationId": "Target organization for this delegation.",
      "targetPortfolioAccountId": "Target portfolio account for this delegation.",
      "ticketReference": "Support ticket reference."
    },
    "purpose": {
      "ACCESS_TROUBLESHOOTING": "Access Troubleshooting",
      "AUDIT_SUPPORT": "Audit Support",
      "CALCULATION_DEFECT_INVESTIGATION": "Calculation Defect Investigation",
      "CONFIGURATION_CORRECTION": "Configuration Correction",
      "DATA_MIGRATION": "Data Migration",
      "FAILED_IMPORT_INVESTIGATION": "Failed Import Investigation",
      "MARKET_DATA_MAPPING_REPAIR": "Market Data Mapping Repair",
      "ORGANIZATION_ADMINISTRATION_ASSISTANCE": "Organization Administration Assistance",
      "PRODUCTION_REMEDIATION_VALIDATION": "Production Remediation Validation",
      "RECONCILIATION_SUPPORT": "Reconciliation Support"
    }
  },
  "session": {
    "compromised": {
      "message": "Your session may be compromised. Please log out and log in again."
    },
    "degraded": {
      "message": "Some features may be unavailable due to session issues."
    },
    "noWorkspace": {
      "title": "No Available Workspace",
      "message": "No workspace available."
    }
  },
  "intents": {
    "transaction": {
      "list": {
        "label": "Transactions",
        "description": "Review transaction activity"
      },
      "approvals": {
        "label": "Pending approvals",
        "description": "Review and approve pending transactions"
      },
      "reversals": {
        "label": "Reversals",
        "description": "Review and reverse posted transactions"
      }
    },
    "instrument": {
      "list": {
        "label": "Instruments",
        "description": "Browse reference instruments"
      }
    },
    "import": {
      "list": {
        "label": "Import jobs",
        "description": "Review and upload data imports"
      }
    },
    "corporateAction": {
      "list": {
        "label": "Corporate actions",
        "description": "Review corporate action events"
      }
    },
    "reconciliation": {
      "list": {
        "label": "Reconciliation runs",
        "description": "Review reconciliation runs and breaks"
      },
      "suspenseCash": {
        "caseCreate": {
          "label": "Ingest unidentified cash case",
          "description": "Record an unallocated receipt or payment in the suspense cash control."
        },
        "caseList": {
          "label": "List unidentified cash cases",
          "description": "Review scoped unresolved cash cases and their escalation state."
        },
        "resolutionRequest": {
          "label": "Request unidentified cash resolution",
          "description": "Submit evidence-backed allocation or refund resolution for independent approval."
        },
        "resolutionApprove": {
          "label": "Approve unidentified cash resolution",
          "description": "Independently approve an evidence-backed unidentified cash resolution."
        },
        "reopenRequest": {
          "label": "Request unidentified cash reopening",
          "description": "Request a correction to a resolved unidentified cash allocation."
        },
        "reopenApprove": {
          "label": "Approve unidentified cash reopening",
          "description": "Independently approve a correction that reverses a resolved allocation."
        }
      }
    },
    "factBatch": {
      "list": {
        "label": "Fact batches",
        "description": "Review fact batch ingestions"
      }
    },
    "dataHoldings": {
      "list": {
        "label": "Holdings",
        "description": "Review portfolio holdings"
      }
    },
    "admin": {
      "users": {
        "label": "Users",
        "description": "Manage organization users"
      },
      "roles": {
        "label": "Roles",
        "description": "Manage roles and permissions"
      },
      "organization": {
        "label": "Organization",
        "description": "View and edit organization details"
      },
      "audit": {
        "label": "Audit Explorer",
        "description": "Review immutable audit logs"
      }
    }
  },
  "actions": {
    "admin": {
      "users": {
        "create": {
          "label": "Create user"
        },
        "update": {
          "label": "Edit user"
        },
        "delete": {
          "label": "Delete user"
        }
      },
      "roles": {
        "create": {
          "label": "Create role"
        },
        "update": {
          "label": "Edit role"
        },
        "delete": {
          "label": "Delete role"
        }
      },
      "organization": {
        "edit": {
          "label": "Edit organization"
        }
      },
      "audit": {
        "export": {
          "label": "Export audit log"
        }
      }
    }
  },
  "enum": {
    "locale": {
      "en-US": "English (United States)",
      "ne-NP": "Nepali (Nepal)"
    },
    "timeZone": {
      "Asia_Kathmandu": "Asia/Kathmandu",
      "Asia_Singapore": "Asia/Singapore",
      "UTC": "UTC"
    },
    "status": {
      "PENDING": "Pending",
      "RUNNING": "Running",
      "COMPLETED": "Completed",
      "FAILED": "Failed",
      "PROCESSING": "Processing"
    },
    "corporateActionType": {
      "DIVIDEND": "Dividend",
      "INTEREST": "Interest income",
      "BONUS": "Bonus",
      "RIGHTS_ISSUE": "Rights issue",
      "SPLIT": "Stock split",
      "CONSOLIDATION": "Share consolidation",
      "MERGER": "Merger",
      "SPINOFF": "Spinoff"
    },
    "corporateActionStatus": {
      "DRAFT": "Draft",
      "ANNOUNCED": "Announced",
      "PROCESSING": "Processing",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "importJobStatus": {
      "PENDING": "Pending",
      "PREVIEWING": "Previewing",
      "PREVIEWED": "Previewed",
      "COMMITTING": "Committing",
      "COMMITTED": "Committed",
      "FAILED": "Failed",
      "PARTIAL": "Partial",
      "RECOVERING": "Recovering"
    },
    "reconciliationStatus": {
      "PENDING": "Pending",
      "IN_PROGRESS": "In progress",
      "COMPLETED": "Completed",
      "FAILED": "Failed"
    },
    "positionTransferStatus": {
      "REQUESTED": "Requested",
      "APPROVED": "Approved",
      "EXECUTED": "Executed",
      "CANCELLED": "Cancelled",
      "REVERSED": "Reversed"
    },
    "settlementInstructionStatus": {
      "PENDING": "Pending",
      "PARTIALLY_SETTLED": "Partially settled",
      "SETTLED": "Settled",
      "FAILED": "Failed",
      "CANCELLED": "Cancelled",
      "CORRECTED": "Corrected"
    },
    "caType": {
      "DIVIDEND": "Dividend",
      "INTEREST": "Interest income",
      "BONUS": "Bonus",
      "SPLIT": "Split",
      "CONSOLIDATION": "Share consolidation",
      "MERGER": "Merger",
      "SPINOFF": "Spinoff",
      "RIGHTS_ISSUE": "Rights Issue"
    },
    "caStatus": {
      "DRAFT": "Draft",
      "ANNOUNCED": "Announced",
      "PROCESSING": "Processing",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "importType": {
      "TRANSACTIONS": "Transactions",
      "HOLDINGS": "Holdings",
      "INSTRUMENTS": "Instruments",
      "CLIENTS": "Clients",
      "CORPORATE_ACTIONS": "Corporate Actions",
      "INSTRUMENT": "Instrument",
      "TRANSACTION": "Transaction",
      "MARKET_DATA": "Market data",
      "FACT": "Fact",
      "CORPORATE_ACTION": "Corporate action",
      "CUSTODY_POSITION": "Custody position",
      "OPENING_CUTOVER": "Opening cutover",
      "TAX_RULE": "Tax rule"
    },
    "importStatus": {
      "PENDING": "Pending",
      "PREVIEWING": "Previewing",
      "PREVIEWED": "Previewed",
      "COMMITTING": "Committing",
      "COMMITTED": "Committed",
      "FAILED": "Failed"
    },
    "rowStatus": {
      "VALID": "Valid",
      "INVALID": "Invalid",
      "WARNING": "Warning"
    },
    "assetType": {
      "EQUITY": "Equity",
      "BOND": "Bond",
      "FUND": "Fund",
      "ETF": "Etf",
      "DERIVATIVE": "Derivative",
      "CRYPTO": "Crypto",
      "CASH": "Cash"
    },
    "instrumentType": {
      "EQUITY": "Equity",
      "DEBT": "Debt",
      "MUTUAL_FUND": "Mutual Fund",
      "PROMISSORY_NOTE": "Promissory Note"
    },
    "instrumentStatus": {
      "ACTIVE": "Active",
      "CLOSED": "Closed",
      "INACTIVE": "Inactive",
      "DELISTED": "Delisted",
      "SUSPENDED": "Suspended"
    },
    "orgStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "SUSPENDED": "Suspended"
    },
    "userStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "SUSPENDED": "Suspended",
      "PENDING": "Pending",
      "LOCKED": "Locked"
    },
    "userType": {
      "ADMIN": "Admin",
      "USER": "User",
      "CLIENT": "Client"
    },
    "roleStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive"
    },
    "reconStatus": {
      "PENDING": "Pending",
      "RUNNING": "Running",
      "COMPLETED": "Completed",
      "FAILED": "Failed"
    },
    "factStatus": {
      "PENDING": "Pending",
      "PROCESSING": "Processing",
      "COMPLETED": "Completed",
      "FAILED": "Failed"
    },
    "reportStatus": {
      "GENERATING": "Generating",
      "COMPLETED": "Completed",
      "FAILED": "Failed"
    },
    "recStatus": {
      "MATCHED": "Matched",
      "MISMATCH": "Mismatch",
      "MISSING_SOURCE": "Missing Source",
      "MISSING_TARGET": "Missing Target"
    },
    "txnType": {
      "PURCHASE": "Purchase",
      "SALE": "Sale",
      "BONUS_SHARE": "Bonus Share",
      "RIGHT_SHARE": "Right Share",
      "BUY": "Buy",
      "SELL": "Sell",
      "DIVIDEND": "Dividend",
      "SPLIT": "Split",
      "MERGER": "Merger",
      "FEE": "Fee",
      "TAX": "Tax",
      "TRANSFER_IN": "Transfer In",
      "TRANSFER_OUT": "Transfer Out"
    },
    "txnStatus": {
      "DRAFT": "Draft",
      "SUBMITTED": "Submitted",
      "PENDING_APPROVAL": "Pending Approval",
      "APPROVED": "Approved",
      "POSTED": "Posted",
      "REJECTED": "Rejected",
      "WITHDRAWN": "Withdrawn",
      "REVERSED": "Reversed",
      "ROLLED_BACK": "Rolled Back"
    },
    "module": {
      "ACCOUNTING": "Accounting",
      "ADMIN": "Admin",
      "AUTH": "Auth",
      "CORPORATE_ACTIONS": "Corporate Actions",
      "DASHBOARD": "Dashboard",
      "DATA": "Data",
      "FACTS": "Facts",
      "HOLDINGS": "Holdings",
      "IMPORT": "Import",
      "INSTRUMENTS": "Instruments",
      "INVESTMENT": "Investment",
      "MARKET_DATA": "Market Data",
      "NAVIGATION": "Navigation",
      "RECONCILIATION": "Reconciliation",
      "REGULATORY": "Regulatory",
      "REPORTING": "Reporting",
      "SETTINGS": "Settings",
      "TAX": "Tax"
    },
    "postingStatus": {
      "NOT_POSTED": "Not posted",
      "POSTING": "Posting",
      "POSTED": "Posted",
      "FAILED": "Posting failed",
      "REVERSED": "Reversed"
    },
    "calendarSystem": {
      "AD": "Gregorian (AD)",
      "BS": "Bikram Sambat (BS)",
      "DUAL": "Dual (BS / AD)"
    }
  },
  "validation": {
    "required": "This field is required",
    "min": "Minimum value is {{min}}",
    "max": "Maximum value is {{max}}",
    "minLength": "Minimum length is {{min}}",
    "maxLength": "Maximum length is {{max}}",
    "integer": "Must be a whole number",
    "decimalPrecision": "Maximum {{precision}} decimal places allowed",
    "email": "Invalid email address",
    "url": "Invalid URL",
    "pattern": "This field does not match the required pattern.",
    "allowedValues": "Must be one of: {{values}}",
    "dateMin": "Date must be on or after {{minDate}}",
    "dateMax": "Date must be on or before {{maxDate}}",
    "fileType": "File type must be: {{accepted}}",
    "fileSize": "File size exceeds {{maxBytes}} bytes",
    "branchParentActive": "The parent branch must be active",
    "patternFiscalYear": "Use the YYYY/YY format (for example, 2082/83).",
    "organizationPan": "PAN must contain exactly nine digits."
  },
  "opt": {
    "clientCustodyAccountType": {
      "CUSTODY": "Custody",
      "DEMAT": "Demat",
      "BROKERAGE": "Brokerage"
    },
    "clientAccountType": {
      "INDIVIDUAL": "Individual",
      "INSTITUTIONAL": "Institutional"
    },
    "txnType": {
      "PURCHASE": "Purchase",
      "SALE": "Sale",
      "BONUS_SHARE": "Bonus Share",
      "RIGHT_SHARE": "Right Share",
      "SPLIT": "Split",
      "MERGER": "Merger",
      "TRANSFER_IN": "Transfer In",
      "TRANSFER_OUT": "Transfer Out",
      "CASH_DEPOSIT": "Cash Deposit",
      "CASH_WITHDRAWAL": "Cash Withdrawal",
      "FEE": "Fee",
      "TAX": "Tax",
      "INTEREST": "Interest",
      "MARGIN_INTEREST": "Margin Interest",
      "CORRECTION": "Correction",
      "REVERSAL": "Reversal"
    },
    "status": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "LOCKED": "Locked",
      "SUSPENDED": "Suspended",
      "CLOSED": "Closed"
    },
    "instrumentType": {
      "EQUITY": "Equity",
      "DEBT": "Debt",
      "MUTUAL_FUND": "Mutual Fund",
      "PROMISSORY_NOTE": "Promissory Note"
    },
    "accountType": {
      "INDIVIDUAL": "Individual",
      "JOINT": "Joint",
      "CORPORATE": "Corporate",
      "TRUST": "Trust",
      "NRI": "NRI"
    },
    "ownerType": {
      "CLIENT": "Client",
      "ORGANIZATION": "Organization"
    },
    "txnStatus": {
      "DRAFT": "Draft",
      "SUBMITTED": "Submitted",
      "APPROVED": "Approved",
      "POSTED": "Posted",
      "REJECTED": "Rejected",
      "REVERSED": "Reversed"
    },
    "boolean": {
      "true": "Yes",
      "false": "No"
    },
    "importType": {
      "TRANSACTION": "Transaction",
      "INSTRUMENT": "Instrument",
      "FACT": "Fact",
      "MARKET_DATA": "Market data"
    },
    "runType": {
      "FUNDING": "Funding",
      "POSITION": "Position",
      "CASH": "Cash"
    },
    "permission": {
      "ACCESS_READ_USERS": "Read Users",
      "ACCESS_MANAGE_USERS": "Manage Users",
      "ACCESS_READ_ROLES": "Read Roles",
      "ACCESS_MANAGE_ROLES": "Manage Roles"
    },
    "mock": {
      "option1": "Option 1",
      "option2": "Option 2",
      "option3": "Option 3"
    }
  },
  "portfolioPerformance": {
    "columns": {
      "portfolioReference": "Portfolio",
      "dpCode": "DP code",
      "boIdMasked": "BOID",
      "asOfDate": "As of (AD)",
      "asOfDateBs": "As of (BS)",
      "periodStart": "Period start (AD)",
      "currency": "Currency",
      "totalCost": "Cost basis",
      "marketValue": "Market value",
      "realizedGainLoss": "Realized gain/loss",
      "unrealizedGainLoss": "Unrealized gain/loss",
      "totalGainLoss": "Total gain/loss",
      "capitalGainTax": "Capital gain tax",
      "returnOnCostPct": "Return on cost %",
      "benchmarkId": "Benchmark",
      "benchmarkReturnPct": "Benchmark return (%)",
      "activeReturnPct": "Active return (%)",
      "benchmarkAsOf": "Benchmark as of",
      "benchmarkStatus": "Benchmark status",
      "valuationCoveragePct": "Valuation coverage %",
      "missingPriceCount": "Missing prices",
      "taxProvenanceCoveragePct": "Tax-rule provenance %",
      "missingTaxProvenanceCount": "Missing tax provenance",
      "nfrsEvidenceAvailable": "NFRS evidence",
      "nfrsFactCount": "NFRS fact count",
      "nfrsStandards": "NFRS standards",
      "nfrsMetrics": "NFRS metrics",
      "partialData": "Partial data",
      "methodology": "Methodology",
      "methodologyVersion": "Methodology version",
      "performanceReturnMethodology": "Governed return methodology",
      "performanceReturnMethodologyVersion": "Governed return methodology version",
      "performanceReturnNetTwr": "Net TWR (%)",
      "performanceReturnGrossTwr": "Gross TWR (%)",
      "performanceReturnNetMwr": "Net MWR (%)",
      "performanceReturnGrossMwr": "Gross MWR (%)",
      "performanceReturnInputDigest": "Return input evidence digest",
      "performanceReturnLimitations": "Return limitations",
      "sourceBook": "Source book",
      "sourceAsOf": "Source freshness",
      "stalePriceCount": "Stale price count"
    },
    "methodology": {
      "returnOnCost": "Total realized and unrealized gain divided by cost basis. This is not TWR, MWR, or IRR.",
      "taxProvenance": "Tax evidence is complete only when each disposal carries the effective tax-rule identifier and provenance used for calculation.",
      "nfrsEvidence": "NFRS evidence indicates that governed NFRS facts exist; it does not replace a complete disclosure assessment."
    }
  },
  "governanceWorkspace": {
    "title": "Governance and policy controls",
    "description": "Operate organization-scoped controls from exact, versioned command contracts. Applicable policy and jurisdiction content are selected by the server.",
    "area": "Governance area",
    "areaLabel": "{{area}} controls",
    "commandTitle": "Governed command",
    "commandDescription": "Submit a lifecycle command using its canonical contract. Server policy, branch scope, and independent approval rules remain authoritative.",
    "command": "Command",
    "commandLabel": "{{commandId}}",
    "pathFieldLabel": "{{field}} path identifier",
    "fieldLabel": "{{field}}",
    "structuredHint": "Enter the structured object defined by the command contract as JSON.",
    "listHint": "Enter one value per line or separate values with commas.",
    "instantHint": "Use an ISO 8601 UTC instant, including milliseconds.",
    "submit": "Submit governed command",
    "submitting": "Submitting governed command",
    "commandSucceeded": "The governed command completed and the evidence view was refreshed.",
    "evidenceTitle": "Scoped governance evidence",
    "evidenceDescription": "Server-projected records for the active organization and branch. Sensitive credential material is excluded by the API.",
    "loading": "Loading governance evidence",
    "noAreas": "No governance areas are available for the current module entitlements."
  },
  "fixedIncome": {
    "title": "Fixed-income valuation",
    "description": "Calculate governed clean, accrued, dirty, and yield valuation facts.",
    "policyNotice": "Terms, calendar, convention, and market-price policy are selected by the server for the active organization.",
    "portfolioAccountId": "Portfolio account ID",
    "instrumentSymbol": "Instrument symbol",
    "valuationDate": "Valuation date",
    "calculate": "Calculate valuation",
    "calculating": "Calculating valuation…",
    "result": "Valuation result",
    "cleanPrice": "Clean price",
    "accruedInterest": "Accrued interest",
    "dirtyPrice": "Dirty price",
    "yieldToMaturity": "Yield to maturity",
    "carryingAmount": "Carrying amount",
    "status": "Calculation status",
    "debtEventTitle": "Published debt event",
    "debtEventDescription": "Process a published call, put, redemption, default, or restructuring notice for this scoped portfolio.",
    "issuerEventVersionId": "Issuer event version ID",
    "processDebtEvent": "Process debt event",
    "processingDebtEvent": "Processing debt event…",
    "debtEventType": "Debt event type",
    "debtEventAmount": "Controlled amount",
    "cashDelta": "Cash change",
    "impairmentDelta": "Impairment change",
    "settlementQuantityDelta": "Position quantity change",
    "overrideTitle": "Exceptional valuation input",
    "overrideDescription": "Request a bounded price or FX override with evidence. An independent organization administrator must approve it before valuation can use it.",
    "overrideField": "Input type",
    "overridePriceClose": "Closing price",
    "overrideFxRate": "FX rate",
    "overrideSourceState": "Source condition",
    "overrideMissing": "Missing source",
    "overrideDisputed": "Disputed source",
    "overrideValue": "Proposed value",
    "overrideSourceObservation": "Disputed observation ID",
    "overrideBaselineValue": "Disputed baseline value",
    "overrideEffectiveFrom": "Effective from",
    "overrideEffectiveTo": "Effective to",
    "overrideEvidence": "Evidence reference",
    "overrideReason": "Reason",
    "overrideRequest": "Request override",
    "overrideRequestCorrection": "Request correction",
    "overrideCancelCorrection": "Cancel correction",
    "overrideCorrectionOf": "Correction of override {{overrideId}}",
    "overrideApprove": "Approve",
    "overrideCorrect": "Correct",
    "overrideRequestRevocation": "Request revocation",
    "overrideApproveRevocation": "Approve revocation",
    "overrideOverTolerance": "Over tolerance",
    "overrideSummary": "Value {{value}}; tolerance {{toleranceBps}} bps; deviation {{deviationBps}} bps",
    "overrideDecisionReason": "Reviewed exceptional valuation input",
    "unavailable": "Unavailable",
    "overrideReference": "Override Reference: {{overrideId}}",
    "lifecycleSchedule": "Schedule lifecycle event",
    "lifecycleApprove": "Approve lifecycle event",
    "lifecyclePost": "Post lifecycle event",
    "lifecycleTitle": "Fixed-income lifecycle",
    "lifecycleDescription": "Schedule, approve, and post governed coupon, maturity, and other fixed-income lifecycle events with maker-checker controls.",
    "lifecycleFailed": "The fixed-income lifecycle action could not be completed.",
    "lifecycleEventDate": "Event date",
    "lifecycleEventId": "Lifecycle event",
    "expectedVersion": "Expected version",
    "lifecycleResult": "{{eventId}} is {{status}} at version {{version}}."
  },
  "valuationRun": {
    "title": "Official portfolio valuation run",
    "description": "Run completeness checks and inspect the controlled approval, publication, locking, and restatement lineage.",
    "portfolioAccountId": "Portfolio account ID",
    "asOfDate": "Valuation date",
    "runPreliminary": "Run preliminary valuation",
    "running": "Running valuation…",
    "refresh": "Refresh runs",
    "status": "Run status",
    "netAssetValue": "Net asset value",
    "checklist": "Prices / FX / actions / cash",
    "exceptions": "Material exceptions",
    "sourceDigest": "Source digest",
    "snapshotHash": "Published snapshot hash",
    "supersedes": "Supersedes run",
    "none": "None",
    "unavailable": "Unavailable",
    "approve": "Approve valuation run",
    "publish": "Publish valuation run",
    "requestReopen": "Request reopening",
    "approveReopen": "Approve reopening",
    "reason": "Reason",
    "reasonHelp": "Required for approval and reopening requests. The reason is retained as audit evidence."
  },
  "cutoffControls": {
    "title": "Cutoff control report",
    "description": "Read the latest immutable cash and holdings control run with source, subledger, and posting lineage.",
    "loading": "Loading cutoff control report…",
    "empty": "No cutoff control run is available for this organization.",
    "policyVersion": "Policy version",
    "breaks": "Control breaks",
    "sourceLinks": "Source links",
    "subledgerLinks": "Subledger links",
    "postingLinks": "Posting links"
  },
  "ok": "ok",
  "err": "err",
  "importWizard": {
    "title": "Import",
    "step": {
      "upload": "Upload",
      "map": "Map columns",
      "validate": "Validate",
      "preview": "Preview",
      "commit": "Commit",
      "result": "Result"
    },
    "upload": {
      "dropHere": "Drop CSV or Excel here",
      "orClick": "or click to choose a file",
      "constraints": "Maximum 25 MB · .csv, .xlsx",
      "downloadTemplate": "Download template"
    },
    "map": {
      "title": "Map columns",
      "sourceColumns": "File columns",
      "targetSchema": "Product schema",
      "dragHelp": "Choose a target for each file column. You can also drag a file column onto a target field.",
      "unmapped": "— Unmapped —",
      "matched": "Matched",
      "dropField": "Drop a file column here",
      "mappingName": "Mapping name",
      "savedMapping": "Saved mapping",
      "autoMap": "Auto-map columns",
      "required": "Required field",
      "mappedCount": "{{count}} fields mapped",
      "unmappedCount": "{{count}} fields unmapped",
      "continue": "Continue to validation",
      "selectionHelp": "Use the Map to selector for quick mapping. Optional transforms run before validation.",
      "chooseTarget": "Map to",
      "transformLabel": "Transform",
      "transform": {
        "NONE": "As-is",
        "TRIM": "Trim spaces",
        "UPPERCASE": "Uppercase",
        "LOWERCASE": "Lowercase",
        "NUMBER": "Number (remove separators)",
        "PERCENT_TO_DECIMAL": "Percent to decimal",
        "DATE_ISO": "Date: YYYY-MM-DD",
        "DATE_MDY": "Date: MM/DD/YYYY",
        "DATE_DMY": "Date: DD/MM/YYYY",
        "BOOLEAN": "Boolean (Yes/No)",
        "JSON": "JSON"
      }
    },
    "validate": {
      "title": "Validation results",
      "valid": "valid",
      "warnings": "warnings",
      "errors": "errors",
      "status": "Status",
      "details": "Details",
      "rowValid": "Row is valid",
      "rowWarning": "Row has warnings",
      "rowError": "Row has errors",
      "andMore": "...and {{count}} more",
      "continue": "Continue to preview"
    },
    "preview": {
      "title": "Preview changes",
      "willCreate": "records will be created",
      "willUpdate": "records will be updated",
      "willSkip": "unchanged",
      "willReject": "rejected",
      "commit": "Confirm and commit import"
    },
    "result": {
      "successTitle": "Import completed",
      "successMessage": "Your import has been processed successfully.",
      "created": "Created",
      "updated": "Updated",
      "skipped": "Skipped",
      "failed": "Failed",
      "committedBy": "Committed by",
      "committedAt": "Committed at",
      "sourceFile": "Source file",
      "auditReference": "Audit reference",
      "viewRecords": "View imported records",
      "importAnother": "Import another file"
    },
    "template": {
      "label": "Template",
      "autoDetectedHigh": "Format recognized — {{matched}} of {{total}} columns matched",
      "autoDetectedMedium": "Possible match — {{matched}} of {{total}} columns recognized",
      "standardSection": "Standard templates",
      "savedSection": "Your saved templates",
      "stale": "Outdated"
    },
    "productTemplate": {
      "nepse": {
        "daily": "NEPSE Daily Market Data"
      },
      "marketData": {
        "standard": "Standard Market Data"
      },
      "transactions": {
        "standard": "Standard Transactions"
      }
    }
  },
  "section": {
    "client": {
      "profile": "Investor Profile",
      "settings": "Account Settings"
    },
    "portfolio": {
      "ownership": "Client & Account Linkage",
      "details": "Portfolio Details"
    },
    "clientAccount": {
      "identity": "Client identity",
      "details": "Account details"
    },
    "instrument": {
      "identity": "Instrument identity",
      "classification": "Classification"
    },
    "portfolioAccount": {
      "identity": "Portfolio identity",
      "ownership": "Ownership"
    },
    "role": {
      "definition": "Role definition",
      "permissions": "Permissions"
    },
    "transaction": {
      "trade": "Trade Details",
      "allocation": "Allocation",
      "charges": "Charges",
      "details": "Transaction Details",
      "source": "Source",
      "status": "Status"
    },
    "user": {
      "identity": "Identity",
      "assignment": "Access assignment"
    },
    "profile": {
      "identity": "Profile identity"
    }
  },
  "helpText": {
    "field": {
      "user": {
        "email": "The user's login email address. Must be unique within the platform. Used for authentication and notifications.",
        "emailEdit": "The user's login email address. This field is read-only after creation; contact a platform admin to change it.",
        "firstName": "The user's legal first name as it appears on official identification.",
        "lastName": "The user's legal last name as it appears on official identification.",
        "password": "Initial password for the user. Must be at least 8 characters. The user will be prompted to change it on first login.",
        "roles": "Assign one or more organization roles to grant the user their permissions. Search by role name to find available roles.",
        "branch": "The primary branch this user is assigned to. Scopes the user's default operational context.",
        "clientAccountId": "For users with the Client role, link this user to their client account to scope their portfolio and transaction access.",
        "status": "Active users can log in and access the platform. Inactive users are suspended and cannot authenticate."
      },
      "role": {
        "name": "A human-readable name for this role, shown in role assignment lists and audit logs.",
        "description": "An optional description of the role's purpose and responsibilities.",
        "code": "An immutable system identifier auto-generated from the role name. Used internally for permission resolution and audit trails. Not editable after creation.",
        "status": "Active roles can be assigned to users. Inactive roles remain assigned but cannot be assigned to new users.",
        "permissions": "Select the permissions this role grants to its holders. Only permissions you hold can be assigned. Search by permission name or domain."
      },
      "branch": {
        "address": "The physical address of this branch location."
      },
      "reports": {
        "accountCode": "The account code to filter by. Leave blank to include all accounts.",
        "dimension": "The allocation dimension to analyze (currency, instrument, instrument type, or sector)."
      },
      "positionTransfer": {
        "workflowKind": "Type of position transfer workflow",
        "id": "Unique identifier for this position transfer",
        "expectedVersion": "Version number for conflict detection",
        "sourcePortfolioAccountId": "Portfolio account from which positions are transferred",
        "instrumentSymbol": "Security symbol identifier",
        "businessReference": "External reference for this transfer",
        "reason": "Reason for the transfer, approval, cancellation, or reversal",
        "allocationPlan": "Specify which lots to transfer and quantities"
      }
    },
    "semantic": {
      "email": "Email used for account identification, sign-in, and account or security communication.",
      "firstName": "The person's given name, used to identify them throughout the application.",
      "lastName": "The person's family name, used with the first name in user and audit records.",
      "fullName": "The client's full legal or commonly used name, shown on accounts, records, and reports.",
      "password": "Initial sign-in secret for this account; it protects access until the user changes it.",
      "currentPassword": "Your current password, required to verify your identity before a security-sensitive change.",
      "newPassword": "The password you will use for future sign-ins after this change is saved.",
      "confirmPassword": "Repeat the new password to prevent an unintended password from being saved.",
      "roles": "Roles assigned to this user; they determine what the user can view and change.",
      "role": "The role being assigned or changed; it determines the permissions granted through this assignment.",
      "permissions": "Permissions granted by this role; they control the operations role members can perform.",
      "status": "Current lifecycle state of this record; it controls whether the record can be used operationally.",
      "code": "Short stable code used to identify this record in lists, imports, integrations, and reports.",
      "name": "User-facing name used to recognize this record throughout the application.",
      "description": "Brief explanation of the record's purpose so users can distinguish and use it correctly.",
      "notes": "Optional context that helps reviewers understand details not captured by the structured fields.",
      "branch": "Branch that owns or can use this record; it limits where the record is visible and actionable.",
      "parentBranch": "Parent branch used to place this branch in the organization hierarchy and inherit its context.",
      "organization": "Organization that owns this record and defines its authorization and data boundary.",
      "client": "Client this record belongs to; it keeps holdings, activity, and reporting within the correct client scope.",
      "clientAccount": "Client account affected by this record; it determines the customer account used for processing and reporting.",
      "portfolio": "Portfolio affected by this record; it determines where investment activity, holdings, and performance are recorded.",
      "custodyAccount": "Custody or portfolio account used to hold assets and route account-specific activity correctly.",
      "account": "Account affected by this record; it determines where balances and activity are recorded.",
      "accountNumber": "External or business account identifier used to match this account with statements, imports, and operations.",
      "accountType": "Classification of this account or client; it controls the applicable processing and reporting behavior.",
      "baseCurrency": "Primary currency used to value and report this account or portfolio consistently.",
      "currency": "Currency of this amount or transaction; it is required for correct valuation, conversion, and reporting.",
      "instrumentSymbol": "Tradable instrument identifier used to link activity to the correct security, prices, holdings, and reports.",
      "instrument": "Financial instrument affected by this record; it links the record to security master data and valuation.",
      "instrumentName": "Primary user-facing name of the financial instrument, used to identify it across investment workflows.",
      "securityName": "Formal security name used for statements, reference data, and regulatory or client-facing reporting.",
      "instrumentType": "Security classification that determines which instrument attributes and processing rules apply.",
      "sector": "Economic sector assigned to the instrument, used for classification, exposure analysis, and reporting.",
      "isin": "International Securities Identification Number used to match the security reliably across external data sources.",
      "exchange": "Exchange where the security is listed or traded, used for market-data and reference-data matching.",
      "transactionType": "Type of investment activity being recorded; it determines how cash, quantity, cost, and gains are affected.",
      "transaction": "Transaction-related value used to record investment activity correctly in holdings, cash, and reporting.",
      "transactionDate": "Date the investment activity occurred; it determines the accounting, holdings, tax, and reporting period affected.",
      "settlementDate": "Date cash and securities are considered settled; it is used for settlement and cash-position processing.",
      "quantity": "Number or face amount of units affected; it determines the position movement and related valuation.",
      "price": "Price applied to the instrument; it is used to calculate transaction value or market valuation.",
      "pricePerUnit": "Price for one unit of the instrument, used with quantity to calculate transaction value and cost basis.",
      "marketPrice": "Observed market price used to value holdings as of the selected pricing date.",
      "priceDate": "Date this market price applies to; it ensures valuations use the correct observation for the reporting date.",
      "valuationDate": "Date on which positions and values are measured for this calculation or report.",
      "commission": "Broker commission charged on the transaction; it is included where applicable in cost, proceeds, and reporting.",
      "sebonFee": "SEBON-related transaction fee; it is recorded so Nepal market charges are reflected correctly.",
      "dpCharge": "Depository participant charge associated with the transaction; it is captured for complete transaction costs.",
      "fees": "Fees associated with this activity; they are recorded so net cost, proceeds, and reporting are accurate.",
      "charges": "Other applicable charges for this activity; they are included so financial results reflect the full transaction cost.",
      "externalReference": "Reference from a broker, bank, custodian, or source system used to trace and reconcile this record.",
      "importType": "Kind of data being imported; it selects the correct template, validation rules, and processing workflow.",
      "file": "Source file containing the data to process; it is validated before any accepted rows are committed.",
      "sourceSheetName": "Worksheet to read from a multi-sheet file; specify it when the required data is not on the default sheet.",
      "phone": "Client or user contact number used when operational or account communication requires a telephone contact.",
      "panNumber": "Nepal PAN used for tax identity and applicable regulatory or tax reporting; provide the registered number when available.",
      "legalName": "Registered legal name used for official, regulatory, tax, and contractual records.",
      "jurisdiction": "Legal jurisdiction governing this organization or record; it determines which regulatory context applies.",
      "locale": "Language and regional formatting preference used for dates, numbers, and user-facing content.",
      "timeZone": "Time zone used to interpret local dates and times consistently for operations, cutoffs, and audit history.",
      "calendarSystem": "Calendar system used for date representation and fiscal period calculations.",
      "isDefault": "Marks this as the default choice when no more specific selection is made for the same context.",
      "isActive": "Controls whether this record is currently available for new operational use without deleting its history.",
      "strategy": "Investment strategy or mandate followed by the portfolio; it provides context for portfolio management and reporting.",
      "mandateStartDate": "Date the portfolio mandate becomes effective and portfolio activity is considered within the mandate period.",
      "mandateEndDate": "Optional date the portfolio mandate ends; activity after this date should not be treated as within the mandate.",
      "effectiveFrom": "First date this rule, rate, or configuration applies; calculations before this date use the prior applicable version.",
      "effectiveTo": "Last date this rule, rate, or configuration applies; leave it open only when the version remains current.",
      "effectiveDate": "Date this value or configuration takes effect and begins influencing processing or calculations.",
      "taxRate": "Percentage applied by this tax rule when its conditions are met; it directly affects calculated tax amounts.",
      "rate": "Rate applied by this rule or calculation; it determines the resulting charge, tax, return, or value as applicable.",
      "taxType": "Tax category this rule represents; it determines where and how the rule is applied and reported.",
      "holdingPeriodDays": "Holding-period threshold used to choose the applicable tax treatment for realized gains or other rules.",
      "regulatoryProfileReady": "Shows whether required regulatory organization details are complete enough for governed reporting.",
      "assignedModules": "Modules enabled for this organization; they determine which licensed capabilities are available.",
      "branchCount": "Number of branches configured for the organization, shown to summarize its current operating structure.",
      "module": "Product module being assigned or configured; it determines which capabilities become available in the selected scope.",
      "modules": "Product modules selected for this organization or assignment; they determine the enabled capability set.",
      "reason": "Business reason for this action; it provides context for reviewers, audit history, and later investigation.",
      "expiresAt": "Date and time this access or configuration stops being valid, limiting how long it can be used.",
      "startDate": "Beginning of the requested period; only activity on or after this date is included.",
      "endDate": "End of the requested period; only activity on or before this date is included.",
      "fiscalYear": "Fiscal year to use for period boundaries and financial or tax reporting.",
      "month": "Month to include in this request, used to limit calculations and reporting to that period.",
      "quarter": "Quarter to include in this request, used to group calculations and reporting to the selected period.",
      "outputFormat": "Format of the generated result or file, chosen to match how the report will be reviewed or shared.",
      "grouping": "How result rows are grouped, which changes the presentation and aggregation of the report without changing source data.",
      "comparisonPeriod": "Prior or alternate period used as the comparison baseline for trend and performance analysis.",
      "instructionType": "Type of settlement instruction being configured; it determines which settlement details and processing rules apply.",
      "settlementMethod": "Method used to settle the activity, which determines the operational path for cash or securities delivery.",
      "bankAccount": "Bank account used for cash settlement; it directs settlement cash to the correct account.",
      "dematAccount": "Demat account used for securities settlement; it directs securities to the correct depository account.",
      "tax": "Tax-related value used by the applicable tax rule, calculation, or regulatory reporting workflow.",
      "settlement": "Settlement-related value used to route and complete the associated cash or securities settlement correctly.",
      "reportParameter": "Report filter or option used to define which authorized data is included and how the result is presented.",
      "delegation": "Delegation setting that defines the authorized support scope and limits how delegated access can be used.",
      "openingBalance": "Opening or cutover value used to establish the starting position before subsequently recorded activity is applied.",
      "date": "Date used to determine when this record or value applies in processing, calculations, or reporting.",
      "numericValue": "Numeric value used by this record in its calculation, limit, quantity, or financial result.",
      "selection": "Select the applicable option because it determines how this record is classified or processed.",
      "setting": "Controls whether this behavior is enabled for the record and therefore how it is used operationally.",
      "collection": "Add the structured rows required for this record; each row is processed as part of the submitted financial data.",
      "textValue": "Provide the business value for this field so the record can be identified and processed correctly.",
      "adminEmail": "Email for the initial organization administrator; used to create their sign-in account.",
      "adminPassword": "Initial password for the organization administrator's first sign-in.",
      "roleCode": "Platform role assigned to this user; determines their platform permissions.",
      "cancellationReason": "Reason for cancellation; retained in the audit history.",
      "defaultBranchCode": "Code for the initial Branch; used in records and integrations.",
      "defaultBranchName": "Name of the initial Branch shown to users.",
      "targetOrganization": "Organization receiving this module assignment.",
      "organizationName": "Organization that owns this module assignment.",
      "replacementInstrumentSymbol": "Instrument replacing the original security after this corporate action.",
      "transactionId": "Transaction this settlement instruction belongs to.",
      "expectedQuantity": "Securities quantity expected to settle.",
      "tradedDate": "Date this market price was observed or traded.",
      "sourceReference": "Source document or external reference used to verify this record.",
      "source": "Source of this value; used for lineage and review.",
      "freshness": "Shows whether this market price is current enough for use.",
      "sebonRegistrationNumber": "SEBON registration number used to identify the organization for regulatory purposes.",
      "graceEndsAt": "Date access stops after the assignment's grace period.",
      "createdAt": "When this record was created; shown for audit history.",
      "updatedAt": "When this record was last changed; shown for audit history.",
      "approvedAt": "When this record was approved; shown for audit history.",
      "holdingPeriodMinimumDays": "Minimum holding days required for this tax classification.",
      "holdingPeriodClassification": "Holding-period category this tax rule applies to.",
      "maxBranches": "Maximum Branches allowed under this module assignment.",
      "maxUsers": "Maximum users allowed under this module assignment.",
      "configurationVersionId": "Configuration version applied to this module assignment.",
      "transactionPeriodStart": "First transaction date included in the activity report.",
      "transactionPeriodEnd": "Last transaction date included in the activity report.",
      "periodStart": "First date included in this report.",
      "periodEnd": "Last date included in this report.",
      "reportingPeriodStart": "First date included in the regulatory reporting period.",
      "reportingPeriodEnd": "Last date included in the regulatory reporting period.",
      "asOfDate": "Snapshot date used to calculate balances or holdings.",
      "cutoffAt": "Cutoff date used to select the completed statement period.",
      "year": "Year used to constrain this report.",
      "reportType": "Report to generate; determines the required parameters and output.",
      "reconciliationRun": "Reconciliation run whose breaks are included in this report.",
      "severity": "Break severity used to filter reconciliation results.",
      "transactionActivityType": "Transaction category used to filter the activity report.",
      "expectedCash": "Cash amount expected to settle.",
      "expectedSettlementDate": "Date settlement is expected to complete.",
      "externalMessageId": "External settlement message reference used for traceability and duplicate detection.",
      "settlementSequence": "Sequence number used to order settlement confirmations.",
      "settledCash": "Cash amount confirmed as settled.",
      "corporateActionType": "Corporate action type; determines the applicable terms and processing rules.",
      "recordDate": "Date used to determine holders entitled to the corporate action.",
      "exDate": "Date the security starts trading without this corporate-action entitlement.",
      "declarationDate": "Date the issuer announced the corporate action.",
      "bookCloseDate": "Date the issuer closes its register for entitlement processing.",
      "payDate": "Date cash or securities are scheduled to be distributed.",
      "ratioNumerator": "Entitlement units received in the corporate-action ratio.",
      "ratioDenominator": "Existing units required for the corporate-action ratio.",
      "cashRate": "Cash amount paid per eligible unit for this corporate action.",
      "rightPrice": "Subscription price per unit for a rights issue.",
      "licenseAuthority": "Regulator or authority that issued this license.",
      "licenseType": "Type of regulatory license held by the organization.",
      "licenseNumber": "Official license identifier used to verify the authorization.",
      "licenses": "License entries defining the organization's authorized capabilities and limits.",
      "authorityTemplateVersion": "Version of the approved filing template used for this report definition.",
      "authorityEffectiveFrom": "First date this filing authority or template is valid.",
      "authorityEffectiveTo": "Last date this filing authority or template is valid.",
      "reportCode": "Stable report-definition code used to identify the report configuration.",
      "reportName": "User-facing name used to recognize this report definition.",
      "regulatoryBody": "Regulator or authority associated with this report definition.",
      "reportDefinition": "Approved report definition used to generate this report run.",
      "theme": "Appearance preference used to choose light, dark, or system-matched visual styling for your account.",
      "language": "Language used for application labels, guidance, and other user-facing content in your account.",
      "defaultContext": "Workspace context opened by default after sign-in so you start in the organization and branch you use most often.",
      "dateFormat": "Calendar display preference used to show dates in AD, BS, or both where supported.",
      "numberFormat": "Number formatting convention used for grouping separators, decimals, and financial values in the interface.",
      "defaultPageSize": "Default number of rows shown in supported lists, balancing how much data you see with page readability."
    }
  },
  "locale": {
    "en-US": "English (US)",
    "ne-NP": "नेपाली (NP)"
  },
  "fiscalYears": {
    "messages": {
      "createSuccess": "Fiscal year created successfully.",
      "generatePeriodsSuccess": "Fiscal periods generated successfully."
    }
  },
  "dashboardWorkspace": {
    "actions": {
      "open": "Open workspace",
      "manage": "Manage",
      "openReports": "Open reports"
    },
    "platform": {
      "title": "Platform overview",
      "subtitle": "Operate the platform without exposing organization investment records.",
      "session": "Signed-in platform identity",
      "adminScope": "Your platform role can administer platform metadata and support access. Organization business data remains isolated.",
      "readerScope": "Your platform role is read-only and limited to platform operational information.",
      "actionsTitle": "Platform workspaces",
      "actionsDescription": "Continue to the platform surfaces available to your role.",
      "administration": "Platform administration",
      "administrationDescription": "Manage platform modules, users, support delegation, health, and governance.",
      "account": "Account and preferences",
      "accountDescription": "Manage your profile, preferences, password, and active sessions."
    },
    "client": {
      "title": "My portfolio overview",
      "subtitle": "A private, read-only view of your own investment relationship.",
      "scopeNotice": "Only records assigned to your client identity are available here. Organization-wide data and administrative actions remain hidden.",
      "organization": "Organization",
      "accessMode": "Access mode",
      "readOnly": "Read only",
      "ownRecordsOnly": "Your assigned records only",
      "reports": "My reports",
      "reportsDescription": "Review the reporting workspace available to your client identity."
    },
    "organization": {
      "partialData": "Some valuation sources are unavailable. Available figures are shown and should be treated as partial.",
      "positions": "Open positions",
      "asOf": "As of {{date}}",
      "quickActions": "Continue working",
      "transactions": "Transactions",
      "transactionsDescription": "Create, review, and progress investment transactions.",
      "data": "Data hub",
      "dataDescription": "Manage instruments, market facts, reconciliation, and governed data workflows.",
      "imports": "Import center",
      "importsDescription": "Upload, validate, preview, and commit transaction, instrument, or market-data files.",
      "team": "Organization administration",
      "teamDescription": "Manage users, roles, access, clients, portfolios, and audit activity."
    }
  },
  "reportsWorkspace": {
    "title": "Reports",
    "subtitle": "Portfolio insight and governed regulatory reporting in one workspace.",
    "clientSubtitle": "Read-only reporting for records assigned to your client identity.",
    "context": "Reporting context",
    "tabs": {
      "reports": "Reports",
      "regulatory": "Regulatory",
      "controls": "Controls"
    },
    "search": {
      "placeholder": "Search reports by title or description"
    },
    "actions": {
      "openDashboard": "Open dashboard",
      "newDefinition": "New definition",
      "generateRun": "Generate report",
      "disable": "Disable",
      "validate": "Validate",
      "submit": "Submit",
      "artifact": "Open artifact",
      "generate": "Generate",
      "cancelRun": "Cancel run",
      "retryRun": "Retry run",
      "more": "More actions"
    },
    "status": {
      "running": "Running",
      "completed": "Completed",
      "failed": "Failed",
      "submitted": "Submitted",
      "acknowledged": "Acknowledged"
    },
    "artifact": {
      "title": "Report artifact",
      "download": "Download artifact",
      "downloadCsv": "Download CSV",
      "downloadJson": "Download JSON",
      "description": "Review the completed filing output and download an allowed format."
    },
    "client": {
      "scopeNotice": "This workspace is restricted to your own client records. Organization-wide regulatory reports and administrative actions are not available.",
      "portfolioTitle": "Portfolio overview",
      "portfolioDescription": "Return to your dashboard for the current client-scoped overview.",
      "deliveryTitle": "Report delivery",
      "deliveryDescription": "Published client statements and downloadable artifacts will appear here when released by your organization."
    },
    "portfolio": {
      "title": "Portfolio insight",
      "description": "Current position and valuation facts from the governed investment data surface.",
      "partialData": "One portfolio data source is unavailable. The remaining figures are shown as partial data.",
      "marketValue": "Market value",
      "costBasis": "Cost basis",
      "unrealized": "Unrealized gain or loss",
      "positions": "Positions"
    },
    "regulatory": {
      "noAccess": "You do not have permission to view organization regulatory reports.",
      "adminOnly": "Regulatory definitions, report generation, validation, and submission are available to organization administrators.",
      "title": "Regulatory filings",
      "description": "Manage report definitions, generate filing runs, validate results, and access completed artifacts."
    },
    "feedback": {
      "definitionSaved": "Report definition saved.",
      "definitionDisabled": "Report definition disabled.",
      "runStarted": "Report generation started.",
      "runCancelled": "Report run cancelled.",
      "runRetried": "Report run queued for retry.",
      "validated": "Report validation completed.",
      "submitted": "Report submitted.",
      "actionFailed": "The report action could not be completed. Review the report state and try again."
    },
    "definitions": {
      "title": "Report definitions",
      "description": "Reusable, governed definitions that control report generation.",
      "emptyTitle": "No report definitions",
      "emptyDescription": "Create a report definition before generating a report run."
    },
    "runs": {
      "title": "Report runs",
      "description": "Generated reports and their validation and submission lifecycle.",
      "emptyTitle": "No report runs",
      "emptyDescription": "Generate a report from an active definition to begin the lifecycle.",
      "periodNotSpecified": "Reporting period not specified",
      "progress": "{{state}}: {{percent}}% complete"
    },
    "definitionForm": {
      "createTitle": "Create report definition",
      "editTitle": "Edit report definition",
      "code": "Report code",
      "name": "Report name",
      "type": "Report type",
      "body": "Regulatory body",
      "types": {
        "sebonMonthly": "SEBON monthly trading report",
        "irdCgt": "IRD capital-gains schedule",
        "nrbQuarterly": "NRB quarterly report",
        "fiuAmlCtf": "FIU AML/CTF report"
      }
    },
    "runForm": {
      "title": "Generate report",
      "definition": "Report definition",
      "start": "Period start",
      "end": "Period end"
    },
    "live": {
      "changeParameters": "Change parameters",
      "exportAvailable": "Export available",
      "pageCoverage": "Showing rows {{from}}–{{to}} of {{total}}.",
      "previousPage": "Previous",
      "nextPage": "Next",
      "pageNumber": "Page {{page}} of {{pages}}",
      "title": "Governed live reports",
      "description": "Run only the reports and parameters authorized for your current context. Results retain source freshness, calculation version, and evidence lineage.",
      "summary": "Report summary",
      "lineage": "Data lineage and evidence",
      "sourceAsOf": "Source as of",
      "partialData": "This report is partial. Review the currency, valuation, reconciliation, or ledger evidence before relying on the totals.",
      "empty": "No rows were found for the selected parameters and authorized scope.",
      "unavailable": "Not aggregatable",
      "noReportsAvailable": "No live reports are available for your current context. Contact your administrator if you believe this is an error.",
      "truncated": "Showing {{returned}} of {{total}} rows. This report is truncated.",
      "truncatedExportPrompt": "Use Export for the full result.",
      "openWorkspace": "Open report workspace",
      "parametersUsed": "Report scope and period",
      "favorites": "Favorites",
      "recent": "Recent reports",
      "addFavorite": "Add to favorites",
      "removeFavorite": "Remove from favorites",
      "savedViews": "Saved parameter views",
      "savedViewsDescription": "Save reusable non-sensitive report parameters. Client, portfolio, account, and other scoped identifiers are never persisted in the browser.",
      "savedViewName": "View name",
      "saveView": "Save view",
      "details": "Details",
      "defaultParameters": "Default report scope",
      "selectedScope": "Selected",
      "currentData": "Current data · as of {{date}}",
      "rowRange": "{{from}}–{{to}} of {{total}}",
      "deleteSavedView": "Delete saved view",
      "saveCurrentView": "Save current view"
    },
    "scope": {
      "organization": "Organization scope",
      "client": "Client scope"
    },
    "navigation": {
      "live": "Live views",
      "label": "Reporting areas",
      "library": "Reports",
      "regulatory": "Regulatory filings",
      "operations": "Valuation & controls"
    },
    "liveViews": {
      "title": "Live financial views",
      "description": "Review the latest authoritative portfolio, activity, accounting, and control information without configuring each report first.",
      "snapshot": "Snapshot",
      "latestAvailable": "Latest available",
      "chooseDate": "Choose as-of date",
      "asOfDate": "As-of date",
      "upperBound": "Financial date upper bound: {{date}}",
      "authorityNote": "Each view resolves independently to its relevant authoritative source date at or before the selected financial date. Source dates can differ across portfolio, ledger, transaction, and reconciliation data.",
      "openFullReport": "Open full report",
      "reportContext": "View: {{context}} · Source as of {{source}}",
      "sourceNotAvailable": "not available",
      "unavailable": "This view is not currently available for the selected date or authorized scope. Other live views remain usable.",
      "partial": "This view is partial. Review its source date and data-quality details before relying on the totals.",
      "empty": "No report data is available for this view and date.",
      "homeAction": "View live financials",
      "noViewsTitle": "No live views available",
      "noViewsDescription": "No essential live report is authorized for your current access and Branch.",
      "states": {
        "current": "Current",
        "stale": "Stale",
        "partial": "Partial",
        "empty": "No data",
        "unavailable": "Unavailable"
      },
      "sections": {
        "portfolio": "Portfolio",
        "activity_accounting": "Activity & accounting",
        "controls": "Controls"
      },
      "sectionDescriptions": {
        "portfolio": "Current positions, valuation, and portfolio performance from governed investment facts.",
        "activity_accounting": "Recent investment activity and the accounting result for the relevant financial period.",
        "controls": "Latest reconciliation and ledger-control views used to confirm financial completeness and balance."
      }
    },
    "library": {
      "title": "Reports",
      "description": "Find and run the financial reports you need without navigating operational controls.",
      "searchPlaceholder": "Search reports",
      "category": "Category",
      "allCategories": "All categories",
      "quickAccess": "Quick access",
      "noResultsTitle": "No matching reports",
      "noResultsDescription": "Try a different report name, financial concept, or category."
    },
    "regulatoryTable": {
      "report": "Report",
      "code": "Code",
      "body": "Regulatory body",
      "period": "Reporting period",
      "status": "Status",
      "created": "Created",
      "action": "Action"
    },
    "operations": {
      "title": "Valuation & controls",
      "description": "Open the operational workspace for the valuation or financial-control task you need.",
      "open": "Open workspace",
      "emptyTitle": "No operational workspaces available",
      "emptyDescription": "No valuation or control workspace is authorized for your current access and Branch.",
      "unavailableTitle": "Workspace unavailable",
      "unavailableDescription": "This workspace is not available for your current access and Branch.",
      "fixedIncome": {
        "title": "Fixed-income valuation",
        "description": "Value fixed-income instruments and manage related valuation, override, lifecycle, and debt-event tasks.",
        "calculateTitle": "Calculate valuation",
        "calculateDescription": "Choose a portfolio, instrument, and financial date. The calculation uses governed market and instrument inputs.",
        "overridesTitle": "Valuation overrides",
        "overridesDescription": "Review or manage authorized instrument-specific valuation overrides only when an exception requires it.",
        "overrideDisclosure": "An approved valuation override is applied for {{effectiveFrom}} through {{effectiveTo}}."
      },
      "valuationRuns": {
        "title": "Portfolio valuation runs",
        "description": "Create, review, approve, publish, and reopen governed portfolio valuation runs.",
        "selectedPortfolio": "Selected portfolio",
        "createTitle": "Run portfolio valuation",
        "createDescription": "Select a portfolio and as-of date to create a governed valuation snapshot.",
        "historyTitle": "Valuation history",
        "historyDescription": "Review valuation state, data quality, and the next permitted lifecycle action.",
        "portfolio": "Portfolio",
        "dataQuality": "Data quality",
        "complete": "Complete",
        "needsAttention": "Needs attention",
        "view": "View",
        "reasonTitle": "Reason required",
        "detailsTitle": "Valuation run details",
        "prices": "Prices",
        "fx": "FX",
        "corporateActions": "Corporate actions",
        "cash": "Cash",
        "evidence": "Evidence & lineage"
      },
      "cutoffControls": {
        "title": "Cutoff controls",
        "description": "Review period-end control results, breaks, and supporting source, subledger, and posting evidence.",
        "latestRun": "Latest completed or available cutoff-control run",
        "breaksDescription": "Differences that require review between source and ledger values.",
        "noBreaks": "No breaks were recorded for this run.",
        "control": "Control",
        "kind": "Type",
        "source": "Source",
        "ledger": "Ledger",
        "difference": "Difference",
        "reference": "Reference",
        "dimension": "Dimension",
        "amount": "Amount",
        "journal": "Journal",
        "account": "Account",
        "debit": "Debit",
        "credit": "Credit"
      }
    },
    "branch": "Branch",
    "controls": {
      "title": "Valuation and control workflows",
      "description": "Run governed valuation, cutoff, and review workflows. These are operational controls, not report outputs."
    }
  },
  "importsWorkspace": {
    "description": "Upload governed CSV data, validate every row, preview issues, and commit only approved records.",
    "dialog": {
      "guidance": "Select the matching import type and paste CSV content using the exact template headers. Preview the job before committing any records.",
      "templates": "Download a CSV template"
    },
    "feedback": {
      "uploaded": "Import job uploaded. Preview it before committing.",
      "previewed": "Import preview completed.",
      "committed": "Valid import rows were committed.",
      "recovered": "Import recovery completed.",
      "actionFailed": "The import action could not be completed. Review the job status and row errors."
    },
    "errors": {
      "unsupportedCommand": "This import command is not supported.",
      "unsupportedType": "Choose Transactions, Instruments, or Market Data.",
      "invalidCsv": "The CSV is malformed. Check quotes, headers, and column counts.",
      "emptyCsv": "Add a header row and at least one data row."
    }
  },
  "operations.platform.integration.bootstrap-attestation.ingest.label": "Accept runtime bootstrap completion",
  "operations.platform.integration.bootstrap-attestation.ingest.description": "Validate and persist privacy-bounded evidence that an installation completed local Organization bootstrap and its initial usage handshake.",
  "clientReporting": {
    "home": {
      "title": "Your portfolio",
      "subtitle": "A clear view of your managed investments and latest statement.",
      "asOf": "Values as of {{date}}",
      "managedAccount": "Managed account",
      "portfolioValue": "Portfolio value",
      "performanceUnavailable": "Performance is not available for this view yet.",
      "totalGain": "Total gain {{value}}",
      "totalLoss": "Total loss {{value}}",
      "investmentReturn": "Investment return",
      "returnExplanation": "Return excludes the effect of deposits and withdrawals when a finalized time-weighted return is available.",
      "returnUnavailable": "A reliable return is not available for this scope.",
      "cash": "Cash",
      "latestStatement": "Latest portfolio statement",
      "latestStatementDescription": "Review your completed statement, including investments, activity, fees, taxes, and valuation notes.",
      "viewStatement": "View statement",
      "investments": "Your investments",
      "investmentsDescription": "Your largest current holdings. Open the full investments report for more detail.",
      "investment": "Investment",
      "viewAllInvestments": "View all investments",
      "noInvestments": "No investments to show",
      "noInvestmentsDescription": "Your managed account does not currently have reportable holdings."
    },
    "reports": {
      "title": "Statements & reports",
      "subtitle": "The documents and views you need to understand your managed account—without operational or accounting complexity.",
      "statementTitle": "Portfolio statement",
      "statementDescription": "Your periodic portfolio picture: investments, cash, performance, activity, fees, taxes, and important valuation notes.",
      "performanceTitle": "Your performance",
      "performanceDescription": "See how your investments performed for a selected period using the finalized portfolio return methodology.",
      "investmentsTitle": "Your investments",
      "investmentsDescription": "See the investments you currently own and their latest governed values.",
      "accountDetailsTitle": "Account & custody details",
      "accountDetailsDescription": "Review the identity and custody evidence associated with your managed portfolio when you need it.",
      "recommended": "Recommended",
      "viewStatement": "View statement",
      "open": "Open",
      "back": "Back to statements",
      "taxDocuments": "Tax documents",
      "emptyTitle": "No reports are available yet",
      "emptyDescription": "Your reporting documents will appear here when they are available for your account.",
      "moreReports": "More reports"
    },
    "statement": {
      "notAvailableTitle": "No completed statement is available",
      "notAvailableDescription": "A completed portfolio statement has not been published for this account or selected period yet.",
      "latestPeriod": "Latest completed statement",
      "period": "Statement period",
      "asOf": "Values current through {{date}}",
      "partial": "Some values need attention",
      "current": "Statement complete",
      "portfolioValue": "Portfolio value",
      "multipleCurrencies": "Multiple currencies",
      "periodEndValue": "Value at the end of the statement period",
      "investmentReturn": "Investment return",
      "returnExplanation": "Finalized time-weighted return for the statement period.",
      "returnUnavailable": "A finalized return is not available for this statement period.",
      "compositeReturnUnavailable": "This statement covers multiple portfolios and no governed composite return is available, so returns are not averaged.",
      "findAnother": "Find another statement",
      "printOrSavePdf": "Print / save PDF",
      "downloadDetails": "Download details",
      "investments": "Investments",
      "investmentsDescription": "What you owned at the statement date and the latest governed value used for the statement.",
      "investment": "Investment",
      "allocation": "{{value}} of this currency's invested value",
      "quantity": "Quantity {{value}}",
      "value": "Value",
      "gainLoss": "Gain / loss",
      "noInvestments": "No investments in this statement",
      "noInvestmentsDescription": "There were no reportable positions at the statement date.",
      "cash": "Cash",
      "activity": "Activity",
      "activityDescription": "Recent posted activity included in this statement period.",
      "feesAndTaxes": "Fees & taxes",
      "fees": "Fees with verified currency",
      "taxes": "Taxes",
      "aboutValues": "About these values",
      "cashDescription": "Cash held in the portfolio at the statement cutoff.",
      "showAll": "Show all {{count}}",
      "showLess": "Show less"
    }
  },
  "financialDataQuality": {
    "current": "Current financial data",
    "delayed": "Financial data is delayed. Review the source timestamp before relying on it.",
    "stale": "Financial data is stale. Values may not reflect current market, ledger, or custody state.",
    "partial": "Financial data is partial. Missing or excluded inputs are not shown as zero.",
    "unavailable": "Financial data is unavailable. No value is presented in place of missing evidence.",
    "sourceBook": "Source book",
    "asOf": "As of",
    "generatedAt": "Generated at",
    "calculationVersion": "Calculation version",
    "restatement": "Restatement status",
    "lineage": "View lineage and evidence"
  },
  "table": {
    "export": {
      "help": "Choose which records and business fields to export. Hidden table fields are available unless the descriptor marks them non-exportable.",
      "visibleFields": "Visible fields",
      "scope": "Export scope",
      "currentPage": "Current page",
      "selectedRows": "Selected rows",
      "allMatching": "All matching",
      "configureSchema": "Define schema",
      "availableFields": "Available fields",
      "schemaFields": "Export schema",
      "schemaHelp": "Drag fields from the available list into export positions and reorder them by dragging between slots.",
      "position": "Export column {{position}}",
      "dropField": "Drop a field here",
      "included": "Included",
      "available": "Available",
      "resetSchema": "Reset schema",
      "applySchema": "Apply schema",
      "selectAll": "Select all",
      "deselectAll": "Deselect all",
      "fieldsSelected": "{{selected}} of {{total}} fields selected"
    },
    "resizeColumn": "Resize column",
    "actions": "Actions",
    "moreActions": "More actions",
    "selectRow": "Select row",
    "collapseDetails": "Collapse details",
    "expandDetails": "Expand details",
    "showLess": "Show less",
    "showMore": "Show more",
    "globalSearch": {
      "placeholder": "Search..."
    },
    "clearFilters": "Clear filters",
    "groupBy": "Group and totals",
    "sum": "Total",
    "showFilterRow": "Show filter row",
    "hideFilterRow": "Hide filter row",
    "showFilters": "Show filters",
    "hideFilters": "Hide filters",
    "columns": "Columns",
    "searchColumns": "Search columns",
    "pinnedLeft": "Pinned left",
    "pinnedRight": "Pinned right",
    "showAll": "Show all",
    "hideOptional": "Hide optional",
    "resetLayout": "Reset layout",
    "densityLabel": "Density",
    "density": {
      "compact": "Compact",
      "standard": "Standard",
      "comfortable": "Comfortable"
    },
    "refresh": "Refresh",
    "exportLabel": "Export",
    "bulkActions": "Bulk actions",
    "rowSelected": "row selected",
    "rowsSelected": "rows selected",
    "savedViews": "Saved views",
    "saveViewAs": "Save view as",
    "unsavedChanges": "unsaved changes",
    "resetFilters": "Reset filters",
    "resetAll": "Reset all",
    "resultsCount": "{{count}} results",
    "perPage": "per page",
    "rowsPerPage": "Rows per page",
    "pageInfo": "{{start}}-{{end}} of {{total}}",
    "pageOf": "Page {{current}} of {{total}}",
    "firstPage": "First page",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "lastPage": "Last page",
    "collapseGroup": "Collapse group",
    "expandGroup": "Expand group",
    "aggregates": "Σ: {{value}}",
    "row": "row",
    "rows": "rows",
    "group": {
      "nullValue": "None"
    },
    "loading": "Loading",
    "viewOptions": "View options",
    "emptyState": {
      "readOnlyHint": "This data is derived from transactions and opening balances. Post a transaction or import an opening cutover to populate it."
    },
    "selected": "selected",
    "resultsCount_one": "{{count}} result",
    "resultsCount_other": "{{count}} results"
  },
  "lotTimeline": {
    "title": "Lot timeline (FIFO)",
    "summary": "{{lots}} lots, {{disposals}} disposals",
    "openLots": "Open lots",
    "closedLots": "Closed lots",
    "disposals": "Disposals and realized gain or loss",
    "acquired": "Acquired",
    "source": "Source",
    "originalQuantity": "Original quantity",
    "remaining": "Remaining",
    "costPerUnit": "Cost per unit",
    "totalCost": "Total cost",
    "status": "Status",
    "disposalDate": "Disposal date",
    "lotAcquired": "Lot acquired",
    "quantitySold": "Quantity sold",
    "salePrice": "Sale price",
    "holdingDays": "Holding days",
    "realizedGainLoss": "Realized gain or loss",
    "empty": "No lots or disposals are available for this transaction.",
    "expand": "Expand lot timeline",
    "collapse": "Collapse lot timeline"
  },
  "data": {
    "marketPrices": {
      "description": "Review market-price observations, add a missing observation, import batches, and correct an existing observation with governed evidence.",
      "createTitle": "Add market price",
      "createDescription": "Record a new market-price observation for a governed instrument. Currency is derived from the instrument; an existing observation must be corrected rather than overwritten.",
      "editTitle": "Correct market price",
      "editDescription": "Record an evidence-backed correction. Only the changed observation fields are amended; the original value and prior version remain auditable.",
      "detailTitle": "Market price details",
      "detailDescription": "Review the observation value, source, freshness, version, and lineage used by valuation and reporting.",
      "createSuccess": "Market price added.",
      "correctSuccess": "Market price correction recorded.",
      "detail": {
        "title": "Market data detail"
      },
      "actions": {
        "add": "Add price",
        "correct": "Correct",
        "recordCorrection": "Record correction"
      },
      "columns": {
        "instrumentSymbol": "Symbol",
        "instrumentName": "Instrument",
        "tradedDate": "Trading date",
        "open": "Open",
        "high": "High",
        "low": "Low",
        "close": "Close",
        "last": "Last traded",
        "volume": "Volume",
        "turnover": "Turnover",
        "tradeCount": "Trades",
        "observationKind": "Observation type",
        "priceType": "Valuation / metric type",
        "canonicalPrice": "Canonical valuation price",
        "price": "Stored observation value",
        "currency": "Currency",
        "exchange": "Exchange",
        "source": "Source",
        "freshness": "Freshness",
        "asOf": "As of",
        "createdAt": "Ingested at",
        "updatedAt": "Last updated",
        "sourceEntity": "Source entity",
        "sourceRecordId": "Source record ID",
        "asOfDate": "Source as of",
        "effectiveTimestamp": "Effective timestamp",
        "restatementState": "Restatement state",
        "lineage": "Lineage"
      },
      "fields": {
        "instrumentSymbol": "Instrument",
        "instrumentName": "Instrument name",
        "tradedDate": "Trading date",
        "source": "Source",
        "open": "Open",
        "high": "High",
        "low": "Low",
        "close": "Close",
        "last": "Last traded price",
        "volume": "Volume",
        "turnover": "Turnover",
        "tradeCount": "Number of trades",
        "observationKind": "Observation type",
        "priceType": "Price type",
        "price": "Price",
        "currency": "Currency",
        "exchange": "Exchange",
        "freshness": "Freshness",
        "createdAt": "Recorded at",
        "updatedAt": "Last updated",
        "reason": "Correction reason",
        "expectedVersion": "Record version"
      },
      "help": {
        "instrument": "Search by instrument name or symbol. The instrument determines the observation currency in this release.",
        "source": "Use MANUAL for an administrator-entered observation, or identify the authoritative source when known.",
        "open": "First traded price for the session.",
        "high": "Highest traded price for the session; must not be below open, close or last traded price.",
        "low": "Lowest traded price for the session; must not exceed open, close or last traded price.",
        "close": "Official closing price. Required when recording a daily OHLCV market snapshot and used as the canonical daily valuation price when released.",
        "last": "Last traded price for the session when supplied by the market source.",
        "volume": "Total traded quantity for the session. Zero is allowed for a valid no-trade session.",
        "turnover": "Total traded monetary value for the session when supplied by the market source.",
        "tradeCount": "Number of executed trades for the session; enter a whole number.",
        "priceType": "Choose the market observation represented by this value.",
        "price": "Enter the observed price using the instrument currency.",
        "correctionPriceType": "The stored scalar observation being corrected. OHLCV metrics are independently versioned observations.",
        "correctionPrice": "Leave unchanged unless the recorded price itself is being corrected.",
        "correctionReason": "Describe the source evidence and why the existing observation is incorrect."
      },
      "section": {
        "scope": "Observation context",
        "scopeDescription": "Choose the instrument, business date and authoritative source once for the observation set.",
        "marketSnapshot": "Daily market observation",
        "marketSnapshotDescription": "For exchange-traded instruments, record the conventional OHLCV session values. Close is required when any daily market metrics are entered; the backend validates high/low consistency and stores every metric as an immutable sourced observation.",
        "valuation": "Standalone valuation price",
        "valuationDescription": "For NAV-based, evaluated or manually valued instruments, record a single governed valuation type and value instead of forcing OHLCV fields that do not apply.",
        "observation": "Price observation",
        "observationDescription": "Choose the governed instrument, observation type, price, trading date, and source.",
        "correction": "Correction evidence",
        "correctionDescription": "Explain why this observation must change. The correction is version-checked and auditable."
      },
      "priceType": {
        "OPEN": "Open",
        "HIGH": "High",
        "LOW": "Low",
        "CLOSE": "Close",
        "LAST": "Last traded",
        "VOLUME": "Volume",
        "TURNOVER": "Turnover",
        "TRADE_COUNT": "Trade count",
        "NAV": "NAV",
        "EVALUATED": "Evaluated price",
        "MANUAL": "Manual valuation",
        "BID": "Bid",
        "OFFER": "Offer"
      }
    }
  },
  "organization": {
    "regulatoryProfile": {
      "title": "Regulatory profile",
      "description": "Maintain the organization's verified regulatory identities and effective licenses. Filing capabilities remain unavailable unless an active license and an approved report template apply to the reporting date.",
      "sections": {
        "identity": "Filing identity",
        "licenses": "Regulatory licenses"
      },
      "fields": {
        "expectedVersion": "Record version",
        "panNumber": "PAN number",
        "sebonRegistrationNumber": "SEBON registration number",
        "licenses": "Licenses",
        "authority": "Authority",
        "licenseType": "License type",
        "licenseNumber": "License number",
        "status": "Status",
        "effectiveFrom": "Effective from",
        "effectiveTo": "Effective to",
        "sourceReference": "Source reference"
      },
      "help": {
        "panNumber": "Enter the organization's nine-digit Nepal PAN.",
        "licenses": "Add only licenses verified from an authoritative regulator source. Dates and status determine whether a regulated report may be generated."
      },
      "validation": {
        "panNumber": "PAN must contain exactly nine digits."
      },
      "licenses": {
        "add": "Add license",
        "remove": "Remove license",
        "empty": "No regulatory licenses have been recorded.",
        "item": "License"
      },
      "actions": {
        "save": "Save regulatory profile"
      },
      "messages": {
        "saved": "Regulatory profile updated."
      },
      "authority": {
        "IRD": "Inland Revenue Department",
        "SEBON": "Securities Board of Nepal",
        "NRB": "Nepal Rastra Bank",
        "FIU_NEPAL": "Financial Intelligence Unit Nepal"
      },
      "licenseType": {
        "SEBON_PORTFOLIO_MANAGER": "SEBON portfolio manager",
        "SEBON_MERCHANT_BANKER": "SEBON merchant banker",
        "SEBON_SECURITIES_BROKER": "SEBON securities broker",
        "NRB_CLASS_A_BANK": "NRB Class A bank",
        "NRB_CLASS_B_BANK": "NRB Class B bank",
        "NRB_CLASS_C_FINANCE": "NRB Class C finance company",
        "NRB_CLASS_D_MICROFINANCE": "NRB Class D microfinance",
        "NRB_PAYMENT_SERVICE_PROVIDER": "NRB payment service provider",
        "NRB_OTHER_LICENSED_ENTITY": "Other NRB-licensed entity",
        "FIU_REPORTING_ENTITY": "FIU reporting entity"
      },
      "status": {
        "ACTIVE": "Active",
        "SUSPENDED": "Suspended",
        "REVOKED": "Revoked",
        "EXPIRED": "Expired"
      }
    }
  },
  "a11y.form.platformOrganization.registration": "Register an organization deployment",
  "a11y.action.platformOrganization.register": "Register organization deployment",
  "form.platformOrganization.registrationTitle": "Register organization deployment",
  "form.platformOrganization.registrationDescription": "Create the Platform commercial registration and license plan. Branches and the first organization administrator are created locally by the organization runtime after it verifies the signed license.",
  "field.organization.licenses": "Initial license plan",
  "platformOnboarding.section.identity": "Organization identity",
  "platformOnboarding.section.licenses": "PMS license plan",
  "platformOnboarding.section.licensesDescription": "The released portfolio-management capability bundle must be licensed completely. Capacity and term values are enforced by Platform and projected to the organization runtime.",
  "platformOnboarding.license.add": "Add license",
  "platformOnboarding.license.remove": "Remove license",
  "platformOnboarding.license.empty": "No licenses configured",
  "platformOnboarding.license.item": "Module license",
  "platformOnboarding.license.module": "Capability",
  "platformOnboarding.license.maxBranches": "Maximum Branches",
  "platformOnboarding.license.maxUsers": "Maximum users",
  "platformOnboarding.license.effectiveFrom": "Effective from",
  "platformOnboarding.license.effectiveTo": "Effective to",
  "platformOnboarding.license.graceEndsAt": "Grace ends",
  "platformOnboarding.action.register": "Register deployment",
  "platformOnboarding.registration.success": "Organization deployment registered. Complete installation credential enrollment before starting the organization runtime.",
  "platformOnboarding.registration.error": "The organization deployment could not be registered. Review the commercial profile and license plan and try again.",
  "form.platformOrganization.runtimeCredential.title": "Enroll organization runtime",
  "form.platformOrganization.runtimeCredential.description": "Issue one installation-bound control-plane credential for the organization runtime. The secret is displayed once and must be stored immediately in the deployment secret provider.",
  "a11y.form.platformOrganization.runtimeCredential": "Enroll the organization runtime control-plane credential",
  "a11y.action.platformOrganization.runtimeCredential.enroll": "Issue the organization runtime credential",
  "platformOnboarding.runtimeCredential.section.security": "Runtime credential security",
  "platformOnboarding.runtimeCredential.section.securityDescription": "Limit this credential to the runtime's known source addresses and a short rotation window. It cannot be used for another installation.",
  "platformOnboarding.runtimeCredential.allowedNetworks": "Allowed source IP addresses",
  "platformOnboarding.runtimeCredential.allowedNetworksHelp": "Add the exact public or private source IP addresses used by this organization runtime. CIDR ranges are intentionally not accepted by this enrollment flow.",
  "platformOnboarding.runtimeCredential.network.add": "Add source IP",
  "platformOnboarding.runtimeCredential.network.remove": "Remove source IP",
  "platformOnboarding.runtimeCredential.network.empty": "Add at least one source IP address.",
  "platformOnboarding.runtimeCredential.network.item": "Source IP",
  "platformOnboarding.runtimeCredential.network.value": "IP address",
  "platformOnboarding.runtimeCredential.network.placeholder": "203.0.113.10",
  "platformOnboarding.runtimeCredential.expiresAt": "Credential expiry date",
  "platformOnboarding.runtimeCredential.expiresAtHelp": "Choose a date within the next 90 days. Rotate the credential before it expires.",
  "platformOnboarding.runtimeCredential.action.enroll": "Enroll runtime",
  "platformOnboarding.runtimeCredential.description": "Create the installation-bound credential required for license refresh, usage tracking and controlled support communication.",
  "platformOnboarding.runtimeCredential.secret.title": "Runtime credential secret",
  "platformOnboarding.runtimeCredential.secret.warning": "Copy this secret now. It will not be shown again.",
  "platformOnboarding.runtimeCredential.secret.copied": "Runtime credential copied. Store it in the organization deployment secret provider before closing this view.",
  "tableExport": {
    "completed": "Export downloaded.",
    "failed": "Export could not be completed. Review the filters or try a smaller result set.",
    "unavailable": "This export option is not available for the current table and scope.",
    "title": "Export {{resource}}",
    "description": "Choose what to export and in which format.",
    "action": "Export",
    "asyncHint": "Exports over {{threshold}} rows are processed in the background.",
    "records": {
      "title": "Records"
    },
    "scope": {
      "all": "All records",
      "allCount": "All {{count}} records",
      "filtered": "Current filtered results",
      "filteredCount": "Current filtered results — {{count}}",
      "selected": "Selected rows",
      "selectedCount": "Selected rows — {{count}}"
    },
    "fields": {
      "title": "Fields",
      "recommended": "Recommended fields",
      "current": "Current table columns",
      "custom": "Choose fields",
      "search": "Search fields…",
      "selectRecommended": "Select recommended",
      "selectAll": "Select all",
      "clear": "Clear",
      "selectedCount": "{{count}} of {{total}} selected"
    },
    "format": {
      "title": "Format"
    }
  }
}
